/* TYD Library v140 fast-snapshot reader — V116 developer-safety baseline.
   ACG is checked by SLB, while Library data loads directly for speed. */
/* GOD_ATLAS_PHASE7_AUDIT_POLISH */
/* TYD_LIBRARY_V140_BCM_KAD_JKF_EXACT_20260919_05 */
/* TYD Lineage Library script - v106 God blog details import. Based on v105 hide empty God sections. */
/* RC_ATLAS_V84_DIRECT_TEACHING_EMPTY_CATEGORY_FIX */
(function(){
  var root = document.getElementById('tydLibraryApp');
  if(!root) return;
  if(window.__TYD_LIBRARY_MAIN_STARTED__) return;
  window.__TYD_LIBRARY_MAIN_STARTED__ = true;
  var TYD_LIBRARY_BUILD_TAG = 'TYD_LIBRARY_V140_BCM_KAD_JKF_EXACT_20260919_05';
  var TYD_PERF_ZERO = (window.performance && performance.now) ? performance.now() : Date.now();
  function tydPerfMark_(name, detail){
    try{
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      var ms = Math.max(0, Math.round(now - TYD_PERF_ZERO));
      console.info('[TYD Library]', name, ms+'ms', detail || '');
      window.__TYD_LIBRARY_TIMINGS__ = window.__TYD_LIBRARY_TIMINGS__ || [];
      window.__TYD_LIBRARY_TIMINGS__.push({ name:String(name||''), ms:ms, detail:String(detail||''), at:Date.now() });
      if(window.__TYD_LIBRARY_TIMINGS__.length > 40) window.__TYD_LIBRARY_TIMINGS__.splice(0, window.__TYD_LIBRARY_TIMINGS__.length-40);
    }catch(_e){}
  }
  tydPerfMark_('script-start', TYD_LIBRARY_BUILD_TAG);
  if(window.CSS && !CSS.escape){ CSS.escape = function(v){ return String(v).replace(/[^a-zA-Z0-9_\-]/g,'\\$&'); }; }
  if(!window.CSS){ window.CSS = { escape:function(v){ return String(v).replace(/[^a-zA-Z0-9_\-]/g,'\\$&'); } }; }

  try{ document.title = 'Saam Law Magic Library'; }catch(e){}

  var ADD_BOOK_PROMPT = [
    'Add this attached book into the Saam Law Magic Library / TYD Lineage Content Library database.',
    '',
    'Use the existing Google Sheet database: TYD Lineage Content Library.',
    'Tabs/schema to use: Books, Items, Lines, Book_Index, Review_Log, Saamlawnese_Exceptions.',
    'For fast Supercharge updates, keep the updated_at column on Items, Lines, Books, and Book_Index and set it to an ISO timestamp whenever a row is added or edited.',
    '',
    'IMPORTANT SOURCE OF TRUTH FOR SAAMLAWNESE:',
    '- Before writing any book rows, load the SLB master truth sheet: TYW — Saamlawnese DB, tab SAAML_MASTER_CHAR.',
    '- The Library follows the SLB master. Do not keep book pinyin/Saamlawnese when it conflicts with the SLB master.',
    '- For every Chinese line, check/rebuild the Saamlawnese from the Chinese using the SLB master character/phrase readings.',
    '- If the book has Saamlawnese already, use it only as a reference for spotting line breaks or source intent. The final Lines.saamlawnese must match the SLB master.',
    '- If a Chinese character/phrase is missing from the SLB master, STOP before adding the book to the database.',
    '- When unknown master words are found, create an XLSX for Jee Sifu to fill. Keep it simple with one sheet and these columns: Chinese, Source line / context, Book Saamlawnese if shown, Your Correct Saamlawnese, Notes.',
    '- Give Jee Sifu the XLSX for download and wait for the filled file. After he returns it, update the SLB master first, then add/rebuild the book lines from the updated master.',
    '',
    '',
    'LEGACY SCRIPTURE BOOK MODE:',
    '- If Jee Sifu says the attached book is OLD, legacy, or not updated, treat it as a Legacy Version book source. Do not import the whole document as final.',
    '- For legacy scripture books, follow the normal Morning Rite-style structure unless Jee Sifu says otherwise:',
    '  1. Opening Sky Door',
    '  2. Incense Blessing Spell',
    '  3. Cleansing spells',
    '  4. Opening The Prayers',
    '  5. Book-specific custom prayer(s)',
    '  6. Closing The Prayers',
    '  7. Scripture Opening Spell',
    '  8. Main scripture content',
    '  9. Book-specific required spell(s) after the scripture, if the source has them',
    '  10. Scripture Closing Spell',
    '  11. Three Ordains',
    '  12. Twelve Wishes',
    '- Do NOT add a god/deity channeling spell unless Jee Sifu specifically asks for it.',
    '- Keep the book-specific prayer(s) related to the god/deity of that book, for example 天醫仙師 prayer in a Celestial Medic book.',
    '- For shared/common rite sections, compare to the current Library/Morning Rite standard and reuse the current standard item when appropriate. Do not blindly import old versions of common spells, openings, closings, Three Ordains, or Twelve Wishes.',
    '- Treat old Saamlawnese and old English translation as reference only. Rebuild Saamlawnese from SLB master and rewrite the English cleanly in current Tin Yat / Saam Law wording.',
    '- Tag/report the book as Legacy Version / rebuilt from legacy source so we know it came from an old source but was cleaned before import.',
    'Workflow:',
    '1. Read the attached book file carefully.',
    '2. Identify the book title, English title if any, file name, updated date/version, and all sections in order.',
    '3. Load and use the current SLB master truth before generating or validating any Saamlawnese.',
    '4. Scan the book Chinese for unknown master words. If any are unknown, create the easy-fill XLSX and do not write database rows yet.',
    '5. If all words are known, rebuild/check all Saamlawnese line-by-line against the SLB master.',
    '6. For each section/spell/prayer/scripture, decide whether it is a new item or already exists in the database.',
    '7. Reuse existing item_id for shared/common sections. Do not duplicate Items or Lines for the same text.',
    '8. Add one Books row, new Items rows only when needed, new Lines rows only for new items, and Book_Index rows for the whole book order.',
    '9. For the Books row, do not leave display fields blank. Always fill: book_id, book_title_chinese, book_title_english, file_name, updated_date, status, notes, library_type, category_group, directory_group, display_order, updated_at.',
    '10. For legacy scripture books, library_type must usually be Scriptures/Rite; category_group must be the real top-level scripture group such as Tin, Dei, Daai, or Daily; directory_group must be the displayed group such as Tin Scriptures, Dei / Salvation, or Daily Rites. Do not let a scripture book fall into All unless Jee Sifu specifically asks for All.',
    '11. The public book title must come from Books.book_title_chinese and Books.book_title_english, not from item_id or book_id. After writing, verify the new book does not display as a machine key like saam_law_truth_scripture_book.',
    '12. For Book_Index, the main scripture item must be placed immediately after Scripture Opening Spell. If the source has required spell(s) after the scripture, place those immediately after the main scripture and before Scripture Closing Spell. Otherwise, the main scripture must be immediately before Scripture Closing Spell. Do not rely on item row order, source_book matching, search rescue, cached rows, or fallback grouping to place it; verify the frontend reader/directory order after patching.',
    '13. After updating, search/read back the exact new Books row and every Book_Index row for the new book_id. If the Books row is missing, blank, wrong category_group, or the Book_Index order is wrong, fix it before reporting done.',
    '',
    'Important parsing and cleanup rules:',
    '- Chinese, Saamlawnese, and English may wrap across multiple visual lines in the book. Do not drop continuation lines.',
    '- Especially for Saamlawnese/pinyin: if one Chinese line has its pinyin split into 2 or more rows, join all of those rows into the same Lines.saamlawnese cell.',
    '- Reading-mode line break rule: if one Chinese database line has two Chinese phrase chunks separated by punctuation, the Saamlawnese cell should normally have matching line breaks, one Saamlawnese phrase per line. Example: 入我心中，我今行法， should become Yip Whuoh Sim Jong, newline Whuoh Gim Kong Whua, not one stuck line.',
    '- Do not over-split a single Chinese phrase just because the Saamlawnese has commas inside it. Split only when it matches actual Chinese phrase chunks or intended chant/vocal breaks.',
    '- Remove accidental slash weirdness from imported text. Do not insert /, //, or slash separators into Chinese or Saamlawnese cells unless the original content clearly requires it in English/notes.',
    '- Clean common import artifacts before writing: dangling slashes, random separator marks, duplicate spaces, pasted page headers/footers, and pinyin fragments that got detached from their Chinese line.',
    '- Preserve intentional chant marks and repeats such as x7, 3x, Ha!, Hor!, Hwall Hwall!, and song/vocal callouts when they are part of the source.',
    '- Keep the source wording, punctuation, capitalization, and intended line breaks as close as possible, but correct Saamlawnese spelling to the SLB master.',
    '- A book/rite is not a category. Put the book structure into Books + Book_Index.',
    '- IMPORTANT: category means the lineage set/group used by the book, not every possible function of the spell.',
    '- Do not over-tag categories. If a spell belongs to a named set, keep it with that set even if it can also protect, block, cleanse, etc.',
    '- Morning Rite beginning purification/cleansing set = Jing Spells. Golden Light Spell stays inside Jing Spells; do not split it into protection.',
    '- Evening Rite spell set = Exorcism Spells. Do not split the Evening Rite spells into barrier/protection/etc categories.',
    '- Noon Rite beginning spell set = Wealth Spells.',
    '- Common rite/opening/closing support items are NOT members of Jing Spells, Wealth Spells, or Exorcism Spells. Examples: Opening Sky Door, Scripture Opening Spell, Scripture Closing Spell, Incense Blessing Spell.',
    '- Do not put Ground Emperor God of Wealth Spell inside Jing Spells just because it appears in a morning book/source.',
    '- Use individual extra functions only in notes when needed, not as the main category.',
    '- For book/category labels, use real displayed categories only, such as Scriptures/Rite, Jing Spells, Wealth Spells, Exorcism Spells, Cheng Sun Spells, Chick Spells, Hoi Gwong Spells, Practical Spells, Soul Spells, War Spells. Do not create lowercase tag categories such as scripture, prayer, offering, opening, ordination, wishes, protection, or wealth.',
    '- If a title is the same but the text differs, treat it as a new item or ask before updating.',
    '',
    'Required QA before and after updating:',
    '- Confirm every Chinese character/phrase used by the book exists in the SLB master, or stop and produce the unknown-word XLSX.',
    '- Confirm Lines.saamlawnese matches the SLB master readings for the Chinese in the same row.',
    '- Confirm no accidental / slash separators were inserted.',
    '- Confirm no pinyin/Saamlawnese phrase is stuck together when the Chinese has separate phrase chunks.',
    '- Confirm no single phrase was over-split incorrectly.',
    '- Confirm there are no active Saamlawnese_Exceptions being used to hide mismatches.',
    '- Confirm the new book appears through Books + Book_Index, not as an orphan item in All / Unassigned / Needs Book_Index.',
    '- Confirm the whole-book reader order follows Book_Index and the main scripture / required after-scripture spells are sandwiched between Scripture Opening Spell and Scripture Closing Spell.',
    '- Confirm the Books row title fields display the real Chinese/English book title, not the book_id or item_id.',
    '',
    'After updating:',
    '- Verify the rows added/changed.',
    '- Check for incomplete pinyin caused by line wrapping.',
    '- Report the book_id, new item_ids, reused item_ids, rows added, unknown words resolved, and anything uncertain.'
  ].join('\n');

  var CFG = {
    sheetId: root.getAttribute('data-sheet-id') || '1tmtGzRvL513_YBgB1y04_85-SLCRksiuiacYprVI59E',
    masterSheetId: root.getAttribute('data-saaml-master-id') || '1eiPaLK6F9g_KCg_hI1BnsNxmIoFr3SMgz1nx015ZmFU',
    sheets: { items:'Items', lines:'Lines', books:'Books', index:'Book_Index', review:'Review_Log', exceptions:'Saamlawnese_Exceptions', rc:'RC_Atlas', gods:'God_Atlas' },
    masterSheet: 'SAAML_MASTER_CHAR'
  };

  var qs = new URLSearchParams(window.location.search || '');
  var auditParam = String(qs.get('audit') || '');
  // TYD Library v115: hard full-book reader restore / no progressive chunks.
  var state = { items:[], lines:[], books:[], index:[], rcAtlas:[], godAtlas:[], godAnnivItems:[], godAnnivLoaded:false, godAnnivLoading:false, review:[], exceptions:[], exceptionMap:{}, masterRows:[], masterMap:{}, masterError:'', selectedId:null, query:'', type:'', category:'', godSection:'', mode:'chant', directoryView:'book', directorySort:'sheet', openGroups:{}, auditMode: !!auditParam || qs.get('review') === '1', auditPanel:(auditParam === 'review' || qs.get('review') === '1') ? 'review' : 'saamlawnese', auditFilter:'problem', auditHideDecided:false, auditGroupDuplicates:true, auditShowExceptions:false, auditRows:[], auditDecisions:{}, reviewFilter:'open', reviewHideApproved:true, reviewHideDuplicates:true, reviewDecisions:{}, chantPages:[], chantPage:0, chantActive:false, chantScale:1, chantTheme:'light', chantTouchStartX:0, chantTouchStartY:0, articleFocusActive:false, articleFocusFont:'sans', printScale:1.15, readerSize:'normal', mobileDrawerOpen:false, downloadDrawerOpen:false, imeAccess:false, mobileTouchStartX:0, mobileTouchStartY:0, cacheManifest:null, supercharged:false, builder:{ open:false, title:'Custom Saam Law Book', description:'', versionMode:'latest', defaultMode:'chant', layoutPreset:'normal', sections:[] }, builderLibrary:{ activeId:'', books:[] }, builderDragIdx:null, builderExpanded:{}, acgAccess:'checking', acgLimited:false, fastDirectoryMode:false, fullLinesLoaded:true, lazyLineLoading:false, lazyLineMissing:{}, quickShelf:[], quickShelfLoaded:false, quickShelfSaving:false, quickShelfFirstPaint:false, collections:[], collectionsLoaded:false, collectionsLoading:false, articleBodyLoading:{}, bcmAccess:false };
  function perfMark_(name){
    try{
      window.__TYD_LIBRARY_TIMING = window.__TYD_LIBRARY_TIMING || {};
      window.__TYD_LIBRARY_TIMING[name] = Math.round(performance.now());
    }catch(_e){}
  }
  perfMark_('scriptStart');
  var deepLinkViewParam = String(qs.get('view') || qs.get('tyd_view') || '').toLowerCase().trim();
  if(deepLinkViewParam === 'gods' || deepLinkViewParam === 'god' || deepLinkViewParam === 'god_atlas' || deepLinkViewParam === 'god atlas') state.directoryView = 'gods';
  else if(deepLinkViewParam === 'rc' || deepLinkViewParam === 'rc_atlas' || deepLinkViewParam === 'rc atlas') state.directoryView = 'rc';
  else if(deepLinkViewParam === 'quick' || deepLinkViewParam === 'quick_shelf' || deepLinkViewParam === 'quick shelf' || deepLinkViewParam === 'shelf') state.directoryView = 'quick';
  else if(deepLinkViewParam === 'video' || deepLinkViewParam === 'videos' || deepLinkViewParam === 'teaching videos') state.directoryView = 'videos';
  else if(deepLinkViewParam === 'fun' || deepLinkViewParam === 'funwatch' || deepLinkViewParam === 'fun watch' || deepLinkViewParam === 'entertainment') state.directoryView = 'funwatch';
  else if(deepLinkViewParam === 'article' || deepLinkViewParam === 'articles' || deepLinkViewParam === 'teaching articles') state.directoryView = 'articles';
  else if(deepLinkViewParam === 'supply' || deepLinkViewParam === 'supplies' || deepLinkViewParam === 'shopping' || deepLinkViewParam === 'shopping list') state.directoryView = 'supplies';
  else if(deepLinkViewParam === 'book' || deepLinkViewParam === 'books') state.directoryView = 'book';

  /* RC Atlas Phase 2 Skeleton — disciple-only study atlas inside TYD Library */
  var RC_ATLAS_TYPES = ['Basics','Tin Yat','Saam Law','Sun Lung','TYHQ'];
  var RC_ATLAS_CATEGORIES = {
    'Basics':['Start Here','Lessons','Overview','Concept','Journey','Afterdeath System','Afterdeath Placement','Study Notes'],
    'Tin Yat':['Overview','Purpose','Gods','Palace','Hall','Courtyard','Public Life','Worship','Celebration','Help / Rescue','Study Notes'],
    'Saam Law':['Overview','Purpose','Gods','Palace','Hall','Courtyard','Residence','Care','Learning','Knowledge','Law / Justice','Study Notes'],
    'Sun Lung':['Overview','Purpose','Gods','Palace','Hall','Courtyard','Work','Business','Communication','Civic Service','Military','Protection','Exorcism','Study Notes'],
    'TYHQ':['Overview','Purpose','Saam Law Jo Si','Altar','Institution','Ministry','Admin','Approval','Judgment','Human Altar Connection','Celestial Court Connection','Study Notes']
  };
  var RC_ATLAS_ENTRIES = [
  {
    "rc_id": "rc_basics_start_here",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Start Here",
    "title_en": "How to Study the RC Atlas",
    "title_zh": "",
    "parent": "RC Atlas",
    "belongs_to": "Religious Court",
    "display_order": "1000",
    "short_summary": "A starting guide for using the Religious Court Atlas as disciple-only study material.",
    "simple_meaning": "The RC Atlas is not a public article and not a normal scripture book. It is a place-based study section for disciples to explore the Religious Court system by area, purpose, and function.",
    "what_it_does": "It gives disciples a clean way to move from the big picture into the actual zones, palaces, halls, courtyards, gods, duties, and afterdeath arrangements of the Religious Court.",
    "disciple_study_notes": "Begin with Basics first. After the foundation is clear, study Tin Yat, Saam Law, Sun Lung, and TYHQ. Do not jump straight into halls, courtyards, or ministries without knowing what each main area is for.",
    "afterdeath_meaning": "The Atlas helps disciples understand the court-world they are connected to, the route a soul can take after death, and why cultivation changes the quality of that route.",
    "practice_usage": "Use this as a self-study map. Review one entry at a time, follow related entries, and use the tags/search to connect doctrine, court structure, and practice.",
    "related_entries": "rc_basics_what_is_rc, rc_basics_afterdeath_country, rc_basics_afterdeath_journey",
    "tags": "rc, atlas, start here, disciple study, religious court",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_what_is_rc",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Overview",
    "title_en": "What is the Religious Court?",
    "title_zh": "",
    "parent": "RC Atlas",
    "belongs_to": "Religious Court",
    "display_order": "1010",
    "short_summary": "The Religious Court is the lineage court-world that receives, manages, teaches, protects, and arranges souls and disciples.",
    "simple_meaning": "The Religious Court is not just a courtroom. It is a complete court-world of Saam Law Tao. It has places to arrive, places to live, places to work, places to learn, and a high government system to handle court affairs.",
    "what_it_does": "It receives disciples and saved souls, gives them care and order, connects them with gods and departments, and supports the path toward better future arrangements such as Daai Law Tin.",
    "disciple_study_notes": "When studying RC, think of it as a spiritual country under the lineage system. There is public life, residence, work, justice, communication, protection, and administration. Each zone has its own purpose.",
    "afterdeath_meaning": "After death, a disciple or saved ghost can be received into the Religious Court instead of wandering outside. The soul enters a system with guidance, care, law, and direction.",
    "practice_usage": "Use this entry as the foundation for all other RC studies. Every palace, hall, courtyard, god, and ministry should be understood as part of this larger court-world.",
    "related_entries": "rc_basics_afterdeath_country, rc_basics_four_main_areas, rc_tyhq_overview",
    "tags": "religious court, rc, court-world, afterdeath, lineage",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_afterdeath_country",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Concept",
    "title_en": "RC as an Afterlife Country",
    "title_zh": "",
    "parent": "Religious Court",
    "belongs_to": "Basics",
    "display_order": "1020",
    "short_summary": "The Religious Court functions like an afterlife country where saved souls can belong and continue.",
    "simple_meaning": "A saved soul is not only pulled away from danger. The soul is brought into a court-country where there is shelter, order, food, care, work, worship, learning, residence, and future direction.",
    "what_it_does": "This concept explains why RC has zones and departments. Tin Yat supports public life and first arrival. Saam Law supports residence and care. Sun Lung supports work and protection. TYHQ governs the whole system.",
    "disciple_study_notes": "Do not reduce the Religious Court to only judgment or punishment. It is also a living system. This makes the afterdeath teaching warmer, more complete, and easier to understand.",
    "afterdeath_meaning": "After death, being received by the RC means the soul enters a place with belonging. The soul can be cleaned up, fed, housed, taught, corrected, protected, and arranged for the next step.",
    "practice_usage": "Use this concept whenever explaining why salvation, ordination, and cultivation are practical and not only symbolic.",
    "related_entries": "rc_basics_four_main_areas, rc_tinyat_zone_overview, rc_saamlaw_zone_overview, rc_sunlung_zone_overview, rc_tyhq_overview",
    "tags": "afterlife country, court-world, shelter, residence, afterdeath",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_four_main_areas",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Overview",
    "title_en": "Four Main Areas of the Religious Court",
    "title_zh": "",
    "parent": "Religious Court",
    "belongs_to": "Basics",
    "display_order": "1030",
    "short_summary": "The RC can be studied through four main areas: Tin Yat, Saam Law, Sun Lung, and TYHQ.",
    "simple_meaning": "The easiest way to study the Religious Court is to divide it into four main areas. Tin Yat is public life and first arrival. Saam Law is residence and care. Sun Lung is work and protection. TYHQ is the government and command center.",
    "what_it_does": "This gives disciples a mental map before studying smaller places. Once the four areas are clear, halls, courtyards, gods, and ministries become easier to place.",
    "disciple_study_notes": "Use this entry as the main navigation key. If an entry feels confusing, ask first which main area it belongs to, then ask what its role is inside that area.",
    "afterdeath_meaning": "The afterdeath route moves through these areas according to need: arrival and help, residence and waiting, work or service, and higher approval or arrangement.",
    "practice_usage": "Use this as the first study checkpoint before reading zone overviews and detailed department entries.",
    "related_entries": "rc_tinyat_zone_overview, rc_saamlaw_zone_overview, rc_sunlung_zone_overview, rc_tyhq_overview",
    "tags": "four areas, tin yat, saam law, sun lung, tyhq, map",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_afterdeath_journey",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Journey",
    "title_en": "Your Journey After Death",
    "title_zh": "",
    "parent": "Religious Court",
    "belongs_to": "Afterdeath System",
    "display_order": "1040",
    "short_summary": "The basic route from death to rescue, first arrival, home assignment, ghost life, and Daai Law Tin direction.",
    "simple_meaning": "After death, the soul needs a path. In Saam Law Tao, the path can include rescue by the Religious Court, first arrival in Tin Yat Zone, settling into Saam Law Zone, living through ghost life, and moving toward Daai Law Tin.",
    "what_it_does": "This entry gives disciples the big route so the details do not feel scattered. The journey explains why the zones exist and how salvation and cultivation connect to court life.",
    "disciple_study_notes": "Study this before studying hell, palaces, halls, and ministries. The afterdeath journey gives the reason behind the structure.",
    "afterdeath_meaning": "A saved soul is guided into a system instead of being left outside. The soul is received, cleaned up, cared for, housed, and placed into a future route.",
    "practice_usage": "Use this entry as the foundation for afterdeath teachings, salvation discussions, and personal cultivation reflection.",
    "related_entries": "rc_basics_rescue_into_rc, rc_basics_first_arrival_tinyat, rc_basics_home_ticket_system, rc_basics_dlt_goal",
    "tags": "afterdeath, journey, rescue, ghost life, dlt",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_rescue_into_rc",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Afterdeath System",
    "title_en": "Rescue into the Religious Court",
    "title_zh": "",
    "parent": "Afterdeath Journey",
    "belongs_to": "Religious Court",
    "display_order": "1050",
    "short_summary": "How disciples and ceremony-saved ghosts can be received by the Religious Court.",
    "simple_meaning": "Rescue means the Religious Court sends help to receive the soul. A disciple has lineage connection for this. A deceased person saved by ceremony may also receive the court's offer and be brought in if they accept.",
    "what_it_does": "Rescue stops the soul from remaining lost, exposed, or wandering without direction. It brings the soul into the RC system where further help can happen.",
    "disciple_study_notes": "Do not think rescue is the final destination. Rescue is the doorway. After the soul enters, there is still care, correction, settling, ticketing, and future arrangement.",
    "afterdeath_meaning": "The soul is taken toward the court system, usually entering the first-arrival process through Tin Yat Zone before being assigned further.",
    "practice_usage": "Use this with Ghost Month salvation study and personal disciple afterdeath preparation.",
    "related_entries": "rc_basics_first_arrival_tinyat, rc_basics_saved_by_ceremony, rc_tinyat_zone_overview",
    "tags": "rescue, salvation, receiving, religious court, ghost",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_first_arrival_tinyat",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Journey",
    "title_en": "First Arrival in Tin Yat Zone",
    "title_zh": "",
    "parent": "Afterdeath Journey",
    "belongs_to": "Tin Yat Zone",
    "display_order": "1060",
    "short_summary": "The first-arrival stage where the soul receives help, food, cleanup, temporary shelter, and guidance.",
    "simple_meaning": "Tin Yat Zone works like the first warm public arrival area. The newly received soul can get help, food, cleanup, rest, temporary shelter, and guidance before moving deeper into the court system.",
    "what_it_does": "It helps the soul stabilize after death or rescue. It is not the final residence, but it gives first care and a safe starting point.",
    "disciple_study_notes": "Think of this like a refugee arrival center inside a sacred court-country, but warmer and more spiritual. The soul is not thrown into a cold judgment system immediately.",
    "afterdeath_meaning": "The first arrival protects the soul from panic and disorder. It begins the transition from wandering ghost life into court life.",
    "practice_usage": "Study this before Tin Yat Zone Overview so the public and rescue side of Tin Yat makes sense.",
    "related_entries": "rc_tinyat_zone_overview, rc_basics_rescue_into_rc, rc_basics_home_ticket_system",
    "tags": "first arrival, tin yat, food, cleanup, shelter, guidance",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_home_ticket_system",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "DLT Path",
    "title_en": "Home Ticket System",
    "title_zh": "",
    "parent": "Afterdeath Journey",
    "belongs_to": "Saam Law Zone",
    "display_order": "1070",
    "short_summary": "The saved soul waits for home assignment in Saam Law Zone and future DLT direction.",
    "simple_meaning": "After the first arrival, the soul enters an assignment process. The soul can wait for a home in Saam Law Zone. Living there is also connected to the future ticket path toward Daai Law Tin.",
    "what_it_does": "It explains why the RC is not only a rescue place. It also gives residence, belonging, waiting time, and future arrangement.",
    "disciple_study_notes": "The home is a lineage privilege. Better disciples can receive better arrangements because cultivation builds stronger connection, merit, and readiness.",
    "afterdeath_meaning": "A saved soul can receive a free home in Saam Law Zone and wait there while the DLT path is arranged. The soul is not homeless while waiting.",
    "practice_usage": "Use this with Saam Law Zone Overview, Ghost Life, and Daai Law Tin Goal.",
    "related_entries": "rc_saamlaw_zone_overview, rc_basics_ghost_life_backward_aging, rc_basics_dlt_goal",
    "tags": "home, ticket, saam law zone, dlt, residence, waiting",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_ghost_life_backward_aging",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Ghost Life",
    "title_en": "Ghost Life and Backward Aging",
    "title_zh": "",
    "parent": "Afterdeath System",
    "belongs_to": "Religious Court",
    "display_order": "1080",
    "short_summary": "Ghost life usually runs around 100 years and the ghost ages backward toward baby form.",
    "simple_meaning": "In this system, a ghost does not simply age forward like a living person. Ghost life moves backward. Adult form can become younger, then childlike, then baby-like as the ghost life approaches its end.",
    "what_it_does": "This gives disciples a clear time concept. Ghost life is not eternal and not meaningless. It is a limited stage with its own direction and ending.",
    "disciple_study_notes": "The backward aging idea explains why the court should not delay important arrangements forever. Time still matters after death.",
    "afterdeath_meaning": "If the ghost life is close to ending, the RC may need to arrange the DLT trip quickly so the soul can move upward before the ghost life disappears.",
    "practice_usage": "Use this with Home Ticket System and Saved Only vs Cultivated Disciple Route.",
    "related_entries": "rc_basics_home_ticket_system, rc_basics_saved_only_vs_cultivated, rc_basics_dlt_goal",
    "tags": "ghost life, backward aging, 100 years, baby form, dlt",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_foundation_study_path",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Lessons",
    "title_en": "Foundation Study Path",
    "title_zh": "",
    "parent": "How to Study the RC Atlas",
    "belongs_to": "RC Atlas",
    "display_order": "1090",
    "short_summary": "A recommended first reading path for disciples who are new to the RC Atlas.",
    "simple_meaning": "This study path tells disciples what to read first so the Religious Court does not feel like a pile of random places.",
    "what_it_does": "It gives a first route through the foundation entries: what the Religious Court is, how it works as an afterlife country, how the soul enters, and why cultivation matters.",
    "disciple_study_notes": "Read these in order: What is the Religious Court, RC as an Afterlife Country, Four Main Areas, Your Journey After Death, Rescue into the Religious Court, Home Ticket System, Ghost Life, Saved Only vs Cultivated Disciple, and Daai Law Tin as the Ultimate Goal.",
    "afterdeath_meaning": "This path helps disciples see the whole afterdeath route before studying halls, courtyards, altars, and ministries.",
    "practice_usage": "Use this as the first self-study assignment before moving into Tin Yat, Saam Law, Sun Lung, and TYHQ.",
    "related_entries": "rc_basics_what_is_rc, rc_basics_afterdeath_country, rc_basics_four_main_areas, rc_basics_afterdeath_journey, rc_basics_dlt_goal",
    "tags": "study path, foundation, start here, basics, disciple study",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_saved_by_ceremony",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Saved vs Cultivated",
    "title_en": "Saved by Ceremony",
    "title_zh": "",
    "parent": "Afterdeath System",
    "belongs_to": "Religious Court",
    "display_order": "1090",
    "short_summary": "A deceased person can receive help through ceremony, but their route differs from a cultivated disciple.",
    "simple_meaning": "When living people do salvation work for the deceased, the Religious Court can send an offer and help. The ghost still has to accept. If accepted, the ghost can be received, cleaned, corrected, and placed into the court system.",
    "what_it_does": "It gives passed-away relatives and related ghosts a chance to stop wandering and enter a proper route.",
    "disciple_study_notes": "Being saved by ceremony is precious, but it is not the same as having cultivated while alive. Ceremony opens the door and sends help; cultivation builds the person's own path and connection.",
    "afterdeath_meaning": "A saved ghost can live in the RC and later move toward DLT arrangements, often through rebirth or another arrangement based on the court's conditions.",
    "practice_usage": "Use this when studying Ghost Month salvation and family-related afterdeath work.",
    "related_entries": "rc_basics_rescue_into_rc, rc_basics_saved_only_vs_cultivated, rc_basics_home_ticket_system",
    "tags": "saved by ceremony, salvation, ghost month, rescue, deceased",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_court_structure_study_path",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Lessons",
    "title_en": "Court Structure Study Path",
    "title_zh": "",
    "parent": "How to Study the RC Atlas",
    "belongs_to": "Three Palaces and Six Halls",
    "display_order": "1100",
    "short_summary": "A guided route for studying the zones, palaces, halls, and courtyards of the Religious Court.",
    "simple_meaning": "This path is for disciples who already understand the basics and now want to study the actual structure of the court.",
    "what_it_does": "It guides disciples from four main areas into the three palaces, six halls, and 24 courtyards.",
    "disciple_study_notes": "Read the four zone overviews first. Then study Tin Yat Palace with Golden Dragon Hall and Purple Dragon Hall. Then study Saam Law Palace with Tin Law Hall and Dei Law Hall. Then study Sun Lung Palace with White Crane Hall and Five Thunder Hall.",
    "afterdeath_meaning": "This helps disciples understand where different afterdeath support, care, law, training, work, and protection functions happen inside the court.",
    "practice_usage": "Use this path when reviewing the court map or preparing to teach disciples the layout of the Religious Court.",
    "related_entries": "rc_basics_four_main_areas, rc_tinyat_zone_overview, rc_saamlaw_zone_overview, rc_sunlung_zone_overview, rc_tyhq_overview",
    "tags": "study path, court structure, palace, hall, courtyard, map",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_cultivated_disciple_route",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Saved vs Cultivated",
    "title_en": "Cultivated Disciple Route",
    "title_zh": "",
    "parent": "Afterdeath System",
    "belongs_to": "Religious Court",
    "display_order": "1100",
    "short_summary": "A cultivated disciple has a stronger afterdeath route because they built connection and readiness while alive.",
    "simple_meaning": "A cultivated disciple is not only someone helped after death. The disciple has already built a path through ordination, trust, faith, determination, practice, contribution, and relationship with the lineage gods.",
    "what_it_does": "This route explains why cultivation changes the afterdeath result. The disciple can be received with stronger recognition, better support, and a clearer future direction.",
    "disciple_study_notes": "The better the disciple cultivates, the more usable connection and credit they carry. This does not mean ego or status; it means readiness and alignment with the Tao.",
    "afterdeath_meaning": "A cultivated disciple may be picked up toward Daai Law Tin as themselves when ready, with memory and identity kept, instead of going only through a saved-only rebirth route.",
    "practice_usage": "Use this for personal reflection: what kind of path am I building now while alive?",
    "related_entries": "rc_basics_saved_only_vs_cultivated, rc_basics_why_cultivation_changes_route, rc_basics_dlt_goal",
    "tags": "cultivated disciple, ordination, cultivation, memory kept, dlt",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_saved_only_vs_cultivated",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Saved vs Cultivated",
    "title_en": "Saved Only vs Cultivated Disciple",
    "title_zh": "",
    "parent": "Afterdeath System",
    "belongs_to": "DLT Path",
    "display_order": "1110",
    "short_summary": "The saved-only route and cultivated-disciple route are both helped, but they are not the same.",
    "simple_meaning": "A saved-only soul receives help because someone opened the door for them. A cultivated disciple has already built their own road before death. Both can enter help, but the quality and direction differ.",
    "what_it_does": "It prevents disciples from mixing up salvation with cultivation. Salvation can rescue and arrange. Cultivation prepares the disciple's own future.",
    "disciple_study_notes": "This is one of the most important RC Atlas concepts. It shows why disciples should not wait until death and hope others will fix everything later.",
    "afterdeath_meaning": "Saved-only souls may enter RC and later be reborn in DLT when conditions open. Cultivated disciples may go as themselves and keep memory if the arrangement is ready.",
    "practice_usage": "Use this to understand why study, practice, ordination, and consistent cultivation matter now.",
    "related_entries": "rc_basics_saved_by_ceremony, rc_basics_cultivated_disciple_route, rc_basics_dlt_goal",
    "tags": "saved only, cultivated, disciple, rebirth, memory, dlt",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_tyhq_study_path",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Lessons",
    "title_en": "TYHQ Study Path",
    "title_zh": "",
    "parent": "How to Study the RC Atlas",
    "belongs_to": "TYHQ",
    "display_order": "1110",
    "short_summary": "A recommended route for studying TYHQ, altars, institutions, and ministries.",
    "simple_meaning": "This path helps disciples study TYHQ without getting lost inside the many departments.",
    "what_it_does": "It tells disciples to first understand TYHQ purpose, then Saam Law Jo Si at TYHQ, then the Four Altars, Three Institutions, and finally the 24 Ministries.",
    "disciple_study_notes": "Do not start with the ministries. Start with TYHQ Overview and Purpose. Then study Saam Law Jo Si at TYHQ, Four Altars, Three Institutions, and then the ministries by function group.",
    "afterdeath_meaning": "TYHQ is the higher administration of the Religious Court. Understanding it helps disciples understand approval, judgment, arrangement, duties, records, merit, credit, debt, and problem solving.",
    "practice_usage": "Use this path for deeper internal study, especially when connecting court structure with altar work, requests, approvals, and assignments.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_saam_law_jo_si, rc_tyhq_hq_altar, rc_tyhq_institution_sky_emperor",
    "tags": "study path, TYHQ, altar, institution, ministry, administration",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_afterdeath_review_path",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Journey",
    "title_en": "Afterdeath Review Path",
    "title_zh": "",
    "parent": "Your Journey After Death",
    "belongs_to": "Afterdeath System",
    "display_order": "1120",
    "short_summary": "A review route for studying the afterdeath flow from rescue to Daai Law Tin.",
    "simple_meaning": "This path helps disciples review what happens after death in the correct order.",
    "what_it_does": "It connects death, rescue, first arrival, home assignment, ghost life, saved-only route, cultivated disciple route, and Daai Law Tin.",
    "disciple_study_notes": "Read Your Journey After Death, Rescue into the Religious Court, First Arrival in Tin Yat Zone, Home Ticket System, Ghost Life and Backward Aging, Saved by Ceremony, Cultivated Disciple Route, and Daai Law Tin as the Ultimate Goal.",
    "afterdeath_meaning": "This is the main route disciples should understand before studying detailed court departments.",
    "practice_usage": "Use this path when reviewing salvation, funeral-related questions, or disciple afterdeath preparation.",
    "related_entries": "rc_basics_afterdeath_journey, rc_basics_rescue_into_rc, rc_basics_first_arrival_tinyat, rc_basics_home_ticket_system, rc_basics_ghost_life, rc_basics_dlt_goal",
    "tags": "afterdeath, review path, rescue, ghost life, DLT",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_dlt_goal",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "DLT Path",
    "title_en": "Daai Law Tin as the Ultimate Goal",
    "title_zh": "",
    "parent": "Afterdeath Journey",
    "belongs_to": "Daai Law Tin Path",
    "display_order": "1120",
    "short_summary": "Daai Law Tin is the higher destination beyond the Religious Court arrangement.",
    "simple_meaning": "The Religious Court is a major afterdeath court-world, but it is not the final highest goal. Daai Law Tin is the higher destination where the soul can continue in a better realm and future life.",
    "what_it_does": "It gives the RC journey an upward direction. RC receives, cares, teaches, corrects, houses, and prepares; DLT is the higher destination that follows when conditions are ready.",
    "disciple_study_notes": "Do not treat RC as the endpoint. For disciples, RC should be understood as the court-country that manages the transition and supports the path upward.",
    "afterdeath_meaning": "Saved souls may be reborn in DLT with new parents and memory reset. Cultivated disciples may be picked up as themselves and keep memory when ready.",
    "practice_usage": "Study this together with Home Ticket System and Cultivated Disciple Route.",
    "related_entries": "rc_basics_home_ticket_system, rc_basics_cultivated_disciple_route, rc_basics_saved_only_vs_cultivated",
    "tags": "Daai Law Tin, DLT, ultimate goal, heaven, higher destination",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_navigation_tips",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Study Notes",
    "title_en": "Navigation Tips for the RC Atlas",
    "title_zh": "",
    "parent": "How to Study the RC Atlas",
    "belongs_to": "RC Atlas",
    "display_order": "1130",
    "short_summary": "Simple practical tips for using Type, Category, Search, related entries, previous, and next.",
    "simple_meaning": "The RC Atlas is easiest when disciples use the filters like a map: choose a main area, then choose the kind of thing inside it.",
    "what_it_does": "It explains how to browse by Type and Category, how to use Search for terms like DLT or justice, and how to follow related entries.",
    "disciple_study_notes": "Use Type to choose the main area: Basics, Tin Yat, Saam Law, Sun Lung, or TYHQ. Use Category to choose the kind of entry: overview, purpose, hall, courtyard, altar, institution, ministry, and so on.",
    "afterdeath_meaning": "Good navigation helps disciples connect doctrine with the actual court structure instead of memorizing isolated names.",
    "practice_usage": "Use Search when you know the topic; use the directory when you want to walk through the court system step by step.",
    "related_entries": "rc_basics_foundation_study_path, rc_basics_court_structure_study_path, rc_basics_tyhq_study_path",
    "tags": "navigation, filters, search, related entries, study notes",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_why_cultivation_changes_route",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Study Notes",
    "title_en": "Why Cultivation Changes the Afterdeath Route",
    "title_zh": "",
    "parent": "Afterdeath System",
    "belongs_to": "Disciple Study",
    "display_order": "1130",
    "short_summary": "Cultivation changes the route because the disciple builds usable connection, credit, readiness, and identity before death.",
    "simple_meaning": "Cultivation is not only learning information. It builds connection with the Tao, the lineage, the gods, the altar, and the disciple's own future path.",
    "what_it_does": "It changes what can be done for the disciple after death. A stronger cultivated connection gives the Religious Court more to work with.",
    "disciple_study_notes": "This should not be read as pride. It is practical spiritual logistics. The court can arrange more when the disciple has actually built more while alive.",
    "afterdeath_meaning": "A cultivated disciple may have better home arrangement, clearer recognition, stronger protection, and a more direct path toward DLT as themselves.",
    "practice_usage": "Use this as a reminder to keep doing daily cultivation, not only reading doctrine.",
    "related_entries": "rc_basics_cultivated_disciple_route, rc_basics_saved_only_vs_cultivated, rc_basics_dlt_goal",
    "tags": "cultivation, afterdeath route, credit, readiness, disciple",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_final_review_questions",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Study Notes",
    "title_en": "RC Atlas Review Questions",
    "title_zh": "",
    "parent": "How to Study the RC Atlas",
    "belongs_to": "RC Atlas",
    "display_order": "1140",
    "short_summary": "Review questions disciples can use after studying the RC Atlas.",
    "simple_meaning": "These questions help disciples check if they truly understand the Religious Court as a system.",
    "what_it_does": "It turns the Atlas into a self-study tool by giving disciples questions to answer after reading.",
    "disciple_study_notes": "Ask yourself: What is the Religious Court? What are the four main areas? Why does a soul first enter Tin Yat Zone? Why is Saam Law Zone important? What does Sun Lung Zone handle? Why is TYHQ different from the other zones? What changes when a disciple cultivated while alive?",
    "afterdeath_meaning": "The review questions help disciples connect court structure with the actual afterdeath route and the DLT goal.",
    "practice_usage": "Use these questions after each study session, or use them as a simple review for disciple classes.",
    "related_entries": "rc_basics_foundation_study_path, rc_basics_afterdeath_review_path, rc_basics_court_structure_study_path",
    "tags": "review, questions, study notes, disciple class, self study",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_basics_use_atlas_for_study",
    "directory": "RC Atlas",
    "type": "Basics",
    "category": "Lessons",
    "title_en": "How to Use the Atlas for Ongoing Study",
    "title_zh": "",
    "parent": "RC Atlas",
    "belongs_to": "Disciple Study",
    "display_order": "1140",
    "short_summary": "A study method for using the RC Atlas over time without getting overwhelmed.",
    "simple_meaning": "Do not try to memorize the whole Religious Court in one sitting. Use the Atlas like a map. Read one entry, understand its place, then follow the related entries.",
    "what_it_does": "It turns the court study into a stable long-term learning path instead of a pile of names.",
    "disciple_study_notes": "Suggested order: Basics, four zone overviews, palaces, halls, courtyards, TYHQ altars, institutions, ministries, then guardians and advanced usage.",
    "afterdeath_meaning": "The better you understand the court structure, the easier it is to understand what the gods are doing and why the afterdeath system is arranged this way.",
    "practice_usage": "Use search tags, Type, and Category filters. Review related entries after each study session.",
    "related_entries": "rc_basics_start_here, rc_basics_four_main_areas, rc_tyhq_overview",
    "tags": "study method, lessons, ongoing study, rc atlas",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_zone_overview",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Overview",
    "title_en": "Tin Yat Palace System Overview",
    "title_zh": "",
    "parent": "Religious Court",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2000",
    "short_summary": "The Tin Yat Palace system includes Tin Yat Palace, Golden Dragon Hall, Purple Dragon Hall, and their related courtyards.",
    "simple_meaning": "Tin Yat Palace is tied to worship, reverence, HS3, Bagwa Jo Si, Gum Lung Sin Si, Jee Lung Sin Si, Tin Yat Stage disciples after death, and support for non-disciples connected to disciples.",
    "what_it_does": "It handles worship, celebration, letters of gratitude, requests, protection, emergency help, blessings, observation, strategy, wealth/blessing distribution, and guardian support through its halls and courtyards.",
    "disciple_study_notes": "Use “Tin Yat Palace system” as the doc-supported structure. “Tin Yat Zone” can remain a UI label if needed, but the formal doc wording is Tin Yat Palace and its halls/courtyards.",
    "afterdeath_meaning": "Tin Yat Palace serves as the dwelling place for Tin Yat Stage disciples after physical departure and can also attend to non-disciples connected to disciples.",
    "practice_usage": "Study Tin Yat Palace first, then Golden Dragon Hall and Purple Dragon Hall, then the eight related courtyards.",
    "related_entries": "rc_basics_first_arrival_tinyat, rc_saamlaw_zone_overview, rc_tyhq_overview",
    "tags": "rc, religious court, Tin Yat Palace, worship, protection, afterdeath",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_palace",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Palace",
    "title_en": "Tin Yat Palace",
    "title_zh": "",
    "parent": "Tin Yat Zone",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2100",
    "short_summary": "The main palace center of the Tin Yat side of the Religious Court.",
    "simple_meaning": "Tin Yat Palace is the palace center for the Tin Yat Zone, the public and first-arrival side of the court.",
    "what_it_does": "It organizes the worship, public service, celebration, blessing, help, observation, medicine, and guarding work connected to Tin Yat.",
    "disciple_study_notes": "Study Tin Yat Palace as the front-facing palace of the court. It is where saved souls first feel welcomed and where public blessings and support can be arranged.",
    "afterdeath_meaning": "After rescue, the soul can first be handled through the Tin Yat side before moving toward home assignment and longer-term living.",
    "practice_usage": "Use this entry as the parent map before studying Golden Dragon Hall, Purple Dragon Hall, and their courtyards.",
    "related_entries": "rc_tinyat_zone_overview, rc_tinyat_golden_dragon_hall, rc_tinyat_purple_dragon_hall",
    "tags": "tin yat, palace, arrival, worship, blessing, public life",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_golden_dragon_hall",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Hall",
    "title_en": "Golden Dragon Hall",
    "title_zh": "金龍殿",
    "parent": "Tin Yat Palace",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2110",
    "short_summary": "A Tin Yat hall for worship, celebration, gratitude, blessings, and public support.",
    "simple_meaning": "Golden Dragon Hall is the bright public hall of Tin Yat Palace. It connects to worship, thanksgiving, blessings, strategy, wealth support, and public celebration.",
    "what_it_does": "It manages worship-related matters and public blessing distribution through its four courtyards.",
    "disciple_study_notes": "This hall shows the joyful and public side of the court. It is not only serious judgment; the court also has places for praise, gratitude, good fortune, and life improvement.",
    "afterdeath_meaning": "For saved souls, this hall helps them enter a positive court environment instead of staying in fear after death.",
    "practice_usage": "Study this before the Celestial Worshiping, Observation, Celestial Strategy, and God of Wealth courtyards.",
    "related_entries": "rc_tinyat_palace, rc_tinyat_celestial_worshiping_courtyard, rc_tinyat_god_of_wealth_courtyard",
    "tags": "golden dragon hall, tin yat, worship, celebration, blessing",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_celestial_worshiping_courtyard",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Courtyard",
    "title_en": "Celestial Worshiping Courtyard",
    "title_zh": "朝天院",
    "parent": "Golden Dragon Hall",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2120",
    "short_summary": "A courtyard for worship, gratitude, offerings, respect, and connection to the court.",
    "simple_meaning": "This courtyard handles worshiping, greeting, giving thanks, and building respectful connection with the gods and court.",
    "what_it_does": "It organizes the worship side of Tin Yat Palace so residents and disciples know where to express gratitude and faith.",
    "disciple_study_notes": "Worship here is not empty form. It is a court relationship. The disciple studies how respect, offerings, and trust build connection.",
    "afterdeath_meaning": "After death, a saved person needs to learn how to relate to the court with respect and gratitude, not fear and confusion.",
    "practice_usage": "Use this entry when studying offerings, court greeting, and why faith matters in the afterdeath world.",
    "related_entries": "rc_tinyat_golden_dragon_hall, rc_basics_what_is_rc",
    "tags": "worship, offerings, gratitude, tin yat, golden dragon hall",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_observation_courtyard",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Courtyard",
    "title_en": "Observation Courtyard",
    "title_zh": "都察院",
    "parent": "Golden Dragon Hall",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2130",
    "short_summary": "A courtyard for watching, checking, observing, and understanding situations.",
    "simple_meaning": "Observation Courtyard is the place for seeing conditions clearly before the court decides what help or arrangement is needed.",
    "what_it_does": "It supports the court by gathering clear view, status, and signs from people, spirits, places, and situations.",
    "disciple_study_notes": "Disciples should understand that the court does not act blindly. Observation comes before action and arrangement.",
    "afterdeath_meaning": "After death, the soul’s condition, attachment, fear, and readiness must be observed before the next move.",
    "practice_usage": "Use this entry when studying diagnosis, spiritual checking, and why the court needs to see before acting.",
    "related_entries": "rc_tinyat_golden_dragon_hall, rc_basics_rescue_into_rc",
    "tags": "observation, checking, seeing, tin yat, court work",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_celestial_strategy_courtyard",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Courtyard",
    "title_en": "Celestial Strategy Courtyard",
    "title_zh": "天鑒院",
    "parent": "Golden Dragon Hall",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2140",
    "short_summary": "A courtyard for planning, strategy, timing, and arranging the best route.",
    "simple_meaning": "Celestial Strategy Courtyard handles the planning side of Tin Yat Palace.",
    "what_it_does": "It helps choose direction, timing, order, and method after a situation is observed.",
    "disciple_study_notes": "Study this as the planning brain of the Golden Dragon Hall side. Help is stronger when the method is right.",
    "afterdeath_meaning": "For afterdeath rescue, strategy matters because different souls need different handling and timing.",
    "practice_usage": "Use this entry when studying why ritual work has sequence, timing, and planned steps.",
    "related_entries": "rc_tinyat_observation_courtyard, rc_basics_afterdeath_journey",
    "tags": "strategy, planning, timing, tin yat, arrangement",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_god_of_wealth_courtyard",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Courtyard",
    "title_en": "God of Wealth Courtyard",
    "title_zh": "財神院",
    "parent": "Golden Dragon Hall",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2150",
    "short_summary": "A courtyard for fortune, resource flow, wealth support, and material-life blessing.",
    "simple_meaning": "God of Wealth Courtyard manages resource and wealth-related blessings in the Tin Yat public side.",
    "what_it_does": "It handles money luck, resource flow, support, and practical blessings that help people and residents live better.",
    "disciple_study_notes": "Wealth here should be understood as resource support, not greedy desire. The court can help people have what they need to continue.",
    "afterdeath_meaning": "After death, a resident still needs resources and support in the court-world, not only religious ideas.",
    "practice_usage": "Use this entry when studying blessing work and the court’s support for life conditions.",
    "related_entries": "rc_tinyat_golden_dragon_hall, rc_tinyat_zone_overview",
    "tags": "wealth, resources, blessing, money luck, tin yat",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_purple_dragon_hall",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Hall",
    "title_en": "Purple Dragon Hall",
    "title_zh": "紫龍殿",
    "parent": "Tin Yat Palace",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2160",
    "short_summary": "A Tin Yat hall for healing, movement, guarding, and lineage protection.",
    "simple_meaning": "Purple Dragon Hall handles the protective and service-support side of Tin Yat Palace.",
    "what_it_does": "It connects to medicine, wind-fire movement, magical guarding, and lineage protection through its courtyards.",
    "disciple_study_notes": "Study this hall as the side that helps people recover, move, and stay protected after entering the court.",
    "afterdeath_meaning": "Afterdeath arrival can involve shock, weakness, confusion, or danger. This hall shows how the court provides care and protection.",
    "practice_usage": "Study this before the Celestial Medic, Wind and Fire, Magic Guardian, and Lineage Guardian courtyards.",
    "related_entries": "rc_tinyat_palace, rc_tinyat_celestial_medic_courtyard, rc_tinyat_magic_guardian_courtyard",
    "tags": "purple dragon hall, medicine, protection, movement, tin yat",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_celestial_medic_courtyard",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Courtyard",
    "title_en": "Celestial Medic Courtyard",
    "title_zh": "天醫院",
    "parent": "Purple Dragon Hall",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2170",
    "short_summary": "A courtyard for spiritual medical care, recovery, repair, and healing.",
    "simple_meaning": "Celestial Medic Courtyard handles healing and recovery for people or souls who need care.",
    "what_it_does": "It gives the Tin Yat side a medical support function so arrival, weakness, and injury can be handled.",
    "disciple_study_notes": "Disciples should not think the afterdeath court is only judgment. It also includes recovery and treatment.",
    "afterdeath_meaning": "After rescue, a soul may be damaged, dirty, shocked, or weak. Medical support helps them stabilize.",
    "practice_usage": "Use this entry when studying healing, cleansing support, and recovery after salvation.",
    "related_entries": "rc_tinyat_purple_dragon_hall, rc_saamlaw_zone_overview",
    "tags": "medicine, healing, recovery, tin yat, care",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_wind_fire_courtyard",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Courtyard",
    "title_en": "Wind and Fire Courtyard",
    "title_zh": "風火院",
    "parent": "Purple Dragon Hall",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2180",
    "short_summary": "A courtyard for movement, speed, delivery, transformation, and active support.",
    "simple_meaning": "Wind and Fire Courtyard handles the moving and active force side of Purple Dragon Hall.",
    "what_it_does": "It helps send help, move things, change conditions, and push stuck energy forward.",
    "disciple_study_notes": "Wind means movement and reach. Fire means action and transformation. Together they make support active, not passive.",
    "afterdeath_meaning": "Afterdeath rescue often needs movement because a soul must be brought from one state or place into the court route.",
    "practice_usage": "Use this entry when studying fast support, energy movement, and active rescue work.",
    "related_entries": "rc_tinyat_purple_dragon_hall, rc_sunlung_zone_overview",
    "tags": "wind, fire, movement, transformation, rescue",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_magic_guardian_courtyard",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Courtyard",
    "title_en": "Magic Guardian Courtyard",
    "title_zh": "護法院",
    "parent": "Purple Dragon Hall",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2190",
    "short_summary": "A courtyard for magical guarding, protection, shielding, and defense.",
    "simple_meaning": "Magic Guardian Courtyard handles magical protection and guarding on the Tin Yat side.",
    "what_it_does": "It helps protect the court, the residents, the route, and the work from disturbance.",
    "disciple_study_notes": "Study this as protection through magic authority, not physical fighting only.",
    "afterdeath_meaning": "When a soul is saved, protection is needed so interference does not pull the soul back out.",
    "practice_usage": "Use this entry when studying protection FU, spiritual guarding, and safe court entry.",
    "related_entries": "rc_tinyat_purple_dragon_hall, rc_sunlung_five_thunder_hall",
    "tags": "magic guardian, protection, guarding, shield, tin yat",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tinyat_lineage_guardian_courtyard",
    "directory": "RC Atlas",
    "type": "Tin Yat",
    "category": "Courtyard",
    "title_en": "Lineage Guardian Courtyard",
    "title_zh": "護教院",
    "parent": "Purple Dragon Hall",
    "belongs_to": "Tin Yat Zone",
    "display_order": "2200",
    "short_summary": "A courtyard for guarding the lineage route, disciple connection, and court identity.",
    "simple_meaning": "Lineage Guardian Courtyard protects the Tin Yat Lineage connection inside the court system.",
    "what_it_does": "It helps keep the path, identity, and disciple relationship protected and recognized.",
    "disciple_study_notes": "This courtyard shows that the lineage is not only teachings in the human world. It has a protected route and identity in the court.",
    "afterdeath_meaning": "After death, the disciple’s lineage connection helps the court identify, receive, and arrange them.",
    "practice_usage": "Use this entry when studying ordination identity and why disciple status matters after death.",
    "related_entries": "rc_tinyat_purple_dragon_hall, rc_basics_saved_cultivated",
    "tags": "lineage, guardian, disciple identity, protection, tin yat",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_zone_overview",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Overview",
    "title_en": "Saam Law Palace System Overview",
    "title_zh": "",
    "parent": "Religious Court",
    "belongs_to": "Saam Law Zone",
    "display_order": "3000",
    "short_summary": "The Saam Law Palace system includes Saam Law Palace, Tin Law Hall, Dei Law Hall, and their related courtyards.",
    "simple_meaning": "Saam Law Palace is the palace named Saam Law Gong (三羅宮). It is connected to Daai Law Jo Si, Tin Law Jo Si, and Dei Law Jo Si, and it serves as the ancestral homeland and primary residence for ordained Saam Law Taoists after death.",
    "what_it_does": "Its system supports daily life, cultivation, knowledge, tools, law, justice, protection, academy training, spiritual arts, resident care, police, jail, court, and prison functions.",
    "disciple_study_notes": "Use “Saam Law Palace system” as the doc-supported wording. It is not just a care zone; it includes residence, learning, information, tools, and law enforcement.",
    "afterdeath_meaning": "The doc teaches Saam Law Palace as the ancestral homeland and primary residence for ordained Saam Law Taoists who have passed away.",
    "practice_usage": "Study Saam Law Palace, Tin Law Hall, Dei Law Hall, and the eight related courtyards.",
    "related_entries": "rc_basics_home_ticket_system, rc_basics_ghost_life_backward_aging, rc_tinyat_zone_overview",
    "tags": "rc, religious court, Saam Law Palace, 三羅宮, residence, learning, law",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_palace",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Palace",
    "title_en": "Saam Law Palace",
    "title_zh": "三羅宮",
    "parent": "Saam Law Zone",
    "belongs_to": "Saam Law Zone",
    "display_order": "3100",
    "short_summary": "The main palace center of Saam Law Zone, the residence, care, learning, and law side.",
    "simple_meaning": "Saam Law Palace is the palace center for the zone where saved souls and disciples settle down, live, learn, and receive court order.",
    "what_it_does": "It organizes learning, treasures, heart/spirit support, law, police, jail, court, and prison functions.",
    "disciple_study_notes": "Study Saam Law Palace as the practical living center, not only a ceremonial name.",
    "afterdeath_meaning": "After the first arrival side, the soul needs home, care, knowledge, order, and long-term direction. This palace supports that stage.",
    "practice_usage": "Use this entry before studying Tin Law Hall and Dei Law Hall.",
    "related_entries": "rc_saamlaw_zone_overview, rc_saamlaw_tin_law_hall, rc_saamlaw_dei_law_hall",
    "tags": "saam law palace, residence, care, learning, justice",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_tin_law_hall",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Hall",
    "title_en": "Tin Law Hall",
    "title_zh": "天羅殿",
    "parent": "Saam Law Palace",
    "belongs_to": "Saam Law Zone",
    "display_order": "3110",
    "short_summary": "The knowledge, library, training, treasure, Tao, spiritual, and heart-support hall.",
    "simple_meaning": "Tin Law Hall is the learning and inner-support hall of Saam Law Palace.",
    "what_it_does": "It manages teachings, spiritual resources, treasures, Tao learning, spiritual growth, and heart-related support.",
    "disciple_study_notes": "This hall shows why the court is also a cultivation environment. Residents do not only wait; they can keep learning and refining.",
    "afterdeath_meaning": "After death, cultivated disciples can continue study and growth instead of only waiting passively.",
    "practice_usage": "Use this entry before studying the Celestial Treasure, Celestial Tao, Celestial Spiritual, and Celestial Heart courtyards.",
    "related_entries": "rc_saamlaw_palace, rc_saamlaw_celestial_tao_courtyard, rc_saamlaw_celestial_heart_courtyard",
    "tags": "tin law hall, learning, treasure, Tao, heart",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_celestial_treasure_courtyard",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Courtyard",
    "title_en": "Celestial Treasure Courtyard",
    "title_zh": "天寶院",
    "parent": "Tin Law Hall",
    "belongs_to": "Saam Law Zone",
    "display_order": "3120",
    "short_summary": "A courtyard for treasures, tools, resources, and useful spiritual assets.",
    "simple_meaning": "Celestial Treasure Courtyard manages the treasures and useful resources connected to Tin Law Hall.",
    "what_it_does": "It helps store, prepare, and distribute tools, treasures, and support items needed for study and court work.",
    "disciple_study_notes": "Treasure means useful power and resource, not only expensive objects.",
    "afterdeath_meaning": "After death, a resident may need tools, supplies, or support to live and cultivate in the court.",
    "practice_usage": "Use this entry when studying court resources, magical tools, and the meaning of spiritual treasures.",
    "related_entries": "rc_saamlaw_tin_law_hall, rc_tyhq_overview",
    "tags": "treasure, resources, tools, saamlaw, tin law hall",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_celestial_tao_courtyard",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Courtyard",
    "title_en": "Celestial Tao Courtyard",
    "title_zh": "天道院",
    "parent": "Tin Law Hall",
    "belongs_to": "Saam Law Zone",
    "display_order": "3130",
    "short_summary": "A courtyard for Tao learning, doctrine, direction, and correct path understanding.",
    "simple_meaning": "Celestial Tao Courtyard handles the Tao teaching and path-direction side of Tin Law Hall.",
    "what_it_does": "It supports learning the correct Tao, understanding doctrine, and staying on the proper route.",
    "disciple_study_notes": "Disciples should see this courtyard as the study direction center, not just a classroom.",
    "afterdeath_meaning": "After death, a soul still needs correct direction or they can drift, misunderstand, or lose motivation.",
    "practice_usage": "Use this entry when studying doctrine, path correction, and ongoing cultivation in the court.",
    "related_entries": "rc_saamlaw_tin_law_hall, rc_basics_saved_cultivated",
    "tags": "Tao, learning, doctrine, direction, cultivation",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_celestial_spiritual_courtyard",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Courtyard",
    "title_en": "Celestial Spiritual Courtyard",
    "title_zh": "天靈院",
    "parent": "Tin Law Hall",
    "belongs_to": "Saam Law Zone",
    "display_order": "3140",
    "short_summary": "A courtyard for spiritual development, soul support, sensitivity, and inner growth.",
    "simple_meaning": "Celestial Spiritual Courtyard supports the spiritual side of residents and disciples.",
    "what_it_does": "It helps with spiritual growth, inner refinement, soul condition, and the ability to connect with the court.",
    "disciple_study_notes": "This entry helps disciples understand that court study is not only information; it also changes the soul and spiritual body.",
    "afterdeath_meaning": "After death, the soul needs spiritual adjustment and growth to move toward a better future route.",
    "practice_usage": "Use this entry when studying soul development and spiritual cultivation inside the court.",
    "related_entries": "rc_saamlaw_tin_law_hall, rc_saamlaw_celestial_heart_courtyard",
    "tags": "spiritual, soul, inner growth, saamlaw, tin law",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_celestial_heart_courtyard",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Courtyard",
    "title_en": "Celestial Heart Courtyard",
    "title_zh": "天心院",
    "parent": "Tin Law Hall",
    "belongs_to": "Saam Law Zone",
    "display_order": "3150",
    "short_summary": "A courtyard for heart power, faith, intention, trust, and inner stability.",
    "simple_meaning": "Celestial Heart Courtyard supports the heart-side of cultivation and court relationship.",
    "what_it_does": "It helps stabilize faith, intention, trust, and personal direction.",
    "disciple_study_notes": "In Saam Law Tao, heart is not merely emotion. It is the inner connection and decision power that keeps a disciple on the path.",
    "afterdeath_meaning": "After death, the soul’s heart condition affects whether it trusts the court and continues the upward route.",
    "practice_usage": "Use this entry when studying faith, determination, vows, and the heart side of cultivation.",
    "related_entries": "rc_saamlaw_tin_law_hall, rc_basics_saved_cultivated",
    "tags": "heart, faith, intention, trust, cultivation",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_dei_law_hall",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Hall",
    "title_en": "Dei Law Hall",
    "title_zh": "地羅殿",
    "parent": "Saam Law Palace",
    "belongs_to": "Saam Law Zone",
    "display_order": "3160",
    "short_summary": "The law, justice, correction, punishment, and order hall of Saam Law Palace.",
    "simple_meaning": "Dei Law Hall handles the court’s law-and-justice side.",
    "what_it_does": "It manages police, jail, court judgment, prison, correction, and the rules that keep the Religious Court clean and orderly.",
    "disciple_study_notes": "Disciples should not see care and law as opposites. A good residence zone needs law, discipline, and correction.",
    "afterdeath_meaning": "After death, ghosts may bring sins, attachments, and wrong habits. Law and correction help them become safe and suitable for the court path.",
    "practice_usage": "Use this entry before studying Immortal Police Station, Immortal Jail, Immortal Court of Justice, and Immortal Prison.",
    "related_entries": "rc_saamlaw_palace, rc_saamlaw_immortal_police_station, rc_saamlaw_immortal_court_of_justice",
    "tags": "dei law hall, law, justice, correction, punishment",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_immortal_police_station",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Courtyard",
    "title_en": "Immortal Police Station",
    "title_zh": "仙警院",
    "parent": "Dei Law Hall",
    "belongs_to": "Saam Law Zone",
    "display_order": "3170",
    "short_summary": "A station for enforcement, protection, investigation, and keeping order.",
    "simple_meaning": "Immortal Police Station handles police-style work inside the Saam Law side.",
    "what_it_does": "It watches problems, responds to disturbance, investigates, protects residents, and enforces court order.",
    "disciple_study_notes": "Police here means lawful protection and correction, not random punishment.",
    "afterdeath_meaning": "After death, some ghosts may be confused, harmful, or stubborn. Police work keeps the court safe and orderly.",
    "practice_usage": "Use this entry when studying court enforcement and the difference between protection and punishment.",
    "related_entries": "rc_saamlaw_dei_law_hall, rc_saamlaw_immortal_jail",
    "tags": "police, enforcement, order, protection, saamlaw",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_immortal_jail",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Courtyard",
    "title_en": "Immortal Jail",
    "title_zh": "仙獄院",
    "parent": "Dei Law Hall",
    "belongs_to": "Saam Law Zone",
    "display_order": "3180",
    "short_summary": "A temporary holding and correction place for ghosts or residents who need control.",
    "simple_meaning": "Immortal Jail is for holding, stopping, and correcting a problem before deeper judgment or punishment.",
    "what_it_does": "It keeps harmful or unstable beings from continuing damage while the court handles the matter.",
    "disciple_study_notes": "Study jail as temporary control and correction, not the final destiny of a soul.",
    "afterdeath_meaning": "After death, some souls may need to be stopped first before they can be taught or arranged.",
    "practice_usage": "Use this entry when studying discipline, correction, and why the court has law facilities.",
    "related_entries": "rc_saamlaw_immortal_police_station, rc_saamlaw_immortal_court_of_justice",
    "tags": "jail, correction, holding, discipline, saamlaw",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_immortal_court_of_justice",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Courtyard",
    "title_en": "Immortal Court of Justice",
    "title_zh": "仙法院",
    "parent": "Dei Law Hall",
    "belongs_to": "Saam Law Zone",
    "display_order": "3190",
    "short_summary": "The judgment place for deciding fault, correction, punishment, and rightful arrangement.",
    "simple_meaning": "Immortal Court of Justice handles judgment and decision-making under Dei Law Hall.",
    "what_it_does": "It reviews cases, weighs problems, decides correction, and assigns lawful outcomes.",
    "disciple_study_notes": "Disciples should understand that judgment in the court is for order, purification, and proper future arrangement.",
    "afterdeath_meaning": "After death, unresolved sins, harms, and wrong actions may need to be judged before the soul can move forward safely.",
    "practice_usage": "Use this entry when studying court judgment, justice, and why afterdeath help must still respect law.",
    "related_entries": "rc_saamlaw_dei_law_hall, rc_saamlaw_immortal_prison",
    "tags": "court, justice, judgment, law, saamlaw",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_saamlaw_immortal_prison",
    "directory": "RC Atlas",
    "type": "Saam Law",
    "category": "Courtyard",
    "title_en": "Immortal Prison",
    "title_zh": "仙牢院",
    "parent": "Dei Law Hall",
    "belongs_to": "Saam Law Zone",
    "display_order": "3200",
    "short_summary": "A stronger correction and confinement place for serious cases.",
    "simple_meaning": "Immortal Prison handles heavier correction when a case is more serious than temporary holding.",
    "what_it_does": "It confines and corrects beings that are dangerous, deeply sinful, or strongly resistant to order.",
    "disciple_study_notes": "Prison is not eternal hatred. It is a court mechanism for protecting the system and forcing correction when needed.",
    "afterdeath_meaning": "After death, serious wrong energies can require stronger confinement before purification or future route can continue.",
    "practice_usage": "Use this entry with Hell, Blood Lake, correction, and court justice studies.",
    "related_entries": "rc_saamlaw_immortal_court_of_justice, rc_basics_rescue_into_rc",
    "tags": "prison, correction, punishment, justice, saamlaw",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_zone_overview",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Overview",
    "title_en": "Sun Lung Palace System Overview",
    "title_zh": "",
    "parent": "Religious Court",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4000",
    "short_summary": "The Sun Lung Palace system includes Sun Lung Palace, White Crane Hall, Five Thunder Hall, and their related courtyards.",
    "simple_meaning": "Sun Lung Palace is Sun Lung Gong (神龍宮). It is connected to Sun Lung Jo Si, Baak Hork Sin Si, and Ng Lui Sin Si, and it offers higher living standard and job opportunities for faithful Sun Lung Stage priests and priestesses after death.",
    "what_it_does": "Its system handles communication, delivery, information, connection to Celestial Court, outbound magic, troop/magic delivery, military administration, army, exorcism, and Thunder/Justice punishments.",
    "disciple_study_notes": "Use “Sun Lung Palace system” as the doc-supported wording. It is especially tied to communication, civic/military work, protection, exorcism, and magical battles.",
    "afterdeath_meaning": "Faithful Sun Lung Stage priests and priestesses can have their abode and work opportunities in this palace system after passing.",
    "practice_usage": "Study Sun Lung Palace, White Crane Hall, Five Thunder Hall, and the eight related courtyards.",
    "related_entries": "rc_basics_four_main_areas, rc_tyhq_overview, rc_saamlaw_zone_overview",
    "tags": "rc, religious court, Sun Lung Palace, 神龍宮, communication, military, exorcism",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_palace",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Palace",
    "title_en": "Sun Lung Palace",
    "title_zh": "神龍宮",
    "parent": "Sun Lung Zone",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4100",
    "short_summary": "The main palace center for work, service, communication, military, protection, and action.",
    "simple_meaning": "Sun Lung Palace is the palace center of the Sun Lung Zone, the serious work side of the Religious Court.",
    "what_it_does": "It organizes communication, delivery, civic service, crane work, dragon movement, army, exorcism, thunder, and justice work.",
    "disciple_study_notes": "Study Sun Lung Palace as the active service system of the court. This is where work gets done.",
    "afterdeath_meaning": "After death, residents may work, serve, protect, communicate, or assist depending on their ability and arrangement.",
    "practice_usage": "Use this entry before studying White Crane Hall and Five Thunder Hall.",
    "related_entries": "rc_sunlung_zone_overview, rc_sunlung_white_crane_hall, rc_sunlung_five_thunder_hall",
    "tags": "sun lung palace, work, communication, military, protection",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_white_crane_hall",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Hall",
    "title_en": "White Crane Hall",
    "title_zh": "白鶴殿",
    "parent": "Sun Lung Palace",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4110",
    "short_summary": "The communication, travel, movement, delivery, and civic-service hall.",
    "simple_meaning": "White Crane Hall handles movement, delivery, message flow, travel, and public-service work inside Sun Lung Palace.",
    "what_it_does": "It manages crane-related and dragon-related movement systems through its courtyards.",
    "disciple_study_notes": "White Crane Hall helps disciples see how the court communicates and moves things between places.",
    "afterdeath_meaning": "After death, souls and court workers still need communication, transport, delivery, and service systems.",
    "practice_usage": "Use this entry before Immortal Crane, Godly Crane, Nine Dragon, and Flying Dragon courtyards.",
    "related_entries": "rc_sunlung_palace, rc_sunlung_immortal_crane_courtyard, rc_sunlung_flying_dragon_courtyard",
    "tags": "white crane hall, communication, delivery, movement, service",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_immortal_crane_courtyard",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Courtyard",
    "title_en": "Immortal Crane Courtyard",
    "title_zh": "仙鶴院",
    "parent": "White Crane Hall",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4120",
    "short_summary": "A courtyard for refined transport, messenger work, and gentle movement.",
    "simple_meaning": "Immortal Crane Courtyard handles graceful and refined movement and message delivery.",
    "what_it_does": "It supports travel, communication, and careful carrying of people, messages, or spiritual tasks.",
    "disciple_study_notes": "Crane work is not only flying. It means clean movement, stable delivery, and graceful service.",
    "afterdeath_meaning": "After death, movement between areas must be safe and clean, especially for weak or newly saved souls.",
    "practice_usage": "Use this entry when studying transport and message systems inside the court.",
    "related_entries": "rc_sunlung_white_crane_hall, rc_sunlung_godly_crane_courtyard",
    "tags": "crane, transport, messenger, movement, sun lung",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_godly_crane_courtyard",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Courtyard",
    "title_en": "Godly Crane Courtyard",
    "title_zh": "神鶴院",
    "parent": "White Crane Hall",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4130",
    "short_summary": "A courtyard for stronger crane service, higher delivery, and godly movement work.",
    "simple_meaning": "Godly Crane Courtyard handles a higher and stronger level of crane movement and service.",
    "what_it_does": "It supports important delivery, escort, and movement tasks with more authority.",
    "disciple_study_notes": "Study this as the stronger extension of crane work after understanding the Immortal Crane side.",
    "afterdeath_meaning": "After death, some movements require more authority or stronger protection, not just gentle transport.",
    "practice_usage": "Use this entry when studying escort, delivery, and movement authority in Sun Lung Palace.",
    "related_entries": "rc_sunlung_white_crane_hall, rc_sunlung_immortal_crane_courtyard",
    "tags": "godly crane, transport, escort, movement, sun lung",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_nine_dragon_courtyard",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Courtyard",
    "title_en": "Nine Dragon Courtyard",
    "title_zh": "九龍院",
    "parent": "White Crane Hall",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4140",
    "short_summary": "A courtyard for dragon force, large movement, power, and major route handling.",
    "simple_meaning": "Nine Dragon Courtyard handles strong dragon movement and major-scale activity.",
    "what_it_does": "It supports powerful movement, route-opening, escorting, and forceful adjustment when a bigger push is required.",
    "disciple_study_notes": "Dragon work is strong and directional. It is used when the court needs more power than normal movement.",
    "afterdeath_meaning": "After death, big movement may be needed for difficult souls, special missions, or strong route changes.",
    "practice_usage": "Use this entry when studying dragon movement, route work, and powerful support systems.",
    "related_entries": "rc_sunlung_white_crane_hall, rc_sunlung_flying_dragon_courtyard",
    "tags": "nine dragon, dragon force, movement, route, sun lung",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_flying_dragon_courtyard",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Courtyard",
    "title_en": "Flying Dragon Courtyard",
    "title_zh": "飛龍院",
    "parent": "White Crane Hall",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4150",
    "short_summary": "A courtyard for fast dragon movement, quick action, and elevated route work.",
    "simple_meaning": "Flying Dragon Courtyard handles fast, elevated, and active dragon movement.",
    "what_it_does": "It supports rapid transport, quick mission action, and forceful route movement when speed matters.",
    "disciple_study_notes": "This courtyard shows the fast-response side of Sun Lung work.",
    "afterdeath_meaning": "After death, some rescue or escort work must move quickly before the soul is pulled away or weakened.",
    "practice_usage": "Use this entry when studying urgent movement and fast support in court work.",
    "related_entries": "rc_sunlung_nine_dragon_courtyard, rc_sunlung_white_crane_hall",
    "tags": "flying dragon, fast movement, urgent, transport, sun lung",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_five_thunder_hall",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Hall",
    "title_en": "Five Thunder Hall",
    "title_zh": "五雷殿",
    "parent": "Sun Lung Palace",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4160",
    "short_summary": "The civic service, army, exorcism, thunder, justice, and enforcement hall.",
    "simple_meaning": "Five Thunder Hall handles the stronger action side of Sun Lung Palace.",
    "what_it_does": "It manages civic service, army power, exorcism, thunder justice, and forceful correction through its courtyards.",
    "disciple_study_notes": "This hall is where Sun Lung becomes serious. It is not casual work but official action, protection, and enforcement.",
    "afterdeath_meaning": "After death, the court must protect residents, remove threats, and correct harmful beings or forces.",
    "practice_usage": "Use this entry before Immortal Civic, Celestial Army, Exorcism, and Thunder and Justice courtyards.",
    "related_entries": "rc_sunlung_palace, rc_sunlung_celestial_army_courtyard, rc_sunlung_thunder_justice_courtyard",
    "tags": "five thunder hall, army, exorcism, justice, protection",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_immortal_civic_courtyard",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Courtyard",
    "title_en": "Immortal Civic Courtyard",
    "title_zh": "仙官院",
    "parent": "Five Thunder Hall",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4170",
    "short_summary": "A courtyard for civic service, public order, official tasks, and practical court work.",
    "simple_meaning": "Immortal Civic Courtyard handles practical civic work inside the Sun Lung side.",
    "what_it_does": "It supports public service, official errands, daily court operations, and organized civic tasks.",
    "disciple_study_notes": "This courtyard reminds disciples that a spiritual country still needs administration and civil service.",
    "afterdeath_meaning": "After death, residents may live in a society with services, duties, and public systems.",
    "practice_usage": "Use this entry when studying normal work and service inside the Religious Court.",
    "related_entries": "rc_sunlung_five_thunder_hall, rc_tyhq_overview",
    "tags": "civic, service, public work, official tasks, sun lung",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_celestial_army_courtyard",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Courtyard",
    "title_en": "Celestial Army Courtyard",
    "title_zh": "神兵院",
    "parent": "Five Thunder Hall",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4180",
    "short_summary": "A courtyard for army, guards, battle force, and large-scale protection.",
    "simple_meaning": "Celestial Army Courtyard handles the military force of the Sun Lung side.",
    "what_it_does": "It protects the court, guards important routes, and deals with threats that require organized force.",
    "disciple_study_notes": "Army work is official protection. It should not be confused with personal anger or fighting.",
    "afterdeath_meaning": "After death, the court must be able to defend rescued souls, residents, routes, and missions.",
    "practice_usage": "Use this entry when studying spiritual army, protection, and large-scale defense.",
    "related_entries": "rc_sunlung_five_thunder_hall, rc_tinyat_magic_guardian_courtyard",
    "tags": "army, military, protection, defense, sun lung",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_exorcism_courtyard",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Courtyard",
    "title_en": "Exorcism Courtyard",
    "title_zh": "驅邪院",
    "parent": "Five Thunder Hall",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4190",
    "short_summary": "A courtyard for removing evil, clearing harmful beings, and breaking disturbance.",
    "simple_meaning": "Exorcism Courtyard handles the removal and suppression of evil or harmful spiritual forces.",
    "what_it_does": "It supports cleansing, eviction, forceful removal, and protection against external disturbance.",
    "disciple_study_notes": "Exorcism is not random attack. It is official court work to remove harmful influence and protect the path.",
    "afterdeath_meaning": "After death, a soul may be affected by outside evil, attachments, or harmful ghosts; exorcism helps clear the route.",
    "practice_usage": "Use this entry with protection, Ghost Month, and rescue-route studies.",
    "related_entries": "rc_sunlung_five_thunder_hall, rc_sunlung_thunder_justice_courtyard",
    "tags": "exorcism, remove evil, cleansing, protection, sun lung",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_sunlung_thunder_justice_courtyard",
    "directory": "RC Atlas",
    "type": "Sun Lung",
    "category": "Courtyard",
    "title_en": "Thunder and Justice Courtyard",
    "title_zh": "雷霆院",
    "parent": "Five Thunder Hall",
    "belongs_to": "Sun Lung Zone",
    "display_order": "4200",
    "short_summary": "A courtyard for thunder authority, punishment, justice, and forceful correction.",
    "simple_meaning": "Thunder and Justice Courtyard handles thunder power and justice enforcement.",
    "what_it_does": "It uses strong authority to correct, punish, break through, and enforce order when gentler methods are not enough.",
    "disciple_study_notes": "Thunder justice is serious. It is used when the court must stop wrong force and restore order.",
    "afterdeath_meaning": "After death, harmful beings, stubborn ghosts, or serious obstructions may require thunder authority before the route can continue.",
    "practice_usage": "Use this entry when studying Thunder God of Salvation, correction, and forceful court power.",
    "related_entries": "rc_sunlung_five_thunder_hall, rc_saamlaw_dei_law_hall",
    "tags": "thunder, justice, punishment, correction, sun lung",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_overview",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Overview",
    "title_en": "TYHQ Overview",
    "title_zh": "",
    "parent": "Religious Court",
    "belongs_to": "TYHQ",
    "display_order": "5000",
    "short_summary": "TYHQ is the high government, admin, approval, judgment, and command center of the Religious Court.",
    "simple_meaning": "TYHQ is the master government center of the Religious Court. It is where high-level administration, approval, judgment, assignment, records, and commands are handled.",
    "what_it_does": "It coordinates the court through Saam Law Jo Si authority, altars, institutions, ministries, and connection to the human lineage altar system.",
    "disciple_study_notes": "Do not treat TYHQ as a casual area. It is the command center. Many serious court matters must go through approval, law, and proper routing.",
    "afterdeath_meaning": "TYHQ can affect assignments, judgment, correction, reward, punishment, records, approval, and upward direction for souls and disciples.",
    "practice_usage": "Study this before the Four Altars, Three Institutions, 24 Ministries, and high-level RC administration topics.",
    "related_entries": "rc_basics_what_is_rc, rc_basics_four_main_areas, rc_basics_why_cultivation_changes_route",
    "tags": "TYHQ, HQ, government, admin, approval, judgment, Saam Law Jo Si",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_purpose",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Purpose",
    "title_en": "Purpose of TYHQ",
    "title_zh": "",
    "parent": "TYHQ",
    "belongs_to": "TYHQ",
    "display_order": "5010",
    "short_summary": "TYHQ exists to command, approve, judge, record, assign, and connect the whole Religious Court system.",
    "simple_meaning": "The purpose of TYHQ is to be the main government center of the Religious Court. It is where high-level decisions and official routing are handled.",
    "what_it_does": "It manages court authority through Saam Law Jo Si, the four altars, three institutions, and ministries. It gives structure to approval, judgment, administration, assignment, records, and official communication.",
    "disciple_study_notes": "Disciples should understand TYHQ as the highest working center of the court, not as a public leisure zone. It is serious, official, and rule-based.",
    "afterdeath_meaning": "After death, TYHQ can be involved in important arrangements such as receiving a soul, checking merit or debt, assigning the next place, approving movement, and directing the DLT route.",
    "practice_usage": "Use this entry as the doorway into all TYHQ studies before reading altars, institutions, and ministries.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_saam_law_jo_si, rc_tyhq_hq_altar, rc_tyhq_institution_sky_emperor",
    "tags": "TYHQ, purpose, government, approval, judgment, admin",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_saam_law_jo_si",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Saam Law Jo Si",
    "title_en": "Saam Law Jo Si at TYHQ",
    "title_zh": "",
    "parent": "TYHQ",
    "belongs_to": "TYHQ",
    "display_order": "5020",
    "short_summary": "Saam Law Jo Si is the central authority connected to TYHQ and the Religious Court government.",
    "simple_meaning": "Saam Law Jo Si at TYHQ means the court system is not loose or random. It is commanded through the lineage authority.",
    "what_it_does": "This authority connects the court, altars, institutions, ministries, disciples, human altars, and the afterdeath route.",
    "disciple_study_notes": "When studying TYHQ, do not separate the building or department idea from Saam Law Jo Si authority. The system works because authority, law, and lineage connection are present.",
    "afterdeath_meaning": "After death, the soul is not only moving through places; it is moving through a court system under authority. Saam Law Jo Si is the highest center that gives direction to that court route.",
    "practice_usage": "Use this entry when studying why official request, proper ritual, and lineage connection matter.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar, rc_basics_what_is_rc",
    "tags": "Saam Law Jo Si, TYHQ, authority, lineage, court command",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_hq_altar",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Altar",
    "title_en": "HQ Altar",
    "title_zh": "總壇",
    "parent": "Four Altars",
    "belongs_to": "TYHQ",
    "display_order": "5100",
    "short_summary": "The central altar of TYHQ for main command, records, and official connection.",
    "simple_meaning": "HQ Altar is the central command altar of TYHQ.",
    "what_it_does": "It receives, routes, and stabilizes high-level court connection. It is the main altar point for TYHQ authority and official handling.",
    "disciple_study_notes": "Study this as the main central altar, not as one of the specialized side altars.",
    "afterdeath_meaning": "After death, central altar authority can support official routing, identity, record, and assignment in the court system.",
    "practice_usage": "Use this entry before the Sky, Ground, and Immortal Altars.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_saam_law_jo_si",
    "tags": "TYHQ, altar, four altars, hq altar",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_sky_altar",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Altar",
    "title_en": "Sky Altar",
    "title_zh": "天壇",
    "parent": "Four Altars",
    "belongs_to": "TYHQ",
    "display_order": "5110",
    "short_summary": "The altar connection for upper authority, sky-level order, and higher command.",
    "simple_meaning": "Sky Altar links TYHQ to upper authority and sky-level command.",
    "what_it_does": "It supports commands, approvals, and upper-level connection that need higher court authority.",
    "disciple_study_notes": "Sky does not mean only weather or physical sky. It refers to the upper command side of the system.",
    "afterdeath_meaning": "For afterdeath movement, upper approval can affect higher routing, DLT direction, and major changes in status.",
    "practice_usage": "Use this entry with Institution of Sky Emperor and DLT Path studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_saam_law_jo_si",
    "tags": "TYHQ, altar, four altars, sky altar",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ground_altar",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Altar",
    "title_en": "Ground Altar",
    "title_zh": "地壇",
    "parent": "Four Altars",
    "belongs_to": "TYHQ",
    "display_order": "5120",
    "short_summary": "The altar connection for grounding, judgment, settlement, and lower-side administration.",
    "simple_meaning": "Ground Altar handles grounding and lower-side stability inside TYHQ.",
    "what_it_does": "It supports judgment, settlement, records, practical arrangement, and the stable base of court administration.",
    "disciple_study_notes": "Ground is about order, placement, and stable handling. It keeps matters from floating without conclusion.",
    "afterdeath_meaning": "After death, grounding is needed for settling a soul, assigning place, and resolving heavier matters.",
    "practice_usage": "Use this entry with Institution of Ground Emperor, justice, debts, and repenting studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_saam_law_jo_si",
    "tags": "TYHQ, altar, four altars, ground altar",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_immortal_altar",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Altar",
    "title_en": "Immortal Altar",
    "title_zh": "仙壇",
    "parent": "Four Altars",
    "belongs_to": "TYHQ",
    "display_order": "5130",
    "short_summary": "The altar connection for immortals, cultivation result, and the immortal-side court route.",
    "simple_meaning": "Immortal Altar connects TYHQ to the immortal-side arrangement of the court.",
    "what_it_does": "It supports cultivated status, immortal connection, higher body arrangement, and matters connected to disciples who cultivated deeply.",
    "disciple_study_notes": "This altar is especially important when studying cultivated disciple route instead of only saved-only route.",
    "afterdeath_meaning": "After death, cultivated disciples may need immortal-side handling instead of ordinary ghost handling.",
    "practice_usage": "Use this entry with Immortals Ministry, cultivated disciple route, and DLT path studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_saam_law_jo_si",
    "tags": "TYHQ, altar, four altars, immortal altar",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_institution_sky_emperor",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Institution",
    "title_en": "Institution of Sky Emperor",
    "title_zh": "天官省",
    "parent": "Three Institutions",
    "belongs_to": "TYHQ",
    "display_order": "5200",
    "short_summary": "The institution for upper-level command, approval, sky authority, and higher order.",
    "simple_meaning": "Institution of Sky Emperor is the upper authority institution inside TYHQ.",
    "what_it_does": "It handles matters that require higher approval, high-level command, and upper order.",
    "disciple_study_notes": "Study this as a government institution, not only a god name. It is a working body inside TYHQ.",
    "afterdeath_meaning": "After death, major upward movement or high-level routing may require this type of authority.",
    "practice_usage": "Use this with Sky Altar, DLT Path, and approval studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, institution, three institutions, institution of sky emperor",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_institution_ground_emperor",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Institution",
    "title_en": "Institution of Ground Emperor",
    "title_zh": "地官省",
    "parent": "Three Institutions",
    "belongs_to": "TYHQ",
    "display_order": "5210",
    "short_summary": "The institution for grounding, settlement, law, correction, and stable arrangement.",
    "simple_meaning": "Institution of Ground Emperor handles the grounded side of TYHQ administration.",
    "what_it_does": "It supports placement, justice, correction, settlement, and the stable handling of difficult cases.",
    "disciple_study_notes": "This institution helps disciples understand why afterdeath matters require order and not only compassion.",
    "afterdeath_meaning": "After death, unresolved burden, debt, attachment, or punishment can require grounded correction before movement continues.",
    "practice_usage": "Use this with Ground Altar, Justice Ministry, Debts Ministry, and Repenting Ministry.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, institution, three institutions, institution of ground emperor",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_institution_water_emperor",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Institution",
    "title_en": "Institution of Water Emperor",
    "title_zh": "水官省",
    "parent": "Three Institutions",
    "belongs_to": "TYHQ",
    "display_order": "5220",
    "short_summary": "The institution for flow, cleansing, transition, communication, and route movement.",
    "simple_meaning": "Institution of Water Emperor handles the flowing and transitional side of TYHQ.",
    "what_it_does": "It supports movement, cleansing, delivery, message flow, and route arrangement between places or stages.",
    "disciple_study_notes": "Water in this context means flow and transition. It helps matters move instead of staying blocked.",
    "afterdeath_meaning": "After death, souls often need transition, cleansing, and movement from one route to another.",
    "practice_usage": "Use this with salvation, disaster dissolving, and problem solving studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, institution, three institutions, institution of water emperor",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_finance",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Finance",
    "title_zh": "戶部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5300",
    "short_summary": "A TYHQ ministry for resources, funding, offerings, court wealth, and distribution.",
    "simple_meaning": "Ministry of Finance is the TYHQ department for resources, funding, offerings, court wealth, and distribution.",
    "what_it_does": "It handles finance, resources, offerings, and the movement of value inside the court.",
    "disciple_study_notes": "Study this to understand that spiritual work also has resource flow and accounting.",
    "afterdeath_meaning": "After death, offerings, merits, credits, and resources may affect how help is delivered.",
    "practice_usage": "Use with Merits, Credits, Debts, and God of Wealth studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, finance, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_etiquette",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Etiquette",
    "title_zh": "禮部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5310",
    "short_summary": "A TYHQ ministry for ritual order, manners, protocol, ceremony, and proper conduct.",
    "simple_meaning": "Ministry of Etiquette is the TYHQ department for ritual order, manners, protocol, ceremony, and proper conduct.",
    "what_it_does": "It handles the rules of respect, ceremony, presentation, greetings, and official conduct.",
    "disciple_study_notes": "Court work must follow etiquette. Wrong attitude or wrong form can block proper connection.",
    "afterdeath_meaning": "After death, a soul entering the court also enters a place with rules, manners, and order.",
    "practice_usage": "Use with worship, ceremonies, and altar protocol studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, etiquette, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_justice",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Justice",
    "title_zh": "刑部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5320",
    "short_summary": "A TYHQ ministry for law, judgment, fairness, case handling, and court justice.",
    "simple_meaning": "Ministry of Justice is the TYHQ department for law, judgment, fairness, case handling, and court justice.",
    "what_it_does": "It handles justice, legal order, review, correction, and judgment inside TYHQ.",
    "disciple_study_notes": "Justice is not only punishment. It is the process of placing matters into correct order.",
    "afterdeath_meaning": "After death, wrongdoings, debts, harm, or disputes may need justice before movement can continue.",
    "practice_usage": "Use with Dei Law Hall, Immortal Court of Justice, and Thunder Justice studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, justice, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_personal",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Personal",
    "title_zh": "吏部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5330",
    "short_summary": "A TYHQ ministry for personal records, identity, staffing, assignment, and personnel matters.",
    "simple_meaning": "Ministry of Personal is the TYHQ department for personal records, identity, staffing, assignment, and personnel matters.",
    "what_it_does": "It handles personal records, identity, staffing, placement, and human-related assignment.",
    "disciple_study_notes": "This ministry helps explain how beings are recorded, recognized, and assigned in the court.",
    "afterdeath_meaning": "After death, identity, lineage connection, name, and assignment matter when the soul is received.",
    "practice_usage": "Use with rescue, records, and home assignment studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, personal, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_works",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Works",
    "title_zh": "工部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5340",
    "short_summary": "A TYHQ ministry for construction, maintenance, facilities, court building, and project work.",
    "simple_meaning": "Ministry of Works is the TYHQ department for construction, maintenance, facilities, court building, and project work.",
    "what_it_does": "It handles building, repair, maintenance, and practical construction work inside the court.",
    "disciple_study_notes": "The court is a working world. Places, homes, and systems must be maintained.",
    "afterdeath_meaning": "After death, a soul can receive residence and services that require actual court infrastructure.",
    "practice_usage": "Use with Saam Law Zone residence and Sun Lung work studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, works, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_military",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Military",
    "title_zh": "兵部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5350",
    "short_summary": "A TYHQ ministry for army, defense, protection force, command, and combat readiness.",
    "simple_meaning": "Ministry of Military is the TYHQ department for army, defense, protection force, command, and combat readiness.",
    "what_it_does": "It handles military authority, protection teams, defense, and forceful response.",
    "disciple_study_notes": "Military work is official protection, not random fighting. It protects the court and its routes.",
    "afterdeath_meaning": "After death, rescue routes and residents may need military protection from harmful forces.",
    "practice_usage": "Use with Five Thunder Hall and Celestial Army Courtyard studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, military, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_thunder",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Thunder",
    "title_zh": "雷部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5360",
    "short_summary": "A TYHQ ministry for thunder authority, forceful correction, breaking obstacles, and enforcement.",
    "simple_meaning": "Ministry of Thunder is the TYHQ department for thunder authority, forceful correction, breaking obstacles, and enforcement.",
    "what_it_does": "It handles thunder power, urgent correction, punishment, and strong clearing work.",
    "disciple_study_notes": "Thunder work is serious. It breaks what ordinary methods cannot break.",
    "afterdeath_meaning": "After death, stubborn ghosts, harmful beings, or strong obstructions may require thunder authority.",
    "practice_usage": "Use with Thunder and Justice Courtyard and Thunder God of Salvation studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, thunder, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_immortals",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Immortals",
    "title_zh": "仙部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5370",
    "short_summary": "A TYHQ ministry for immortal-side records, cultivation status, immortal body, and high-level disciple matters.",
    "simple_meaning": "Ministry of Immortals is the TYHQ department for immortal-side records, cultivation status, immortal body, and high-level disciple matters.",
    "what_it_does": "It handles matters connected to immortals, cultivated status, immortal body, and higher route arrangements.",
    "disciple_study_notes": "Study this when comparing ordinary saved ghosts with cultivated disciples.",
    "afterdeath_meaning": "After death, cultivated disciples may be handled differently from saved-only souls because their path can preserve self and memory.",
    "practice_usage": "Use with Immortal Altar, cultivated disciple route, and DLT studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, immortals, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_heart",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Heart",
    "title_zh": "心法部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5380",
    "short_summary": "A TYHQ ministry for heart connection, faith, inner alignment, and sincerity.",
    "simple_meaning": "Ministry of Heart is the TYHQ department for heart connection, faith, inner alignment, and sincerity.",
    "what_it_does": "It handles heart quality, inner connection, faith, trust, determination, and sincerity.",
    "disciple_study_notes": "The heart is not emotion only. It is the center of connection and commitment.",
    "afterdeath_meaning": "After death, the heart condition affects acceptance, trust, and willingness to follow the court route.",
    "practice_usage": "Use with ordination, HS practice, and disciple self-study.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, heart, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_scriptures",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Scriptures",
    "title_zh": "經法部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5390",
    "short_summary": "A TYHQ ministry for scriptures, written teachings, scripture records, and scripture study.",
    "simple_meaning": "Ministry of Scriptures is the TYHQ department for scriptures, written teachings, scripture records, and scripture study.",
    "what_it_does": "It handles scriptures, scripture records, scripture usage, and written teaching materials.",
    "disciple_study_notes": "Scriptures are not just reading material. They carry structure, doctrine, and court connection.",
    "afterdeath_meaning": "After death, scripture work can support cleansing, guidance, and teaching for souls.",
    "practice_usage": "Use with chanting, scripture books, and Ghost Month scripture work.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, scriptures, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_doctrines",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Doctrines",
    "title_zh": "律法部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5400",
    "short_summary": "A TYHQ ministry for doctrine, teaching system, principles, and correct understanding.",
    "simple_meaning": "Ministry of Doctrines is the TYHQ department for doctrine, teaching system, principles, and correct understanding.",
    "what_it_does": "It handles doctrine, teaching order, principles, and the explanation of Taoist meaning.",
    "disciple_study_notes": "This ministry keeps learning from becoming random personal guessing.",
    "afterdeath_meaning": "After death, correct teaching helps the soul know where to go and what to accept.",
    "practice_usage": "Use with lessons, overviews, and foundation study entries.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, doctrines, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_fu",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of FU",
    "title_zh": "符法部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5410",
    "short_summary": "A TYHQ ministry for FU talismans, request tickets, magical documents, and official written power.",
    "simple_meaning": "Ministry of FU is the TYHQ department for FU talismans, request tickets, magical documents, and official written power.",
    "what_it_does": "It handles FU talismans, magical documents, request tickets, and official written transmissions.",
    "disciple_study_notes": "FU is an official spiritual document, not only a symbol. It carries request and authority.",
    "afterdeath_meaning": "After death, FU work can support rescue, protection, cleansing, and direction.",
    "practice_usage": "Use with FU lessons, protection FU, and salvation work.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, fu, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_spells",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Spells",
    "title_zh": "法咒部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5420",
    "short_summary": "A TYHQ ministry for spells, spoken commands, sound power, and magical activation.",
    "simple_meaning": "Ministry of Spells is the TYHQ department for spells, spoken commands, sound power, and magical activation.",
    "what_it_does": "It handles spells, magical speech, command formulas, and sound-based activation.",
    "disciple_study_notes": "Spells should be understood as official command speech inside the lineage system.",
    "afterdeath_meaning": "After death, spells can call, guide, protect, cleanse, or command depending on the work.",
    "practice_usage": "Use with spell books, rites, and Saamlawnese study.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, spells, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_treasures",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Treasures",
    "title_zh": "法寶部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5430",
    "short_summary": "A TYHQ ministry for spiritual treasures, tools, magical assets, and special items.",
    "simple_meaning": "Ministry of Treasures is the TYHQ department for spiritual treasures, tools, magical assets, and special items.",
    "what_it_does": "It handles court treasures, magical tools, special items, and stored spiritual assets.",
    "disciple_study_notes": "Treasures are not decoration. They are tools and assets that support official work.",
    "afterdeath_meaning": "After death, treasures may support rescue, healing, protection, or higher arrangement.",
    "practice_usage": "Use with court tools, magical weapons, and treasure-related study.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, treasures, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_rituals",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Rituals",
    "title_zh": "法事部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5440",
    "short_summary": "A TYHQ ministry for rites, ceremony procedures, ritual order, and official work steps.",
    "simple_meaning": "Ministry of Rituals is the TYHQ department for rites, ceremony procedures, ritual order, and official work steps.",
    "what_it_does": "It handles ritual procedures, sequence, ceremony structure, and official work format.",
    "disciple_study_notes": "Rituals make the work organized and acceptable to the court system.",
    "afterdeath_meaning": "After death, salvation, cleansing, and rescue often depend on proper ritual routing.",
    "practice_usage": "Use with rites, Ghost Month Salvation, and ceremony instructions.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, rituals, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_altars",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Altars",
    "title_zh": "法壇部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5450",
    "short_summary": "A TYHQ ministry for altar systems, stations, altar connection, and altar maintenance.",
    "simple_meaning": "Ministry of Altars is the TYHQ department for altar systems, stations, altar connection, and altar maintenance.",
    "what_it_does": "It handles altar setup, altar stations, altar connection, and altar-related management.",
    "disciple_study_notes": "An altar is a station of connection, not just a table with offerings.",
    "afterdeath_meaning": "After death, altar work can open the route for contact, request, rescue, and ongoing support.",
    "practice_usage": "Use with TYHQ altars, home altar, and ceremony station studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, altars, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_life",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Life",
    "title_zh": "本命部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5460",
    "short_summary": "A TYHQ ministry for life force, living state, vitality, body-life link, and life route.",
    "simple_meaning": "Ministry of Life is the TYHQ department for life force, living state, vitality, body-life link, and life route.",
    "what_it_does": "It handles life-force matters, living condition, and the connection between life and the court system.",
    "disciple_study_notes": "Life matters connect the living disciple with the court before death happens.",
    "afterdeath_meaning": "After death, the life route changes into ghost life or higher arrangement, so life records matter.",
    "practice_usage": "Use with ghost life, healing, and cultivation route studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, life, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_taoist_connection",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Taoist Connection",
    "title_zh": "道緣部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5470",
    "short_summary": "A TYHQ ministry for Taoist affinity, lineage link, ordination connection, and relationship to the Tao.",
    "simple_meaning": "Ministry of Taoist Connection is the TYHQ department for Taoist affinity, lineage link, ordination connection, and relationship to the Tao.",
    "what_it_does": "It handles Taoist connection, affinity, lineage relationship, and whether someone has a proper route into the Tao.",
    "disciple_study_notes": "Taoist connection is a route and relationship. It affects whether help can reach and be accepted.",
    "afterdeath_meaning": "After death, ordination and Taoist connection can help the soul be recognized and received by the court.",
    "practice_usage": "Use with ordination, saved by ceremony, and disciple route studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, taoist connection, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_merits",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Merits",
    "title_zh": "積福部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5480",
    "short_summary": "A TYHQ ministry for merits, good work, offerings, virtuous contribution, and earned blessing.",
    "simple_meaning": "Ministry of Merits is the TYHQ department for merits, good work, offerings, virtuous contribution, and earned blessing.",
    "what_it_does": "It handles merit records and the good contribution that supports future blessing and help.",
    "disciple_study_notes": "Merit is not vague praise. It is recorded contribution that can support arrangement.",
    "afterdeath_meaning": "After death, merits can help the soul receive better support and smoother route.",
    "practice_usage": "Use with credits, offerings, and cultivation studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, merits, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_credits",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Credits",
    "title_zh": "功德部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5490",
    "short_summary": "A TYHQ ministry for credits, earned service, work record, and contribution value.",
    "simple_meaning": "Ministry of Credits is the TYHQ department for credits, earned service, work record, and contribution value.",
    "what_it_does": "It handles credit earned from service, work, and useful contribution to the Tao and court.",
    "disciple_study_notes": "Credits are connected to what one has actually done and contributed.",
    "afterdeath_meaning": "After death, credits can support arrangement, protection, and upward opportunity.",
    "practice_usage": "Use with merits, finance, and work/service studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, credits, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_debts",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Debts",
    "title_zh": "業報部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5500",
    "short_summary": "A TYHQ ministry for debts, karmic burden, owed matters, repayment, and unresolved accounts.",
    "simple_meaning": "Ministry of Debts is the TYHQ department for debts, karmic burden, owed matters, repayment, and unresolved accounts.",
    "what_it_does": "It handles debts, burden, owed matters, and records that must be addressed.",
    "disciple_study_notes": "Debt is not only money. It can include harm, obligation, unresolved promises, or spiritual burden.",
    "afterdeath_meaning": "After death, debts can hold the soul back until handled, repented, or cleared through proper work.",
    "practice_usage": "Use with justice, repenting, disaster dissolving, and Blood Lake Hell studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, debts, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_repenting",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Repenting",
    "title_zh": "懺罪部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5510",
    "short_summary": "A TYHQ ministry for repentance, confession, correction, and turning back from wrong direction.",
    "simple_meaning": "Ministry of Repenting is the TYHQ department for repentance, confession, correction, and turning back from wrong direction.",
    "what_it_does": "It handles sincere repentance, correction, confession, and the process of turning back to the proper route.",
    "disciple_study_notes": "Repenting is not empty guilt. It is changing direction and allowing correction.",
    "afterdeath_meaning": "After death, repentance can help a soul accept correction and move out of stubborn suffering.",
    "practice_usage": "Use with debts, justice, disaster dissolving, and salvation studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, repenting, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_disaster_dissolving",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Disaster Dissolving",
    "title_zh": "消災部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5520",
    "short_summary": "A TYHQ ministry for dissolving disaster, reducing danger, clearing bad outcomes, and easing impact.",
    "simple_meaning": "Ministry of Disaster Dissolving is the TYHQ department for dissolving disaster, reducing danger, clearing bad outcomes, and easing impact.",
    "what_it_does": "It handles dissolving disasters, reducing bad outcomes, and clearing destructive conditions.",
    "disciple_study_notes": "Disaster dissolving means reducing or transforming an incoming bad route before it fully manifests.",
    "afterdeath_meaning": "After death, disaster energy and bad routes may need to be dissolved before the soul can settle properly.",
    "practice_usage": "Use with problem solving, repenting, and protection studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, disaster dissolving, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  },
  {
    "rc_id": "rc_tyhq_ministry_of_problem_solving",
    "directory": "RC Atlas",
    "type": "TYHQ",
    "category": "Ministry",
    "title_en": "Ministry of Problem Solving",
    "title_zh": "解難部",
    "parent": "24 Ministries",
    "belongs_to": "TYHQ",
    "display_order": "5530",
    "short_summary": "A TYHQ ministry for solving problems, handling blocks, resolving trouble, and opening routes.",
    "simple_meaning": "Ministry of Problem Solving is the TYHQ department for solving problems, handling blocks, resolving trouble, and opening routes.",
    "what_it_does": "It handles practical problem solving, route opening, and clearing difficult knots in court matters.",
    "disciple_study_notes": "This ministry shows that the court does not only judge; it also resolves and opens a workable route.",
    "afterdeath_meaning": "After death, a soul may face blocks, confusion, attachment, or missing connection. Problem solving helps find a way through.",
    "practice_usage": "Use with disaster dissolving, Taoist connection, and rescue studies.",
    "related_entries": "rc_tyhq_overview, rc_tyhq_purpose, rc_tyhq_hq_altar",
    "tags": "TYHQ, ministry, problem solving, 24 ministries",
    "status": "approved",
    "updated_at": "2026-06-28T00:00:00Z"
  }
];
  var RC_ATLAS_DEFAULT_ENTRIES = RC_ATLAS_ENTRIES.slice();

  var GOD_ATLAS_TYPES = ['Main Gods','Saam Ching','Four Emperors','Wealth Gods','Local Gods','Guardians','Three Officials','Others'];
  var GOD_ATLAS_CATEGORIES = ['Details / Info','Prayer','FU Head','God Spell','Scriptures','Art','Anniversary'];
  var GOD_ATLAS_ENTRIES = [
  {
    "god_id": "god_saam_law_tin_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "50",
    "name_en": "Saam Law Tin Si",
    "name_zh": "三羅天師",
    "saamlawnese_name": "",
    "aliases": "Tin Yat Jee Gum Saam Law Jo Si / 天一紫金三羅祖師",
    "short_summary": "Highest main god in this God Atlas structure.",
    "details_info": "Saam Law Tin Si is placed as the highest main god in the God Atlas. This entry is prepared with approved artwork now; more detailed teaching can be expanded later from approved source notes and direct teaching.\n\nTin Yat Jee Gum Saam Law Jo Si is the same god as Saam Law Tin Si; this Atlas uses the shorter name Saam Law Tin Si for display.",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "tin_yat_jee_gum_saam_law_jo_si_prayer",
    "fu_head_item_ids": "fh42_tin_si_fu_head",
    "god_spell_item_ids": "",
    "scripture_book_ids": "",
    "scripture_item_ids": "saam_law_morning_scripture|saam_law_noon_scripture|saam_law_evening_scripture|saam_law_heart_scripture|saam_law_tao_scripture|saam_law_sun_gung_scripture|saam_law_celestial_masters_scripture|saam_law_three_officials_scripture|saam_law_exorcism_scripture|saam_law_truth_scripture|saam_law_altar_cultivation_rite|saam_law_72_chapters_scripture|saam_law_36_chapters_scripture|saam_law_five_virtues_scripture|saam_law_filial_piety_scripture|saam_law_etiquettes_scripture|afterdeath_suffering_relieving_sins_dissolving_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_tin_yat_jee_gum_saam_law_jo_si_art.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_saam_law_tin_si_art.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_saam_law_tin_si",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "main gods|highest main god|saam law tin si|art linked",
    "status": "art_linked_needs_content",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_saam_law_jo_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "100",
    "name_en": "Saam Law Jo Si",
    "name_zh": "三羅祖師",
    "saamlawnese_name": "Saam Noh Ju Cia",
    "aliases": "Jo Si",
    "short_summary": "Main god of Saam Law Tao and the primary god disciples should know first.",
    "details_info": "Saam Law Jo Si is the principal god of the lineage. Disciples can remember this god first when everything else feels too much, because all other gods in the system are specialized forms, representatives, or useful expressions of this same main power. He is the first god of the celestial court given to the lineage, and the other gods are born afterward to handle more specific jobs. In practice, Saam Law Jo Si is the main connection point for disciples, especially through heart spell, prayer, FU head, and faith.\n\nThe god can be understood like the raw source material behind many useful tools. Flour can become bread, and metal can become a sword, door, tool, or vehicle. In the same way, the specialized gods are not separate from the main source; they are the working forms of Saam Law Jo Si for different needs. This makes Saam Law Jo Si suitable as the main god for learning, worship, faith-building, and overall connection to the Tao.",
    "god_power": "Main lineage power, overall support, source connection, faith alignment, and the ability to give rise to specialized gods or powers for different tasks.",
    "disciple_usage": "Use as the primary god to connect with, especially for general worship, foundation cultivation, heart spell connection, and when the disciple does not know which specialized god to call yet.",
    "court_area": "TYHQ / Main lineage authority",
    "palace_hall_department": "TYHQ; also connected to the whole Religious Court system",
    "prayer_item_ids": "saam_law_jo_si_prayer",
    "fu_head_item_ids": "fh01_saam_law_jo_si_fu_head",
    "god_spell_item_ids": "god_spell_saam_law_jo_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "saam_law_morning_scripture|saam_law_noon_scripture|saam_law_evening_scripture|saam_law_heart_scripture|saam_law_tao_scripture|saam_law_sun_gung_scripture|saam_law_celestial_masters_scripture|saam_law_three_officials_scripture|saam_law_exorcism_scripture|saam_law_truth_scripture|saam_law_altar_cultivation_rite|saam_law_72_chapters_scripture|saam_law_36_chapters_scripture|saam_law_five_virtues_scripture|saam_law_filial_piety_scripture|saam_law_etiquettes_scripture|afterdeath_suffering_relieving_sins_dissolving_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_saam_law_jo_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_saam_law_jo_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_saam_law_jo_si",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "main gods|lineage god|saam law|jo si|jade seal nine gods",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_tin_law_jo_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "110",
    "name_en": "Tin Law Jo Si",
    "name_zh": "天羅祖師",
    "saamlawnese_name": "Tian Noh Ju Cia",
    "aliases": "",
    "short_summary": "God of the sky system, positive celestial light, resources, treasures, wisdom, and empowerment.",
    "details_info": "Tin Law Jo Si represents the Tin Law or sky system. His power is positive, bright, and adding in nature. The book compares him to a keeper of a bank of natural resources: when something is needed, he can release resources, treasures, wisdom, knowledge, and other valuable support. His celestial light is also a strong force for defeating evil, because wherever that light shines, evils are pushed back or driven away.\n\nFor disciples, this god is important whenever the work requires adding, empowering, blessing, strengthening, or supplying what is missing. If Dei Law Jo Si takes away and destroys obstruction, Tin Law Jo Si gives and increases what is needed so the disciple can continue the work with more backing from the Tao.",
    "god_power": "Positive celestial light, adding, increasing, empowerment, resources, treasures, wisdom, knowledge, and evil-vanquishing light.",
    "disciple_usage": "Use when more support, power, resources, blessing, knowledge, or empowerment is needed, and when positive celestial light is needed to drive away evil.",
    "court_area": "Saam Law Palace",
    "palace_hall_department": "Saam Law Palace; Tin Law Hall / 天羅殿 connection",
    "prayer_item_ids": "tin_law_jo_si_prayer",
    "fu_head_item_ids": "fh02_tin_law_jo_si_fu_head",
    "god_spell_item_ids": "god_spell_tin_law_jo_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "tin_law_justice_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_tin_law_jo_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_tin_law_jo_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_tin_law_jo_si",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "main gods|tin law|sky system|empowerment|resources|jo si",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_dei_law_jo_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "120",
    "name_en": "Dei Law Jo Si",
    "name_zh": "地羅祖師",
    "saamlawnese_name": "Di Noh Ju Cia",
    "aliases": "",
    "short_summary": "God of the ground system, absorption, destruction, containment, exorcism, and sealing.",
    "details_info": "Dei Law Jo Si represents the Dei Law or ground system. His power is negative in the technical Saam Law sense: it absorbs, destroys, takes away, breaks down, and contains. The book compares this power to a black hole and also to the ground, which can hold things, bury them, and slowly melt them down until they return to earth.\n\nThis god is especially important for removing evil, absorbing bad luck, dissolving unwanted energies, sealing and containing harmful forces, and supporting exorcism work. When something must be captured, broken down, or sent into a corrective prison-like process, Dei Law Jo Si is the god to call. His role is not merely destruction for destruction; it is destruction that restores order by removing what obstructs nature.",
    "god_power": "Absorption, destruction, evil removal, bad luck removal, containment, sealing, imprisonment, and breaking down unwanted forces.",
    "disciple_usage": "Use for exorcism, removing evil, absorbing negative energy, sealing unwanted forces, capturing spirits, and taking away what should not remain.",
    "court_area": "Saam Law Palace",
    "palace_hall_department": "Saam Law Palace; Dei Law Hall / 地羅殿 connection",
    "prayer_item_ids": "dei_law_jo_si_prayer",
    "fu_head_item_ids": "fh03_dei_law_jo_si_fu_head",
    "god_spell_item_ids": "god_spell_dei_law_jo_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_dei_law_jo_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_dei_law_jo_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_dei_law_jo_si",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "main gods|dei law|ground system|exorcism|containment|jo si",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_daai_law_jo_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "130",
    "name_en": "Daai Law Jo Si",
    "name_zh": "大羅祖師",
    "saamlawnese_name": "Daai Noh Ju Cia",
    "aliases": "",
    "short_summary": "God of creation, golden light, FU and magic system power, courage, solutions, and manifestation.",
    "details_info": "Daai Law Jo Si represents Daai Law and the power of creation. The book describes him as a god of golden light who encompasses the FU and magic system. While Tin Law Jo Si gives more and Dei Law Jo Si takes away, Daai Law Jo Si helps the work happen. He is compared to the CPU of spiritual practice because he processes commands and turns intention into action.\n\nHis power is used for creating, manifesting, finding solutions, overcoming stubborn obstacles, bringing harmony, and protecting the heart. In life problems, disasters, and difficult cases where the disciple needs courage, new ideas, or a way through, Daai Law Jo Si helps the heart become stronger and helps the work move into reality.",
    "god_power": "Creation, golden light, manifestation, command processing, FU and magic system power, courage, problem solving, harmony, and heart protection.",
    "disciple_usage": "Use when starting magical work, creating solutions, overcoming obstacles, restoring harmony, strengthening courage, protecting the heart, or manifesting intention into action.",
    "court_area": "Saam Law Palace",
    "palace_hall_department": "Saam Law Palace",
    "prayer_item_ids": "daai_law_jo_si_prayer",
    "fu_head_item_ids": "fh04_daai_law_jo_si_fu_head",
    "god_spell_item_ids": "god_spell_daai_law_jo_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_daai_law_jo_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_daai_law_jo_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_daai_law_jo_si",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "main gods|daai law|creation|golden light|fu|magic|jo si",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_sun_lung_jo_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "140",
    "name_en": "Sun Lung Jo Si",
    "name_zh": "神龍祖師",
    "saamlawnese_name": "Sin Nong Ju Cia",
    "aliases": "Godly Dragon Jo Si",
    "short_summary": "Godly Dragon Jo Si who transfers power and magic from the celestial side to other places.",
    "details_info": "Sun Lung Jo Si is the god responsible for moving power and magic from the celestial court to where it needs to go. The book compares him to a postal system, a cable, and a flying train that delivers magical energy from the court to distant places. The dragon descends from the sky to the ocean, showing the connection between the celestial side and our world.\n\nThis god is very important for distance magic, channel strength, and ordination power transfer. Whenever power from the court needs to travel through a channel to a disciple, altar, target, ceremony, or distant place, the Sun Lung power is involved. This makes Sun Lung Jo Si a key god for keeping magical transmissions stable and secure.",
    "god_power": "Transmission, distance magic, channel connection, power transfer, stable delivery of magic, and ordination empowerment.",
    "disciple_usage": "Use when sending magic over distance, strengthening the channel between court and target, empowering an altar/session, or working with power transmission.",
    "court_area": "Sun Lung Palace",
    "palace_hall_department": "Sun Lung Palace / 神龍宮",
    "prayer_item_ids": "sun_lung_jo_si_prayer",
    "fu_head_item_ids": "fh05_sun_lung_jo_si_fu_head",
    "god_spell_item_ids": "god_spell_sun_lung_jo_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_sun_lung_jo_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_sun_lung_jo_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_sun_lung_jo_si",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "main gods|sun lung|dragon|distance magic|transmission|jo si",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_gum_lung_sin_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "150",
    "name_en": "Gum Lung Sin Si",
    "name_zh": "金龍仙師",
    "saamlawnese_name": "Gim Nong Cian Cia",
    "aliases": "Golden Dragon Immortal",
    "short_summary": "Golden Dragon Sin Si who delivers gold elixir, resources, and internal magical strength.",
    "details_info": "Gum Lung Sin Si is the Golden Dragon Immortal. He is a Sin Si, meaning a deity born after the establishment of the celestial court, and he works closely with the five ancestor gods. His core role is to deliver the gold elixir to practitioners, strengthening internal magical essence and increasing the resources available for spiritual work.\n\nThe book compares this god to someone pouring money into a project. With more resources, a project can grow, and in the same way the gold elixir gives the disciple more magical resources, potential, and possibilities. Gum Lung Sin Si is therefore important when the disciple needs more inner backing, more spiritual wealth, and a stronger foundation for practice.",
    "god_power": "Gold elixir, internal magical essence, resources, wealth-like support, knowledge, potential, and stronger magical foundation.",
    "disciple_usage": "Use when needing more internal resources, blessing, empowerment, magical wealth, knowledge, or stronger foundation for cultivation.",
    "court_area": "Tin Yat Palace",
    "palace_hall_department": "Tin Yat Palace; Golden Dragon Hall connection",
    "prayer_item_ids": "gum_lung_sin_si_prayer",
    "fu_head_item_ids": "fh06_gum_lung_sin_si_fu_head",
    "god_spell_item_ids": "god_spell_gum_lung_sin_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_gum_lung_sin_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_gum_lung_sin_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_gum_lung_sin_si",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "main gods|gum lung|golden dragon|gold elixir|resources|sin si",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_jee_lung_sin_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "160",
    "name_en": "Jee Lung Sin Si",
    "name_zh": "紫龍仙師",
    "saamlawnese_name": "Ju Nong Cian Cia",
    "aliases": "Purple Dragon Immortal",
    "short_summary": "Purple Dragon Sin Si who gives power, speed, practical application, and stronger execution.",
    "details_info": "Jee Lung Sin Si is the Purple Dragon Immortal. He gives the purple elixir, which strengthens power and speed so work can be completed more efficiently. The book explains that while the Golden Dragon provides resources, the Purple Dragon provides power and speed. Together they help the disciple not only have resources, but also apply them effectively.\n\nJee Lung Sin Si also teaches practical use of power. He helps disciples apply knowledge, increase magical ability, align with the Tao, and strengthen exorcism practice. This god is important when the disciple already has something to work with but needs stronger execution, faster completion, and better use of power.",
    "god_power": "Purple elixir, speed, force, practical application, stronger execution, Tao alignment, and exorcism support.",
    "disciple_usage": "Use when needing faster action, stronger output, better practical use of power, improved magical ability, or help applying what has been learned.",
    "court_area": "Tin Yat Palace",
    "palace_hall_department": "Tin Yat Palace; Purple Dragon Hall connection",
    "prayer_item_ids": "jee_lung_sin_si_prayer",
    "fu_head_item_ids": "fh07_jee_lung_sin_si_fu_head",
    "god_spell_item_ids": "god_spell_jee_lung_sin_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_jee_lung_sin_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_jee_lung_sin_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_jee_lung_sin_si",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "main gods|jee lung|purple dragon|speed|power|sin si",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_ng_lui_sin_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "170",
    "name_en": "Ng Lui Sin Si",
    "name_zh": "五雷仙師",
    "saamlawnese_name": "Whuo Le Cian Cia",
    "aliases": "Five Thunder Immortal",
    "short_summary": "Five Thunder Sin Si for hard problems, exorcism, magical battles, protection, and system-changing force.",
    "details_info": "Ng Lui Sin Si is the Five Thunder Immortal. He specializes in problem-solving, overcoming obstacles, difficult cases, high-power evils, exorcism, and magical battles. The book presents him as both a helper and a fighter, like thunder that breaks darkness and brings change.\n\nThis god is also connected to understanding and changing the rules of the magical system. In the teaching about FU paper colors, Ng Lui Sin Si works like a programmer who understands and modifies the source code of the system. Therefore, this god is important when a case is stubborn, technical, violent, blocked, or battle-like. He provides strong thunder force for protection, exorcism, and problem solving.",
    "god_power": "Thunder force, obstacle breaking, hard-case problem solving, exorcism, magical battle support, protection, and rule-changing/system-coding power.",
    "disciple_usage": "Use for strong evils, difficult problems, magical battles, exorcism, protection, and situations where normal methods are not enough.",
    "court_area": "Sun Lung Palace",
    "palace_hall_department": "Sun Lung Palace; Five Thunder Hall / 五雷殿 connection",
    "prayer_item_ids": "ng_lui_sin_si_prayer",
    "fu_head_item_ids": "fh08_ng_lui_sin_si_fu_head",
    "god_spell_item_ids": "god_spell_ng_lui_sin_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_ng_lui_sin_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_ng_lui_sin_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_ng_lui_sin_si",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "main gods|ng lui|five thunder|exorcism|battle|protection|sin si",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_baak_hork_sin_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "180",
    "name_en": "Baak Hork Sin Si",
    "name_zh": "白鶴仙師",
    "saamlawnese_name": "Bye Hwall Cian Cia",
    "aliases": "White Crane Immortal",
    "short_summary": "White Crane Sin Si for upward communication, reports, records, messages, and connection to the court.",
    "details_info": "Baak Hork Sin Si is the White Crane Immortal. His role is communication between the earthly side and the celestial court, especially sending signals upward. The book contrasts dragon and crane: the dragon descends from the sky toward the ocean, while the crane ascends toward the sky. This makes Baak Hork Sin Si important for helping disciples connect upward and communicate with the divine side.\n\nHe also helps submit records to the court. A disciple’s actions, progress, attitude, and contributions are marked and judged, and Baak Hork Sin Si helps present these records. For god-invoking, reporting, messages, and formal connection to the court, this god plays a key communication role.",
    "god_power": "Upward communication, god-invoking support, message delivery, record submission, reporting, and court connection.",
    "disciple_usage": "Use when sending messages upward, invoking gods, reporting to the court, strengthening communication, or making the connection clear and properly recorded.",
    "court_area": "Sun Lung Palace",
    "palace_hall_department": "Sun Lung Palace; White Crane Hall / 白鶴殿 connection",
    "prayer_item_ids": "baak_hork_sin_si_prayer",
    "fu_head_item_ids": "fh09_baak_hork_sin_si_fu_head",
    "god_spell_item_ids": "god_spell_baak_hork_sin_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "white_crane_fortune_disaster_dissolving_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_baak_hork_sin_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_baak_hork_sin_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_baak_hork_sin_si",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "main gods|baak hork|white crane|communication|reports|sin si",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_bagwa_jo_si",
    "directory": "Gods",
    "type": "Main Gods",
    "display_order": "190",
    "name_en": "Bagwa Jo Si",
    "name_zh": "八卦祖師",
    "saamlawnese_name": "Pie Gwa Ju Cia",
    "aliases": "Baat Gwa Jo Si",
    "short_summary": "Religious Court connector deity who links altars to gods, courts, and protective army support.",
    "details_info": "Bagwa Jo Si is a Religious Court deity who helps make connections across different courts and gods within the sect. His anniversary is on lunar July 15.\n\nFor disciples with an altar, Bagwa Jo Si is important before work that calls a specific deity. He helps patch the connection to the right power, gives approval support for altar setup, and works with the Bagwa Army as the first line of altar defense. He also works with the landlord deity side and reports upward to the Ground Emperor when the altar needs protection or correction.",
    "god_power": "Court connection, altar approval, deity routing, Bagwa Army protection, altar defense, and reporting support.",
    "disciple_usage": "Use before calling specific gods, setting up altar connections, defending an altar, or studying how the altar links to the Religious Court.",
    "court_area": "Tin Yat Palace",
    "palace_hall_department": "Tin Yat Palace",
    "prayer_item_ids": "bagwa_jo_si_prayer",
    "fu_head_item_ids": "fh10_bagwa_jo_si_fu_head",
    "god_spell_item_ids": "god_spell_bagwa_jo_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_bagwa_jo_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_bagwa_jo_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_bagwa_jo_si",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Bagwa Jo Si article.",
    "tags": "main gods|bagwa|altar god|search engine|routing|jo si",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_taai_sheung_lo_gwun",
    "directory": "Gods",
    "type": "Saam Ching",
    "display_order": "200",
    "name_en": "Taai Sheung Lo Gwun",
    "name_zh": "太上老君",
    "saamlawnese_name": "Taai Xieong Lu Guan",
    "aliases": "Taai Ching Doe Duck Tin Juen|太清道德天尊|Doe Duck Tin Juen|道德天尊",
    "short_summary": "Saam Ching deity who empowers local magic execution, protection, and exorcism work.",
    "details_info": "Taai Sheung Lo Gwun is the Elder Lord and one of the Saam Ching deities. In this Atlas he is also matched with the Ultimate Clear Do Duck Tin Juen side of the Saam Ching system. His power supports the disciple's local energy body so magical work can be done with more strength, speed, and stability.\n\nThis god is important for ordained disciples because the Saam Ching power is copied into the disciple's own system after ordination. Taai Sheung Lo Gwun helps the disciple use power locally, protect the body and altar side, and make magic easier to execute. He is also connected with exorcism, protection, and practical methods that help the work become less heavy.",
    "god_power": "Local magic execution, Saam Ching empowerment, protection, exorcism support, strengthening the local energy body, and practical magical efficiency.",
    "disciple_usage": "Use when needing stronger local execution, protection, exorcism support, faster FU work, or easier handling of practical magic.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "taai_sheung_lo_gwun_prayer",
    "fu_head_item_ids": "fh13_taai_ching_doe_duck_tin_juen_fu_head",
    "god_spell_item_ids": "practical_spell_taai_xieong_lu_guan",
    "scripture_book_ids": "",
    "scripture_item_ids": "elder_lord_tao_te_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_taai_ching_doe_duck_tin_juen_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_taai_ching_doe_duck_tin_juen_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_taai_sheung_lo_gwun",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Elder Lord and Saam Ching articles.",
    "tags": "saam_ching|art linked|taai ching doe duck tin juen",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_ling_bo_tin_juen",
    "directory": "Gods",
    "type": "Saam Ching",
    "display_order": "210",
    "name_en": "Ling Bo Tin Juen",
    "name_zh": "靈寶天尊",
    "saamlawnese_name": "Nieong Bwa Tian Juan",
    "aliases": "Sheung Ching Ling Bo Tin Juen|上清靈寶天尊",
    "short_summary": "Upper Clears Saam Ching deity who oversees preheaven magic reserves and power reception.",
    "details_info": "Ling Bo Tin Juen is the Upper Clears Heavenly Lord in the Saam Ching system. In the lineage teaching, the Saam Ching powers are copied into an ordained disciple's system so the disciple has support for magical work.\n\nLing Bo Tin Juen's role is the upper side of the Saam Ching function. He helps oversee the disciple's magic power reserve in the preheaven side, helps receive power from the Religious Court, and helps the disciple build up magical resources. This makes him important for long-term power storage, new FU work, and building personal methods inside the disciple's own system.",
    "god_power": "Preheaven power reserve, receiving court energy, magical resource building, Saam Ching empowerment, and support for creating FU and methods.",
    "disciple_usage": "Use when studying Saam Ching power, building reserves, receiving power from the court, or strengthening the upper side of a disciple's magical system.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "ling_bo_tin_juen_prayer",
    "fu_head_item_ids": "fh11_sheung_ching_ling_bo_tin_juen_fu_head",
    "god_spell_item_ids": "",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_sheung_ching_ling_bo_tin_juen_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_sheung_ching_ling_bo_tin_juen_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_ling_bo_tin_juen",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Saam Ching article.",
    "tags": "saam_ching|art linked|sheung ching ling bo tin juen",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_yuen_chi_tin_juen",
    "directory": "Gods",
    "type": "Saam Ching",
    "display_order": "220",
    "name_en": "Yuen Chi Tin Juen",
    "name_zh": "元始天尊",
    "saamlawnese_name": "Xuan Chia Tian Juan",
    "aliases": "Yuk Ching Yuen Chi Tin Juen|玉清元始天尊",
    "short_summary": "Jade Clears Saam Ching deity who helps channel power downward from the soul base.",
    "details_info": "Yuen Chi Tin Juen is the Jade Clears Heavenly Lord in the Saam Ching system. In the lineage teaching, the Saam Ching powers support the disciple after ordination and help the disciple's magical work become accessible inside the disciple's own system.\n\nYuen Chi Tin Juen is connected with the Ghost Altar, the soul base. His role is like helping the disciple withdraw and channel power downward from the deeper spiritual side into practical use. This makes him important when the disciple needs the stored power to move from the deeper base into the working side.",
    "god_power": "Soul-base support, downward power channeling, drawing out stored magical power, Saam Ching empowerment, and bridging deeper power into use.",
    "disciple_usage": "Use when studying Saam Ching structure, soul-base support, drawing power downward, or making stored power usable in practice.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "yuen_chi_tin_juen_prayer",
    "fu_head_item_ids": "fh12_yuk_ching_yuen_chi_tin_juen_fu_head",
    "god_spell_item_ids": "",
    "scripture_book_ids": "",
    "scripture_item_ids": "quitting_evil_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_yuk_ching_yuen_chi_tin_juen_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_yuk_ching_yuen_chi_tin_juen_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_yuen_chi_tin_juen",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Saam Ching article.",
    "tags": "saam_ching|art linked|yuk ching yuen chi tin juen",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_tin_wong_daai_dai",
    "directory": "Gods",
    "type": "Four Emperors",
    "display_order": "310",
    "name_en": "Tin Wong Daai Dai",
    "name_zh": "天皇大帝",
    "saamlawnese_name": "",
    "aliases": "Sky Emperor",
    "short_summary": "Sky Emperor who oversees divine routing, higher-court support, and god assignment.",
    "details_info": "Tin Wong Daai Dai is the Sky Emperor, one of the Four Great Emperors of the Celestial Court. The Four Emperors are major powers in the court and are used by ordained disciples for important ceremonies, god-invoking, exorcism work, and higher-level magical situations.\n\nTin Wong Daai Dai oversees the divine traffic of the court. He helps call in reinforcement from higher levels when needed and gives approval when a god is assigned to a statue or altar object. If an altar's god power goes wrong, this emperor is also the one to ask for correction from the higher authority.",
    "god_power": "Divine routing, higher-court reinforcement, god assignment, altar correction, celestial authority, and ceremonial support.",
    "disciple_usage": "Use when studying Four Emperor authority, god statue assignment, high-level altar correction, or higher-court support.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "sky_emperor_prayer",
    "fu_head_item_ids": "fh14_tin_wong_daai_dai_fu_head",
    "god_spell_item_ids": "",
    "scripture_book_ids": "",
    "scripture_item_ids": "sky_emperor_demon_slaying_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_tin_wong_daai_dai_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_tin_wong_daai_dai_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_tin_wong_daai_dai",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Four Celestial Emperors article.",
    "tags": "four_emperors|art linked|tin wong daai dai",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_dei_wong_daai_dai",
    "directory": "Gods",
    "type": "Four Emperors",
    "display_order": "320",
    "name_en": "Dei Wong Daai Dai",
    "name_zh": "地皇大帝",
    "saamlawnese_name": "",
    "aliases": "Ground Emperor",
    "short_summary": "Ground Emperor who oversees altars, landlord deity assignment, and altar reporting.",
    "details_info": "Dei Wong Daai Dai is the Ground Emperor, one of the Four Great Emperors. He manages the ground-side authority connected to the lineage altar system.\n\nHis role is to oversee altars linked to the sect's power and to assign landlord deities who help connect the local altar to the court above. When an altar has mistakes, bad energy, or misconduct, the landlord side can report upward through this emperor's system. This makes Dei Wong Daai Dai important for stable altar management, local spiritual order, and correction.",
    "god_power": "Altar management, landlord deity assignment, ground-side authority, altar reporting, local order, and correction support.",
    "disciple_usage": "Use when studying altar governance, landlord deity work, local altar problems, and Ground Emperor authority.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "ground_emperor_prayer",
    "fu_head_item_ids": "fh15_dei_wong_daai_dai_fu_head",
    "god_spell_item_ids": "",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_dei_wong_daai_dai_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_dei_wong_daai_dai_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_dei_wong_daai_dai",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Four Celestial Emperors article.",
    "tags": "four_emperors|art linked|dei wong daai dai",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_yuk_wong_daai_dai",
    "directory": "Gods",
    "type": "Four Emperors",
    "display_order": "330",
    "name_en": "Yuk Wong Daai Dai",
    "name_zh": "玉皇大帝",
    "saamlawnese_name": "",
    "aliases": "Jade Emperor",
    "short_summary": "Jade Emperor who oversees disciple records, merit, and court judgment.",
    "details_info": "Yuk Wong Daai Dai is the Jade Emperor, one of the Four Great Emperors. He is a high ruler in the Celestial Court and is connected with judging the disciple's record.\n\nHis role includes watching the disciple's actions and spiritual record. He works with other court powers to judge what the disciple has earned, what support should be given, and what correction may be needed. This makes Yuk Wong Daai Dai important for discipline, merit, and the larger court order.",
    "god_power": "Court ruling, disciple record review, merit judgment, reward and correction, spiritual discipline, and high authority.",
    "disciple_usage": "Use when studying court judgment, disciple record, merit, reward, correction, and the Jade Emperor's authority.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "jade_emperor_prayer",
    "fu_head_item_ids": "fh16_yuk_wong_daai_dai_fu_head",
    "god_spell_item_ids": "",
    "scripture_book_ids": "",
    "scripture_item_ids": "jade_emperor_amnesty_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_yuk_wong_daai_dai_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_yuk_wong_daai_dai_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_yuk_wong_daai_dai",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Four Celestial Emperors article.",
    "tags": "four_emperors|art linked|yuk wong daai dai",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_ji_mei_daai_dai",
    "directory": "Gods",
    "type": "Four Emperors",
    "display_order": "340",
    "name_en": "Ji Mei Daai Dai",
    "name_zh": "紫微大帝",
    "saamlawnese_name": "",
    "aliases": "Jee Mei Emperor",
    "short_summary": "Ji Mei Emperor who commands heavenly army power for justice and protection.",
    "details_info": "Ji Mei Daai Dai is the Ji Mei Emperor, one of the Four Great Emperors. He is the general-like emperor who commands heavenly army power in the court.\n\nHis power is especially important when evil is too strong for ordinary handling. The blog describes him as commanding the army of heaven, bringing force against evils that threaten the Tao. This makes Ji Mei Daai Dai important for high-level protection, court enforcement, and serious magical battles.",
    "god_power": "Heavenly army command, court enforcement, serious protection, high-level exorcism support, and force against heavy evil.",
    "disciple_usage": "Use when studying heavenly troops, serious protection, court enforcement, and difficult magical battles.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "jee_mei_emperor_prayer",
    "fu_head_item_ids": "fh17_ji_mei_daai_dai_fu_head",
    "god_spell_item_ids": "",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_ji_mei_daai_dai_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_ji_mei_daai_dai_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_ji_mei_daai_dai",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Four Celestial Emperors article.",
    "tags": "four_emperors|art linked|ji mei daai dai",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_toe_dei",
    "directory": "Gods",
    "type": "Local Gods",
    "display_order": "600",
    "name_en": "Toe Dei / Landlord Deity",
    "name_zh": "土地神明",
    "saamlawnese_name": "Tu Di",
    "aliases": "Landlord Deity|Toe Dei Sun Ming|Tu Di",
    "short_summary": "Local altar/property deity who protects the altar and manages local spiritual work.",
    "details_info": "The Landlord Deity, called Toe Dei in Cantonese and Tu Di in Saamlawnese, is the local deity of the altar and location. This deity acts like the caretaker or landlord for the physical property and the inner spiritual realm of the altar. The role includes protecting the altar against danger, magical attack, invasion, and other local problems.\n\nThe landlord altar is like the lower-deck training ground and residence for the local spiritual army. It also acts as an intermediary between the human world and the celestial court, helping relay offerings, messages, and communications. During exorcism, the landlord department can also temporarily detain evils before they are returned to the preheaven side.",
    "god_power": "Local protection, altar/property management, first-response support, communication bridge, local army management, and temporary containment.",
    "disciple_usage": "Use for altar/home protection, local altar operations, communication from the local altar upward, and temporary containment during exorcism work.",
    "court_area": "Local altar / physical location",
    "palace_hall_department": "Landlord altar / local department",
    "prayer_item_ids": "landlord_deity_prayer",
    "fu_head_item_ids": "fh18_toe_dei_sun_ming_fu_head",
    "god_spell_item_ids": "god_spell_landlord",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "god_toe_dei",
    "anniv_source": "SLB GOD_ANNIVERSARY",
    "source_notes": "",
    "tags": "local gods|landlord deity|toe dei|tu di|altar protection|local altar",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_saam_ching_dragon",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "500",
    "name_en": "Saam Ching Dragon Guardian",
    "name_zh": "三清神龍護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Saam Ching animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "fh36_saam_ching_sun_lung_wu_faat_sun_fu_head",
    "god_spell_item_ids": "guardian_spell_saam_ching_dragon",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/tyd-guardian-saam-ching-dragon.webp",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_lui_lung_wu_faat_sun",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "510",
    "name_en": "Thunder Dragon Guardian",
    "name_zh": "雷龍護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "fh31_lui_lung_wu_faat_sun_fu_head",
    "god_spell_item_ids": "guardian_spell_thunder_dragon",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/tyd-guardian-thunder-dragon.webp",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_fung_fu_wu_faat_sun",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "520",
    "name_en": "Wind Tiger Guardian",
    "name_zh": "風虎護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "fh32_fung_fu_wu_faat_sun_fu_head",
    "god_spell_item_ids": "guardian_spell_wind_tiger",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/tyd-guardian-wind-tiger.webp",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_foh_fung_wu_faat_sun",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "530",
    "name_en": "Fire Phoenix Guardian",
    "name_zh": "火鳳護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "fh33_foh_fung_wu_faat_sun_fu_head",
    "god_spell_item_ids": "guardian_spell_fire_phoenix",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/tyd-guardian-fire-phoenix.webp",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_gwong_si_wu_faat_sun",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "540",
    "name_en": "Light Lion Guardian",
    "name_zh": "光獅護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "fh34_gwong_si_wu_faat_sun_fu_head",
    "god_spell_item_ids": "guardian_spell_light_lion",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/tyd-guardian-light-lion.webp",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_kei_lun_wu_faat_sun",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "550",
    "name_en": "K-Lun Guardian",
    "name_zh": "麒麟護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "fh35_kei_lun_wu_faat_sun_fu_head",
    "god_spell_item_ids": "guardian_spell_green_klun|guardian_spell_red_klun",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/tyd-guardian-green-k-lun.webp",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/tyd-guardian-red-k-lun.webp",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_toad_guardian",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "560",
    "name_en": "Toad Guardian",
    "name_zh": "靈蟾護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "",
    "god_spell_item_ids": "guardian_spell_toad_guardian",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_turtle_guardian",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "570",
    "name_en": "Turtle Guardian",
    "name_zh": "靈龜護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "",
    "god_spell_item_ids": "guardian_spell_turtle_guardian",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_nine_ox_guardian",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "580",
    "name_en": "Nine Ox Guardian",
    "name_zh": "九牛護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "",
    "god_spell_item_ids": "guardian_spell_nine_ox_guardian",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_shrimp_troop_crab_general",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "590",
    "name_en": "Shrimp Troop and Crab General",
    "name_zh": "蝦兵蟹將護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "",
    "god_spell_item_ids": "guardian_spell_shrimp_troop_crab_general",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_pi_yiou_leopard_dog_guardian",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "595",
    "name_en": "Pi Yiou Leopard Dog Guardian",
    "name_zh": "貔貅護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "",
    "god_spell_item_ids": "guardian_spell_pi_yiou_leopard_dog_guardian",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_celestial_cat_guardian",
    "directory": "Gods",
    "type": "Guardians",
    "display_order": "598",
    "name_en": "Celestial Cat Guardian",
    "name_zh": "神貓護法神",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Animal guardian.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "",
    "fu_head_item_ids": "",
    "god_spell_item_ids": "guardian_spell_celestial_cat_guardian",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_tin_yee_sin_si",
    "directory": "Gods",
    "type": "Others",
    "display_order": "610",
    "name_en": "Tin Yee Sin Si",
    "name_zh": "天醫仙師",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Celestial Medic deity who protects health and supports healing beyond ordinary methods.",
    "details_info": "Tin Yee Sin Si is the Celestial Medic Deity. In the lineage teaching, this god is like a divine physician who helps with sickness, disease threats, and unusual conditions that ordinary methods cannot fully explain.\n\nHis power is especially useful when the problem is linked to spiritual disturbance, harmful energies, or hard-to-understand health changes. He protects before danger arrives, supports recovery, and helps guide a troubled person back toward wellness.",
    "god_power": "Health protection, healing support, disease defense, spiritual disturbance correction, mental stability support, and recovery assistance.",
    "disciple_usage": "Use when praying for health protection, recovery support, spiritual sickness correction, or help during unusual health problems.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "celestial_medic_deity_prayer",
    "fu_head_item_ids": "fh28_tin_yee_sin_si_fu_head",
    "god_spell_item_ids": "god_spell_celestial_medic_deity",
    "scripture_book_ids": "",
    "scripture_item_ids": "celestial_medic_truth_scripture|celestial_medic_dragon_tiger_scripture|celestial_medic_inner_scripture|celestial_medic_five_elements_scripture|celestial_medic_five_poisons_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_tin_yee_sin_si_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_tin_yee_sin_si_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_tin_yee_sin_si",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Celestial Medic Deity article.",
    "tags": "others|art linked|tin yee sin si",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_taai_yuet_gau_fu_tin_juen",
    "directory": "Gods",
    "type": "Others",
    "display_order": "620",
    "name_en": "Taai Yuet Gau Fu Tin Juen",
    "name_zh": "太乙救苦天尊",
    "saamlawnese_name": "Taai Yuet Gau Fu Tin Juen",
    "aliases": "Lord of Salvation|God of Salvation",
    "short_summary": "Heavenly Lord of Salvation who saves and guides souls after death.",
    "details_info": "Taai Yuet Gau Fu Tin Juen is the Heavenly Lord of Salvation. This god works inside the Celestial Court and handles matters of the dead, especially helping disciples after death.\n\nHis role is to pull and guide the disciple's soul back into the lineage network if the disciple cannot reach the court by normal means. If the soul is too heavy, it can enter the Blood Lake Hell correction system, where the negative energy is cleaned and corrected so the soul can move upward again. This god is also connected to the universal salvation period around lunar July 14 to 16.",
    "god_power": "Soul salvation, after-death rescue, Blood Lake Hell correction, guiding souls to the court, mercy, and spiritual continuation.",
    "disciple_usage": "Use when studying after-death salvation, ghost rescue, Blood Lake Hell, and the path for disciples to return to the court after death.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "lord_of_salvation_prayer",
    "fu_head_item_ids": "fh49_god_of_salvation_fu_head",
    "god_spell_item_ids": "",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_taai_yuet_gau_fu_tin_juen_art.jpg?v=1782670305",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "god_taai_yuet_gau_fu_tin_juen",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Taai Yuet Gau Fu Tin Juen article.",
    "tags": "others|art linked|taai yuet gau fu tin juen",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_lui_sing_po_fa_tin_juen",
    "directory": "Gods",
    "type": "Others",
    "display_order": "630",
    "name_en": "Lui Sing Po Fa Tin Juen",
    "name_zh": "雷聲普化天尊",
    "saamlawnese_name": "Lui Sing Po Fa Tin Juen",
    "aliases": "Lui Sing Gau Fu Tin Juen|Lord of Thunder Salvation|God of Thunder Salvation",
    "short_summary": "Lord of Thunder Salvation who corrects lost souls and transforms evil through thunder power.",
    "details_info": "Lui Sing Po Fa Tin Juen is the Lord of Thunder Salvation. His thunder is not only for destruction; in the lineage teaching it is a force for strict correction and transformation.\n\nThis god helps pull lost souls back to the Tao, teaches unruly spirits, and uses the Blood Lake Hell correction system to neutralize and transform evil. In exorcism and evil-busting work, he helps capture harmful spirits into the court's correction system so they can be changed instead of only pushed away.",
    "god_power": "Thunder correction, ghost teaching, evil transformation, Blood Lake Hell work, exorcism support, and strong salvation power.",
    "disciple_usage": "Use when studying thunder salvation, ghost correction, evil-busting work, and transforming harmful spirits through the court system.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "lord_of_thunder_salvation_prayer",
    "fu_head_item_ids": "fh50_god_of_thunder_salvation_fu_head",
    "god_spell_item_ids": "",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_lui_sing_gau_fu_tin_juen_art.jpg?v=1782670305",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "god_lui_sing_po_fa_tin_juen",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Lord of Thunder Salvation article.",
    "tags": "others|art linked|lui sing gau fu tin juen",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_chat_sing_gim_sing",
    "directory": "Gods",
    "type": "Others",
    "display_order": "640",
    "name_en": "Chat Sing Gim Sing",
    "name_zh": "七星劍聖",
    "saamlawnese_name": "",
    "aliases": "Gim Sing",
    "short_summary": "Seven Star Sword Sage who protects victims from sorcery and dark attacks.",
    "details_info": "Chat Sing Gim Sing is the Seven Star Sword Sage. She is a war goddess in the lineage and her anniversary is on lunar January 7.\n\nHer role is to protect people who are under sorcery, dark magic, curses, or hidden attack. She can absorb part of the harm, turn it into counterattack power, and help expose or stop the force behind the attack. This makes her important when the enemy is hidden, when a victim feels powerless, or when the attack needs a fierce protective response.",
    "god_power": "Sorcery defense, curse reversal, warfare protection, counterattack power, hidden-enemy exposure, and victim protection.",
    "disciple_usage": "Use when studying protection against dark attacks, hidden sorcery, curse reversal, and war-goddess defense.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "seven_star_sword_sage_deity_prayer",
    "fu_head_item_ids": "fh20_chat_sing_gim_sing_fu_head",
    "god_spell_item_ids": "god_spell_seven_star_sword_sage_deity",
    "scripture_book_ids": "",
    "scripture_item_ids": "sword_sage_truth_scripture|seven_star_sword_sage_exorcism_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_chat_sing_gim_sing_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_chat_sing_gim_sing_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_chat_sing_gim_sing",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Seven Star Sword Sage article.",
    "tags": "others|art linked|chat sing gim sing",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_luk_sun_mo_sing",
    "directory": "Gods",
    "type": "Others",
    "display_order": "650",
    "name_en": "Luk Sun Mo Sing",
    "name_zh": "六神武聖",
    "saamlawnese_name": "",
    "aliases": "Mo Sing",
    "short_summary": "Martial Sage deity who empowers Taoist martial arts and magical weapon work.",
    "details_info": "Luk Sun Mo Sing is the Six Powers Martial Deity. He is the martial arts deity of the lineage and his anniversary is on lunar October 1.\n\nHis role is not ordinary fighting only. He supports Saam Law Taoist martial arts, protection, and battle against spiritual threats. He can empower magical weapons and help the disciple's heart and spiritual strength hold firm in battle. This makes him important for both physical discipline and magical combat.",
    "god_power": "Taoist martial arts, magical weapon empowerment, battle support, physical and spiritual protection, courage, and fighting strength.",
    "disciple_usage": "Use when studying martial arts, magical weapon work, protection in battle, and strengthening the heart for conflict.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "six_powers_martial_deity_prayer",
    "fu_head_item_ids": "fh27_luk_sun_mo_sing_fu_head",
    "god_spell_item_ids": "god_spell_six_powers_martial_deity",
    "scripture_book_ids": "",
    "scripture_item_ids": "martial_deity_truth_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_luk_sun_mo_sing_letter_name.jpg?v=1782670305",
    "gallery_image_urls": "https://cdn.shopify.com/s/files/1/1299/3411/files/god_atlas_luk_sun_mo_sing_letter.jpg?v=1782670305",
    "download_file_urls": "",
    "anniv_god_key": "god_luk_sun_mo_sing",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Six Powers Martial Deity article.",
    "tags": "others|art linked|luk sun mo sing",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_woh_sing_sun_juen",
    "directory": "Gods",
    "type": "Others",
    "display_order": "660",
    "name_en": "Woh Sing Sun Juen",
    "name_zh": "和聖神尊",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "God of war who protects through defense, timing, and battle control.",
    "details_info": "Woh Sing Sun Juen is the Woh Sing Deity, a god of war in the lineage. His anniversary is on lunar October 29 and he is connected with Tao-Gaming cultivation.\n\nThis god is especially useful when a disciple is not ready to fight immediately. His power can create a shield, delay the clash, control timing, and help the disciple prepare for a better counterattack. He is not only about attacking; he helps the disciple fight smarter, defend the altar and home, and hold the battle until the right time.",
    "god_power": "War protection, golden shield defense, timing control, delay and freeze support, altar protection, and battle preparation.",
    "disciple_usage": "Use when facing spiritual attack, competition, magical battle, or when more time and defense are needed before responding.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "woh_sing_deity_prayer",
    "fu_head_item_ids": "fh21_woh_sing_sun_juen_fu_head",
    "god_spell_item_ids": "god_spell_woh_sing_deity",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Woh Sing Deity article.",
    "tags": "",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_goon_yum_neung_neung",
    "directory": "Gods",
    "type": "Others",
    "display_order": "670",
    "name_en": "Goon Yum Neung Neung",
    "name_zh": "觀音娘娘",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Lineage Guan Yin Goddess who serves as a bridge of compassion and entry into Saam Law Tao connection.",
    "details_info": "Goon Yum Neung Neung is the Guan Yin Goddess used inside this lineage. Her anniversary is on lunar September 19. The blog makes clear that gods and deities are exclusive to the lineage and sect; even if the same name or statue appears elsewhere, the god behind it is not the same.\n\nIn Saam Law Tao, this Guan Yin serves as a gentle bridge for people who already respect her image and want to connect to the Tao. Her role is not to mix systems, but to open a path so believers can come closer, learn properly, and then understand the deeper Saam Law teaching.",
    "god_power": "Compassionate bridge, gentle entry, believer connection, healing support, acceptance, and path-opening toward Saam Law Tao.",
    "disciple_usage": "Use when someone needs a gentle entry point, compassionate support, and a bridge toward deeper lineage teaching.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "guan_yin_goddess_prayer",
    "fu_head_item_ids": "fh25_goon_yum_neung_neung_fu_head",
    "god_spell_item_ids": "god_spell_guan_yin_goddess",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Guan Yin Goddess article.",
    "tags": "",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_gau_tin_yuen_nui",
    "directory": "Gods",
    "type": "Others",
    "display_order": "680",
    "name_en": "Gau Tin Yuen Nui",
    "name_zh": "九天玄女",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Ninth Heaven Goddess who supports creation, exorcism, wisdom, and protection from Yiu/Gwaai evils.",
    "details_info": "Gau Tin Yuen Nui is the Jiu Tian Xuan Nu of this lineage. The blog introduces her as a goddess of creation and exorcism, with power for creativity, ideas, inspiration, and problem-solving.\n\nShe also protects against Yiu and Gwaai type evils, which can twist logic, create strange thoughts, and lead people into scams or traps. Her power helps the disciple think clearer, avoid harmful influence, pass through mental struggles, and repel harmful elements away from the heart.",
    "god_power": "Creation power, exorcism, smart ideas, inspiration, scam and trap avoidance, Yiu/Gwaai defense, and mental support.",
    "disciple_usage": "Use when needing creativity, clear thinking, protection from strange influence, or help against Yiu/Gwaai type evils.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "gau_tin_yuen_nui_prayer",
    "fu_head_item_ids": "fh26_gau_tin_yuen_nui_fu_head",
    "god_spell_item_ids": "god_spell_gau_tin_yuen_nui",
    "scripture_book_ids": "",
    "scripture_item_ids": "nine_sky_celestial_tower_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Jiu Tian Xuan Nu article.",
    "tags": "",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_baat_sin",
    "directory": "Gods",
    "type": "Others",
    "display_order": "690",
    "name_en": "Baat Sin",
    "name_zh": "八仙",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Eight Immortals who support altar work through eight tools and working functions.",
    "details_info": "Baat Sin are the Eight Immortals in this lineage. They are not only story figures; the blog explains that they are real deities of the Religious Court who can be summoned through the altar for magical work.\n\nEach immortal has a tool and a duty. Together they help open the altar, call powers down, move troops, gather resources, issue command, support the work, and make the altar more complete. This makes Baat Sin important for altar operation and balanced magical support.",
    "god_power": "Altar support, tool-based empowerment, invitation, troop mobilization, resource gathering, command power, and complete-cycle support.",
    "disciple_usage": "Use when studying Eight Immortals altar work, calling powers, moving troops, gathering support, and making altar work more complete.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "eight_immortals_prayers",
    "fu_head_item_ids": "fh41_baat_sin_fu_head",
    "god_spell_item_ids": "god_spell_eight_immortals_guardian",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Eight Immortals and Magical Tools article.",
    "tags": "",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_chai_tin_daai_sing",
    "directory": "Gods",
    "type": "Others",
    "display_order": "700",
    "name_en": "Chai Tin Daai Sing",
    "name_zh": "齊天大聖",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Monkey King God who protects against evil and fights through strong guardian power.",
    "details_info": "Chai Tin Daai Sing is the Monkey King God used in this lineage. His anniversary is on lunar July 25. He is a fighting guardian who protects against evils and supports magical battles.\n\nThe blog describes his strengths as loyalty, indestructibility, invincibility against evil magic, and the golden eyes that see through evil disguises. This makes him important when something is hiding its true face, when strong fighting support is needed, or when the disciple needs a guardian that will not back down.",
    "god_power": "Guardian fighting power, anti-evil protection, golden-eye detection, magical battle support, loyalty, and strong defense.",
    "disciple_usage": "Use when needing a fierce guardian, seeing through evil disguise, or support against spiritual attacks and magical battles.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "monkey_king_prayer",
    "fu_head_item_ids": "fh23_chai_tin_daai_sing_fu_head",
    "god_spell_item_ids": "god_spell_monkey_king_god",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Monkey King God article.",
    "tags": "",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_lung_sun_daai_dai",
    "directory": "Gods",
    "type": "Others",
    "display_order": "710",
    "name_en": "Lung Sun Daai Dai",
    "name_zh": "龍神大帝",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "God entry added from God Spell / Prayer / FU Head matching.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "dragon_god_emperor_prayer",
    "fu_head_item_ids": "fh19_lung_sun_daai_dai_fu_head",
    "god_spell_item_ids": "god_spell_dragon_god_emperor",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_bao_gung_daai_dai",
    "directory": "Gods",
    "type": "Others",
    "display_order": "720",
    "name_en": "Bao Gung Daai Dai",
    "name_zh": "包公大帝",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Judge Bao deity who enforces justice and corrects lawbreaking in the Tao system.",
    "details_info": "Bao Gung Daai Dai is the Judge Bao God of this lineage. His anniversary is on lunar February 15. He is a justice deity who reinforces the law of the Tao and corrects disorder.\n\nHis role is to judge and correct those who break the Tao's order, including humans, gods, or troops that have gone wrong. When an altar or spiritual system has become crooked, Judge Bao can help put the offenders to justice or correct them back to good order.",
    "god_power": "Justice enforcement, correction, judgment, fixing crooked altar powers, law restoration, and discipline.",
    "disciple_usage": "Use when studying justice, court correction, crooked altar powers, and fixing spiritual disorder.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "judge_bao_prayer",
    "fu_head_item_ids": "fh22_bao_gung_daai_dai_fu_head",
    "god_spell_item_ids": "god_spell_judge_bao_deity",
    "scripture_book_ids": "",
    "scripture_item_ids": "judge_bao_awareness_scripture",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Judge Bao God article.",
    "tags": "",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_ma_jo_neung_neung",
    "directory": "Gods",
    "type": "Others",
    "display_order": "730",
    "name_en": "Ma Jo Neung Neung",
    "name_zh": "媽祖娘娘",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "Mazu Goddess who supports intelligence, strategy, review, and internal containment.",
    "details_info": "Ma Jo Neung Neung is the Mazu Goddess used in this lineage. Her anniversary is on lunar March 23. The blog explains that the lineage god is exclusive to the sect even when the name or image is known outside.\n\nIn Saam Law Tao, Mazu helps with intelligence, processing, strategy, polishing, and review. She also helps contain energy inside the system so it does not leak out too early. This gives support for self-control, discipline, patience, and the ability to process pressure before acting.",
    "god_power": "Intelligence, strategy, review, internal containment, self-control, discipline, stress processing, and practical problem solving.",
    "disciple_usage": "Use when needing better thinking, review, strategy, containment, patience, or discipline before action.",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "ma_jo_goddess_prayer",
    "fu_head_item_ids": "fh24_ma_jo_neung_neung_fu_head",
    "god_spell_item_ids": "god_spell_ma_jo_emperess",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "SLB anniversary blog reference",
    "source_notes": "Tin Yat Dragon blog import: Mazu Goddess article.",
    "tags": "",
    "status": "approved_blog_import",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_jung_kwai_jo_si",
    "directory": "Gods",
    "type": "Others",
    "display_order": "740",
    "name_en": "Jung Kwai Jo Si",
    "name_zh": "鍾馗祖師",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "God entry added from God Spell / Prayer / FU Head matching.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "jong_kwai_jo_si_prayer",
    "fu_head_item_ids": "fh40_jung_kwai_jo_si_fu_head",
    "god_spell_item_ids": "god_spell_jong_kwai_jo_si",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_tin_moon_yuen_sui",
    "directory": "Gods",
    "type": "Others",
    "display_order": "750",
    "name_en": "Tin Moon Yuen Sui",
    "name_zh": "天門元帥",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "God entry added from God Spell / Prayer / FU Head matching.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "heaven_gate_marshall_prayer",
    "fu_head_item_ids": "fh38_tin_moon_yuen_sui_fu_head",
    "god_spell_item_ids": "god_spell_heaven_gate_marshal",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  },
  {
    "god_id": "god_jung_taan_yuen_sui",
    "directory": "Gods",
    "type": "Others",
    "display_order": "760",
    "name_en": "Jung Taan Yuen Sui",
    "name_zh": "中壇元帥",
    "saamlawnese_name": "",
    "aliases": "",
    "short_summary": "God entry added from God Spell / Prayer / FU Head matching.",
    "details_info": "",
    "god_power": "",
    "disciple_usage": "",
    "court_area": "",
    "palace_hall_department": "",
    "prayer_item_ids": "center_marshall_prayer",
    "fu_head_item_ids": "fh37_jung_taan_yuen_sui_fu_head",
    "god_spell_item_ids": "god_spell_central_marshal",
    "scripture_book_ids": "",
    "scripture_item_ids": "",
    "related_god_ids": "",
    "related_rc_ids": "",
    "primary_image_url": "",
    "gallery_image_urls": "",
    "download_file_urls": "",
    "anniv_god_key": "",
    "anniv_source": "",
    "source_notes": "",
    "tags": "",
    "status": "approved",
    "updated_at": "2026-06-28"
  }
];

    var GOD_ATLAS_DEFAULT_ENTRIES = GOD_ATLAS_ENTRIES.slice();

  /* God Atlas Phase 6 content import */
  function normalizeGodAtlasRows(rows){
    var seen = {};
    return (rows || []).map(function(r, idx){
      r = r || {};
      // Safety guard: if the optional God_Atlas tab is missing, Google may return the first tab.
      // Never accept normal library Items/Books/RC rows as gods.
      var id = godClean(r.god_id || r.id || '');
      if(!id) return null;
      if(r.item_id || r.book_id || r.rc_id) return null;
      var dir = godClean(r.directory || 'Gods');
      if(dir && !/^(gods|god atlas|god)$/i.test(dir)) return null;
      var status = godClean(r.status || 'approved');
      if(/^hide|hidden|archive|archived$/i.test(status)) return null;
      var type = godClean(r.type || 'Others');
      if(GOD_ATLAS_TYPES.indexOf(type) === -1) return null;
      var entry = {
        god_id:id,
        directory:'Gods',
        type:type,
        display_order:Number(r.display_order || r.order || (100000 + idx)) || (100000 + idx),
        name_en:godClean(r.name_en || r.title_en || r.english_name || r.title || id),
        name_zh:godClean(r.name_zh || r.title_zh || r.chinese_name || ''),
        saamlawnese_name:godClean(r.saamlawnese_name || r.saamlawnese || ''),
        aliases:godClean(r.aliases || ''),
        short_summary:godClean(r.short_summary || r.summary || ''),
        details_info:godClean(r.details_info || r.introduction || r.details || ''),
        god_power:godClean(r.god_power || r.power || ''),
        disciple_usage:godClean(r.disciple_usage || r.usage || ''),
        court_area:godClean(r.court_area || ''),
        palace_hall_department:godClean(r.palace_hall_department || r.department || ''),
        prayer_item_ids:godClean(r.prayer_item_ids || r.prayer_ids || ''),
        fu_head_item_ids:godClean(r.fu_head_item_ids || r.fu_head_ids || ''),
        god_spell_item_ids:godClean(r.god_spell_item_ids || r.spell_item_ids || r.god_spell_ids || ''),
        scripture_book_ids:godClean(r.scripture_book_ids || ''),
        scripture_item_ids:godClean(r.scripture_item_ids || ''),
        related_god_ids:godClean(r.related_god_ids || r.related_gods || ''),
        related_rc_ids:godClean(r.related_rc_ids || r.related_rc_entries || ''),
        primary_image_url:godClean(r.primary_image_url || r.image_url || ''),
        gallery_image_urls:godClean(r.gallery_image_urls || ''),
        download_file_urls:godClean(r.download_file_urls || r.download_urls || ''),
        anniv_god_key:godClean(r.anniv_god_key || r.anniversary_key || ''),
        anniv_source:godClean(r.anniv_source || ''),
        source_notes:godClean(r.source_notes || ''),
        tags:godClean(r.tags || ''),
        status:status,
        updated_at:godClean(r.updated_at || r.updatedAt || '')
      };
      if(seen[entry.god_id]) return null;
      seen[entry.god_id] = true;
      return entry;
    }).filter(Boolean).sort(function(a,b){
      return Number(a.display_order || 0) - Number(b.display_order || 0) || String(a.name_en || '').localeCompare(String(b.name_en || ''));
    });
  }
  function godFallbackEntryById(id){
    id = godClean(id || '');
    if(!id) return null;
    for(var i=0;i<GOD_ATLAS_DEFAULT_ENTRIES.length;i++){
      if(godClean(GOD_ATLAS_DEFAULT_ENTRIES[i].god_id) === id) return GOD_ATLAS_DEFAULT_ENTRIES[i];
    }
    return null;
  }
  function mergeGodFallbackArt(entries){
    return (entries || []).map(function(entry){
      if(!entry || !entry.god_id) return entry;
      var fallback = godFallbackEntryById(entry.god_id);
      if(!fallback) return entry;
      if(!entry.primary_image_url && fallback.primary_image_url) entry.primary_image_url = fallback.primary_image_url;
      if(!entry.gallery_image_urls && fallback.gallery_image_urls) entry.gallery_image_urls = fallback.gallery_image_urls;
      if(!entry.download_file_urls && fallback.download_file_urls) entry.download_file_urls = fallback.download_file_urls;
      return entry;
    });
  }
  function applyGodAtlasRows(rows){
    state.godAtlas = mergeGodFallbackArt(normalizeGodAtlasRows(rows || []));
    GOD_ATLAS_ENTRIES = state.godAtlas.length ? state.godAtlas.slice() : GOD_ATLAS_DEFAULT_ENTRIES.slice();
  }


  if(state.auditMode) root.classList.add('auditMode');
  var els = {
    status: document.getElementById('tydLibStatus'), search: document.getElementById('tydLibSearch'), type: document.getElementById('tydLibType'),
    category: document.getElementById('tydLibCategory'), directoryView: document.getElementById('tydLibDirectoryView'), dirSort: document.getElementById('tydLibDirSort'), mode: document.getElementById('tydLibMode'), reload: document.getElementById('tydLibReload'), resetCache: document.getElementById('tydLibResetCache'), addPrompt: document.getElementById('tydCopyAddBookPrompt'), addVideoCollection: document.getElementById('tydAddVideoCollection'), addFunCollection: document.getElementById('tydAddFunCollection'), addArticleCollection: document.getElementById('tydAddArticleCollection'), addSupplyCollection: document.getElementById('tydAddSupplyCollection'), adminTools: document.getElementById('tydAdminTools'),
    list: document.getElementById('tydLibList'), count: document.getElementById('tydLibCount'), reader: document.getElementById('tydLibReader'), readerMeta: document.getElementById('tydReaderMetaFooter'),
    expandAll: document.getElementById('tydExpandAll'), collapseAll: document.getElementById('tydCollapseAll'),
    themeToggle: document.getElementById('tydLibThemeToggle'), supercharge: document.getElementById('tydLibSupercharge'),
    downloadToggle: document.getElementById('tydDownloadsToggle'), downloadDrawer: document.getElementById('tydDownloadsDrawer'), downloadClose: document.getElementById('tydDownloadsClose'),
    superOverlay: document.getElementById('tydSuperchargeOverlay'), superClose: document.getElementById('tydSuperchargeClose'), superBar: document.getElementById('tydSuperchargeBar'), superStatus: document.getElementById('tydSuperchargeStatus'), superLog: document.getElementById('tydSuperchargeLog'),
    chantOverlay: document.getElementById('tydChantOverlay'), chantStage: document.getElementById('tydChantStage'), chantPageEl: document.getElementById('tydChantPage'),
    chantTopTitle: document.getElementById('tydChantTopTitle'), chantProgress: document.getElementById('tydChantProgress'), chantTheme: document.getElementById('tydChantThemeToggle'),
    articleFocusOverlay: document.getElementById('tydArticleFocusOverlay'), articleFocusScroller: document.getElementById('tydArticleFocusScroller'), articleFocusContent: document.getElementById('tydArticleFocusContent'), articleFocusTopTitle: document.getElementById('tydArticleFocusTopTitle'), articleFocusTheme: document.getElementById('tydArticleFocusThemeToggle'), articleFocusFont: document.getElementById('tydArticleFocusFontToggle'), articleFocusProgress: document.getElementById('tydArticleFocusProgress'),
    mobileDrawerOpen: document.getElementById('tydMobileDrawerOpen'), mobileDrawerClose: document.getElementById('tydMobileDrawerClose'), mobileDrawerBackdrop: document.getElementById('tydMobileDrawerBackdrop'),
    builderOpen: document.getElementById('tydBuilderOpen'), builderPanel: document.getElementById('tydBookBuilder'), builderBackdrop: document.getElementById('tydBuilderBackdrop'), builderClose: document.getElementById('tydBuilderClose'),
    builderTitle: document.getElementById('tydBuilderTitleInput'), builderDesc: document.getElementById('tydBuilderDescInput'), builderVersionMode: document.getElementById('tydBuilderVersionMode'), builderDefaultMode: document.getElementById('tydBuilderDefaultMode'),
    builderBookSelect: document.getElementById('tydBuilderBookSelect'), builderNew: document.getElementById('tydBuilderNew'), builderSave: document.getElementById('tydBuilderSave'), builderSaveAs: document.getElementById('tydBuilderSaveAs'), builderRename: document.getElementById('tydBuilderRename'), builderDeleteBook: document.getElementById('tydBuilderDeleteBook'), builderExportAll: document.getElementById('tydBuilderExportAll'), builderTemplateSelect: document.getElementById('tydBuilderTemplateSelect'), builderLoadTemplate: document.getElementById('tydBuilderLoadTemplate'), builderAdminBlock: document.getElementById('tydBuilderAdminTemplateBlock'), builderTemplateId: document.getElementById('tydBuilderTemplateId'), builderCopyTemplatePrompt: document.getElementById('tydBuilderCopyTemplatePrompt'), builderDownloadTemplatePatch: document.getElementById('tydBuilderDownloadTemplatePatch'), builderUpdateBlock: document.getElementById('tydBuilderUpdateBlock'), builderUpdateStatus: document.getElementById('tydBuilderUpdateStatus'), builderCheckUpdates: document.getElementById('tydBuilderCheckUpdates'), builderApplyUpdates: document.getElementById('tydBuilderApplyUpdates'), builderPreview: document.getElementById('tydBuilderPreview'), builderAddCustom: document.getElementById('tydBuilderAddCustom'), builderAddCover: document.getElementById('tydBuilderAddCover'), builderAddDivider: document.getElementById('tydBuilderAddDivider'), builderAddToc: document.getElementById('tydBuilderAddToc'), builderBreakAll: document.getElementById('tydBuilderBreakAll'), builderClearBreaks: document.getElementById('tydBuilderClearBreaks'), builderLayoutPreset: document.getElementById('tydBuilderLayoutPreset'), builderClear: document.getElementById('tydBuilderClear'), builderExport: document.getElementById('tydBuilderExport'), builderImportBtn: document.getElementById('tydBuilderImportBtn'), builderImportFile: document.getElementById('tydBuilderImportFile'), builderDownloadHtml: document.getElementById('tydBuilderDownloadHtml'), builderList: document.getElementById('tydBuilderList'), builderCount: document.getElementById('tydBuilderCount')
  };

  function readStoredTheme(){
    try{
      var saved = localStorage.getItem('tydLineageLibraryTheme');
      if(saved === 'dark' || saved === 'light') return saved;
    }catch(e){}
    return 'light';
  }
  function saveStoredTheme(theme){
    try{ localStorage.setItem('tydLineageLibraryTheme', theme); }catch(e){}
  }
  function applyTydTheme(theme, save){
    theme = theme === 'dark' ? 'dark' : 'light';
    state.theme = theme;
    root.setAttribute('data-tyd-theme', theme);
    if(els.themeToggle){
      els.themeToggle.textContent = theme === 'dark' ? '☀' : '☾';
      els.themeToggle.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
      els.themeToggle.setAttribute('title', theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
      els.themeToggle.setAttribute('aria-label', theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
    }
    if(save) saveStoredTheme(theme);
  }
  applyTydTheme(readStoredTheme(), false);
  if(els.adminTools){
    els.adminTools.hidden = true;
  }

  var CHANT_THEME_ORDER = ['light','dark','warm','paper'];
  var CHANT_THEME_META = {
    light:{icon:'☀', label:'Light'},
    dark:{icon:'☾', label:'Dark'},
    warm:{icon:'◐', label:'Warm'},
    paper:{icon:'📜', label:'Ancient Paper'}
  };
  function readStoredChantTheme(){
    try{
      var saved = localStorage.getItem('tydLineageLibraryChantTheme');
      if(CHANT_THEME_ORDER.indexOf(saved) !== -1) return saved;
    }catch(e){}
    return state.theme === 'dark' ? 'dark' : 'warm';
  }
  function saveStoredChantTheme(theme){
    try{ localStorage.setItem('tydLineageLibraryChantTheme', theme); }catch(e){}
  }
  function applyChantTheme(theme, save){
    if(CHANT_THEME_ORDER.indexOf(theme) === -1) theme = 'warm';
    state.chantTheme = theme;
    if(els.chantOverlay) els.chantOverlay.setAttribute('data-chant-theme', theme);
    if(els.articleFocusOverlay) els.articleFocusOverlay.setAttribute('data-chant-theme', theme);
    var meta = CHANT_THEME_META[theme] || CHANT_THEME_META.warm;
    if(els.chantTheme){
      els.chantTheme.textContent = meta.icon;
      els.chantTheme.setAttribute('title', 'Chant theme: ' + meta.label + ' — tap to change');
      els.chantTheme.setAttribute('aria-label', 'Chant theme: ' + meta.label + '. Tap to change theme.');
    }
    if(els.articleFocusTheme){
      els.articleFocusTheme.textContent = meta.icon;
      els.articleFocusTheme.setAttribute('title', 'Reading background: ' + meta.label + ' — tap to change');
      els.articleFocusTheme.setAttribute('aria-label', 'Reading background: ' + meta.label + '. Tap to change background.');
    }
    if(save) saveStoredChantTheme(theme);
  }
  function cycleChantTheme(){
    var idx = CHANT_THEME_ORDER.indexOf(state.chantTheme);
    var next = CHANT_THEME_ORDER[(idx + 1) % CHANT_THEME_ORDER.length] || 'warm';
    applyChantTheme(next, true);
  }
  applyChantTheme(readStoredChantTheme(), false);

  function readStoredChantScale(){
    try{
      var n = Number(localStorage.getItem('tydLineageLibraryChantScale') || '1');
      if(isFinite(n) && n >= .55 && n <= 1.35) return n;
    }catch(e){}
    return .82;
  }
  function saveStoredChantScale(v){ try{ localStorage.setItem('tydLineageLibraryChantScale', String(v)); }catch(e){} }
  function setChantScale(v, save){
    v = Math.max(.55, Math.min(1.35, Number(v) || .82));
    state.chantScale = Math.round(v * 100) / 100;
    if(els.chantOverlay) els.chantOverlay.style.setProperty('--tyd-chant-scale', state.chantScale);
    if(els.articleFocusOverlay) els.articleFocusOverlay.style.setProperty('--tyd-chant-scale', state.chantScale);
    if(save) saveStoredChantScale(state.chantScale);
  }
  setChantScale(readStoredChantScale(), false);

  var ARTICLE_FOCUS_FONT_ORDER = ['sans','serif','book'];
  var ARTICLE_FOCUS_FONT_META = {
    sans:{label:'Clean Sans', icon:'Aa'},
    serif:{label:'Classic Serif', icon:'Aa'},
    book:{label:'Book Reading', icon:'Aa'}
  };
  function readStoredArticleFocusFont(){
    try{ var saved=localStorage.getItem('tydLineageLibraryArticleFocusFont'); if(ARTICLE_FOCUS_FONT_ORDER.indexOf(saved)!==-1) return saved; }catch(_e){}
    return 'sans';
  }
  function saveStoredArticleFocusFont(font){ try{ localStorage.setItem('tydLineageLibraryArticleFocusFont',font); }catch(_e){} }
  function applyArticleFocusFont(font, save){
    if(ARTICLE_FOCUS_FONT_ORDER.indexOf(font)===-1) font='sans';
    state.articleFocusFont=font;
    if(els.articleFocusOverlay) els.articleFocusOverlay.setAttribute('data-article-font',font);
    var meta=ARTICLE_FOCUS_FONT_META[font]||ARTICLE_FOCUS_FONT_META.sans;
    if(els.articleFocusFont){
      els.articleFocusFont.textContent=meta.icon;
      els.articleFocusFont.setAttribute('title','Article font: '+meta.label+' — tap to change');
      els.articleFocusFont.setAttribute('aria-label','Article font: '+meta.label+'. Tap to change font style.');
    }
    if(save) saveStoredArticleFocusFont(font);
  }
  function cycleArticleFocusFont(){
    var idx=ARTICLE_FOCUS_FONT_ORDER.indexOf(state.articleFocusFont||'sans');
    applyArticleFocusFont(ARTICLE_FOCUS_FONT_ORDER[(idx+1)%ARTICLE_FOCUS_FONT_ORDER.length]||'sans',true);
  }
  applyArticleFocusFont(readStoredArticleFocusFont(), false);

  function setStatus(txt, cls){
    if(!els.status) return;
    txt = txt || '';
    cls = cls || '';
    var lower = String(txt).toLowerCase();
    var busy = cls === 'loading' || /loading|opening|checking|updating|refreshing|preparing|saving|running|sync|quietly/.test(lower);
    if(cls === 'ok' || cls === 'bad') busy = false;
    var className = 'tydLib__status tydLib__heroSync' + (cls ? ' '+cls : '');
    if(busy && className.indexOf(' loading') === -1) className += ' loading';
    els.status.className = className;
    els.status.innerHTML = '<span class="tydLib__syncPulse" aria-hidden="true"></span><span class="tydLib__syncText">'+escapeHtml(txt)+'</span>';
    root.classList.toggle('tydLib--syncBusy', !!busy);
  }

  function libraryLoadingHtml(kind, title, subtitle){
    title = title || 'Loading library';
    subtitle = subtitle || 'Opening the saved library snapshot in this browser.';
    var lines = kind === 'list' ? 7 : 5;
    var out = [];
    out.push('<div class="tydLib__cacheLoader '+escapeHtml(kind || 'reader')+'" aria-live="polite" aria-label="'+escapeHtml(title)+'">');
    out.push('<div class="tydLib__cacheLoaderCard">');
    out.push('<div class="tydLib__cacheLoaderTop"><span class="tydLib__cacheLoaderDot"></span><div><div class="tydLib__cacheLoaderTitle">'+escapeHtml(title)+'</div><div class="tydLib__cacheLoaderSub">'+escapeHtml(subtitle)+'</div></div></div>');
    out.push('<div class="tydLib__cacheLoaderBar"><span></span></div>');
    for(var i=0;i<lines;i++){
      out.push('<div class="tydLib__cacheLoaderLine w'+((i % 4)+1)+'"></div>');
    }
    out.push('</div></div>');
    return out.join('');
  }

  function showLibraryLoading(title, subtitle){
    root.classList.add('tydLib--cacheLoading');
    if(state.quickShelfFirstPaint && isQuickShelfDirectory()){
      root.classList.add('tydLib--quickShelfBackgroundLoad');
      setStatus('Quick Shelf ready — full library is loading in the background.', 'ok');
      return;
    }
    setStatus(title || 'Loading library...', 'loading');
    if(els.count) els.count.textContent = 'Loading...';
    if(els.readerMeta) els.readerMeta.hidden = true;
    if(els.list) els.list.innerHTML = libraryLoadingHtml('list', title || 'Loading directory', subtitle || 'Opening snapshot and preparing the directory.');
    if(els.reader) els.reader.innerHTML = libraryLoadingHtml('reader', title || 'Loading library', subtitle || 'Opening snapshot and preparing the reader.');
  }

  function clearLibraryLoading(){
    root.classList.remove('tydLib--cacheLoading');
    root.classList.remove('tydLib--quickShelfBackgroundLoad');
  }
  var AUTH_KEY = 'ty_auth_v1';
  var authEls = {
    overlay: document.getElementById('tydAuthOverlay'),
    msg: document.getElementById('tydAuthMsg'),
    callsign: document.getElementById('tydAuthCallsign'),
    pin: document.getElementById('tydAuthPin'),
    login: document.getElementById('tydAuthLoginBtn')
  };

  function setAuthMsg(txt, bad){
    if(!authEls.msg) return;
    authEls.msg.textContent = txt || '';
    authEls.msg.classList.toggle('bad', !!bad);
  }
  function resolveWebappUrl(){
    try{ if(window.SLB_WEBAPP_URL && String(window.SLB_WEBAPP_URL).trim()) return String(window.SLB_WEBAPP_URL).trim(); }catch(e){}
    try{ var v = localStorage.getItem('slb_webapp_url'); if(v && String(v).trim()) return String(v).trim(); }catch(e2){}
    try{
      var u = new URL(location.href);
      var q = u.searchParams.get('slb_backend') || u.searchParams.get('backend');
      if(q && String(q).trim()){
        try{ localStorage.setItem('slb_webapp_url', String(q).trim()); }catch(e3){}
        return String(q).trim();
      }
    }catch(e4){}
    return 'https://script.google.com/macros/s/AKfycbwFTGsr-IfaETXvCC4IfTSHTJ3ESkNn46797KvI-hp-n2OIDhlnR7104sfZpheu0YzXCA/exec';
  }
  var WEBAPP_URL = resolveWebappUrl();

  function slbApiJsonp(payload){
    if(!window.SLBPostBridge || typeof window.SLBPostBridge.call !== 'function'){
      return Promise.reject(new Error('Secure SLB transport did not load. Hard refresh and try again.'));
    }
    payload = payload || {};
    if(!payload.requestId) payload.requestId = 'tyd5_' + Date.now() + '_' + Math.floor(Math.random()*1e9);
    return window.SLBPostBridge.call(WEBAPP_URL, payload, {
      timeoutMs: 70000,
      action: String(payload.action || '')
    });
  }
  function slbApi(action, args, token, opts){
    var suppliedToken=String(token||''), rpcOpts=Object.assign({timeoutMs:70000,progressMode:'silent'},opts||{});
    // V4.7: when Lineage Library is hosted inside the same authenticated SLB
    // session, reuse the central RPC owner. Keep the direct secure bridge for
    // standalone Library login/session operation where its token is independent.
    try{
      var sharedToken=(window.SLB_SESSION&&window.SLB_SESSION.get)?String(window.SLB_SESSION.get('token')||''):'';
      var app=window.SLB_APP||null;
      var fn=app&&(typeof app.__realRpc==='function'?app.__realRpc:(typeof app.rpc==='function'?app.rpc:null));
      if(fn && suppliedToken && sharedToken && suppliedToken===sharedToken){
        return Promise.resolve(fn.call(app, action, args||{}, rpcOpts));
      }
    }catch(_eShared){}
    return slbApiJsonp({ requestId:'tyd' + Date.now() + '_' + Math.floor(Math.random()*1e9), action:action, token:suppliedToken, args:args || {} });
  }

  function collectionApiData_(res){
    if(!res) return {};
    if(res.data && typeof res.data === 'object') return res.data;
    if(res.result && typeof res.result === 'object') return res.result;
    return res;
  }
  function collectionNormalize_(r){
    r=r||{};
    var links=r.links, blocks=r.content_blocks;
    if(typeof links==='string'){ try{ links=JSON.parse(links); }catch(_e){ links=[]; } }
    if(typeof blocks==='string'){ try{ blocks=JSON.parse(blocks); }catch(_e2){ blocks=[]; } }
    if(!Array.isArray(links)) links=[]; if(!Array.isArray(blocks)) blocks=[];
    return {
      collection_id:String(r.collection_id||''), kind:(function(k){k=String(k||'').toLowerCase();return k==='video'?'video':(k==='fun'?'fun':(k==='article'?'article':'supply'));})(r.kind),
      date:String(r.date||''), title:String(r.title||''), article_type:String(r.article_type||'Core Concepts'), category:String(r.category||''), description:String(r.description||''),
      content_blocks:blocks.map(function(x){x=x||{};return {type:String(x.type||'text').toLowerCase(),text:String(x.text||''),url:String(x.url||''),caption:String(x.caption||''),alt:String(x.alt||'')};}).filter(function(x){return (x.type==='text'||x.type==='heading')?!!x.text:((x.type==='image'||x.type==='video')&&!!x.url);}),
      links:links.map(function(x){ if(typeof x==='string') return {label:'',url:x}; return {label:String((x||{}).label||''),url:String((x||{}).url||'')}; }).filter(function(x){return !!x.url;}),
      display_order:Number(r.display_order||0)||0, access_scope:(function(v){v=String(v||'daily').toLowerCase();return v==='full'?'full':(v==='bcm'?'bcm':'daily');})(r.access_scope),
      status:String(r.status||'active').toLowerCase()==='hidden'?'hidden':'active', created_at:String(r.created_at||''), updated_at:String(r.updated_at||''), updated_by:String(r.updated_by||'')
    };
  }
  function collectionSelectionId_(id){ return 'col:' + String(id||''); }
  function collectionIdFromSelection_(id){ id=String(id||''); return id.indexOf('col:')===0 ? id.slice(4) : ''; }
  function collectionBySelection_(id){
    var cid=collectionIdFromSelection_(id);
    if(!cid) return null;
    for(var i=0;i<state.collections.length;i++) if(String(state.collections[i].collection_id||'')===cid) return state.collections[i];
    return null;
  }
  function isCollectionSelection_(id){ return !!collectionBySelection_(id); }
  function collectionVideoCategory_(r){
    r=r||{};
    var type=String(r.title||'').trim().toUpperCase(), category=String(r.category||'').trim(), year=String(r.date||'').slice(0,4);
    // ACM is always organized by year. Ignore stray legacy category labels.
    if(type==='ACM') return year||'Other';
    // BCM is organized by topic/series instead of date. Legacy year-only BCM rows
    // fall back to CHI KUNG until an admin assigns a BCM topic explicitly.
    if(type==='BCM'){
      if(!category || /^\d{4}$/.test(category)) return 'CHI KUNG';
      if(category.toUpperCase()==='CHI KUNG') return 'CHI KUNG';
      if(category.toUpperCase()==='KAD') return 'KAD';
      return category;
    }
    return category||year||'Other';
  }
  function collectionVideoGroup_(r){ return collectionVideoCategory_(r); }
  function collectionVisibleRows_(){
    var kind=isVideoDirectory()?'video':(isFunWatchDirectory()?'fun':(isArticleDirectory()?'article':'supply')), q=norm(state.query), typ=String(state.type||''), cat=String(state.category||'');
    return state.collections.filter(function(r){
      if(r.kind!==kind) return false;
      if(!state.isAdmin && r.status==='hidden') return false;
      if(r.access_scope==='bcm' && !state.bcmAccess) return false;
      if(!state.isAdmin && r.access_scope==='full' && state.acgAccess!=='full') return false;
      if(kind==='video' && typ && String(r.title||'')!==typ) return false;
      if(kind==='article' && typ && String(r.article_type||'')!==typ) return false;
      if(cat && String(kind==='video'?collectionVideoGroup_(r):(r.category||''))!==cat) return false;
      if(q){
        var text=[r.date,r.title,r.article_type,r.category,r.description].concat((r.links||[]).map(function(x){return (x.label||'')+' '+(x.url||'');})).concat((r.content_blocks||[]).map(function(x){return (x.text||'')+' '+(x.caption||'')+' '+(x.url||'');})).join(' ').toLowerCase();
        if(text.indexOf(q)===-1) return false;
      }
      return true;
    }).sort(function(a,b){
      if(kind==='video'){ var ab=a.access_scope==='bcm'?0:1, bb=b.access_scope==='bcm'?0:1; return ab-bb || String(b.date||'').localeCompare(String(a.date||'')) || Number(a.display_order||0)-Number(b.display_order||0) || String(a.title||'').localeCompare(String(b.title||'')); }
      if(kind==='article'){ var ar={'Core Concepts':0,'Mindsets':1,'Applications':2}, aa=ar[a.article_type]!=null?ar[a.article_type]:99, bb=ar[b.article_type]!=null?ar[b.article_type]:99; return aa-bb || Number(a.display_order||0)-Number(b.display_order||0) || String(b.date||'').localeCompare(String(a.date||'')) || String(a.title||'').localeCompare(String(b.title||'')); }
      return Number(a.display_order||0)-Number(b.display_order||0) || String(a.category||'').localeCompare(String(b.category||'')) || String(a.title||'').localeCompare(String(b.title||''));
    });
  }
  function collectionDateLabel_(v){
    v=String(v||'').trim(); if(!v) return 'No date';
    try{ var d=new Date(v.length<=10?v+'T12:00:00':v); if(!isNaN(d.getTime())) return d.toLocaleDateString(undefined,{year:'numeric',month:'short',day:'numeric'}); }catch(_e){}
    return v;
  }
  function renderCollectionDirectory_(){
    var rows=collectionVisibleRows_(), html='', lastGroup='';
    state._lastDirectoryCount=rows.length;
    if(!state.collectionsLoaded && state.collectionsLoading) return '<div class="tydLib__empty"><p>Loading '+(isVideoDirectory()?'teaching videos':(isFunWatchDirectory()?'Fun Watch':(isArticleDirectory()?'articles':'supplies')))+'...</p></div>';
    rows.forEach(function(r){
      var group=isVideoDirectory()?collectionVideoGroup_(r):(isArticleDirectory()?(r.article_type||'Core Concepts'):(r.category||'Others'));
      if(group!==lastGroup){ html+='<div class="tydLib__collectionGroupTitle">'+escapeHtml(group||'Other')+'</div>'; lastGroup=group; }
      var sid=collectionSelectionId_(r.collection_id), active=sid===state.selectedId;
      var ancientKad=isVideoDirectory() && !String(r.date||'').trim() && String(r.title||'').trim()==='Ancient KAD' && String(r.description||'').trim();
      var main=isVideoDirectory()?(ancientKad?String(r.description||'').trim():collectionDateLabel_(r.date)):(r.title||(isFunWatchDirectory()?'Fun Watch':(isArticleDirectory()?'Article':'Supply item')));
      var sub=isVideoDirectory()?(r.title||'Teaching video'):(isFunWatchDirectory()?(r.category||'Fun Watch'):(isArticleDirectory()?((r.category||'All')+(r.date?' · '+collectionDateLabel_(r.date):'')):(r.category||'Supply')));
      html+='<div class="tydLib__itemRow tydLib__collectionRow"><button type="button" class="tydLib__item tydLib__collectionItem '+(active?'active':'')+'" data-id="'+escapeHtml(sid)+'">'+
        '<div class="tydLib__itemEn">'+escapeHtml(main)+'</div><div class="tydLib__collectionSub">'+escapeHtml(sub)+'</div>'+
        (state.isAdmin && r.status==='hidden'?'<div class="tydLib__collectionHidden">Hidden</div>':'')+'</button></div>';
    });
    return html;
  }
  function youtubeVideoId_(url){
    try{
      var u=new URL(String(url||'')), host=u.hostname.toLowerCase().replace(/^www\./,'');
      if(host==='youtu.be') return (u.pathname.split('/').filter(Boolean)[0]||'').replace(/[^A-Za-z0-9_-]/g,'');
      if(host==='youtube.com' || host==='m.youtube.com' || host==='youtube-nocookie.com'){
        var v=u.searchParams.get('v'); if(v) return v.replace(/[^A-Za-z0-9_-]/g,'');
        var parts=u.pathname.split('/').filter(Boolean); if(parts.length>1 && ['embed','shorts','live'].indexOf(parts[0])!==-1) return String(parts[1]||'').replace(/[^A-Za-z0-9_-]/g,'');
      }
    }catch(_e){}
    return '';
  }
  function vimeoVideoId_(url){
    try{ var u=new URL(String(url||'')), host=u.hostname.toLowerCase().replace(/^www\./,''); if(host==='vimeo.com' || host==='player.vimeo.com'){ var parts=u.pathname.split('/').filter(Boolean); for(var i=parts.length-1;i>=0;i--) if(/^\d+$/.test(parts[i])) return parts[i]; } }catch(_e){} return '';
  }
  function articleBlockHtml_(block){
    block=block||{}; var type=String(block.type||'text').toLowerCase();
    if(type==='heading') return '<h2 class="tydLib__articleHeading">'+escapeHtml(block.text||'')+'</h2>';
    if(type==='image') return '<figure class="tydLib__articleMedia"><img src="'+escapeHtml(block.url||'')+'" alt="'+escapeHtml(block.alt||block.caption||'')+'" loading="lazy" decoding="async">'+(block.caption?'<figcaption>'+escapeHtml(block.caption)+'</figcaption>':'')+'</figure>';
    if(type==='video'){
      var vid=youtubeVideoId_(block.url), vim=vimeoVideoId_(block.url);
      if(vid) return '<figure class="tydLib__articleMedia tydLib__articleVideo"><div class="tydLib__videoFrame"><iframe src="https://www.youtube-nocookie.com/embed/'+escapeHtml(vid)+'" title="'+escapeHtml(block.caption||'Teaching video')+'" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>'+(block.caption?'<figcaption>'+escapeHtml(block.caption)+'</figcaption>':'')+'</figure>';
      if(vim) return '<figure class="tydLib__articleMedia tydLib__articleVideo"><div class="tydLib__videoFrame"><iframe src="https://player.vimeo.com/video/'+escapeHtml(vim)+'" title="'+escapeHtml(block.caption||'Teaching video')+'" loading="lazy" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>'+(block.caption?'<figcaption>'+escapeHtml(block.caption)+'</figcaption>':'')+'</figure>';
      if(/\.(?:mp4|webm|ogg)(?:[?#].*)?$/i.test(String(block.url||''))) return '<figure class="tydLib__articleMedia tydLib__articleVideo"><video controls preload="metadata" src="'+escapeHtml(block.url||'')+'"></video>'+(block.caption?'<figcaption>'+escapeHtml(block.caption)+'</figcaption>':'')+'</figure>';
      return '<div class="tydLib__articleVideoLink">'+(block.caption?'<div>'+escapeHtml(block.caption)+'</div>':'')+'<a class="tydLib__btn" href="'+escapeHtml(block.url||'')+'" target="_blank" rel="noopener noreferrer">Open video ↗</a></div>';
    }
    var text=escapeHtml(block.text||'').replace(/\n/g,'<br>');
    return text?'<p class="tydLib__articleParagraph">'+text+'</p>':'';
  }
  function renderArticleBody_(r){
    return '<div class="tydLib__articleBody">'+(r.content_blocks||[]).map(articleBlockHtml_).join('')+'</div>';
  }
  function articleFocusSubtitle_(r){
    return (r.article_type||'Core Concepts')+' · '+(r.category||'All')+(r.date?' · '+collectionDateLabel_(r.date):'');
  }
  function updateArticleFocusProgress_(){
    if(!els.articleFocusScroller || !els.articleFocusProgress) return;
    var max=Math.max(0,els.articleFocusScroller.scrollHeight-els.articleFocusScroller.clientHeight);
    var pct=max?Math.max(0,Math.min(100,Math.round((els.articleFocusScroller.scrollTop/max)*100))):100;
    els.articleFocusProgress.style.width=pct+'%';
    els.articleFocusProgress.parentNode && els.articleFocusProgress.parentNode.setAttribute('aria-valuenow',String(pct));
  }
  async function openArticleFocus_(entry){
    entry=entry||collectionBySelection_(state.selectedId);
    if(!entry || entry.kind!=='article'){ setStatus('Select an article first.','bad'); return; }
    if(!(entry.content_blocks&&entry.content_blocks.length)){
      setStatus('Opening article from the local cache...','loading');
      await ensureArticleBody_(entry);
    }
    if(!(entry.content_blocks&&entry.content_blocks.length)){ setStatus('Article body is not available yet.','bad'); return; }
    var title=entry.title||'Article', subtitle=articleFocusSubtitle_(entry);
    var intro=entry.description?'<p class="tydLib__articleFocusIntro">'+escapeHtml(entry.description)+'</p>':'';
    if(els.articleFocusTopTitle) els.articleFocusTopTitle.textContent=title;
    if(els.articleFocusContent){
      els.articleFocusContent.innerHTML='<header class="tydLib__articleFocusHeader"><div class="tydLib__articleFocusKicker">'+escapeHtml(subtitle)+'</div><h1>'+escapeHtml(title)+'</h1>'+intro+'</header><div class="tydLib__articleFocusBody">'+(entry.content_blocks||[]).map(articleBlockHtml_).join('')+'</div><div class="tydLib__articleFocusEnd">End of article</div>';
    }
    state.articleFocusActive=true;
    root.classList.add('articleFocusActive');
    document.documentElement.classList.add('tydLibNoScroll'); if(document.body) document.body.classList.add('tydLibNoScroll');
    applyChantTheme(state.chantTheme||readStoredChantTheme(),false); setChantScale(state.chantScale||readStoredChantScale(),false); applyArticleFocusFont(state.articleFocusFont||readStoredArticleFocusFont(),false);
    if(els.articleFocusOverlay){ els.articleFocusOverlay.hidden=false; els.articleFocusOverlay.setAttribute('aria-hidden','false'); }
    if(els.articleFocusScroller) els.articleFocusScroller.scrollTop=0;
    updateArticleFocusProgress_();
    setStatus('Focus Read opened.','ok');
  }
  function closeArticleFocus_(){
    state.articleFocusActive=false; root.classList.remove('articleFocusActive');
    document.documentElement.classList.remove('tydLibNoScroll'); if(document.body) document.body.classList.remove('tydLibNoScroll');
    if(els.articleFocusOverlay){ els.articleFocusOverlay.hidden=true; els.articleFocusOverlay.setAttribute('aria-hidden','true'); }
  }
  function collectionAdminButtons_(r){
    if(!state.isAdmin || !r) return '';
    return '<div class="tydLib__collectionAdminBtns"><button type="button" class="tydLib__btn secondary" data-collection-edit="'+escapeHtml(r.collection_id)+'">Edit</button><button type="button" class="tydLib__btn secondary" data-collection-delete="'+escapeHtml(r.collection_id)+'">Delete</button></div>';
  }
  function renderCollectionReader_(r){
    ++state._readerRenderToken; root.classList.remove('tydLib--readerRendering');
    if(!r){
      var what=isVideoDirectory()?'teaching video':(isFunWatchDirectory()?'Fun Watch entry':(isArticleDirectory()?'article':'supply item'));
      els.reader.innerHTML='<div class="tydLib__empty"><h2>Select a '+what+'</h2><p>Choose an entry from the directory.</p></div>'; setReaderMeta(''); return;
    }
    var ancientKad=r.kind==='video' && !String(r.date||'').trim() && String(r.title||'').trim()==='Ancient KAD' && String(r.description||'').trim();
    var readerTitle=ancientKad?String(r.description||'').trim():(r.title||'');
    var readerSub=ancientKad?'Ancient KAD':(r.kind==='video'?collectionDateLabel_(r.date):(r.kind==='fun'?(r.category||'Fun Watch'):(r.kind==='article'?((r.article_type||'Core Concepts')+' · '+(r.category||'All')+(r.date?' · '+collectionDateLabel_(r.date):'')):(r.category||'Supplies'))));
    var articleFocusBtn=r.kind==='article'?'<button type="button" class="tydLib__btn secondary tydLib__articleFocusBtn" data-article-focus="'+escapeHtml(r.collection_id)+'" aria-label="Open immersive Focus Read" title="Focus Read">👁 Focus Read</button>':'';
    var top='<div class="tydLib__readerTop"><div><div class="tydLib__titleEn tydLib__titleSolo">'+escapeHtml(readerTitle)+'</div>'+
      '<div class="tydLib__collectionDate">'+escapeHtml(readerSub)+'</div></div><div class="tydLib__collectionReaderActions">'+articleFocusBtn+collectionAdminButtons_(r)+'</div></div>';
    var desc=(!ancientKad && r.description)?'<div class="tydLib__collectionDescription">'+escapeHtml(r.description)+'</div>':'';
    var body='';
    if(r.kind==='article'){
      if(!(r.content_blocks&&r.content_blocks.length)){ ensureArticleBody_(r); body='<div class="tydLib__articleBody"><div class="tydLib__articleLoading">Opening article from the local cache...</div></div>'; }
      else body=renderArticleBody_(r);
    }else if(r.kind==='video' || r.kind==='fun'){
      body='<div class="tydLib__videoStack">'+(r.links||[]).map(function(x,i){
        var vid=youtubeVideoId_(x.url), label=x.label||((r.links||[]).length>1?(r.kind==='fun'?'Watch / Link '+(i+1):'Video '+(i+1)):'');
        if(!vid){
          var openText=r.kind==='fun'?'Open / Watch ↗':'Open video';
          return '<div class="tydLib__collectionLinkCard">'+(label?'<div class="tydLib__collectionLinkLabel">'+escapeHtml(label)+'</div>':'')+'<a class="tydLib__btn" href="'+escapeHtml(x.url)+'" target="_blank" rel="noopener noreferrer">'+openText+'</a></div>';
        }
        return '<section class="tydLib__videoCard">'+(label?'<div class="tydLib__videoLabel">'+escapeHtml(label)+'</div>':'')+'<div class="tydLib__videoFrame"><iframe loading="lazy" src="https://www.youtube-nocookie.com/embed/'+escapeHtml(vid)+'?rel=0" title="'+escapeHtml(label||r.title||(r.kind==='fun'?'Fun Watch':'Teaching video'))+'" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div></section>';
      }).join('')+'</div>';
    }else{
      body='<div class="tydLib__supplyLinks">'+(r.links||[]).map(function(x,i){ var label=x.label||((r.links||[]).length>1?'Buy / View option '+(i+1):'Buy / View item'); return '<a class="tydLib__supplyLink" href="'+escapeHtml(x.url)+'" target="_blank" rel="noopener noreferrer"><span>'+escapeHtml(label)+'</span><strong>Open ↗</strong></a>'; }).join('')+'</div>';
    }
    els.reader.innerHTML='<article class="tydLib__collectionPage">'+top+desc+body+'</article>';
    setReaderMeta(readerMetaHtml([r.kind==='video'?'Teaching Videos':(r.kind==='fun'?'Fun Watch':(r.kind==='article'?'Articles':'Supplies')),r.kind==='article'?(r.article_type||'Core Concepts'):(r.kind==='video'?(r.title||'Teaching'):(r.kind==='fun'?(r.category||'Others'):'')),r.kind==='article'?(r.category||'All'):(r.kind==='video'?collectionVideoGroup_(r):''),r.access_scope==='bcm'?'BCM private':(r.access_scope==='full'?'Full Library':'All disciples'),r.status==='hidden'?{text:'hidden',warn:true}:'' ]));
  }
  function collectionCachePayload_(rows, meta){
    meta=meta||{};
    return {
      v:7,
      savedAt:Number(meta.savedAt||Date.now())||Date.now(),
      callsign:String(state.callsign||'').toUpperCase(),
      rows:(rows||[]).map(function(row){ var n=collectionNormalize_(row); if(n.kind==='article') n.content_blocks=[]; return n; }),
      accessScope:String(meta.accessScope||''),
      bcmAccess:!!state.bcmAccess,
      canAdmin:!!meta.canAdmin
    };
  }
  function readCollectionCache_(){
    try{
      var raw=localStorage.getItem(TYD_COLLECTION_CACHE_KEY);
      if(!raw) return null;
      var payload=JSON.parse(raw);
      if(!payload || payload.v!==7 || !Array.isArray(payload.rows)) return null;
      if(String(payload.callsign||'').toUpperCase()!==String(state.callsign||'').toUpperCase()) return null;
      return payload;
    }catch(_e){ return null; }
  }
  function writeCollectionCache_(payload){
    try{
      localStorage.setItem(TYD_COLLECTION_CACHE_KEY,JSON.stringify(payload));
      localStorage.setItem(TYD_COLLECTION_REFRESH_KEY,String(Number(payload&&payload.savedAt||Date.now())||Date.now()));
      return true;
    }catch(_e){ return false; }
  }
  function articleCacheKey_(id){ return TYD_ARTICLE_CACHE_PREFIX + encodeURIComponent(String(id||'')); }
  function readArticleBodyCache_(entry){
    entry=entry||{}; var id=String(entry.collection_id||''); if(!id) return Promise.resolve(null);
    return openCacheDb().then(function(db){
      return new Promise(function(resolve){
        var settled=false, timer=setTimeout(function(){finish(null);},TYD_IDB_READ_TIMEOUT_MS);
        function finish(v){if(settled)return;settled=true;clearTimeout(timer);try{db.close();}catch(_e){}resolve(v||null);}
        try{ var tx=db.transaction(TYD_CACHE_STORE,'readonly'), req=tx.objectStore(TYD_CACHE_STORE).get(articleCacheKey_(id)); req.onsuccess=function(){finish(req.result&&req.result.payload?req.result.payload:null);}; req.onerror=function(){finish(null);}; tx.onerror=function(){finish(null);}; tx.onabort=function(){finish(null);}; }catch(err){finish(null);}
      });
    }).catch(function(){return null;});
  }
  function writeArticleBodyCache_(entry){
    entry=collectionNormalize_(entry||{}); if(entry.kind!=='article' || !entry.collection_id || !entry.content_blocks.length) return Promise.resolve(false);
    var payload={v:1,collection_id:entry.collection_id,updated_at:entry.updated_at||'',savedAt:Date.now(),content_blocks:entry.content_blocks};
    return openCacheDb().then(function(db){
      return new Promise(function(resolve){
        var settled=false, timer=setTimeout(function(){finish(false);},TYD_IDB_WRITE_TIMEOUT_MS); function finish(ok){if(settled)return;settled=true;clearTimeout(timer);try{db.close();}catch(_e){}resolve(!!ok);}
        try{ var tx=db.transaction(TYD_CACHE_STORE,'readwrite'); tx.objectStore(TYD_CACHE_STORE).put({key:articleCacheKey_(entry.collection_id),payload:payload}); tx.oncomplete=function(){finish(true);}; tx.onerror=function(){finish(false);}; tx.onabort=function(){finish(false);}; }catch(err){finish(false);}
      });
    }).catch(function(){return false;});
  }
  function deleteArticleBodyCache_(id){
    id=String(id||''); if(!id) return Promise.resolve(false);
    return openCacheDb().then(function(db){return new Promise(function(resolve){try{var tx=db.transaction(TYD_CACHE_STORE,'readwrite');tx.objectStore(TYD_CACHE_STORE).delete(articleCacheKey_(id));tx.oncomplete=function(){try{db.close();}catch(_e){}resolve(true);};tx.onerror=function(){try{db.close();}catch(_e2){}resolve(false);};}catch(err){try{db.close();}catch(_e3){}resolve(false);}});}).catch(function(){return false;});
  }
  function mergeArticleBody_(entry, bodyPayload){
    if(!entry || !bodyPayload || !Array.isArray(bodyPayload.content_blocks)) return false;
    entry.content_blocks=bodyPayload.content_blocks.map(function(x){return x||{};}); return !!entry.content_blocks.length;
  }
  function fetchArticleBody_(entry, opts){
    opts=opts||{}; if(!entry || entry.kind!=='article' || !entry.collection_id || !state.authReady || !state.auth || !state.auth.token) return Promise.resolve(false);
    var id=String(entry.collection_id), active=state.articleBodyLoading[id]; if(active && !opts.bypassActive) return active;
    var promise=slbApi('tydLibraryCollectionsList',{collection_id:id},state.auth.token,{cacheTtlMs:TYD_COLLECTION_REFRESH_INTERVAL_MS,useWarmCache:true,dedupe:true,noCacheFirst:!!opts.force,latestKey:'tyd-library-article:'+id}).then(function(res){
      var data=collectionApiData_(res), rows=data.rows||[], full=rows[0]?collectionNormalize_(rows[0]):null; if(!full || full.kind!=='article' || !full.content_blocks.length) return false;
      entry.content_blocks=full.content_blocks; entry.updated_at=full.updated_at||entry.updated_at; writeArticleBodyCache_(full).catch(function(){});
      if(collectionSelectionId_(entry.collection_id)===state.selectedId && isArticleDirectory()) renderCollectionReader_(entry);
      return true;
    }).catch(function(){return false;}).finally(function(){if(!opts.bypassActive) delete state.articleBodyLoading[id];});
    if(!opts.bypassActive) state.articleBodyLoading[id]=promise; return promise;
  }
  function ensureArticleBody_(entry){
    if(!entry || entry.kind!=='article') return Promise.resolve(false); if(entry.content_blocks&&entry.content_blocks.length) return Promise.resolve(true); var id=String(entry.collection_id||''); if(!id) return Promise.resolve(false); if(state.articleBodyLoading[id]) return state.articleBodyLoading[id];
    var outer=readArticleBodyCache_(entry).then(function(cached){
      var have=mergeArticleBody_(entry,cached), stale=have && String(cached.updated_at||'')!==String(entry.updated_at||'');
      if(have && collectionSelectionId_(id)===state.selectedId && isArticleDirectory()) renderCollectionReader_(entry);
      if(!have || stale) return fetchArticleBody_(entry,{force:stale,bypassActive:true});
      return true;
    }).catch(function(){return fetchArticleBody_(entry,{force:false,bypassActive:true});}).finally(function(){ if(state.articleBodyLoading[id]===outer) delete state.articleBodyLoading[id]; });
    state.articleBodyLoading[id]=outer; return outer;
  }
  async function prefetchAllArticleBodies_(){
    var articles=state.collections.filter(function(r){return r.kind==='article';}), batchSize=6, saved=0;
    for(var i=0;i<articles.length;i+=batchSize){
      var ids=articles.slice(i,i+batchSize).map(function(r){return r.collection_id;}).filter(Boolean); if(!ids.length) continue;
      try{
        var res=await slbApi('tydLibraryCollectionsList',{article_ids:ids},state.auth.token,{cacheTtlMs:0,useWarmCache:false,dedupe:false,noCacheFirst:true,latestKey:'tyd-library-article-supercharge:'+i});
        var data=collectionApiData_(res), rows=data.rows||[];
        for(var j=0;j<rows.length;j++){ var full=collectionNormalize_(rows[j]); if(full.kind==='article'&&full.content_blocks.length){ await writeArticleBodyCache_(full); var current=state.collections.find(function(x){return x.collection_id===full.collection_id;}); if(current) current.content_blocks=full.content_blocks; saved++; } }
      }catch(_e){}
      await yieldToBrowser(25);
    }
    return {saved:saved,total:articles.length};
  }
  function applyCollectionPayload_(payload, opts){
    opts=opts||{};
    if(!payload || !Array.isArray(payload.rows)) return false;
    state.collections=payload.rows.map(collectionNormalize_);
    state.collectionsLoaded=true;
    state._directoryRenderCache={};
    var collectionHash=parseLibraryDeepLinkHash();
    if(collectionHash.id && collectionBySelection_(collectionHash.id)){
      var linkedCollection=collectionBySelection_(collectionHash.id);
      state.directoryView=linkedCollection.kind==='video'?'videos':(linkedCollection.kind==='fun'?'funwatch':(linkedCollection.kind==='article'?'articles':'supplies'));
      state.selectedId=collectionHash.id;
      if(els.directoryView) els.directoryView.value=state.directoryView;
    }
    if(isCollectionDirectory()){
      populateFilters();
      ensureDirectorySelection();
      renderList();
      renderReader();
    }
    return true;
  }
  function hydrateLibraryCollectionsFromCache_(){
    if(state.collectionsLoaded && state.collections.length) return true;
    var cached=readCollectionCache_();
    if(!cached) return false;
    return applyCollectionPayload_(cached,{fromCache:true});
  }
  function collectionCacheCoversAccess_(cached){
    cached=cached||readCollectionCache_();
    if(!cached) return false;
    // BCM membership can change while the same callsign stays logged in. Never reuse
    // a collection list captured under different BCM permission.
    if(!!cached.bcmAccess !== !!state.bcmAccess) return false;
    if(state.isAdmin) return !!cached.canAdmin;
    if(state.acgAccess==='full') return !!cached.canAdmin || String(cached.accessScope||'')==='full';
    return true;
  }
  function collectionCacheFresh_(){
    var cached=readCollectionCache_();
    if(!cached || !collectionCacheCoversAccess_(cached)) return false;
    var last=0;
    try{ last=Number(localStorage.getItem(TYD_COLLECTION_REFRESH_KEY)||'0')||0; }catch(_e){}
    if(!last) last=Number(cached.savedAt||0)||0;
    return !!(last && (Date.now()-last)<TYD_COLLECTION_REFRESH_INTERVAL_MS);
  }
  async function loadLibraryCollections(opts){
    opts=opts||{};
    if(!state.authReady || !state.auth || !state.auth.token) return false;

    // Local-first stale-while-revalidate. The first call after auth paints the
    // saved Teaching Videos/Fun Watch/Articles/Supplies immediately; network work is optional and
    // never owns the visible directory unless no local copy exists yet.
    var hadLocal=hydrateLibraryCollectionsFromCache_();
    if(!opts.force && hadLocal && collectionCacheFresh_()) return true;
    if(state.collectionsLoading) return hadLocal;
    state.collectionsLoading=true;
    try{
      var res=await slbApi(
        'tydLibraryCollectionsList',
        {},
        state.auth.token,
        {cacheTtlMs:TYD_COLLECTION_REFRESH_INTERVAL_MS,useWarmCache:true,dedupe:true,noCacheFirst:(!hadLocal || !!opts.force),latestKey:'tyd-library-collections:'+TYD_LIBRARY_BUILD_TAG}
      );
      var data=collectionApiData_(res), rows=data.rows||data.collections||[];
      var payload=collectionCachePayload_(Array.isArray(rows)?rows:[],{
        savedAt:Date.now(),
        accessScope:data.accessScope||'',
        canAdmin:!!data.canAdmin
      });
      writeCollectionCache_(payload);
      applyCollectionPayload_(payload,{fromCache:false});
      return true;
    }catch(err){
      if(!hadLocal && !opts.quiet && isCollectionDirectory()) setStatus('Could not load Library videos/Fun Watch/articles/supplies: '+(err.message||err),'bad');
      return hadLocal;
    }finally{
      state.collectionsLoading=false;
    }
  }
  function prefetchLibraryCollections_(opts){
    opts=opts||{};
    if(!state.authReady || !state.auth || !state.auth.token) return;
    var hadLocal=hydrateLibraryCollectionsFromCache_();
    var force=!!opts.force;
    if(!force && hadLocal && collectionCacheFresh_()) return;
    if(!hadLocal){
      loadLibraryCollections({quiet:true,force:force});
      return;
    }
    setTimeout(function(){
      runWhenQuiet(function(){ loadLibraryCollections({quiet:true,force:force}); }, 9000);
    },900);
  }
  function parseCollectionLinksText_(txt){
    return String(txt||'').split(/\r?\n/).map(function(line){ line=String(line||'').trim(); if(!line)return null; var m=line.match(/^(.*?)\s*\|\s*(https?:\/\/\S+)$/i); return m?{label:m[1].trim(),url:m[2].trim()}:{label:'',url:line}; }).filter(Boolean);
  }
  function parseArticleBlocksText_(txt){
    var lines=String(txt||'').replace(/\r/g,'').split('\n'), out=[], buf=[];
    function flush(){ var t=buf.join('\n').trim(); if(t) out.push({type:'text',text:t}); buf=[]; }
    lines.forEach(function(line){
      var raw=String(line||''), trimmed=raw.trim(), m;
      if(!trimmed){ flush(); return; }
      m=trimmed.match(/^\[heading\]\s*(.+)$/i); if(m){ flush(); out.push({type:'heading',text:m[1].trim()}); return; }
      m=trimmed.match(/^\[(image|video)\]\s*(https?:\/\/\S+?)(?:\s*\|\s*(.*))?$/i); if(m){ flush(); out.push({type:m[1].toLowerCase(),url:m[2].trim(),caption:String(m[3]||'').trim()}); return; }
      buf.push(raw);
    });
    flush(); return out;
  }
  function articleBlocksToText_(blocks){
    return (blocks||[]).map(function(x){
      x=x||{}; if(x.type==='heading') return '[heading] '+(x.text||'');
      if(x.type==='image' || x.type==='video') return '['+x.type+'] '+(x.url||'')+(x.caption?' | '+x.caption:'');
      return x.text||'';
    }).filter(Boolean).join('\n\n');
  }
  function ensureCollectionEditor_(){
    var el=document.getElementById('tydCollectionEditor'); if(el) return el;
    el=document.createElement('div'); el.id='tydCollectionEditor'; el.className='tydLib__collectionModal'; el.hidden=true;
    el.innerHTML='<div class="tydLib__collectionModalCard" role="dialog" aria-modal="true" aria-labelledby="tydCollectionEditorTitle"><button type="button" class="tydLib__collectionModalClose" data-collection-close aria-label="Close">×</button><h2 id="tydCollectionEditorTitle">Library entry</h2><input type="hidden" id="tydCollectionId"><input type="hidden" id="tydCollectionKind">'+
      '<div class="tydLib__collectionFormGrid"><label class="wide"><span id="tydCollectionTitleLabel">Title</span><input id="tydCollectionTitle" type="text" maxlength="220"></label><label data-date-field>Date<input id="tydCollectionDate" type="date"></label><label data-article-field>Article type<select id="tydCollectionArticleType"><option>Core Concepts</option><option>Mindsets</option><option>Applications</option></select></label><label><span id="tydCollectionCategoryLabel">Category</span><input id="tydCollectionCategory" type="text" maxlength="120" placeholder="Altar supplies" list="tydFunWatchCategories"></label><datalist id="tydFunWatchCategories"><option value="KJ"><option value="Movies"><option value="Resources"><option value="Others"></datalist><datalist id="tydBcmVideoCategories"><option value="CHI KUNG"><option value="KAD"></datalist><label>Access<select id="tydCollectionAccess"><option value="full">Full Library / ACG</option><option value="bcm">BCM private — TY9YUE + TY9BEH</option><option value="daily">All logged-in disciples</option></select></label><label>Status<select id="tydCollectionStatus"><option value="active">Active</option><option value="hidden">Hidden</option></select></label><label>Order<input id="tydCollectionOrder" type="number" value="0"></label><label class="wide"><span id="tydCollectionDescriptionLabel">Notes / description (optional)</span><textarea id="tydCollectionDescription" rows="3"></textarea></label><label class="wide" data-article-field>Article body — normal paragraphs are text. Use <b>[heading] Heading</b>, <b>[image] https://... | Caption</b>, or <b>[video] https://... | Caption</b> on their own lines.<textarea id="tydCollectionArticleBody" rows="14" spellcheck="true"></textarea></label><label class="wide" data-links-field>Links — one per line. Optional label: <b>Label | https://...</b><textarea id="tydCollectionLinks" rows="6" spellcheck="false"></textarea></label></div><div class="tydLib__collectionModalActions"><button type="button" class="tydLib__btn secondary" data-collection-close>Cancel</button><button type="button" class="tydLib__btn" data-collection-save>Save</button></div></div>';
    root.appendChild(el);
    var videoTitleInput=el.querySelector('#tydCollectionTitle'); if(videoTitleInput) videoTitleInput.addEventListener('input',function(){ refreshVideoEditorCategoryHint_(el); });
    el.addEventListener('click',function(e){ if(e.target===el || e.target.closest('[data-collection-close]')){ closeCollectionEditor_(); return; } if(e.target.closest('[data-collection-save]')) saveCollectionEditor_(); });
    return el;
  }
  function refreshVideoEditorCategoryHint_(el){
    if(!el) return;
    var kind=String((el.querySelector('#tydCollectionKind')||{}).value||''), title=String((el.querySelector('#tydCollectionTitle')||{}).value||'').trim().toUpperCase();
    var categoryInput=el.querySelector('#tydCollectionCategory'); if(!categoryInput || kind!=='video') return;
    if(title==='BCM'){
      categoryInput.setAttribute('list','tydBcmVideoCategories');
      categoryInput.placeholder='CHI KUNG / KAD';
    }else{
      categoryInput.removeAttribute('list');
      categoryInput.placeholder=title==='ACM'?'Year comes from Date':'Category / Year';
    }
  }
  function openCollectionEditor_(kind,entry){
    if(!state.isAdmin) return; entry=entry||{}; kind=kind==='video'?'video':(kind==='fun'?'fun':(kind==='article'?'article':'supply')); var el=ensureCollectionEditor_();
    var kindLabel=kind==='video'?'Teaching Video':(kind==='fun'?'Fun Watch':(kind==='article'?'Article':'Supply Item'));
    el.querySelector('#tydCollectionEditorTitle').textContent=(entry.collection_id?'Edit ':'Add ')+kindLabel;
    var titleLabel=el.querySelector('#tydCollectionTitleLabel'), categoryLabel=el.querySelector('#tydCollectionCategoryLabel'), categoryInput=el.querySelector('#tydCollectionCategory'), descLabel=el.querySelector('#tydCollectionDescriptionLabel');
    if(titleLabel) titleLabel.textContent=kind==='video'?'Type':'Title';
    if(categoryLabel) categoryLabel.textContent='Category';
    if(descLabel) descLabel.textContent=kind==='article'?'Summary / intro (optional)':'Notes / description (optional)';
    if(categoryInput){ categoryInput.placeholder=kind==='fun'?'KJ / Movies / Resources / Others':(kind==='article'?'All':'Altar supplies'); if(kind==='fun') categoryInput.setAttribute('list','tydFunWatchCategories'); else categoryInput.removeAttribute('list'); }
    el.querySelector('#tydCollectionId').value=entry.collection_id||''; el.querySelector('#tydCollectionKind').value=kind; el.querySelector('#tydCollectionTitle').value=entry.title||''; el.querySelector('#tydCollectionDate').value=(entry.date||'').slice(0,10); el.querySelector('#tydCollectionArticleType').value=entry.article_type||'Core Concepts'; el.querySelector('#tydCollectionCategory').value=entry.category||((kind==='video'&&entry.date)?String(entry.date).slice(0,4):(kind==='article'?'All':'')); el.querySelector('#tydCollectionDescription').value=entry.description||''; el.querySelector('#tydCollectionArticleBody').value=articleBlocksToText_(entry.content_blocks||[]); el.querySelector('#tydCollectionOrder').value=Number(entry.display_order||0)||0; el.querySelector('#tydCollectionAccess').value=entry.access_scope||(kind==='video'?'full':'daily'); el.querySelector('#tydCollectionStatus').value=entry.status||'active'; el.querySelector('#tydCollectionLinks').value=(entry.links||[]).map(function(x){return x.label?(x.label+' | '+x.url):x.url;}).join('\n');
    refreshVideoEditorCategoryHint_(el);
    el.querySelectorAll('[data-date-field]').forEach(function(x){x.hidden=kind!=='video'&&kind!=='article';}); el.querySelectorAll('[data-article-field]').forEach(function(x){x.hidden=kind!=='article';}); el.querySelectorAll('[data-links-field]').forEach(function(x){x.hidden=kind==='article';}); el.hidden=false; setTimeout(function(){el.querySelector('#tydCollectionTitle').focus();},20);
  }
  function closeCollectionEditor_(){ var el=document.getElementById('tydCollectionEditor'); if(el) el.hidden=true; }
  async function saveCollectionEditor_(){
    var el=ensureCollectionEditor_(), kind=el.querySelector('#tydCollectionKind').value, title=el.querySelector('#tydCollectionTitle').value.trim(), links=parseCollectionLinksText_(el.querySelector('#tydCollectionLinks').value), articleBlocks=parseArticleBlocksText_(el.querySelector('#tydCollectionArticleBody').value);
    if(!title){ setStatus(kind==='video'?'Enter a teaching type first.':'Enter a title first.','bad'); return; }
    if(kind==='article' && !articleBlocks.length){ setStatus('Add article text, an image, or a video block first.','bad'); return; }
    if(kind!=='article' && !links.length){ setStatus(kind==='fun'?'Add at least one watch or resource link.':'Add at least one link.','bad'); return; }
    var dateValue=el.querySelector('#tydCollectionDate').value, categoryValue=el.querySelector('#tydCollectionCategory').value.trim();
    if(kind==='video'){
      var videoTypeUpper=String(title||'').trim().toUpperCase();
      if(videoTypeUpper==='ACM' && dateValue) categoryValue=String(dateValue).slice(0,4);
      else if(videoTypeUpper==='BCM' && !categoryValue) categoryValue='CHI KUNG';
      else if(!categoryValue && dateValue) categoryValue=String(dateValue).slice(0,4);
    }
    if(kind==='article' && !categoryValue) categoryValue='All';
    var payload={collection_id:el.querySelector('#tydCollectionId').value,kind:kind,title:title,date:dateValue,article_type:kind==='article'?el.querySelector('#tydCollectionArticleType').value:'',category:categoryValue,description:el.querySelector('#tydCollectionDescription').value.trim(),content_blocks:kind==='article'?articleBlocks:[],display_order:Number(el.querySelector('#tydCollectionOrder').value||0)||0,access_scope:el.querySelector('#tydCollectionAccess').value,status:el.querySelector('#tydCollectionStatus').value,links:kind==='article'?[]:links};
    var saveBtn=el.querySelector('[data-collection-save]'); saveBtn.disabled=true; saveBtn.textContent='Saving...';
    try{
      var res=await slbApi('adminTydLibraryCollectionUpsert',payload,state.auth.token), saved=collectionNormalize_(collectionApiData_(res)); if(!saved.collection_id && res && res.data) saved=collectionNormalize_(res.data);
      if(saved.kind==='article' && saved.content_blocks.length) await writeArticleBodyCache_(saved);
      closeCollectionEditor_(); await loadLibraryCollections({quiet:true,force:true}); state.directoryView=kind==='video'?'videos':(kind==='fun'?'funwatch':(kind==='article'?'articles':'supplies')); if(els.directoryView) els.directoryView.value=state.directoryView; state.selectedId=collectionSelectionId_(saved.collection_id||payload.collection_id); populateFilters(); renderList(); renderReader(); setStatus((kind==='video'?'Teaching video':(kind==='fun'?'Fun Watch entry':(kind==='article'?'Article':'Supply item')))+' saved.','ok');
    }catch(err){ setStatus('Save failed: '+(err.message||err),'bad'); }
    finally{ saveBtn.disabled=false; saveBtn.textContent='Save'; }
  }
  async function deleteCollection_(id){
    var entry=null; state.collections.forEach(function(r){if(r.collection_id===id)entry=r;}); if(!entry||!state.isAdmin)return;
    if(window.confirm && !window.confirm('Delete "'+(entry.title||'this entry')+'"?')) return;
    try{ await slbApi('adminTydLibraryCollectionDelete',{collection_id:id},state.auth.token); await deleteArticleBodyCache_(id); state.selectedId=null; await loadLibraryCollections({quiet:true,force:true}); ensureDirectorySelection(); renderList(); renderReader(); setStatus('Library entry deleted.','ok'); }catch(err){setStatus('Delete failed: '+(err.message||err),'bad');}
  }
  function reportLibraryTelemetry_(event, detail, durationMs){
    try{
      var auth = readSessionAuth();
      if(!auth || !auth.token) return;
      setTimeout(function(){
        slbApi('tydLibraryTelemetry', {
          event:String(event || ''),
          detail:String(detail || '').slice(0,420),
          durationMs:Math.max(0,Number(durationMs || 0) || 0),
          clientBuild:TYD_LIBRARY_BUILD_TAG
        }, auth.token).catch(function(){});
      },0);
    }catch(_e){}
  }
  function tokenExpiryMs_(token){
    try{
      var head=String(token||'').split('.')[0]||''; if(!head)return 0;
      var b64=head.replace(/-/g,'+').replace(/_/g,'/'); while(b64.length%4)b64+='=';
      var body=JSON.parse(atob(b64)), exp=Number(body&&body.e||0);
      return isFinite(exp)&&exp>Date.now()?exp:0;
    }catch(e){return 0;}
  }
  function readAuth(){
    try{
      var auth = JSON.parse(localStorage.getItem(AUTH_KEY) || 'null');
      if(!auth) return null;
      if(auth.token){
        var exp=Number(auth.expiresAt||0)||tokenExpiryMs_(auth.token);
        if(exp&&Date.now()>=exp){localStorage.removeItem(AUTH_KEY);return null;}
        auth.expiresAt=exp||(Date.now()+14*24*60*60*1000);
      }
      return auth;
    }catch(e){ return null; }
  }
  function readSessionAuth(){
    var tok = '', cs = '', dn = '', isAdmin = false, isModerator = false, canCreatePouches = false, acg = false, ime = false, bcm = false;
    try{ tok = sessionStorage.getItem('tyw_token') || ''; }catch(e){}
    try{ cs = sessionStorage.getItem('tyw_callsign') || ''; }catch(e2){}
    try{ dn = sessionStorage.getItem('tyw_displayName') || ''; }catch(e3){}
    try{ isAdmin = sessionStorage.getItem('tyw_isAdmin') === '1'; }catch(e4){}
    try{ isModerator = sessionStorage.getItem('tyw_isModerator') === '1'; }catch(e5){}
    try{ canCreatePouches = sessionStorage.getItem('tyw_canCreatePouches') === '1'; }catch(e6){}
    try{ acg = sessionStorage.getItem('tyw_acg') === '1' || sessionStorage.getItem('tyw_isAcg') === '1'; }catch(e7){}
    try{ ime = sessionStorage.getItem('tyw_ime') === '1' || sessionStorage.getItem('tyw_isIme') === '1'; }catch(e8){}
    try{ bcm = sessionStorage.getItem('tyw_bcm') === '1' || sessionStorage.getItem('tyw_isBcm') === '1'; }catch(e9){}
    if(!tok) return null;
    return { token:tok, callsign:String(cs||'').toUpperCase(), displayName:dn, isAdmin:isAdmin, isModerator:isModerator, canCreatePouches:canCreatePouches, acg:acg, ACG:acg ? '1' : '0', isAcg:acg, acgActive:acg, ime:ime, IME:ime ? '1' : '0', isIme:ime, inIme:ime, bcm:bcm, BCM:bcm ? '1' : '0', isBcm:bcm, inBcm:bcm, ts:Date.now() };
  }
  function writeAuth(auth){
    try{
      auth = auth || {};
      var exp=Number(auth.expiresAt||0)||tokenExpiryMs_(auth.token)||(Date.now()+14*24*60*60*1000);
      localStorage.setItem(AUTH_KEY, JSON.stringify({
        token:String(auth.token || ''),
        callsign:String(auth.callsign || '').toUpperCase(),
        displayName:String(auth.displayName || ''),
        isAdmin:!!auth.isAdmin,
        role:String(auth.role || ''),
        isModerator:!!auth.isModerator,
        canCreatePouches:!!auth.canCreatePouches,
        acg:!!auth.acg,
        ACG:auth.acg ? '1' : '0',
        isAcg:!!auth.isAcg,
        acgActive:!!auth.acgActive,
        ime:!!auth.ime,
        IME:auth.ime ? '1' : '0',
        isIme:!!auth.isIme,
        inIme:!!auth.inIme,
        bcm:!!auth.bcm,
        BCM:auth.bcm ? '1' : '0',
        isBcm:!!auth.isBcm,
        inBcm:!!auth.inBcm,
        ts:Number(auth.ts || Date.now()),
        expiresAt:exp
      }));
    }catch(e){}
  }
  function clearAuth(){
    try{ localStorage.removeItem(AUTH_KEY); }catch(e){}
    try{ sessionStorage.removeItem('tyw_token'); sessionStorage.removeItem('tyw_callsign'); sessionStorage.removeItem('tyw_displayName'); sessionStorage.removeItem('tyw_isAdmin'); sessionStorage.removeItem('tyw_isModerator'); sessionStorage.removeItem('tyw_canCreatePouches'); sessionStorage.removeItem('tyw_acg'); sessionStorage.removeItem('tyw_isAcg'); sessionStorage.removeItem('tyw_ime'); sessionStorage.removeItem('tyw_isIme'); sessionStorage.removeItem('tyw_bcm'); sessionStorage.removeItem('tyw_isBcm'); }catch(e2){}
  }
  function applySession(auth){
    if(!auth || !auth.token) return;
    try{ sessionStorage.setItem('tyw_token', String(auth.token || '')); }catch(e){}
    try{ sessionStorage.setItem('tyw_callsign', String(auth.callsign || '').toUpperCase()); }catch(e2){}
    try{ sessionStorage.setItem('tyw_displayName', String(auth.displayName || auth.callsign || '')); }catch(e3){}
    try{ sessionStorage.setItem('tyw_isAdmin', auth.isAdmin ? '1' : '0'); }catch(e4){}
    try{ sessionStorage.setItem('tyw_isModerator', auth.isModerator ? '1' : '0'); }catch(e5){}
    try{ sessionStorage.setItem('tyw_canCreatePouches', auth.canCreatePouches ? '1' : '0'); }catch(e6){}
    try{ sessionStorage.setItem('tyw_acg', authAccessAcg_(auth) ? '1' : '0'); sessionStorage.setItem('tyw_isAcg', authAccessAcg_(auth) ? '1' : '0'); }catch(e7){}
    try{ sessionStorage.setItem('tyw_ime', authAccessIme_(auth) ? '1' : '0'); sessionStorage.setItem('tyw_isIme', authAccessIme_(auth) ? '1' : '0'); }catch(e8){}
    try{ sessionStorage.setItem('tyw_bcm', authAccessBcm_(auth) ? '1' : '0'); sessionStorage.setItem('tyw_isBcm', authAccessBcm_(auth) ? '1' : '0'); }catch(e9){}
  }

  function truthyAcg_(v){
    if(v === true || v === 1) return true;
    var s = String(v==null?'':v).trim().toLowerCase();
    return s === '1' || s === 'true' || s === 'yes' || s === 'y' || s === 'in' || s === 'acg' || s === 'active';
  }
  function acgMarkerVal_(obj){
    if(!obj) return null;
    var fields = [obj.acgNote, obj.notes, obj.specialNote, obj.SpecialNote, obj['Special Note'], obj.note, obj.remarks];
    for(var i=0;i<fields.length;i++){
      var s = String(fields[i]==null?'':fields[i]);
      if(!s) continue;
      var m = s.match(/\[\s*ACG\s*=\s*([01])\s*\]|\bACG\s*[:=]\s*([01])\b/i);
      if(m) return String(m[1] || m[2] || '') === '1';
    }
    return null;
  }
  function hasAcgField_(obj){
    if(!obj) return false;
    return acgMarkerVal_(obj) !== null || Object.prototype.hasOwnProperty.call(obj,'acg') || Object.prototype.hasOwnProperty.call(obj,'ACG') || Object.prototype.hasOwnProperty.call(obj,'isAcg') || Object.prototype.hasOwnProperty.call(obj,'acgActive') || Object.prototype.hasOwnProperty.call(obj,'inAcg');
  }
  function authAccessAcg_(obj){
    if(!obj) return false;
    var marker = acgMarkerVal_(obj);
    if(marker !== null) return !!marker;
    return truthyAcg_(obj.acg) || truthyAcg_(obj.ACG) || truthyAcg_(obj.isAcg) || truthyAcg_(obj.acgActive) || truthyAcg_(obj.inAcg);
  }
  function truthyAdmin_(v){
    if(v === true || v === 1) return true;
    var s = String(v==null?'':v).trim().toLowerCase();
    return s === '1' || s === 'true' || s === 'yes' || s === 'y' || s === 'admin';
  }
  function isLibraryAdmin(profile, auth){
    try{
      if(truthyAdmin_(profile && profile.isAdmin)) return true;
      if(truthyAdmin_(auth && auth.isAdmin)) return true;
      var role = String((profile && profile.role) || (auth && auth.role) || '').toLowerCase().trim();
      if(role === 'admin') return true;
      var cs = String((profile && profile.callsign) || (auth && auth.callsign) || '').toUpperCase().trim();
      // The built-in SLB administrator account is literally ADMIN. Treat it as full Library admin even if an older dashboard payload omits isAdmin/role.
      if(cs === 'ADMIN') return true;
      try{ if(sessionStorage.getItem('tyw_isAdmin') === '1') return true; }catch(_e0){}
      try{ if(document.documentElement && document.documentElement.classList && document.documentElement.classList.contains('tyRoleAdmin')) return true; }catch(_e1){}
    }catch(e){}
    return false;
  }
  function setDownloadGateVisible_(allow){
    allow = !!allow;
    var btns = root ? Array.from(root.querySelectorAll('[data-acg-download]')) : [];
    for(var i=0;i<btns.length;i++){
      if(!btns[i]) continue;
      btns[i].hidden = !allow;
      btns[i].setAttribute('aria-hidden', allow ? 'false' : 'true');
      btns[i].setAttribute('tabindex', allow ? '0' : '-1');
      btns[i].style.display = allow ? '' : 'none';
      btns[i].style.visibility = allow ? '' : 'hidden';
      btns[i].style.pointerEvents = allow ? '' : 'none';
    }
    root.classList.toggle('tydLib--downloadsAllowed', allow);
    root.classList.toggle('tydLib--downloadsLocked', !allow);
  }
  function authAccessIme_(obj){
    if(!obj) return false;
    return truthyAcg_(obj.ime) || truthyAcg_(obj.IME) || truthyAcg_(obj.isIme) || truthyAcg_(obj.inIme);
  }
  function authAccessBcm_(obj){
    if(!obj) return false;
    return truthyAcg_(obj.bcm) || truthyAcg_(obj.BCM) || truthyAcg_(obj.isBcm) || truthyAcg_(obj.inBcm);
  }
  function setImeDownloadVisible_(allow){
    allow = !!allow;
    var btns = root ? Array.from(root.querySelectorAll('[data-ime-download]')) : [];
    for(var i=0;i<btns.length;i++){
      if(!btns[i]) continue;
      btns[i].hidden = !allow;
      btns[i].setAttribute('aria-hidden', allow ? 'false' : 'true');
      btns[i].setAttribute('tabindex', allow ? '0' : '-1');
      btns[i].style.display = allow ? '' : 'none';
      btns[i].style.visibility = allow ? '' : 'hidden';
      btns[i].style.pointerEvents = allow ? '' : 'none';
    }
    var panel = root && root.querySelector ? root.querySelector('[data-ime-download-panel]') : null;
    if(panel) panel.hidden = !allow;
    root.classList.toggle('tydLib--imeDownloadsAllowed', allow);
  }
  function syncDownloadsDrawerAccess_(){
    var acgAllow = !!(state.isAdmin || state.acgAccess === 'full');
    var imeAllow = !!(state.isAdmin || state.imeAccess);
    var acgPanel = root && root.querySelector ? root.querySelector('[data-acg-download-panel]') : null;
    if(acgPanel) acgPanel.hidden = !acgAllow;
    if(els.downloadToggle){
      var any = acgAllow || imeAllow;
      els.downloadToggle.hidden = !any;
      els.downloadToggle.setAttribute('aria-hidden', any ? 'false' : 'true');
      if(!any) setDownloadsDrawer_(false);
    }
  }
  function setDownloadsDrawer_(open){
    open = !!open;
    if(open && (!els.downloadToggle || els.downloadToggle.hidden)) open = false;
    state.downloadDrawerOpen = open;
    if(els.downloadDrawer) els.downloadDrawer.hidden = !open;
    if(els.downloadToggle) els.downloadToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    root.classList.toggle('tydLibDownloadsOpen', open);
  }
  function refreshLoadedSnapshotAfterAccessChange_(fromAccess, toAccess){
    // ACG/full access can be confirmed after the page already opened from the saved snapshot.
    // Important: the limited view filters state.items down to Daily Rite only. When access becomes
    // full, re-apply the saved RAW local snapshot first, then render. Do not go online unless there
    // is no raw snapshot available.
    try{ clearAcgRestrictedCaches_(); }catch(e){}
    try{ state._directoryRenderCache = {}; state._directoryRenderCacheOrder = []; state._directoryCacheWarmedAt = 0; }catch(e2){}

    var label = (toAccess === 'full') ? 'Full Library access confirmed' : 'Daily Rite access applied';
    if(toAccess === 'full' && state._rawLibraryData && state._rawLibraryData.items && state._rawLibraryData.items.length){
      try{
        applyLoadedDatabase(state._rawLibraryData, true);
        setStatus(label+' — restored full library from saved local snapshot — '+state.items.length+' items / '+state.lines.length+' lines / '+state.rcAtlas.length+' RC entries / '+GOD_ATLAS_ENTRIES.length+' gods', 'ok');
        return;
      }catch(e3){
        try{ console.warn('[TYD Library] raw snapshot reapply failed', e3); }catch(_eWarn){}
      }
    }

    if(toAccess === 'full'){
      // Fallback for browsers that entered this file before v124 had stored the raw snapshot.
      // Read the same IndexedDB cache again and re-apply it under full access. This is still local and fast.
      try{
        readCachedLibrary().then(function(cached){
          if(validCachedLibrary(cached)){
            applyLoadedDatabase(cached, true);
            setStatus(label+' — reopened full saved local snapshot — '+state.items.length+' items / '+state.lines.length+' lines / '+state.rcAtlas.length+' RC entries / '+GOD_ATLAS_ENTRIES.length+' gods', 'ok');
          }else{
            loadAll({force:true});
          }
        }).catch(function(){ loadAll({force:true}); });
        return;
      }catch(e4){}
    }

    try{ populateFilters(); initOpenGroups(); }catch(e5){}
    try{ renderNormalLoadedView(true, { deferReader:!location.hash && !state.selectedId }); }catch(e6){ try{ renderCurrent(); clearLibraryLoading(); }catch(e7){} }
    setStatus(label+' — using saved local snapshot, no full reload needed — '+state.items.length+' items / '+state.lines.length+' lines / '+state.rcAtlas.length+' RC entries / '+GOD_ATLAS_ENTRIES.length+' gods', 'ok');
  }

  function setAuthVisual(mode){
    root.classList.remove('tydLib--authChecking','tydLib--authLocked','tydLib--authReady');
    root.classList.add(mode === 'ready' ? 'tydLib--authReady' : (mode === 'locked' ? 'tydLib--authLocked' : 'tydLib--authChecking'));
    if(mode !== 'ready'){ setDownloadGateVisible_(false); setImeDownloadVisible_(false); syncDownloadsDrawerAccess_(); }
    if(authEls.overlay) authEls.overlay.hidden = (mode === 'ready');
  }
  function applyLibraryAuth(auth, profile){
    auth = auth || {};
    profile = profile || {};
    var beforeAccess = state.acgAccess;
    var beforeCallsign = String(state.callsign||'').toUpperCase();
    state.authReady = true;
    state.auth = auth;
    state.callsign = String(profile.callsign || auth.callsign || '').toUpperCase();
    if(beforeCallsign && beforeCallsign!==state.callsign){
      state.collections=[]; state.collectionsLoaded=false; state.selectedId=null;
    }
    state.isAdmin = isLibraryAdmin(profile, auth);
    auth.isAdmin = !!state.isAdmin;
    if(profile && profile.role && !auth.role) auth.role = String(profile.role || '');
    var acgOn = authAccessAcg_(profile) || authAccessAcg_(auth);
    state.acgAccess = (state.isAdmin || acgOn) ? 'full' : 'daily';
    state.acgLimited = (state.acgAccess !== 'full');
    state.imeAccess = !!(state.isAdmin || authAccessIme_(profile) || authAccessIme_(auth));
    // BCM never inherits from admin or ACG. It is an explicit private group only.
    state.bcmAccess = !!(authAccessBcm_(profile) || authAccessBcm_(auth));
    auth.acg = acgOn ? true : false;
    auth.ACG = acgOn ? '1' : '0';
    auth.isAcg = acgOn ? true : false;
    auth.ime = !!state.imeAccess;
    auth.IME = state.imeAccess ? '1' : '0';
    auth.isIme = !!state.imeAccess;
    auth.inIme = !!state.imeAccess;
    auth.bcm = !!state.bcmAccess;
    auth.BCM = state.bcmAccess ? '1' : '0';
    auth.isBcm = !!state.bcmAccess;
    auth.inBcm = !!state.bcmAccess;
    try{ writeAuth(auth); applySession(auth); }catch(_eAuth){}
    clearAcgRestrictedCaches_();
    if(els.adminTools) els.adminTools.hidden = !state.isAdmin;
    setDownloadGateVisible_(state.isAdmin || state.acgAccess === 'full');
    setImeDownloadVisible_(state.isAdmin || state.imeAccess);
    syncDownloadsDrawerAccess_();
    if(!state.isAdmin && state.auditMode){
      state.auditMode = false;
      state.auditPanel = 'saamlawnese';
      root.classList.remove('auditMode');
      try{ history.replaceState(null, '', location.pathname + location.hash); }catch(e){}
    }
    setAuthVisual('ready');
    hydrateLibraryCollectionsFromCache_();
    prefetchLibraryCollections_({force:false});
    if(state.acgLimited){
      setStatus('Daily Rite access only. Join/renew ACG for full Library.', 'ok');
    }
    var accessChanged = !!(beforeAccess && beforeAccess !== state.acgAccess);
    if(!state.dataLoaded){
      // First entry still loads the saved IndexedDB snapshot or, if no snapshot exists yet, the live database.
      state.dataLoaded = false;
      loadAll({fastBoot:!!state.authFastBoot});
    }else if(accessChanged){
      // Important: do not force a fresh full Sheet reload when ACG/full access is confirmed.
      // That was the reason the Library kept doing the long cache rebuild on every visit.
      refreshLoadedSnapshotAfterAccessChange_(beforeAccess, state.acgAccess);
    }
  }
  function profileFromStoredAuth(auth){
    auth = auth || {};
    var trustedAcg = storedAccessStillFresh_(auth) && authAccessAcg_(auth);
    var trustedIme = storedAccessStillFresh_(auth) && authAccessIme_(auth);
    var trustedBcm = storedAccessStillFresh_(auth) && authAccessBcm_(auth);
    return {
      callsign:String(auth.callsign || '').toUpperCase(),
      displayName:String(auth.displayName || auth.callsign || ''),
      isAdmin:isLibraryAdmin(auth, auth),
      isModerator:!!auth.isModerator,
      canCreatePouches:!!auth.canCreatePouches,
      // A recently server-verified access result is safe to use for first paint.
      // It is revalidated 250 ms later; stale results still open Daily Rite only.
      acg:trustedAcg,
      ACG:trustedAcg ? '1' : '0',
      isAcg:trustedAcg,
      acgActive:trustedAcg,
      ime:trustedIme,
      IME:trustedIme ? '1' : '0',
      isIme:trustedIme,
      inIme:trustedIme,
      bcm:trustedBcm,
      BCM:trustedBcm ? '1' : '0',
      isBcm:trustedBcm,
      inBcm:trustedBcm
    };
  }
  function storedAccessStillFresh_(auth){
    auth = auth || {};
    var verifiedAt = Number(auth.ts || 0);
    return !!(verifiedAt && (Date.now() - verifiedAt) >= 0 && (Date.now() - verifiedAt) < 12 * 60 * 60 * 1000);
  }
  async function validateStoredAuth(opts){
    opts = opts || {};
    var background = !!opts.background;
    if(!background){
      setAuthVisual('checking');
      setAuthMsg('Checking login...', false);
    }
    var auth = readSessionAuth() || readAuth();
    if(!auth || !auth.token){
      if(!background){
        setAuthVisual('locked');
        setAuthMsg('Please log in with your SLB account.', false);
        try{
          var last = localStorage.getItem('ty_auth_last_callsign') || '';
          if(authEls.callsign && last && !authEls.callsign.value) authEls.callsign.value = String(last).toUpperCase();
        }catch(e){}
      }
      return;
    }
    applySession(auth);
    try{
      tydPerfMark_('access-check-start', 'saved session');
      var access = await slbApi('getLibraryAccess', {}, auth.token);
      var p = access && access.profile ? access.profile : access;
      if(!p || !p.callsign) throw new Error('Bad session.');
      var next = {
        token:String(auth.token || ''),
        callsign:String(p.callsign || auth.callsign || '').toUpperCase(),
        displayName:String(p.displayName || auth.displayName || p.callsign || ''),
        isAdmin:isLibraryAdmin(p, auth),
        role:String(p.role || ''),
        isModerator:!!p.isModerator,
        canCreatePouches:!!p.canCreatePouches,
        libraryAccess:String(p.libraryAccess || ''),
        isLineageMember:!!p.isLineageMember,
        acg: hasAcgField_(p) ? authAccessAcg_(p) : false,
        ACG: (hasAcgField_(p) ? authAccessAcg_(p) : false) ? '1' : '0',
        isAcg: hasAcgField_(p) ? authAccessAcg_(p) : false,
        acgActive: hasAcgField_(p) ? authAccessAcg_(p) : false,
        ime:authAccessIme_(p),
        IME:authAccessIme_(p) ? '1' : '0',
        isIme:authAccessIme_(p),
        inIme:authAccessIme_(p),
        bcm:authAccessBcm_(p),
        BCM:authAccessBcm_(p) ? '1' : '0',
        isBcm:authAccessBcm_(p),
        inBcm:authAccessBcm_(p),
        ts:Date.now(),
        expiresAt:tokenExpiryMs_(auth.token)||(Date.now()+14*24*60*60*1000)
      };
      writeAuth(next);
      applySession(next);
      try{ localStorage.setItem('ty_auth_last_callsign', next.callsign); }catch(e2){}
      state.authFastBoot = false;
      applyLibraryAuth(next, p);
      tydPerfMark_('access-check-ready', String(next.libraryAccess || (next.acg ? 'full' : 'daily')));
      if(background){
        if(state.fastDirectoryMode) setStatus('Saved login confirmed — fast directory ready; selected text opens from local cache.', 'ok');
        else setStatus('Saved login confirmed — '+(state.items.length || 0)+' items / '+(state.lines.length || 0)+' lines / '+state.rcAtlas.length+' RC entries', 'ok');
      }
    }catch(err){
      clearAuth();
      state.authReady = false;
      state.authFastBoot = false;
      setAuthVisual('locked');
      setAuthMsg('Session expired. Please log in again.', true);
      if(authEls.pin) authEls.pin.value = '';
    }
  }
  function fastBootStoredAuth(){
    var auth = readSessionAuth() || readAuth();
    if(!auth || !auth.token) return false;
    var trustStoredAccess = storedAccessStillFresh_(auth);
    // Old access results open limited first. Fresh server-verified results can
    // paint the saved full directory immediately, avoiding a second full render.
    if(!auth.isAdmin && !trustStoredAccess){
      auth.acg = false; auth.ACG = '0'; auth.isAcg = false; auth.acgActive = false; auth.inAcg = false;
      auth.ime = false; auth.IME = '0'; auth.isIme = false; auth.inIme = false;
    }
    state.authFastBoot = true;
    applySession(auth);
    setAuthMsg('Opening saved login...', false);
    applyLibraryAuth(auth, profileFromStoredAuth(auth));
    setTimeout(function(){ validateStoredAuth({background:true}); }, 250);
    return true;
  }
  async function doLibraryLogin(){
    var callsign = String((authEls.callsign && authEls.callsign.value) ? authEls.callsign.value : '').trim().toUpperCase();
    var pin = String((authEls.pin && authEls.pin.value) ? authEls.pin.value : '').trim();
    if(!callsign || !/^\d{4}$/.test(pin)){
      setAuthMsg('Enter callsign and four-digit PIN.', true);
      if(!callsign && authEls.callsign) authEls.callsign.focus();
      else if(authEls.pin) authEls.pin.focus();
      return;
    }
    if(authEls.login) authEls.login.disabled = true;
    setAuthMsg('Logging in...', false);
    try{
      tydPerfMark_('library-login-start', callsign);
      var out = await slbApi('libraryLogin', { callsign:callsign, pin:pin }, '');
      if(!out || !out.token || !out.profile) throw new Error('Login failed.');
      var p = out.profile;
      var auth = {
        token:String(out.token || ''),
        callsign:String(p.callsign || callsign || '').toUpperCase(),
        displayName:String(p.displayName || p.callsign || callsign || ''),
        isAdmin:isLibraryAdmin(p, {callsign:callsign}),
        role:String(p.role || ''),
        isModerator:!!p.isModerator,
        canCreatePouches:!!p.canCreatePouches,
        libraryAccess:String(p.libraryAccess || ''),
        isLineageMember:!!p.isLineageMember,
        acg:authAccessAcg_(p),
        ACG:authAccessAcg_(p) ? '1' : '0',
        isAcg:authAccessAcg_(p),
        acgActive:authAccessAcg_(p),
        ime:authAccessIme_(p),
        IME:authAccessIme_(p) ? '1' : '0',
        isIme:authAccessIme_(p),
        inIme:authAccessIme_(p),
        bcm:authAccessBcm_(p),
        BCM:authAccessBcm_(p) ? '1' : '0',
        isBcm:authAccessBcm_(p),
        inBcm:authAccessBcm_(p),
        ts:Date.now(),
        expiresAt:tokenExpiryMs_(out.token)||(Date.now()+14*24*60*60*1000)
      };
      writeAuth(auth);
      applySession(auth);
      try{ localStorage.setItem('ty_auth_last_callsign', auth.callsign); }catch(e2){}
      if(authEls.pin) authEls.pin.value = '';
      setAuthMsg('', false);
      applyLibraryAuth(auth, p);
      tydPerfMark_('library-login-ready', String(p.libraryAccess || (auth.acg ? 'full' : 'daily')));
      try{ window.dispatchEvent(new CustomEvent('ty_auth_ready', { detail:auth })); }catch(e3){}
    }catch(err){
      setAuthMsg((err && err.message) ? err.message : 'Login failed.', true);
      if(authEls.pin) authEls.pin.focus();
    }finally{
      if(authEls.login) authEls.login.disabled = false;
    }
  }
  function startAuthGate(){
    if(authEls.login) authEls.login.addEventListener('click', doLibraryLogin);
    if(authEls.pin) authEls.pin.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); doLibraryLogin(); } });
    if(authEls.callsign){
      authEls.callsign.addEventListener('input', function(){ this.value = String(this.value || '').toUpperCase().replace(/[^A-Z0-9]/g,''); });
      authEls.callsign.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); if(authEls.pin) authEls.pin.focus(); } });
    }
    if(!fastBootStoredAuth()) validateStoredAuth();
  }

  function cleanDisplayText(s){ return String(s == null ? '' : s).replace(/[\u200B-\u200D\uFEFF]/g, ''); }
  function cleanLineText(s){ return cleanDisplayText(s).replace(/\s+\/\s+/g, '\n'); }
  function escapeHtml(s){ return cleanDisplayText(s).replace(/[&<>\"]/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;'}[c]); }); }
  function norm(s){ return String(s || '').toLowerCase().trim(); }
  function uniq(arr){ return Array.from(new Set(arr.filter(Boolean))).sort(function(a,b){return String(a).localeCompare(String(b));}); }

  var TYD_CACHE_VERSION = 140;
  var TYD_CACHE_KEY = 'tydLineageLibraryData:' + CFG.sheetId + ':v' + TYD_CACHE_VERSION;
  var TYD_CACHE_DB = 'tydLineageLibraryCache';
  var TYD_CACHE_STORE = 'payloads';
  var TYD_SUPERCHARGE_FLAG_KEY = 'tydLineageLibrarySupercharged:' + CFG.sheetId + ':v' + TYD_CACHE_VERSION;
  var TYD_LAST_LIVE_CHECK_KEY = 'tydLineageLibraryLastLiveCheck:' + CFG.sheetId + ':v' + TYD_CACHE_VERSION;
  var TYD_V69D_BOOT_SNAPSHOT_KEY = 'tydLineageLibraryBootSnapshot:' + CFG.sheetId + ':v' + TYD_CACHE_VERSION;
  var TYD_BAD_INSTANT_BOOT_KEYS = [
    TYD_V69D_BOOT_SNAPSHOT_KEY,
    'tydLineageLibraryFastBoot:' + CFG.sheetId + ':v' + TYD_CACHE_VERSION,
    'tydLineageLibraryInstantBoot:' + CFG.sheetId + ':v' + TYD_CACHE_VERSION,
    'tydLineageLibraryInstantDirectoryBoot:' + CFG.sheetId + ':v' + TYD_CACHE_VERSION
  ];
  // v131 deliberately changes only the small boot index. The full v114 cache
  // remains compatible, so existing users do not need to download Lines again.
  var TYD_FAST_DIR_CACHE_KEY = TYD_CACHE_KEY + ':fastDirectory:v135';
  var TYD_LEGACY_FAST_DIR_CACHE_KEY = TYD_CACHE_KEY + ':fastDirectory:v131';
  var TYD_LINE_CACHE_PREFIX = TYD_CACHE_KEY + ':lineByItem:v129:';
  var TYD_BOOK_CACHE_PREFIX = TYD_CACHE_KEY + ':bookText:v135:';
  var TYD_LINE_CACHE_META_KEY = TYD_CACHE_KEY + ':lineByItem:v129:meta';
  var TYD_LINE_CACHE_READY_KEY = TYD_LINE_CACHE_META_KEY + ':ready';
  // Teaching Videos + Fun Watch + Articles + Supplies are a small authenticated collection dataset.
  // Keep only collection DIRECTORY METADATA in a tiny localStorage snapshot so those directories can
  // paint synchronously before any network request starts. Article bodies live in IndexedDB.
  var TYD_COLLECTION_CACHE_KEY = TYD_CACHE_KEY + ':collections:v8';
  var TYD_COLLECTION_REFRESH_KEY = TYD_COLLECTION_CACHE_KEY + ':lastRefresh';
  var TYD_ARTICLE_CACHE_PREFIX = TYD_CACHE_KEY + ':articleBody:v1:';
  var TYD_COLLECTION_REFRESH_INTERVAL_MS = 10 * 60 * 1000;
  var TYD_IDB_OPEN_TIMEOUT_MS = 3200;
  var TYD_IDB_READ_TIMEOUT_MS = 4200;
  var TYD_IDB_WRITE_TIMEOUT_MS = 6500;
  // v120 safety rollback: remove the partial/instant directory snapshots from v117-v119.
  // They were too small and could make directory groups expand with empty content.
  try{ TYD_BAD_INSTANT_BOOT_KEYS.forEach(function(k){ localStorage.removeItem(k); sessionStorage.removeItem(k); }); localStorage.removeItem(TYD_LEGACY_FAST_DIR_CACHE_KEY); }catch(e){}
  var TYD_LIVE_CHECK_INTERVAL_MS = 30 * 60 * 1000;
  var TYD_USER_QUIET_MS = 2200;
  var TYD_MANIFEST_CONCURRENCY = 2;
  var TYD_BOOK_PROGRESSIVE_SECTION_THRESHOLD = 18;
  var TYD_BOOK_PROGRESSIVE_LINE_THRESHOLD = 320;
  var TYD_BOOK_PROGRESSIVE_CHUNK_SECTIONS = 8;
  var TYD_LIBRARY_TABS = [CFG.sheets.items, CFG.sheets.lines, CFG.sheets.books, CFG.sheets.index];
  var TYD_TAB_PROP = { Items:'items', Lines:'lines', Books:'books', Book_Index:'index', Review_Log:'review', Saamlawnese_Exceptions:'exceptions', RC_Atlas:'rcAtlas', God_Atlas:'godAtlas' };
  var TYD_MANIFEST_FIELDS = {
    // Content-signature fields. Keep this matched to TYD_MANIFEST_COLS below.
    // updated_at is checked separately through TYD_ROW_INDEX_COLS so timestamp changes alone do not force full-tab reloads.
    Items:['item_id','type','chinese_title','english_title','category','first_source_book','status','notes','image_url','image_alt','image_caption'],
    Lines:['item_id','line_no','chinese','saamlawnese','english_translation','source_book','status','notes'],
    Books:['book_id','book_title_chinese','book_title_english','file_name','updated_date','status','notes','library_type','category_group','directory_group','display_order'],
    Book_Index:['book_id','order_no','item_id','display_section','source_book','notes'],
    Review_Log:['date','book_id','item_id','line_no','problem','status']
  };
  var TYD_MANIFEST_COLS = {
    // Do not include updated_at here. It is used only by the row-level index below.
    Items:['A','B','C','D','E','F','G','H','J','K','L'],
    Lines:['A','B','C','D','E','F','G','H'],
    Books:['A','B','C','D','E','F','G','H','I','J','K'],
    Book_Index:['A','B','C','D','E','F'],
    God_Atlas:['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O'],
    Review_Log:['A','B','C','D','E','G']
  };
  var TYD_ROW_INDEX_COLS = {
    // updated_at columns in the live TYD database:
    // Items I, Lines I, Books L, Book_Index G.
    Items:['A','I'],
    Lines:['A','B','I'],
    Books:['A','L'],
    Book_Index:['A','B','C','G'],
    God_Atlas:['A','AD']
  };
  var TYD_SUMMARY_STAMP_COL = { Items:'I', Lines:'I', Books:'L', Book_Index:'G' };
  var TYD_ROW_KEY_FIELDS = {
    Items:['item_id'],
    Lines:['item_id','line_no'],
    Books:['book_id'],
    Book_Index:['book_id','order_no','item_id'],
    God_Atlas:['god_id']
  };
  var TYD_PRIMARY_ID_FIELDS = { Items:'item_id', Lines:'item_id', Books:'book_id', Book_Index:'book_id', God_Atlas:'god_id' };

  function runWhenIdle(fn, timeout){
    if(window.requestIdleCallback) return window.requestIdleCallback(fn, { timeout: timeout || 1500 });
    return setTimeout(fn, 0);
  }
  function yieldToBrowser(delay){
    return new Promise(function(resolve){ setTimeout(resolve, delay || 0); });
  }
  function withSoftTimeout(promise, ms, fallbackValue){
    var done = false;
    return new Promise(function(resolve, reject){
      var timer = setTimeout(function(){
        if(done) return;
        done = true;
        resolve(fallbackValue);
      }, ms || 7000);
      Promise.resolve(promise).then(function(value){
        if(done) return;
        done = true;
        clearTimeout(timer);
        resolve(value);
      }, function(err){
        if(done) return;
        done = true;
        clearTimeout(timer);
        reject(err);
      });
    });
  }
  function prepareSuperchargeAtlasData(data){
    data = data || {};
    var rcRows = normalizeRcAtlasRows(data.rcAtlas || []).map(rcNormalizeEntryForDisplay);
    data.rcAtlas = (rcRows.length ? rcRows : ((state.rcAtlas && state.rcAtlas.length) ? state.rcAtlas : RC_ATLAS_DEFAULT_ENTRIES).slice()).map(rcNormalizeEntryForDisplay);
    var godRows = mergeGodFallbackArt(normalizeGodAtlasRows(data.godAtlas || []));
    data.godAtlas = godRows.length ? godRows : (((state.godAtlas && state.godAtlas.length) ? state.godAtlas : GOD_ATLAS_DEFAULT_ENTRIES).slice());
    return data;
  }
  function markUserActivity(){ state._lastUserActivity = Date.now(); }
  function userIsQuiet(ms){ return (Date.now() - (state._lastUserActivity || 0)) >= (ms || TYD_USER_QUIET_MS); }
  function runWhenQuiet(fn, maxWaitMs){
    var started = Date.now();
    function attempt(){
      var wait = TYD_USER_QUIET_MS - (Date.now() - (state._lastUserActivity || 0));
      if(wait > 0 && (Date.now() - started) < (maxWaitMs || 15000)){
        setTimeout(attempt, Math.min(900, wait + 80));
        return;
      }
      runWhenIdle(fn, 2000);
    }
    setTimeout(attempt, 0);
  }
  function writeTinyCacheFallback(payload){
    // Do not put the whole library into localStorage. Large synchronous writes can freeze the page.
    try{
      localStorage.setItem(TYD_CACHE_KEY + ':mini', JSON.stringify({ v:TYD_CACHE_VERSION, savedAt:Date.now(), supercharged:!!(payload && payload.supercharged) }));
    }catch(e){}
  }
  function cacheStamp(ts){ return new Date(ts || Date.now()).toLocaleString([], {month:'short', day:'numeric', hour:'2-digit', minute:'2-digit'}); }
  function cacheMiniData(data){
    data = data || {};
    return {
      v: TYD_CACHE_VERSION,
      savedAt: Number(data.savedAt || Date.now()) || Date.now(),
      supercharged: !!data.supercharged,
      compactDirectory: !!data.compactDirectory,
      manifest: data.manifest || null,
      items: data.items || [],
      lines: data.lines || [],
      books: data.books || [],
      index: data.index || [],
      rcAtlas: data.rcAtlas || [],
      godAtlas: data.godAtlas || [],
      review: data.review || []
    };
  }

  function compactBootGroupData_(groups){
    var out = {};
    Object.keys(groups || {}).forEach(function(key){
      var src = groups[key] || {};
      var row = { type:src.type || '', title:src.title || '', bookId:src.bookId || '' };
      if(Array.isArray(src.bookIds)) row.bookIds = src.bookIds.slice();
      if(Array.isArray(src.items)) row.itemIds = src.items.map(function(item){ return item && item.item_id; }).filter(Boolean);
      out[key] = row;
    });
    return out;
  }
  function expandBootGroupData_(groups){
    var out = {};
    var used = {};
    Object.keys(groups || {}).forEach(function(key){
      var src = groups[key] || {};
      var row = Object.assign({}, src);
      if(Array.isArray(src.itemIds)){
        row.items = src.itemIds.map(function(id){ if(id) used[id] = true; return state._itemsById && state._itemsById[id]; }).filter(Boolean);
        if(src.type === 'book' && src.bookId){
          state._bookItemsFullCache = state._bookItemsFullCache || {};
          state._bookItemsFullCache[String(src.bookId)] = row.items.slice();
        }
      }
      out[key] = row;
    });
    if(Object.keys(used).length) state._itemsUsedByBookGroupsCache = used;
    return out;
  }
  function currentClosedBookBoot_(){
    try{
      var key = ['book','sheet','',''].join('\u001f');
      var cached = state._directoryRenderCache && state._directoryRenderCache[key];
      if(cached && cached.html) return { html:cached.html, count:Number(cached.count || 0), groups:compactBootGroupData_(cached.groupData || {}) };
    }catch(_e){}
    return null;
  }

  function cacheDirectoryData(data){
    data = data || {};
    var boot = (data.bootHtml ? { html:data.bootHtml, count:Number(data.bootCount || 0), groups:data.bootGroups || {} } : null) || currentClosedBookBoot_();
    return {
      v: TYD_CACHE_VERSION,
      savedAt: Date.now(),
      supercharged: !!data.supercharged,
      // Row-level manifests can be larger than the directory itself (especially
      // Lines). Keep those in the full IndexedDB snapshot, never in the
      // synchronous localStorage boot index.
      manifest: data.manifest ? { v:data.manifest.v || 0, madeAt:data.manifest.madeAt || Date.now(), tabs:data.manifest.tabs || {}, summaries:data.manifest.summaries || {} } : null,
      items: data.items || [],
      books: data.books || [],
      index: data.index || [],
      // RC/God defaults are already embedded in this asset and the full cache is
      // opened quietly after first paint. Duplicating them here made every boot
      // parse and stringify hundreds of KB that the directory did not need.
      rcAtlas: [],
      godAtlas: [],
      review: [],
      lineCount: Array.isArray(data.lines) ? data.lines.length : Number(data.lineCount || 0) || 0,
      bootHtml:boot && boot.html || '',
      bootCount:boot && Number(boot.count || 0) || 0,
      bootGroups:boot && boot.groups || {}
    };
  }
  function validFastDirectoryCache(payload){
    return payload && payload.v === TYD_CACHE_VERSION && Array.isArray(payload.items) && Array.isArray(payload.books) && Array.isArray(payload.index);
  }
  function readBundledDirectoryBootstrap_(){
    try{
      var payload = window.TYD_LIBRARY_BOOTSTRAP_V132;
      return validFastDirectoryCache(payload) ? payload : null;
    }catch(e){ return null; }
  }
  function readFastDirectoryCacheSync(){
    // Phase 2: never parse a large directory JSON object synchronously from localStorage.
    return null;
  }
  function writeFastDirectoryCache(payload){
    var dir = cacheDirectoryData(payload);
    state._pendingFastDirectoryWrite = dir;
    if(state._fastDirectoryWriteScheduled) return;
    state._fastDirectoryWriteScheduled = true;
    runWhenQuiet(function(){
      var next = state._pendingFastDirectoryWrite;
      state._pendingFastDirectoryWrite = null;
      state._fastDirectoryWriteScheduled = false;
      if(!next) return;
      try{
        openCacheDb().then(function(db){
          var done = false;
          var timer = setTimeout(function(){ if(done) return; done = true; try{ db.close(); }catch(e){} }, TYD_IDB_WRITE_TIMEOUT_MS);
          try{
            var tx = db.transaction(TYD_CACHE_STORE, 'readwrite');
            function finish(){ if(done) return; done = true; clearTimeout(timer); try{ db.close(); }catch(e){} }
            tx.oncomplete = finish; tx.onerror = finish; tx.onabort = finish;
            tx.objectStore(TYD_CACHE_STORE).put({ key:TYD_FAST_DIR_CACHE_KEY, payload:next });
          }catch(e2){ clearTimeout(timer); done = true; try{ db.close(); }catch(e3){} }
        }).catch(function(){});
      }catch(e4){}
    }, 12000);
  }
  function readFastDirectoryCacheAsync(){
    return openCacheDb().then(function(db){
      return new Promise(function(resolve){
        var settled = false;
        var timer = setTimeout(function(){
          if(settled) return;
          settled = true;
          try{ db.close(); }catch(e){}
          resolve(null);
        }, TYD_IDB_READ_TIMEOUT_MS);
        function finish(value){
          if(settled) return;
          settled = true;
          clearTimeout(timer);
          try{ db.close(); }catch(e){}
          resolve(value);
        }
        var tx = db.transaction(TYD_CACHE_STORE, 'readonly');
        var store = tx.objectStore(TYD_CACHE_STORE);
        var req = store.get(TYD_FAST_DIR_CACHE_KEY);
        req.onsuccess = function(){ finish(req.result && req.result.payload ? req.result.payload : null); };
        req.onerror = function(){ finish(null); };
        tx.onabort = function(){ finish(null); };
        tx.onerror = function(){ finish(null); };
      });
    }).catch(function(){ return null; });
  }
  function lineCacheKey(itemId){ return TYD_LINE_CACHE_PREFIX + encodeURIComponent(String(itemId || '')); }
  function bookCacheKey(bookId){ return TYD_BOOK_CACHE_PREFIX + encodeURIComponent(String(bookId || '')); }
  function persistLazyLineSelection_(map, bookId, itemIds){
    map = map || {};
    var writeIds = Object.keys(map).filter(Boolean).map(String);
    itemIds = Array.from(new Set((itemIds || writeIds).filter(Boolean).map(String)));
    if(!writeIds.length && !bookId) return Promise.resolve(false);
    return openCacheDb().then(function(db){
      return new Promise(function(resolve){
        var settled=false, timer=setTimeout(function(){ finish(false); }, TYD_IDB_WRITE_TIMEOUT_MS);
        function finish(ok){ if(settled) return; settled=true; clearTimeout(timer); try{ db.close(); }catch(e){} resolve(!!ok); }
        try{
          var tx=db.transaction(TYD_CACHE_STORE,'readwrite'), store=tx.objectStore(TYD_CACHE_STORE), lineCount=0;
          writeIds.forEach(function(id){ var rows=map[id] || []; lineCount += rows.length; store.put({key:lineCacheKey(id),payload:{v:TYD_CACHE_VERSION,itemId:id,lines:rows,savedAt:Date.now()}}); });
          if(bookId) store.put({key:bookCacheKey(bookId),payload:{v:TYD_CACHE_VERSION,bookId:String(bookId),itemIds:itemIds,savedAt:Date.now(),lineCount:lineCount}});
          tx.oncomplete=function(){ finish(true); }; tx.onerror=function(){ finish(false); }; tx.onabort=function(){ finish(false); };
        }catch(err){ finish(false); }
      });
    }).catch(function(){ return false; });
  }
  function groupLinesByItem_(rows){
    var grouped = {};
    (rows || []).forEach(function(l){
      if(!l || !l.item_id) return;
      var id = String(l.item_id);
      (grouped[id] = grouped[id] || []).push(l);
    });
    Object.keys(grouped).forEach(function(id){ grouped[id].sort(function(a,b){ return Number(a.line_no||0)-Number(b.line_no||0); }); });
    return grouped;
  }
  function scheduleLazyLineCacheWrite(payload){
    payload = payload || {};
    var rows = payload.lines || [];
    if(!rows || !rows.length) return;
    var lineTab = payload.manifest && payload.manifest.tabs ? payload.manifest.tabs[CFG.sheets.lines] : null;
    var cacheSignature = [rows.length, (payload.items || []).length, lineTab && lineTab.hash || '', lineTab && lineTab.count || ''].join(':');
    try{ if(localStorage.getItem(TYD_LINE_CACHE_READY_KEY) === cacheSignature) return; }catch(eReady){}
    // Write line text as per-item records so future page visits do not need to open one giant cache object.
    setTimeout(function(){
      runWhenIdle(function(){
        try{
          var grouped = groupLinesByItem_(rows);
          (payload.items || []).forEach(function(item){
            if(item && item.item_id && !grouped[String(item.item_id)]) grouped[String(item.item_id)] = [];
          });
          var ids = Object.keys(grouped);
          if(!ids.length) return;
          openCacheDb().then(function(db){
            return new Promise(function(resolve){
              var pos = 0;
              var batchSize = 24;
              var finished = false;
              function finish(ok){
                if(finished) return;
                finished = true;
                if(ok){ try{ localStorage.setItem(TYD_LINE_CACHE_READY_KEY, cacheSignature); }catch(eReadyWrite){} }
                try{ db.close(); }catch(e){}
                resolve(!!ok);
              }
              function writeBatch(){
                if(finished) return;
                if(pos >= ids.length){ finish(true); return; }
                var batch = ids.slice(pos, pos + batchSize);
                var timer = setTimeout(function(){ finish(false); }, TYD_IDB_WRITE_TIMEOUT_MS);
                try{
                  var tx = db.transaction(TYD_CACHE_STORE, 'readwrite');
                  var store = tx.objectStore(TYD_CACHE_STORE);
                  if(pos === 0) store.put({ key:TYD_LINE_CACHE_META_KEY, payload:{ v:TYD_CACHE_VERSION, savedAt:Date.now(), count:ids.length, lineCount:rows.length, ids:ids } });
                  batch.forEach(function(id){ store.put({ key:lineCacheKey(id), payload:{ v:TYD_CACHE_VERSION, itemId:id, lines:grouped[id] || [] } }); });
                  tx.oncomplete = function(){
                    clearTimeout(timer);
                    pos += batch.length;
                    setTimeout(writeBatch, 0);
                  };
                  tx.onerror = function(){ clearTimeout(timer); finish(false); };
                  tx.onabort = function(){ clearTimeout(timer); finish(false); };
                }catch(err){ clearTimeout(timer); finish(false); }
              }
              writeBatch();
            });
          }).catch(function(){});
        }catch(e){}
      }, 4000);
    }, 900);
  }
  function clearFastBootCaches(){
    try{ localStorage.removeItem(TYD_FAST_DIR_CACHE_KEY); }catch(e){}
    try{ localStorage.removeItem(TYD_LINE_CACHE_READY_KEY); }catch(eReady){}
    return openCacheDb().then(function(db){
      return new Promise(function(resolve){
        try{
          var tx = db.transaction(TYD_CACHE_STORE, 'readwrite');
          var store = tx.objectStore(TYD_CACHE_STORE);
          var req = store.openCursor();
          req.onsuccess = function(ev){
            var cur = ev.target.result;
            if(cur){
              var k = String(cur.key || '');
              if(k === TYD_FAST_DIR_CACHE_KEY || k === TYD_LINE_CACHE_META_KEY || k.indexOf(TYD_LINE_CACHE_PREFIX) === 0 || k.indexOf(TYD_BOOK_CACHE_PREFIX) === 0 || k.indexOf(TYD_ARTICLE_CACHE_PREFIX) === 0) cur.delete();
              cur.continue();
            }
          };
          tx.oncomplete = function(){ try{ db.close(); }catch(e){} resolve(true); };
          tx.onerror = function(){ try{ db.close(); }catch(e){} resolve(false); };
        }catch(e2){ try{ db.close(); }catch(e3){} resolve(false); }
      });
    }).catch(function(){ return false; });
  }
  function cacheFromCurrentState(){
    return cacheMiniData({ items:state.items, lines:state.lines, books:state.books, index:state.index, rcAtlas:state.rcAtlas, godAtlas:state.godAtlas, review:state.review, manifest:state.cacheManifest, supercharged:!!state.supercharged });
  }
  function readLocalCacheFallback(){
    try{ return JSON.parse(localStorage.getItem(TYD_CACHE_KEY) || 'null'); }catch(e){ return null; }
  }
  function writeLocalCacheFallback(payload){
    try{ localStorage.setItem(TYD_CACHE_KEY, JSON.stringify(payload)); }catch(e){}
  }
  function markSuperchargedFlag(v){
    try{
      if(v) localStorage.setItem(TYD_SUPERCHARGE_FLAG_KEY, '1');
      else localStorage.removeItem(TYD_SUPERCHARGE_FLAG_KEY);
    }catch(e){}
  }
  function getSessionNumber(key){
    var n = 0;
    try{ n = Number(sessionStorage.getItem(key) || '0') || 0; }catch(e){}
    if(n) return n;
    try{ n = Number(localStorage.getItem(key) || '0') || 0; }catch(e2){}
    return n || 0;
  }
  function setSessionNumber(key, value){
    try{ sessionStorage.setItem(key, String(value || 0)); }catch(e){}
    try{ localStorage.setItem(key, String(value || 0)); }catch(e2){}
  }
  function recentLiveCheck(maxAgeMs){
    var last = getSessionNumber(TYD_LAST_LIVE_CHECK_KEY);
    return !!(last && (Date.now() - last) < (maxAgeMs || 600000));
  }
  function markLiveCheckDone(){ setSessionNumber(TYD_LAST_LIVE_CHECK_KEY, Date.now()); }
  function openCacheDb(){
    return new Promise(function(resolve, reject){
      if(!window.indexedDB){ reject(new Error('IndexedDB unavailable')); return; }
      var settled = false;
      var timer = setTimeout(function(){
        if(settled) return;
        settled = true;
        reject(new Error('Library cache open timed out'));
      }, TYD_IDB_OPEN_TIMEOUT_MS);
      var req;
      try{ req = indexedDB.open(TYD_CACHE_DB, 1); }
      catch(err){ clearTimeout(timer); settled = true; reject(err); return; }
      req.onupgradeneeded = function(ev){
        var db = ev.target.result;
        if(!db.objectStoreNames.contains(TYD_CACHE_STORE)) db.createObjectStore(TYD_CACHE_STORE, { keyPath:'key' });
      };
      req.onsuccess = function(){
        if(settled){ try{ req.result.close(); }catch(e){} return; }
        settled = true;
        clearTimeout(timer);
        resolve(req.result);
      };
      req.onerror = function(){
        if(settled) return;
        settled = true;
        clearTimeout(timer);
        reject(req.error || new Error('Could not open cache'));
      };
      req.onblocked = function(){
        if(settled) return;
        settled = true;
        clearTimeout(timer);
        reject(new Error('Library cache is blocked by another tab'));
      };
    });
  }
  function readCachedLibrary(){
    return openCacheDb().then(function(db){
      return new Promise(function(resolve){
        var settled = false;
        var timer = setTimeout(function(){ finish(readLocalCacheFallback()); }, TYD_IDB_READ_TIMEOUT_MS);
        function finish(value){
          if(settled) return;
          settled = true;
          clearTimeout(timer);
          try{ db.close(); }catch(e){}
          resolve(value);
        }
        try{
          var tx = db.transaction(TYD_CACHE_STORE, 'readonly');
          var store = tx.objectStore(TYD_CACHE_STORE);
          var req = store.get(TYD_CACHE_KEY);
          req.onsuccess = function(){ finish(req.result && req.result.payload ? req.result.payload : null); };
          req.onerror = function(){ finish(readLocalCacheFallback()); };
          tx.onabort = function(){ finish(readLocalCacheFallback()); };
          tx.onerror = function(){ finish(readLocalCacheFallback()); };
        }catch(err){ finish(readLocalCacheFallback()); }
      });
    }).catch(function(){ return readLocalCacheFallback(); });
  }
  function writeCachedLibrary(payload){
    payload = cacheMiniData(payload);
    markSuperchargedFlag(!!payload.supercharged);
    writeTinyCacheFallback(payload);
    writeFastDirectoryCache(payload);
    scheduleLazyLineCacheWrite(payload);
    // IndexedDB write is async. Avoid the old localStorage full-library fallback because it blocks clicks/scrolls.
    return openCacheDb().then(function(db){
      return new Promise(function(resolve){
        var settled = false;
        var timer = setTimeout(function(){ finish(false); }, TYD_IDB_WRITE_TIMEOUT_MS);
        function finish(ok){
          if(settled) return;
          settled = true;
          clearTimeout(timer);
          try{ db.close(); }catch(e){}
          resolve(!!ok);
        }
        try{
          var tx = db.transaction(TYD_CACHE_STORE, 'readwrite');
          tx.oncomplete = function(){ finish(true); };
          tx.onerror = function(){ finish(false); };
          tx.onabort = function(){ finish(false); };
          tx.objectStore(TYD_CACHE_STORE).put({ key:TYD_CACHE_KEY, payload:payload });
        }catch(err){ finish(false); }
      });
    }).catch(function(){ return false; });
  }
  function scheduleCachedLibraryWrite(){
    var payload = cacheFromCurrentState();
    runWhenIdle(function(){ writeCachedLibrary(payload); }, 2000);
  }
  function clearLibraryCache(){
    if(!window.confirm('Clear the saved Library snapshot on this device and reload it from the Library database?')) return;
    markSuperchargedFlag(false);
    try{ localStorage.removeItem(TYD_CACHE_KEY); }catch(e){}
    try{ localStorage.removeItem(TYD_CACHE_KEY + ':mini'); }catch(e2){}
    try{ localStorage.removeItem(TYD_FAST_DIR_CACHE_KEY); }catch(eFast){}
    try{ localStorage.removeItem(TYD_COLLECTION_CACHE_KEY); localStorage.removeItem(TYD_COLLECTION_REFRESH_KEY); }catch(eCollections){}
    try{ sessionStorage.removeItem(TYD_LAST_LIVE_CHECK_KEY); }catch(e3){}
    try{ localStorage.removeItem(TYD_LAST_LIVE_CHECK_KEY); }catch(e4){}
    state.supercharged = false;
    state.cacheManifest = null;
    function finish(){
      setStatus('Cache reset — loading fresh library...', 'ok');
      loadAll({force:true});
    }
    return openCacheDb().then(function(db){
      return new Promise(function(resolve){
        var tx = db.transaction(TYD_CACHE_STORE, 'readwrite');
        tx.oncomplete = function(){ try{ db.close(); }catch(e){} resolve(true); };
        tx.onerror = function(){ try{ db.close(); }catch(e){} resolve(false); };
        tx.objectStore(TYD_CACHE_STORE).delete(TYD_CACHE_KEY);
      });
    }).then(function(){ return clearFastBootCaches(); }).then(finish).catch(finish);
  }
  function validCachedLibrary(payload){
    return payload && payload.v === TYD_CACHE_VERSION && Array.isArray(payload.items) && Array.isArray(payload.lines) && Array.isArray(payload.books) && Array.isArray(payload.index);
  }
  function manifestVal(v){ return String(v == null ? '' : v).replace(/\s+/g, ' ').trim(); }
  function manifestHash(str){
    str = String(str || '');
    var h = 2166136261;
    for(var i=0;i<str.length;i++){
      h ^= str.charCodeAt(i);
      h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
    }
    return ('00000000' + (h >>> 0).toString(16)).slice(-8);
  }
  function manifestFromMatrix(rows){
    rows = rows || [];
    var body = rows.map(function(r){ return (r || []).map(manifestVal).join('\u001f'); }).join('\u001e');
    return { count:rows.length, hash:manifestHash(body) };
  }
  function sheetManifestFromFull(sheetName, rows){
    var fields = TYD_MANIFEST_FIELDS[sheetName] || [];
    return manifestFromMatrix((rows || []).map(function(r){ return fields.map(function(k){ return r && r[k]; }); }));
  }
  function buildLibraryManifest(data){
    data = data || {};
    var tabs = {}, rows = {}, summaries = {};
    TYD_LIBRARY_TABS.forEach(function(sheetName){
      var prop = TYD_TAB_PROP[sheetName];
      var list = data[prop] || [];
      tabs[sheetName] = sheetManifestFromFull(sheetName, list);
      rows[sheetName] = rowIndexFromFull(sheetName, list);
      summaries[sheetName] = versionSummaryFromRowIndex_(rows[sheetName]);
    });
    return { v:4, madeAt:Date.now(), tabs:tabs, rows:rows, summaries:summaries };
  }
  function rowKeyParts(sheetName, row){
    row = row || {};
    return (TYD_ROW_KEY_FIELDS[sheetName] || []).map(function(k){ return manifestVal(row[k]); });
  }
  function rowKeyFor(sheetName, row){ return rowKeyParts(sheetName, row).join('\u001f'); }
  function updatedAtValue(row){
    row = row || {};
    return manifestVal(row.updated_at || row.updatedAt || row.updated || row.modified_at || row.modifiedAt || '');
  }
  function rowIndexFromFull(sheetName, rows){
    var seen = {}, list = [];
    (rows || []).forEach(function(r){
      var key = rowKeyFor(sheetName, r);
      if(!key.replace(/\u001f/g, '')) return;
      var stamp = updatedAtValue(r);
      seen[key] = { key:key, updated_at:stamp };
    });
    Object.keys(seen).sort().forEach(function(k){ list.push(seen[k]); });
    return { hasUpdatedAt:list.some(function(x){ return !!x.updated_at; }), count:list.length, list:list };
  }
  function rowIndexFromProjection(sheetName, rows){
    var list = [], hasStamp = false;
    (rows || []).forEach(function(vals){
      vals = vals || [];
      var key = '';
      var stamp = '';
      if(sheetName === CFG.sheets.items){ key = manifestVal(vals[0]); stamp = manifestVal(vals[1]); }
      else if(sheetName === CFG.sheets.lines){ key = [manifestVal(vals[0]), manifestVal(vals[1])].join('\u001f'); stamp = manifestVal(vals[2]); }
      else if(sheetName === CFG.sheets.books){ key = manifestVal(vals[0]); stamp = manifestVal(vals[1]); }
      else if(sheetName === CFG.sheets.index){ key = [manifestVal(vals[0]), manifestVal(vals[1]), manifestVal(vals[2])].join('\u001f'); stamp = manifestVal(vals[3]); }
      else if(sheetName === CFG.sheets.gods){ key = manifestVal(vals[0]); stamp = manifestVal(vals[1]); }
      if(!key || !key.replace(/\u001f/g, '')) return;
      if(stamp) hasStamp = true;
      list.push({ key:key, updated_at:stamp });
    });
    list.sort(function(a,b){ return String(a.key).localeCompare(String(b.key)); });
    return { hasUpdatedAt:hasStamp, count:list.length, list:list };
  }
  function latestUpdatedStamp_(list){
    var best = '', bestTime = -1;
    (list || []).forEach(function(x){
      var stamp = manifestVal(x && x.updated_at);
      if(!stamp) return;
      var time = Date.parse(stamp);
      if(isFinite(time)){
        if(time > bestTime){ bestTime = time; best = stamp; }
      }else if(bestTime < 0 && stamp > best){
        best = stamp;
      }
    });
    return best;
  }
  function versionSummaryFromRowIndex_(rowIndex){
    var list = (rowIndex && rowIndex.list) || [];
    return { count:Number((rowIndex && rowIndex.count) || list.length || 0), maxUpdated:latestUpdatedStamp_(list) };
  }
  function manifestSummaryForTab_(manifest, sheetName){
    if(manifest && manifest.summaries && manifest.summaries[sheetName]) return manifest.summaries[sheetName];
    if(manifest && manifest.rows && manifest.rows[sheetName]) return versionSummaryFromRowIndex_(manifest.rows[sheetName]);
    return null;
  }
  function versionSummariesEqual_(a, b){
    return !!(a && b && Number(a.count || 0) === Number(b.count || 0) && manifestVal(a.maxUpdated) === manifestVal(b.maxUpdated));
  }
  function rowIndexMap(rowIndex){
    var m = {};
    ((rowIndex && rowIndex.list) || []).forEach(function(x){ m[x.key] = x.updated_at || ''; });
    return m;
  }
  function primaryIdFromRowKey(sheetName, key){
    var parts = String(key || '').split('\u001f');
    return parts[0] || '';
  }
  function rowIndexDiff(sheetName, oldIndex, liveIndex){
    var oldMap = rowIndexMap(oldIndex), liveMap = rowIndexMap(liveIndex);
    var changed = [], removed = [], affected = {};
    Object.keys(liveMap).forEach(function(k){
      if(oldMap[k] == null || String(oldMap[k]) !== String(liveMap[k])){
        changed.push(k);
        var id = primaryIdFromRowKey(sheetName, k); if(id) affected[id] = true;
      }
    });
    Object.keys(oldMap).forEach(function(k){
      if(liveMap[k] == null){
        removed.push(k);
        var id = primaryIdFromRowKey(sheetName, k); if(id) affected[id] = true;
      }
    });
    return { changedKeys:changed, removedKeys:removed, primaryIds:Object.keys(affected) };
  }
  function buildIncrementalPlan(oldManifest, liveManifest){
    var legacyChanged = changedManifestTabs(oldManifest, liveManifest);
    var plan = { rowTabs:{}, fullTabs:[], changedTabs:[], canUseRows:false };
    var legacySet = {};
    legacyChanged.forEach(function(t){ legacySet[t] = true; });
    TYD_LIBRARY_TABS.forEach(function(sheetName){
      var oldRows = oldManifest && oldManifest.rows && oldManifest.rows[sheetName];
      var liveRows = liveManifest && liveManifest.rows && liveManifest.rows[sheetName];
      var canRows = !!(oldRows && liveRows && oldRows.hasUpdatedAt && liveRows.hasUpdatedAt);
      if(!canRows){
        if(legacySet[sheetName]){
          plan.fullTabs.push(sheetName);
          plan.changedTabs.push(sheetName);
        }
        return;
      }
      plan.canUseRows = true;
      var diff = rowIndexDiff(sheetName, oldRows, liveRows);
      var hasRowChanges = diff.changedKeys.length || diff.removedKeys.length;
      if(hasRowChanges){
        plan.rowTabs[sheetName] = diff;
        plan.changedTabs.push(sheetName);
      }
    });
    plan.changedTabs = uniq(plan.changedTabs);
    plan.fullTabs = uniq(plan.fullTabs);
    return plan;
  }
  function changedManifestTabs(oldManifest, newManifest){
    var changed = [];
    if(!oldManifest || !oldManifest.tabs || !newManifest || !newManifest.tabs) return TYD_LIBRARY_TABS.slice();
    TYD_LIBRARY_TABS.forEach(function(sheetName){
      var a = oldManifest.tabs[sheetName] || {};
      var b = newManifest.tabs[sheetName] || {};
      if(String(a.hash || '') !== String(b.hash || '') || Number(a.count || 0) !== Number(b.count || 0)) changed.push(sheetName);
    });
    return changed;
  }
  function projectionRows(resp){
    if(!resp || !resp.table || !resp.table.rows) return [];
    return (resp.table.rows || []).map(function(r){
      return (r.c || []).map(function(c){ return cellVal(c); });
    }).filter(function(vals){
      return vals.some(function(v){ return String(v || '').trim() !== ''; });
    });
  }
  function loadSheetProjection(sheetName){
    var cols = TYD_MANIFEST_COLS[sheetName] || ['A'];
    return new Promise(function(resolve, reject){
      var cb = '__tydManifestCb_' + Math.random().toString(36).slice(2);
      var timer, script;
      window[cb] = function(resp){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        if(script && script.parentNode) script.parentNode.removeChild(script);
        try{ resolve(projectionRows(resp)); }catch(err){ reject(err); }
      };
      script = document.createElement('script');
      var tq = 'select ' + cols.join(',') + ' where ' + cols[0] + ' is not null';
      script.src = 'https://docs.google.com/spreadsheets/d/' + encodeURIComponent(CFG.sheetId) + '/gviz/tq?headers=1&sheet=' + encodeURIComponent(sheetName) + '&tq=' + encodeURIComponent(tq) + '&tqx=out:json;responseHandler:' + cb;
      script.onerror = function(){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Could not check Google Sheet tab: ' + sheetName));
      };
      timer = setTimeout(function(){
        try{ if(script && script.parentNode) script.parentNode.removeChild(script); }catch(e){}
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Timed out checking Google Sheet tab: ' + sheetName));
      }, 10000);
      document.head.appendChild(script);
    });
  }
  function loadSheetRowIndexProjection(sheetName){
    var cols = TYD_ROW_INDEX_COLS[sheetName];
    if(!cols) return Promise.resolve(null);
    return new Promise(function(resolve, reject){
      var cb = '__tydRowIndexCb_' + Math.random().toString(36).slice(2);
      var timer, script;
      window[cb] = function(resp){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        if(script && script.parentNode) script.parentNode.removeChild(script);
        try{ resolve(rowIndexFromProjection(sheetName, projectionRows(resp))); }catch(err){ reject(err); }
      };
      script = document.createElement('script');
      var tq = 'select ' + cols.join(',') + ' where ' + cols[0] + ' is not null';
      script.src = 'https://docs.google.com/spreadsheets/d/' + encodeURIComponent(CFG.sheetId) + '/gviz/tq?headers=1&sheet=' + encodeURIComponent(sheetName) + '&tq=' + encodeURIComponent(tq) + '&tqx=out:json;responseHandler:' + cb;
      script.onerror = function(){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Could not check row updates for tab: ' + sheetName));
      };
      timer = setTimeout(function(){
        try{ if(script && script.parentNode) script.parentNode.removeChild(script); }catch(e){}
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Timed out checking row updates for tab: ' + sheetName));
      }, 10000);
      document.head.appendChild(script);
    });
  }
  function loadSheetVersionSummary_(sheetName){
    var stampCol = TYD_SUMMARY_STAMP_COL[sheetName];
    if(!stampCol) return Promise.resolve(null);
    return new Promise(function(resolve, reject){
      var cb = '__tydSummaryCb_' + Math.random().toString(36).slice(2);
      var timer, script;
      window[cb] = function(resp){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        if(script && script.parentNode) script.parentNode.removeChild(script);
        try{
          var vals = projectionRows(resp)[0] || [];
          resolve({ count:Number(vals[0] || 0), maxUpdated:manifestVal(vals[1]) });
        }catch(err){ reject(err); }
      };
      script = document.createElement('script');
      var tq = 'select count(A), max(' + stampCol + ') where A is not null';
      script.src = 'https://docs.google.com/spreadsheets/d/' + encodeURIComponent(CFG.sheetId) + '/gviz/tq?headers=1&sheet=' + encodeURIComponent(sheetName) + '&tq=' + encodeURIComponent(tq) + '&tqx=out:json;responseHandler:' + cb;
      script.onerror = function(){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Could not check Library version: ' + sheetName));
      };
      timer = setTimeout(function(){
        try{ if(script && script.parentNode) script.parentNode.removeChild(script); }catch(e){}
        try{ delete window[cb]; }catch(e2){ window[cb]=undefined; }
        reject(new Error('Timed out checking Library version: ' + sheetName));
      }, 8000);
      document.head.appendChild(script);
    });
  }
  function rowIndexSignature(rowIndex){
    var rows = ((rowIndex && rowIndex.list) || []).map(function(x){ return [x.key || '', x.updated_at || '']; });
    return manifestFromMatrix(rows);
  }
  function promiseMapLimit(list, limit, iterator){
    list = list || [];
    limit = Math.max(1, limit || 2);
    var out = new Array(list.length), next = 0, active = 0;
    return new Promise(function(resolve, reject){
      function pump(){
        if(next >= list.length && active === 0){ resolve(out); return; }
        while(active < limit && next < list.length){
          (function(i){
            active++;
            Promise.resolve(iterator(list[i], i)).then(function(v){ out[i] = v; }, reject).finally(function(){ active--; pump(); });
          })(next++);
        }
      }
      pump();
    });
  }
  function loadLiveManifest(oldManifest){
    // Most visits need four aggregate rows (about 1 KB total), not the old
    // 1.5 MB key scan. Fetch row indexes only for tabs whose count/latest
    // updated_at summary actually changed.
    return promiseMapLimit(TYD_LIBRARY_TABS, 4, function(sheetName){
      return loadSheetVersionSummary_(sheetName).then(function(summary){ return { name:sheetName, summary:summary }; });
    }).then(function(summaryList){
      var summaries = {}, changed = [];
      summaryList.forEach(function(x){
        summaries[x.name] = x.summary;
        if(!versionSummariesEqual_(manifestSummaryForTab_(oldManifest, x.name), x.summary)) changed.push(x.name);
      });
      return promiseMapLimit(changed, TYD_MANIFEST_CONCURRENCY, function(sheetName){
        return loadSheetRowIndexProjection(sheetName).then(function(rowIndex){ return { name:sheetName, rows:rowIndex }; });
      }).then(function(changedRows){
        var rows = {}, tabs = {};
        TYD_LIBRARY_TABS.forEach(function(sheetName){
          var oldRows = oldManifest && oldManifest.rows && oldManifest.rows[sheetName];
          if(oldRows) rows[sheetName] = oldRows;
          tabs[sheetName] = manifestFromMatrix([[summaries[sheetName] && summaries[sheetName].count, summaries[sheetName] && summaries[sheetName].maxUpdated]]);
        });
        changedRows.forEach(function(x){ rows[x.name] = x.rows; });
        return { v:4, madeAt:Date.now(), tabs:tabs, rows:rows, summaries:summaries };
      });
    });
  }
  function refreshChangedTabs(cached, liveManifest, changed){
    var merged = {
      items:(cached && cached.items) || [],
      lines:(cached && cached.lines) || [],
      books:(cached && cached.books) || [],
      index:(cached && cached.index) || [],
      rcAtlas:(cached && cached.rcAtlas) || [],
      godAtlas:(cached && cached.godAtlas) || [],
      review:(cached && cached.review) || [],
      manifest:liveManifest,
      supercharged:!!(cached && cached.supercharged)
    };
    return Promise.all((changed || []).map(function(sheetName){
      return loadSheet(sheetName).then(function(rows){
        var prop = TYD_TAB_PROP[sheetName];
        if(prop) merged[prop] = rows || [];
      });
    })).then(function(){ return merged; });
  }
  function gvizQuote(s){ return "'" + String(s == null ? '' : s).replace(/\\/g, '\\\\').replace(/'/g, "\\'") + "'"; }
  function regexEscape(s){ return String(s == null ? '' : s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function chunkArray(arr, size){
    arr = arr || []; size = size || 35;
    var out = [];
    for(var i=0;i<arr.length;i+=size) out.push(arr.slice(i,i+size));
    return out;
  }
  function loadSheetWhere(sheetName, whereClause, sheetId){
    sheetId = sheetId || CFG.sheetId;
    return new Promise(function(resolve, reject){
      var cb = '__tydLibWhereCb_' + Math.random().toString(36).slice(2);
      var timer, script;
      window[cb] = function(resp){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        if(script && script.parentNode) script.parentNode.removeChild(script);
        try{ resolve(normalizeSheetRows(sheetName, tableToObjects(resp))); }catch(err){ reject(err); }
      };
      script = document.createElement('script');
      var tq = 'select * where ' + whereClause;
      script.src = 'https://docs.google.com/spreadsheets/d/' + encodeURIComponent(sheetId) + '/gviz/tq?headers=1&sheet=' + encodeURIComponent(sheetName) + '&tq=' + encodeURIComponent(tq) + '&tqx=out:json;responseHandler:' + cb;
      script.onerror = function(){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Could not load changed rows from tab: ' + sheetName));
      };
      timer = setTimeout(function(){
        try{ if(script && script.parentNode) script.parentNode.removeChild(script); }catch(e){}
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Timed out loading changed rows from tab: ' + sheetName));
      }, 12000);
      document.head.appendChild(script);
    });
  }
  function fetchRowsByPrimaryIds(sheetName, primaryIds){
    primaryIds = uniq(primaryIds || []);
    if(!primaryIds.length) return Promise.resolve([]);
    var col = (sheetName === CFG.sheets.lines || sheetName === CFG.sheets.index) ? 'A' : 'A';
    var batches = chunkArray(primaryIds, 35);
    return Promise.all(batches.map(function(batch){
      var pattern = '^(' + batch.map(regexEscape).join('|') + ')$';
      return loadSheetWhere(sheetName, col + ' matches ' + gvizQuote(pattern));
    })).then(function(parts){ return [].concat.apply([], parts); });
  }
  function mergeRowsByPrimary(sheetName, cachedRows, newRows, primaryIds){
    var field = TYD_PRIMARY_ID_FIELDS[sheetName];
    var affected = {};
    (primaryIds || []).forEach(function(id){ if(id) affected[String(id)] = true; });
    var kept = (cachedRows || []).filter(function(r){ return !affected[String((r || {})[field] || '')]; });
    return kept.concat(newRows || []);
  }
  function refreshIncrementalRows(cached, liveManifest, plan){
    var merged = {
      items:(cached && cached.items) || [],
      lines:(cached && cached.lines) || [],
      books:(cached && cached.books) || [],
      index:(cached && cached.index) || [],
      rcAtlas:(cached && cached.rcAtlas) || [],
      godAtlas:(cached && cached.godAtlas) || [],
      review:(cached && cached.review) || [],
      manifest:liveManifest,
      supercharged:!!(cached && cached.supercharged)
    };
    var jobs = [];
    Object.keys((plan && plan.rowTabs) || {}).forEach(function(sheetName){
      var prop = TYD_TAB_PROP[sheetName];
      var diff = plan.rowTabs[sheetName] || {};
      var primaryIds = diff.primaryIds || [];
      if(!prop || !primaryIds.length) return;
      jobs.push(fetchRowsByPrimaryIds(sheetName, primaryIds).then(function(rows){
        merged[prop] = mergeRowsByPrimary(sheetName, merged[prop] || [], rows || [], primaryIds);
      }).catch(function(){
        // If row fetch fails for any reason, refresh that whole tab rather than leaving stale rows.
        return loadSheet(sheetName).then(function(rows){ merged[prop] = rows || []; });
      }));
    });
    (plan.fullTabs || []).forEach(function(sheetName){
      var prop = TYD_TAB_PROP[sheetName];
      if(!prop) return;
      jobs.push(loadSheet(sheetName).then(function(rows){ merged[prop] = rows || []; }));
    });
    return Promise.all(jobs).then(function(){ return merged; });
  }

  function loadSheet(sheetName, sheetId){
    sheetId = sheetId || CFG.sheetId;
    return new Promise(function(resolve, reject){
      var cb = '__tydLibCb_' + Math.random().toString(36).slice(2);
      var timer;
      window[cb] = function(resp){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        if(script && script.parentNode) script.parentNode.removeChild(script);
        try{ resolve(normalizeSheetRows(sheetName, tableToObjects(resp))); }catch(err){ reject(err); }
      };
      var script = document.createElement('script');
      var url = 'https://docs.google.com/spreadsheets/d/' + encodeURIComponent(sheetId) + '/gviz/tq?headers=1&sheet=' + encodeURIComponent(sheetName) + '&tqx=out:json;responseHandler:' + cb;
      script.src = url;
      script.onerror = function(){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Could not load Google Sheet tab: ' + sheetName));
      };
      var fullSheetTimeoutMs = sheetName === CFG.sheets.lines ? 30000 : 16000;
      timer = setTimeout(function(){
        try{ if(script && script.parentNode) script.parentNode.removeChild(script); }catch(e){}
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Timed out loading Google Sheet tab: ' + sheetName));
      }, fullSheetTimeoutMs);
      document.head.appendChild(script);
    });
  }


  function loadOptionalSheet(sheetName, sheetId){
    return loadSheet(sheetName, sheetId).catch(function(){ return []; });
  }

  function loadMasterCharSheet(){
    // Master sheet is critical. Read by gid=0 and first two columns instead of relying only on header names.
    // This avoids the common Google gviz problem where headers become A/B/C or the wrong tab gets inferred.
    return new Promise(function(resolve, reject){
      var cb = '__tydMasterCb_' + Math.random().toString(36).slice(2);
      var timer, script;
      window[cb] = function(resp){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        if(script && script.parentNode) script.parentNode.removeChild(script);
        try{
          var rows = masterTableToRows(resp);
          if(rows.length < 50){
            reject(new Error('SLB master loaded only '+rows.length+' characters. Check sharing/publish settings or tab gid.'));
            return;
          }
          resolve(rows);
        }catch(err){ reject(err); }
      };
      script = document.createElement('script');
      var tq = 'select A,B where A is not null';
      var url = 'https://docs.google.com/spreadsheets/d/' + encodeURIComponent(CFG.masterSheetId) + '/gviz/tq?gid=' + encodeURIComponent(CFG.masterGid || '0') + '&headers=1&tq=' + encodeURIComponent(tq) + '&tqx=out:json;responseHandler:' + cb;
      script.src = url;
      script.onerror = function(){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Could not load SLB master sheet by gid=0. Make sure the SLB sheet is shared/published.'));
      };
      timer = setTimeout(function(){
        try{ if(script && script.parentNode) script.parentNode.removeChild(script); }catch(e){}
        try{ delete window[cb]; }catch(e){ window[cb]=undefined; }
        reject(new Error('Timed out loading SLB master sheet.'));
      }, 15000);
      document.head.appendChild(script);
    });
  }

  function masterTableToRows(resp){
    if(!resp || !resp.table || !resp.table.rows) return [];
    var out = [];
    (resp.table.rows || []).forEach(function(r){
      var a = cellVal(r.c && r.c[0]);
      var b = cellVal(r.c && r.c[1]);
      var ch = String(a || '').trim();
      var tok = String(b || '').trim().toLowerCase();
      if(!ch || !tok) return;
      if(ch.toLowerCase() === 'chinese_char' || tok.toLowerCase() === 'token') return;
      // Only keep true single Chinese characters in the master map.
      if(!/^[\u3400-\u9FFF]$/.test(ch)) return;
      out.push({ chinese_char: ch, token: tok });
    });
    return out;
  }

  function cellVal(cell){
    if(!cell) return '';
    if(cell.f != null && cell.f !== '') return cell.f;
    if(cell.v != null) return String(cell.v);
    return '';
  }

  function cleanHeader(s){
    return String(s || '').trim().replace(/^\uFEFF/, '').toLowerCase().replace(/\s+/g, '_');
  }

  function tableToObjects(resp){
    if(!resp || !resp.table || !resp.table.cols) return [];
    var rawRows = resp.table.rows || [];
    var cols = resp.table.cols.map(function(c, i){
      var label = (c.label || '').trim();
      var id = (c.id || '').trim();
      return cleanHeader(label || id || ('col'+i));
    });

    var rows = rawRows.map(function(r){
      var o = {};
      cols.forEach(function(name, i){ o[name] = cellVal(r.c && r.c[i]); });
      return o;
    }).filter(function(o){
      return Object.keys(o).some(function(k){ return String(o[k] || '').trim() !== ''; });
    });

    if(rows.length){
      var firstVals = cols.map(function(c){ return cleanHeader(rows[0][c]); });
      var headerScore = firstVals.filter(function(v){
        return ['item_id','line_no','chinese','saamlawnese','english_translation','type','chinese_title','english_title','category','book_id','order_no'].indexOf(v) !== -1;
      }).length;
      if(headerScore >= 2){
        var promoted = firstVals.map(function(v, i){ return v || ('col'+i); });
        rows = rows.slice(1).map(function(old){
          var o = {};
          cols.forEach(function(c, i){ o[promoted[i]] = old[c]; });
          return o;
        }).filter(function(o){
          return Object.keys(o).some(function(k){ return String(o[k] || '').trim() !== ''; });
        });
      }
    }
    return rows;
  }

  function normalizeSheetRows(sheetName, rows){
    var map = {
      Items: ['item_id','type','chinese_title','english_title','category','first_source_book','status','notes','updated_at','image_url','image_alt','image_caption'],
      Lines: ['item_id','line_no','chinese','saamlawnese','english_translation','source_book','status','notes','updated_at'],
      Books: ['book_id','book_title_chinese','book_title_english','file_name','updated_date','status','notes','library_type','category_group','directory_group','display_order','updated_at'],
      Book_Index: ['book_id','order_no','item_id','display_section','source_book','notes','updated_at'],
      Review_Log: ['date','book_id','item_id','line_no','problem','fixed_by','status'],
      Saamlawnese_Exceptions: ['decision','item_id','line_no','chinese_char','current_token','master_token','source_book','notes','updated_date'],
      RC_Atlas: ['rc_id','directory','type','category','title_en','title_zh','parent','belongs_to','display_order','short_summary','simple_meaning','what_it_does','disciple_study_notes','afterdeath_meaning','practice_usage','related_entries','tags','status','updated_at'],
      God_Atlas: ['god_id','directory','type','display_order','name_en','name_zh','saamlawnese_name','aliases','short_summary','details_info','god_power','disciple_usage','court_area','palace_hall_department','prayer_item_ids','fu_head_item_ids','god_spell_item_ids','scripture_book_ids','scripture_item_ids','related_god_ids','related_rc_ids','primary_image_url','gallery_image_urls','download_file_urls','anniv_god_key','anniv_source','source_notes','tags','status','updated_at'],
      SAAML_MASTER_CHAR: ['chinese_char','token','updatedAt','updatedBy']
    };
    var expected = map[sheetName] || [];
    var letters = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o'];
    return rows.map(function(r, idx){
      var out = {};
      expected.forEach(function(key, i){
        out[key] = r[key] != null ? r[key] : (r[letters[i]] != null ? r[letters[i]] : (r['col'+i] != null ? r['col'+i] : ''));
      });
      Object.keys(r).forEach(function(k){ if(out[k] == null) out[k] = r[k]; });
      out._row_index = idx;
      out._sheet_row = idx + 2;
      out._sheet_name = sheetName;
      return out;
    }).filter(function(o){
      return Object.keys(o).some(function(k){ return String(o[k] || '').trim() !== ''; });
    });
  }

  function buildDerivedIndexes(opts){
    opts = opts || {};
    var skipSearch = !!opts.skipSearch;
    var itemsById = {}, booksById = {}, linesByItem = {}, indexByBook = {}, indexByItem = {}, searchTextByItem = {};
    (state.items || []).forEach(function(i){ if(i && i.item_id) itemsById[String(i.item_id)] = i; });
    (state.books || []).forEach(function(b){ if(b && b.book_id) booksById[String(b.book_id)] = b; });
    (state.lines || []).forEach(function(l){
      if(!l || !l.item_id) return;
      var id = String(l.item_id);
      (linesByItem[id] = linesByItem[id] || []).push(l);
    });
    Object.keys(linesByItem).forEach(function(id){
      linesByItem[id].sort(function(a,b){ return Number(a.line_no||0)-Number(b.line_no||0); });
    });
    (state.index || []).forEach(function(x){
      if(!x) return;
      if(x.book_id) (indexByBook[String(x.book_id)] = indexByBook[String(x.book_id)] || []).push(x);
      if(x.item_id) (indexByItem[String(x.item_id)] = indexByItem[String(x.item_id)] || []).push(x);
    });
    Object.keys(indexByBook).forEach(function(id){
      indexByBook[id].sort(function(a,b){ return Number(a.order_no||0)-Number(b.order_no||0); });
    });
    if(!skipSearch){
      (state.items || []).forEach(function(item){
        if(!item || !item.item_id) return;
        var id = String(item.item_id);
        var rows = linesByItem[id] || [];
        searchTextByItem[id] = norm([
          item.item_id, item.type, item.chinese_title, item.english_title, item.category, item.notes,
          rows.map(function(l){ return [l.chinese,l.saamlawnese,l.english_translation,l.notes].join(' '); }).join(' ')
        ].join(' '));
      });
    }
    state._itemsById = itemsById;
    state._booksById = booksById;
    state._linesByItem = linesByItem;
    state._indexByBook = indexByBook;
    state._indexByItem = indexByItem;
    state._searchTextByItem = searchTextByItem;
    state._validItemsCache = (state.items || []).filter(dataItemHasId).filter(itemAllowedByAcg_);
    state._allBookIdsCache = null;
    state._sortedBookIdsCache = {};
    state._bookIdsForItemCache = {};
    state._browseCatsByItemCache = {};
    state._bookTitlePartsCache = {};
    state._bookMatchKeysCache = {};
    state._sourceMatchesBookCache = {};
    state._bookItemsFullCache = {};
    state._itemsUsedByBookGroupsCache = null;
    state._itemLibraryTypeCache = {};
    state._bookLibraryTypeCache = {};
    state._bookCategoryCache = {};
    state._directoryGroupData = {};
    state._directoryRenderCache = {};
    state._directoryRenderCacheOrder = [];
    state._directoryCacheWarmedAt = 0;
    state._directoryCacheWarmRunning = false;
  }

  function lineRows(itemId){
    var rows = state._linesByItem && state._linesByItem[String(itemId || '')];
    if(rows) return rows;
    return state.lines.filter(function(l){ return l.item_id === itemId; }).sort(function(a,b){ return Number(a.line_no||0)-Number(b.line_no||0); });
  }

  function itemLinesAreReady(itemId){
    if(!state.fastDirectoryMode || state.fullLinesLoaded) return true;
    var id = String(itemId || '');
    return !!(state._linesByItem && Object.prototype.hasOwnProperty.call(state._linesByItem, id));
  }
  function itemIdsLinesAreReady(ids){
    ids = (ids || []).filter(Boolean).map(String);
    for(var i=0;i<ids.length;i++){
      if(!itemLinesAreReady(ids[i])) return false;
    }
    return true;
  }
  function readLineCacheForItems(itemIds){
    itemIds = Array.from(new Set((itemIds || []).filter(Boolean).map(String)));
    if(!itemIds.length) return Promise.resolve({ ok:true, missing:[], map:{} });
    return openCacheDb().then(function(db){
      return new Promise(function(resolve){
        var map = {}, missing = [], left = itemIds.length, settled = false;
        var timer = setTimeout(function(){
          itemIds.forEach(function(id){ if(!Object.prototype.hasOwnProperty.call(map, id) && missing.indexOf(id) < 0) missing.push(id); });
          done();
        }, TYD_IDB_READ_TIMEOUT_MS);
        function done(){
          if(settled) return;
          settled = true;
          clearTimeout(timer);
          try{ db.close(); }catch(e){}
          resolve({ ok:missing.length === 0, missing:missing, map:map });
        }
        try{
          var tx = db.transaction(TYD_CACHE_STORE, 'readonly');
          var store = tx.objectStore(TYD_CACHE_STORE);
          itemIds.forEach(function(id){
            var req = store.get(lineCacheKey(id));
            req.onsuccess = function(){
              var payload = req.result && req.result.payload;
              if(payload && payload.v === TYD_CACHE_VERSION && Array.isArray(payload.lines)) map[id] = payload.lines;
              else missing.push(id);
              left -= 1; if(left <= 0) done();
            };
            req.onerror = function(){ missing.push(id); left -= 1; if(left <= 0) done(); };
          });
          tx.onabort = function(){ done(); };
          tx.onerror = function(){ done(); };
        }catch(e){ missing = itemIds.slice(); done(); }
      });
    }).catch(function(){ return { ok:false, missing:itemIds, map:{} }; });
  }
  function installLazyLines(map){
    map = map || {};
    state._linesByItem = state._linesByItem || {};
    Object.keys(map).forEach(function(id){
      var rows = (map[id] || []).filter(function(l){ return l && String(l.item_id || '').trim(); }).sort(function(a,b){ return Number(a.line_no||0)-Number(b.line_no||0); });
      state._linesByItem[id] = rows;
    });
  }
  function showLazyTextLoading(title, subtitle){
    title = title || 'Opening text from local cache...';
    subtitle = subtitle || 'The directory is ready. The selected book text is opening now.';
    setStatus(title, 'loading');
    if(els.reader) els.reader.innerHTML = libraryLoadingHtml('reader', title, subtitle);
    setReaderMeta(readerMetaHtml(['directory ready','opening text']));
  }
  function readSelectedLinesFromFullCache_(itemIds){
    itemIds = Array.from(new Set((itemIds || []).filter(Boolean).map(String)));
    return readCachedLibrary().then(function(cached){
      if(!validCachedLibrary(cached)) return null;
      var wanted={}; itemIds.forEach(function(id){ wanted[id]=true; });
      var map=groupLinesByItem_((cached.lines || []).filter(function(row){ return row && wanted[String(row.item_id || '')]; }));
      itemIds.forEach(function(id){ if(!Object.prototype.hasOwnProperty.call(map,id)) map[id]=[]; });
      return map;
    }).catch(function(){ return null; });
  }
  function ensureLinesForItems(itemIds, label, bookId){
    itemIds = Array.from(new Set((itemIds || []).filter(Boolean).map(String)));
    if(!state.fastDirectoryMode || state.fullLinesLoaded || itemIdsLinesAreReady(itemIds)) return true;
    if(state.lazyLineLoading) return false;
    state.lazyLineLoading = true;
    showLazyTextLoading(label || 'Opening selected text...', 'Only this selected content is being opened and saved.');
    readLineCacheForItems(itemIds).then(function(res){
      installLazyLines(res.map || {});
      if(res.ok || itemIdsLinesAreReady(itemIds)){
        state.lazyLineLoading = false;
        setStatus(bookId ? 'Opened book from its saved cache.' : 'Opened selected text from fast local cache.', 'ok');
        renderReader();
        return true;
      }
      var missing = (res.missing && res.missing.length) ? res.missing : itemIds;
      setStatus(bookId ? 'Downloading this book text...' : 'Downloading selected text...', 'loading');
      return fetchRowsByPrimaryIds(CFG.sheets.lines, missing).then(function(rows){
        var grouped = groupLinesByItem_(rows || []);
        missing.forEach(function(id){ if(!Object.prototype.hasOwnProperty.call(grouped, id)) grouped[id] = []; });
        installLazyLines(grouped);
        persistLazyLineSelection_(grouped, bookId || '', itemIds).catch(function(){});
        if(itemIdsLinesAreReady(itemIds)){
          state.lazyLineLoading = false;
          setStatus(bookId ? 'Book downloaded and saved for faster reopening.' : 'Selected text downloaded and saved.', 'ok');
          renderReader();
          return true;
        }
        return false;
      }).catch(function(){ return false; }).then(function(openedLive){
        if(openedLive) return true;
        // Offline fallback: extract only the selected rows from an existing Supercharge cache.
        return readSelectedLinesFromFullCache_(missing).then(function(map){
          if(map){ installLazyLines(map); persistLazyLineSelection_(map, bookId || '', itemIds).catch(function(){}); }
          state.lazyLineLoading = false;
          if(itemIdsLinesAreReady(itemIds)){ setStatus('Opened selected text from the offline Supercharge cache.', 'ok'); renderReader(); return true; }
          setStatus('Could not open the selected text. Check the connection or run Supercharge for offline use.', 'bad');
          return false;
        });
      });
    }).catch(function(){
      state.lazyLineLoading = false;
      setStatus('Could not open selected text from cache.', 'bad');
    });
    return false;
  }
  function hasReview(itemId){ return lineRows(itemId).some(function(l){ return String(l.status||'').toLowerCase() === 'review'; }); }

  function searchableText(item){
    item = item || {};
    var id = String(item.item_id || '');
    if(id && state._searchTextByItem && state._searchTextByItem[id] != null) return state._searchTextByItem[id];
    var lines = lineRows(item.item_id);
    var txt = norm([
      item.item_id, item.type, item.chinese_title, item.english_title, item.category, item.notes,
      lines.map(function(l){ return [l.chinese,l.saamlawnese,l.english_translation,l.notes].join(' '); }).join(' ')
    ].join(' '));
    if(id){ state._searchTextByItem = state._searchTextByItem || {}; state._searchTextByItem[id] = txt; }
    return txt;
  }

  function sourceNorm(s){
    return String(s || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201c\u201d]/g, '"')
      .replace(/\.[a-z0-9]{1,8}$/i, '')
      .replace(/[^a-z0-9\u3400-\u9fff]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isLooseBucket(v){
    var k = sourceNorm(v);
    return k === 'loose' || k === 'loose item' || k === 'loose items';
  }

  function isLegacySourceText(v){
    var k = sourceNorm(v);
    return !!k && k.indexOf('legacy') !== -1;
  }

  function isLegacyMarkedText(v){
    var k = sourceNorm(v);
    if(!k) return false;
    return k === 'legacy' || k === 'legacy item' || k === 'legacy items' || k.indexOf('legacy item') !== -1;
  }

  function itemIsMarkedLegacy(item){
    item = item || {};
    // If the row itself says Legacy Item / legacy in status/category/type, it is old
    // content and should not appear under the updated rite books.
    return [item.item_id, item.type, item.category, item.status].some(function(v){ return isLegacyMarkedText(v); });
  }

  function indexRowIsLegacy(x){
    x = x || {};
    // Only source/display labels should control old-row hiding. Notes are free text.
    return [x.source_book, x.display_section].some(function(v){ return isLegacySourceText(v); });
  }

  function itemIsHiddenLegacy(item){
    return itemIsMarkedLegacy(item) || itemIsLegacyOnly(item);
  }


  function dataItemHasId(item){
    return !!String(item && item.item_id || '').trim();
  }


  function acgFullAccess_(){ return !!(state && (state.isAdmin || state.acgAccess === 'full')); }
  function acgDailyTextAllowed_(txt){
    txt = String(txt || '').toLowerCase();
    return /(daily|morning|noon|evening|早壇|早坛|午壇|午坛|晚壇|晚坛|日常|功課|功课)/i.test(txt);
  }
  function clearAcgRestrictedCaches_(){
    try{ state._validItemsCache = null; }catch(_e){}
    try{ state._allBookIdsCache = null; }catch(_e2){}
    try{ state._sortedBookIdsCache = {}; }catch(_e3){}
    try{ state._browseCatsByItemCache = {}; }catch(_e4){}
  }
  function bookAllowedByAcg_(bookOrId){
    if(acgFullAccess_()) return true;
    var b = null;
    if(typeof bookOrId === 'string'){
      var bid = String(bookOrId || '');
      b = (state._booksById && state._booksById[bid]) || (state.books || []).find(function(x){ return String(x && x.book_id || '') === bid; }) || { book_id:bid };
    }else{
      b = bookOrId || {};
    }
    var fb = null;
    try{ fb = canonicalBookTitleFallback(b); }catch(_e){}
    var txt = [
      b.book_id, b.book_title_english, b.book_title_chinese, b.english_title, b.chinese_title,
      b.library_type, b.category_group, b.directory_group, b.file_name,
      fb && fb.en, fb && fb.zh
    ].map(function(x){ return String(x||''); }).join(' ');
    return acgDailyTextAllowed_(txt);
  }
  function itemAllowedByAcg_(item){
    if(acgFullAccess_()) return true;
    if(!item) return false;
    var txt = [
      item.item_id, item.english_title, item.chinese_title, item.title, item.directory, item.library_type,
      item.type, item.category, item.category_group, item.directory_group, item.book_id
    ].map(function(x){ return String(x||''); }).join(' ');
    if(acgDailyTextAllowed_(txt)) return true;
    try{
      var bids = bookIdsForItem(item) || [];
      for(var i=0;i<bids.length;i++){ if(bookAllowedByAcg_(bids[i])) return true; }
    }catch(_e){}
    return false;
  }
  function acgLimitedReaderHtml_(){
    return '<div class="tydLib__empty"><h2>Daily Rite access only</h2><p>This account is not marked as ACG yet. Full TYD Lineage Library access opens when ACG is set to 1 in SLB.</p></div>';
  }

  function validItemRows(items){
    if(items === state.items && state._validItemsCache) return state._validItemsCache;
    if(items === state._validItemsCache) return state._validItemsCache;
    return (items || []).filter(dataItemHasId).filter(itemAllowedByAcg_);
  }

  function displayableDirectoryItem(item){
    if(!dataItemHasId(item)) return false;
    return !!String((item.english_title || item.chinese_title || item.item_id || '')).trim();
  }

  function displayableDirectoryItems(items){
    return validItemRows(items).filter(displayableDirectoryItem);
  }

  function repairBucketsAllowedInBookView(){
    var domType = els.type && els.type.value ? String(els.type.value).trim() : '';
    var domCat = els.category && els.category.value ? String(els.category.value).trim() : '';
    return !(String(state.type || '').trim() || String(state.category || '').trim() || domType || domCat);
  }


  function isLegacyRiteText(v){
    var k = sourceNorm(v);
    if(!k || k.indexOf('legacy') === -1) return false;
    // Covers old morning/noon/evening rite rows and any old source/book row
    // explicitly marked as legacy so they do not get appended after updated rites.
    return k.indexOf('rite') !== -1 || k.indexOf('ritual') !== -1 || k.indexOf('right') !== -1 ||
      k.indexOf('morning') !== -1 || k.indexOf('noon') !== -1 || k.indexOf('evening') !== -1 ||
      k.indexOf('早') !== -1 || k.indexOf('午') !== -1 || k.indexOf('晚') !== -1;
  }

  function isLegacyEveningRiteText(v){
    var k = sourceNorm(v);
    if(!k) return false;
    return k.indexOf('legacy') !== -1 &&
      k.indexOf('evening') !== -1 &&
      (k.indexOf('rite') !== -1 || k.indexOf('ritual') !== -1 || k.indexOf('right') !== -1);
  }

  function isLegacyBook(bookOrId){
    var book = (typeof bookOrId === 'object' && bookOrId) ? bookOrId : null;
    if(!book) book = state.books.find(function(b){ return b.book_id === bookOrId; });
    var vals = book ? [book.book_id, book.book_title_chinese, book.book_title_english, book.file_name, book.status] : [bookOrId];
    return vals.some(function(v){ return isLegacySourceText(v); });
  }

  function isLegacyEveningRiteBook(bookOrId){
    var book = (typeof bookOrId === 'object' && bookOrId) ? bookOrId : null;
    if(!book) book = state.books.find(function(b){ return b.book_id === bookOrId; });
    var vals = book ? [book.book_id, book.book_title_chinese, book.book_title_english, book.file_name, book.status] : [bookOrId];
    return vals.some(function(v){ return isLegacyEveningRiteText(v); });
  }

  function rawSourceLabelsForItem(item){
    item = item || {};
    var labels = [], seen = {};
    function addRaw(v){
      v = String(v || '').trim();
      if(!v || isLooseBucket(v)) return;
      addUnique(labels, seen, v);
    }
    addRaw(item.first_source_book);
    addRaw(item.source_book);
    lineRows(item.item_id).forEach(function(l){ addRaw(l.source_book); });
    return labels;
  }

  function itemIsLegacyOnly(item){
    if(!item || !item.item_id) return false;
    var labels = rawSourceLabelsForItem(item);
    var hasLegacyLabel = labels.some(function(label){ return isLegacySourceText(label); });
    var hasNonLegacyLabel = labels.some(function(label){ return !isLegacySourceText(label); });
    var idxRows = (state._indexByItem && state._indexByItem[String(item.item_id)]) || state.index.filter(function(x){ return x.item_id === item.item_id; });
    var hasNonLegacyIndex = idxRows.some(function(x){
      return x.item_id === item.item_id && !isLegacyBook(x.book_id) && !indexRowIsLegacy(x);
    });
    return hasLegacyLabel && !hasNonLegacyLabel && !hasNonLegacyIndex;
  }

  function itemIsLegacyEveningOnly(item){
    return itemIsLegacyOnly(item);
  }

  function itemGroupRaw(item){
    item = item || {};
    return [item.item_id, item.type, item.category, item.chinese_title, item.english_title, item.notes].join(' ');
  }

  function isSetCategoryLabel(cat){
    cat = String(cat || '').trim().toLowerCase();
    return cat === 'jing spells' || cat === 'wealth spells' || cat === 'exorcism spells';
  }

  function itemIsRiteSupportItem(item){
    var raw = itemGroupRaw(item);
    var k = sourceNorm(raw);
    // These are common rite support/opening/closing items. They can appear inside
    // several books, but they are not members of the main spell set for that rite.
    if(/(opening sky door|open sky door|sky door|scripture opening|opening scripture|scripture closing|closing scripture|incense blessing)/.test(k)) return true;
    if(/開天門|开天门|開經|开经|完經|完经|收經|收经|化香|祝香/.test(raw)) return true;
    return false;
  }

  function itemIsGroundEmperorGodOfWealth(item){
    var raw = itemGroupRaw(item);
    var k = sourceNorm(raw);
    return /ground emperor.*god.*wealth|god.*wealth.*ground emperor/.test(k) || /地皇.*財神|地皇.*财神|財神.*地皇|财神.*地皇/.test(raw);
  }

  function baseCategoryForItem(item){
    item = item || {};
    var cat = String(item.category || '').trim();
    if(itemIsRiteSupportItem(item) && (isSetCategoryLabel(cat) || isLooseBucket(cat) || !cat)){
      if(/incense blessing|化香|祝香/i.test(itemGroupRaw(item))) return 'Incense / Offering';
      return 'Opening / Closing';
    }
    if(itemIsGroundEmperorGodOfWealth(item) && (cat === 'Jing Spells' || cat === 'Exorcism Spells' || isLooseBucket(cat) || !cat)){
      return 'Wealth Spells';
    }
    if(isLooseBucket(cat)){
      // A rite/book source is not a category. If old rows were marked as
      // "Loose Items", keep the public category useful by falling back to type.
      return String(item.type || '').trim() || 'uncategorized';
    }
    return cat || 'uncategorized';
  }

  function itemExcludedFromRiteSet(item, kind){
    if(itemIsRiteSupportItem(item)) return true;
    // This item can be a wealth item, but it should not become part of the Morning Rite Jing set.
    if(kind === 'morning' && itemIsGroundEmperorGodOfWealth(item)) return true;
    return false;
  }

  function itemLooksLikeSpellSetMember(item){
    item = item || {};
    var raw = itemGroupRaw(item);
    var k = sourceNorm(raw);
    if(!k) return false;
    if(/(^| )(spell|spells|jing|purifying|purification|cleansing|cleanse|wealth|exorcism|exorcist|barrier|protection|protect)( |$)/.test(k)) return true;
    return /[咒符訣诀]/.test(raw);
  }

  function riteKindForBookId(bookId){
    var book = bookById(bookId) || { book_id:bookId };
    var raw = [book.book_id, book.book_title_chinese, book.book_title_english, book.file_name, book.notes].join(' ');
    var k = sourceNorm(raw);
    if(k.indexOf('morning') !== -1 || raw.indexOf('早壇') !== -1 || raw.indexOf('早坛') !== -1) return 'morning';
    if(k.indexOf('noon') !== -1 || raw.indexOf('午壇') !== -1 || raw.indexOf('午坛') !== -1) return 'noon';
    if(k.indexOf('evening') !== -1 || raw.indexOf('晚壇') !== -1 || raw.indexOf('晚坛') !== -1) return 'evening';
    return '';
  }

  function riteCategoryForItemInBook(item, bookId){
    if(!itemLooksLikeSpellSetMember(item)) return '';
    var kind = riteKindForBookId(bookId);
    if(!kind || itemExcludedFromRiteSet(item, kind)) return '';
    if(kind === 'morning') return 'Jing Spells';
    if(kind === 'noon') return 'Wealth Spells';
    if(kind === 'evening') return 'Exorcism Spells';
    return '';
  }

  function riteCategoriesForItem(item){
    if(!itemLooksLikeSpellSetMember(item)) return [];
    var seen = {};
    var byKind = { morning:'Jing Spells', noon:'Wealth Spells', evening:'Exorcism Spells' };
    bookIdsForItem(item).forEach(function(bookId){
      var kind = riteKindForBookId(bookId);
      if(!kind || itemExcludedFromRiteSet(item, kind)) return;
      var label = byKind[kind] || '';
      if(label) seen[label] = true;
    });
    return ['Jing Spells','Wealth Spells','Exorcism Spells'].filter(function(label){ return !!seen[label]; });
  }

  function categoriesForItem(item){
    var riteCats = riteCategoriesForItem(item);
    if(riteCats.length) return riteCats;
    return [baseCategoryForItem(item)];
  }

  function categoryForItem(item, contextBookId){
    if(contextBookId){
      var contextual = riteCategoryForItemInBook(item, contextBookId);
      if(contextual) return contextual;
    }
    return categoriesForItem(item)[0] || 'uncategorized';
  }

  function categoryMatchesItem(item, cat){
    cat = String(cat || '').trim();
    if(!cat) return true;
    return categoriesForItem(item).indexOf(cat) !== -1;
  }

  function cleanTaxonomyLabel(v){ return String(v || '').trim(); }

  function isScriptureRiteLabel(v){
    var k = sourceNorm(v || '');
    return k === 'scriptures rite' || k === 'scripture rite' || k === 'scriptures rites' || k === 'scripture rites' || k === 'scriptures/rite' || k === 'scriptures';
  }
  function normalizeScriptureRiteCategory(cat){
    var raw = String(cat || '').trim();
    var k = sourceNorm(raw);
    if(!raw) return '';
    if(k === 'tin' || k.indexOf('tin scripture') !== -1 || /天/.test(raw)) return 'Tin';
    if(k === 'dei' || k.indexOf('dei') !== -1 || k.indexOf('salvation') !== -1 || /地/.test(raw)) return 'Dei';
    if(k === 'daai' || k.indexOf('daai') !== -1 || k.indexOf('human') !== -1 || /大|人/.test(raw)) return 'Daai';
    if(k === 'daily' || k.indexOf('daily') !== -1 || k.indexOf('rite') !== -1 || /日常|早壇|早坛|午壇|午坛|晚壇|晚坛|功課|功课/.test(raw)) return 'Daily';
    return '';
  }
  function scriptureRiteCategoryRank(cat){
    var c = normalizeScriptureRiteCategory(cat) || String(cat || '');
    var order = { Tin:1, Dei:2, Daai:3, Daily:4 };
    return order[c] || 999;
  }
  function scriptureRiteCategoryLabel(cat){
    return normalizeScriptureRiteCategory(cat) || String(cat || 'Other');
  }
  function scriptureRiteCategoryGroupKey(cat){ return 'bookcat:' + scriptureRiteCategoryLabel(cat); }

  function bookRawForTaxonomy(book){
    book = book || {};
    return [book.book_id, book.book_title_chinese, book.book_title_english, book.file_name, book.notes, book.library_type, book.category_group, book.directory_group].join(' ');
  }

  function bookLibraryTypeForDirectory(bookId){
    var book = (typeof bookId === 'object' && bookId) ? bookId : (bookById(bookId) || { book_id:bookId });
    var cacheKey = String((book && book.book_id) || bookId || '');
    if(cacheKey && state._bookLibraryTypeCache && state._bookLibraryTypeCache[cacheKey]) return state._bookLibraryTypeCache[cacheKey];
    var fallback = canonicalBookTitleFallback(book);
    var v = cleanTaxonomyLabel(book.library_type || book.libraryType || book.book_type || book.type_group || (fallback && fallback.library_type) || '');
    if(!v){
      var raw = bookRawForTaxonomy(book);
      var k = sourceNorm(raw);
      if(/lineage songs|tao song|anthem|song/.test(k) || /道歌|軍歌|战舞|戰舞|歌/.test(raw)) v = 'Songs';
      else if(/teaching gate|doctrine|commandment|commandments|rules|virtues|precepts/.test(k) || /教門|教门|教義|教义|誡|戒|規|规|德/.test(raw)) v = 'Teachings';
      else if(/cheng sun|chick|hoi gwong|consecration|practical spells|soul spells|war spells|wealth spells|god spells|guardian spells|harmonizing spells|five ghosts/.test(k)) v = 'Spells';
      else if(/請神|请神|勅符|開光|开光|實用|实用|魂魄|鬦法|斗法|財科|财神|財神|護法|和合|五鬼|法咒/.test(raw)) v = 'Spells';
      else v = 'Scriptures/Rite';
    }
    if(cacheKey){ state._bookLibraryTypeCache = state._bookLibraryTypeCache || {}; state._bookLibraryTypeCache[cacheKey] = v; }
    return v;
  }

  function bookCategoryForDirectory(bookId){
    var book = (typeof bookId === 'object' && bookId) ? bookId : (bookById(bookId) || { book_id:bookId });
    var cacheKey = String((book && book.book_id) || bookId || '');
    if(cacheKey && state._bookCategoryCache && state._bookCategoryCache[cacheKey]) return state._bookCategoryCache[cacheKey];
    var fallback = canonicalBookTitleFallback(book);
    var out = cleanTaxonomyLabel(book.category_group || book.browse_category || book.book_category || (fallback && fallback.category_group) || '');
    if(!out){
      var raw = bookRawForTaxonomy(book);
      var k = sourceNorm(raw);
      var type = bookLibraryTypeForDirectory(book);

      if(type === 'Songs') out = 'Lineage Songs';
      else if(type === 'Teachings') out = 'Teaching Gate';
      else if(type === 'Spells'){
        if(/wealth spells|財科|财神|財神/.test(k) || /財科|財神|财神/.test(raw)) out = 'Wealth';
        else if(/war spells|magic war|鬦法|斗法/.test(k) || /鬦法|斗法/.test(raw)) out = 'War';
        else if(/soul spells|soul related|魂魄/.test(k) || /魂魄/.test(raw)) out = 'Soul';
        else if(/practical spells|實用|实用/.test(k) || /實用|实用/.test(raw)) out = 'Practical';
        else if(/hoi gwong|consecration|開光|开光/.test(k) || /開光|开光/.test(raw)) out = 'Hoi Gwong';
        else if(/chick spells|sanctification|勅符/.test(k) || /勅符/.test(raw)) out = 'Chick';
        else if(/cheng sun|inviting.*god|請神|请神/.test(k) || /請神|请神/.test(raw)) out = 'Cheng Sun';
        else if(/five ghosts|五鬼/.test(k) || /五鬼/.test(raw)) out = 'Five Ghosts';
        else if(/harmonizing|和合/.test(k) || /和合/.test(raw)) out = 'Harmonizing';
        else if(/guardian|護法|护法/.test(k) || /護法|护法/.test(raw)) out = 'Guardian';
        else if(/god spells|deities|deity|法源|神咒/.test(k) || /法源神咒/.test(raw)) out = 'Gods / Deities';
        else out = 'General';
      } else {
        // Scripture/Rite categories: the collection-level grouping Jee Sifu uses.
        if(/morning|noon|evening|daily|日常|早壇|早坛|午壇|午坛|晚壇|晚坛|功課|功课/.test(k) || /日常|早壇|早坛|午壇|午坛|晚壇|晚坛|功課|功课/.test(raw)) out = 'Daily';
        else if(/blood lake|hell|ghost king|ground official|salvation|exorcism|地官|血湖|地獄|地狱|鬼王|普渡|滅邪|灭邪/.test(k) || /地官|血湖|地獄|地狱|鬼王|普渡|滅邪|灭邪/.test(raw)) out = 'Dei';
        else if(/daai|human world|true merit|virtue|human|repenting|quitting evil|harmony|amnesty|heart scripture|five virtues|filial piety|etiquettes|elder lord|tao te|一善|功德|善/.test(k) || /一善|功德|善|懺罪|忏罪|戒邪|和合|赦罪|心經|心经|五德|孝經|孝经|禮經|礼经|老君|道德經|道德经/.test(raw)) out = 'Daai';
        else if(/truth scripture|prayers of faith|wealth god rite|celestial masters|prayer|寶誥|宝诰|天師|天师|財神經|财神经/.test(k) || /真經|真经|寶誥|宝诰|天師|天师|財神經|财神经/.test(raw)) out = 'Tin';
        else out = 'All';
      }
    }
    if(cacheKey){ state._bookCategoryCache = state._bookCategoryCache || {}; state._bookCategoryCache[cacheKey] = out; }
    return out;
  }

  function itemLibraryTypeForDirectory(item){
    item = item || {};
    var cacheKey = String(item.item_id || '');
    if(cacheKey && state._itemLibraryTypeCache && state._itemLibraryTypeCache[cacheKey]) return state._itemLibraryTypeCache[cacheKey];
    var v = cleanTaxonomyLabel(item.library_type || item.libraryType || item.browse_type || '');
    if(!v){
      var raw = [item.item_id, item.type, item.category, item.first_source_book, item.chinese_title, item.english_title, item.notes].join(' ');
      var k = sourceNorm(raw);
      if(item.type === 'handsign' || /handsign|hand sign|seals?/.test(k) || /手訣|手诀|手印/.test(raw)) v = 'Teachings';
      else if(item.type === 'song' || /lineage songs|tao song|anthem|song/.test(k) || /道歌|軍歌|战舞|戰舞|歌/.test(raw)) v = 'Songs';
      else if(item.type === 'guideline' || /teaching gate|doctrine|commandment|rules|virtues|precepts/.test(k) || /教門|教门|教義|教义|誡|戒|規|规|德/.test(raw)) v = 'Teachings';
      else if(/spells?$/.test(sourceNorm(baseCategoryForItem(item))) || /cheng sun|chick|hoi gwong|consecration|practical spells|soul spells|war spells|wealth spells|god spells|guardian spells|harmonizing spells|five ghosts/.test(k)) v = 'Spells';
      else if(/[咒符訣诀]/.test(raw) && !/(scripture|rite|prayer|寶誥|宝诰|經|经)/.test(k)) v = 'Spells';
      else v = 'Scriptures/Rite';
    }
    if(cacheKey){ state._itemLibraryTypeCache = state._itemLibraryTypeCache || {}; state._itemLibraryTypeCache[cacheKey] = v; }
    return v;
  }

  function spellCategoryForItem(item){
    item = item || {};
    var raw = [item.item_id, item.category, item.first_source_book, item.chinese_title, item.english_title, item.notes].join(' ');
    var k = sourceNorm(raw);
    if(riteCategoriesForItem(item).indexOf('Jing Spells') !== -1) return 'Jing';
    if(/wealth spells|wealth|財科|財神|财神|招財|发财|發財|財/.test(k) || /財科|財神|财神|招財|发财|發財|財/.test(raw)) return 'Wealth';
    if(/war spells|magic war|war|鬦法|斗法|兵|煞/.test(k) || /鬦法|斗法|兵|煞/.test(raw)) return 'War';
    if(/soul spells|soul related|soul|魂魄|魂|魄/.test(k) || /魂魄|魂|魄/.test(raw)) return 'Soul';
    if(/practical spells|practical|實用|实用/.test(k) || /實用|实用/.test(raw)) return 'Practical';
    if(/hoi gwong|consecration|開光|开光/.test(k) || /開光|开光/.test(raw)) return 'Hoi Gwong';
    if(/chick spells|sanctification|chick|勅符/.test(k) || /勅符/.test(raw)) return 'Chick';
    if(/cheng sun|inviting.*god|請神|请神/.test(k) || /請神|请神/.test(raw)) return 'Cheng Sun';
    if(/five ghosts|五鬼/.test(k) || /五鬼/.test(raw)) return 'Five Ghosts';
    if(/harmonizing|和合/.test(k) || /和合/.test(raw)) return 'Harmonizing';
    if(/guardian|護法|护法/.test(k) || /護法|护法/.test(raw)) return 'Guardian';
    if(/god spells|deities|deity|法源|神咒/.test(k) || /法源神咒/.test(raw)) return 'Gods / Deities';
    return 'General';
  }

  function itemBrowseCategoriesForDirectory(item){
    if(item && item.item_id && state._browseCatsByItemCache && state._browseCatsByItemCache[String(item.item_id)]) return state._browseCatsByItemCache[String(item.item_id)].slice();
    var type = itemLibraryTypeForDirectory(item);
    function saveCats(out){ if(item && item.item_id){ state._browseCatsByItemCache = state._browseCatsByItemCache || {}; state._browseCatsByItemCache[String(item.item_id)] = (out || []).slice(); } return out || []; }
    if(type === 'Spells') return saveCats([spellCategoryForItem(item)]);
    if(type === 'Songs') return saveCats(['Lineage Songs']);
    if(type === 'Teachings'){
      var rawTeach = [item && item.item_id, item && item.type, item && item.category, item && item.first_source_book, item && item.chinese_title, item && item.english_title, item && item.notes].join(' ');
      var kTeach = sourceNorm(rawTeach);
      if(/handsign|hand sign|seals?/.test(kTeach) || /手訣|手诀|手印/.test(rawTeach)) return saveCats(['Handsign']);
      return saveCats(['Teaching Gate']);
    }
    var seen = {}, cats = [];
    bookIdsForItem(item).forEach(function(bookId){
      if(bookLibraryTypeForDirectory(bookId) === 'Scriptures/Rite') addUnique(cats, seen, bookCategoryForDirectory(bookId));
    });
    if(!cats.length){
      var raw = [item.item_id, item.category, item.first_source_book, item.chinese_title, item.english_title, item.notes].join(' ');
      var k = sourceNorm(raw);
      if(/blood lake|hell|ghost king|ground official|salvation|exorcism|地官|血湖|地獄|地狱|鬼王|普渡|滅邪|灭邪/.test(k) || /地官|血湖|地獄|地狱|鬼王|普渡|滅邪|灭邪/.test(raw)) cats.push('Dei');
      else if(/true merit|virtue|human|一善|功德|善/.test(k) || /一善|功德|善/.test(raw)) cats.push('Daai');
      else if(/truth scripture|prayer|寶誥|宝诰|天師|天师|財神經|财神经/.test(k) || /真經|真经|寶誥|宝诰|天師|天师|財神經|财神经/.test(raw)) cats.push('Tin');
      else cats.push('All');
    }
    return saveCats(cats);
  }

  function itemMatchesSmartCategory(item, cat){
    cat = String(cat || '').trim();
    if(!cat) return true;
    return itemBrowseCategoriesForDirectory(item).indexOf(cat) !== -1;
  }

  function bookMatchesDirectoryFilters(bookId){
    var bookType = bookLibraryTypeForDirectory(bookId);
    if(state.type && bookType !== state.type) return false;
    if(state.category){
      var bookCat = bookCategoryForDirectory(bookId);
      if(isScriptureRiteLabel(bookType) || isScriptureRiteLabel(state.type)){
        if(normalizeScriptureRiteCategory(bookCat) !== normalizeScriptureRiteCategory(state.category)) return false;
      }else if(bookCat !== state.category) return false;
    }
    return true;
  }

  function filteredItems(opts){
    opts = opts || {};
    var useCategory = opts.useCategory !== false;
    var useType = opts.useType !== false;
    var q = norm(state.query);
    if(!q && !(useType && state.type) && !(useCategory && state.category)) return validItemRows(state.items);
    return validItemRows(state.items).filter(function(item){
      if(itemIsHiddenLegacy(item)) return false;
      if(useType && state.type && itemLibraryTypeForDirectory(item) !== state.type) return false;
      if(useCategory && state.category && !itemMatchesSmartCategory(item, state.category)) return false;
      if(q && searchableText(item).indexOf(q) === -1) return false;
      return true;
    });
  }



  /* RC Atlas Phase 3 DB Loader */
  function rcClean(v){ return String(v == null ? '' : v).trim(); }
  function normalizeRcAtlasRows(rows){
    var seen = {};
    return (rows || []).map(function(r, idx){
      r = r || {};
      // Critical safety guard:
      // Google gviz can silently return the first sheet when the optional RC_Atlas tab is missing.
      // When that happens, normal Items rows appear under the requested RC_Atlas name.
      // Only accept real RC rows with rc_id beginning with rc_. Never fall back to item_id.
      var id = rcClean(r.rc_id || r.id);
      if(!id || !/^rc_/i.test(id)) return null;
      var dir = rcClean(r.directory || 'RC Atlas');
      if(dir && !/^rc\s*atlas$/i.test(dir)) return null;
      var status = rcClean(r.status || 'approved');
      if(/^hide|hidden|archive|archived$/i.test(status)) return null;
      var type = rcClean(r.type || 'Basics');
      if(RC_ATLAS_TYPES.indexOf(type) === -1) type = 'Basics';
      var entry = {
        rc_id:id,
        directory:'RC Atlas',
        type:type,
        category:rcClean(r.category || 'Study Notes'),
        title_en:rcClean(r.title_en || r.title || id),
        title_zh:rcClean(r.title_zh || ''),
        parent:rcClean(r.parent || ''),
        belongs_to:rcClean(r.belongs_to || ''),
        display_order:Number(r.display_order || r.order || (100000 + idx)) || (100000 + idx),
        short_summary:rcClean(r.short_summary || r.summary || ''),
        simple_meaning:rcClean(r.simple_meaning || ''),
        what_it_does:rcClean(r.what_it_does || ''),
        disciple_study_notes:rcClean(r.disciple_study_notes || r.study_notes || ''),
        afterdeath_meaning:rcClean(r.afterdeath_meaning || ''),
        practice_usage:rcClean(r.practice_usage || ''),
        related_entries:rcClean(r.related_entries || ''),
        tags:rcClean(r.tags || ''),
        status:status,
        updated_at:rcClean(r.updated_at || r.updatedAt || '')
      };
      if(seen[entry.rc_id]) return null;
      seen[entry.rc_id] = true;
      return entry;
    }).filter(Boolean).sort(function(a,b){
      return Number(a.display_order || 0) - Number(b.display_order || 0) || String(a.title_en || '').localeCompare(String(b.title_en || ''));
    });
  }
  function applyRcAtlasRows(rows){
    var normalized = normalizeRcAtlasRows(rows || []).map(rcNormalizeEntryForDisplay);
    // If the optional RC_Atlas tab is empty/missing, keep the built-in RC Atlas visible
    // AND keep it in state.rcAtlas so status/cache counts do not show false 0 entries.
    state.rcAtlas = (normalized.length ? normalized : RC_ATLAS_DEFAULT_ENTRIES.slice()).map(rcNormalizeEntryForDisplay);
    RC_ATLAS_ENTRIES = state.rcAtlas.slice();
  }
  function normalizeDirectoryView(){
    var v = String(state.directoryView || '').toLowerCase().trim();
    if(v === 'rc atlas' || v === 'rc_atlas') state.directoryView = 'rc';
    else if(v === 'god' || v === 'gods' || v === 'god atlas' || v === 'god_atlas') state.directoryView = 'gods';
    else if(v === 'quick' || v === 'quick shelf' || v === 'quick_shelf' || v === 'shelf') state.directoryView = 'quick';
    else if(v === 'video' || v === 'videos' || v === 'teaching videos') state.directoryView = 'videos';
    else if(v === 'fun' || v === 'fun watch' || v === 'funwatch' || v === 'entertainment') state.directoryView = 'funwatch';
    else if(v === 'article' || v === 'articles' || v === 'teaching articles') state.directoryView = 'articles';
    else if(v === 'supply' || v === 'supplies' || v === 'shopping' || v === 'shopping list') state.directoryView = 'supplies';
    else if(v !== 'rc') state.directoryView = 'book';
    if(els.directoryView && els.directoryView.value !== state.directoryView) els.directoryView.value = state.directoryView;
  }
  function isRcDirectory(){ var v = String(state.directoryView || '').toLowerCase().trim(); return v === 'rc' || v === 'rc atlas' || v === 'rc_atlas'; }
  function isGodDirectory(){ var v = String(state.directoryView || '').toLowerCase().trim(); return v === 'gods' || v === 'god' || v === 'god atlas' || v === 'god_atlas'; }
  function isQuickShelfDirectory(){ var v = String(state.directoryView || '').toLowerCase().trim(); return v === 'quick' || v === 'quick shelf' || v === 'quick_shelf' || v === 'shelf'; }
  function isVideoDirectory(){ return String(state.directoryView || '').toLowerCase().trim() === 'videos'; }
  function isFunWatchDirectory(){ return String(state.directoryView || '').toLowerCase().trim() === 'funwatch'; }
  function isArticleDirectory(){ return String(state.directoryView || '').toLowerCase().trim() === 'articles'; }
  function isSupplyDirectory(){ return String(state.directoryView || '').toLowerCase().trim() === 'supplies'; }
  function isCollectionDirectory(){ return isVideoDirectory() || isFunWatchDirectory() || isArticleDirectory() || isSupplyDirectory(); }
  function rcEntryById(id){
    id = String(id || '');
    for(var i=0;i<RC_ATLAS_ENTRIES.length;i++){ if(RC_ATLAS_ENTRIES[i].rc_id === id) return RC_ATLAS_ENTRIES[i]; }
    return null;
  }
  function isRcSelection(id){ return !!rcEntryById(id); }
  function rcSearchText(entry){
    var fields = ['rc_id','type','category','title_en','title_zh','parent','belongs_to','short_summary','simple_meaning','what_it_does','disciple_study_notes','afterdeath_meaning','practice_usage','related_entries','tags'];
    return fields.map(function(k){ return entry[k] || ''; }).join(' ').toLowerCase();
  }
  function rcFilteredEntries(){
    var q = norm(state.query);
    return RC_ATLAS_ENTRIES.filter(function(e){
      if(state.type && e.type !== state.type) return false;
      if(state.category && e.category !== state.category) return false;
      if(q && rcSearchText(e).indexOf(q) === -1) return false;
      return true;
    }).sort(function(a,b){ return Number(a.display_order || 0) - Number(b.display_order || 0) || String(a.title_en || '').localeCompare(String(b.title_en || '')); });
  }
  function rcGroupTitle(key){
    if(!key) return 'RC Atlas';
    return key;
  }
  function rcGroupKeyForEntry(entry){
    if(state.type) return 'rc:cat:' + groupKey(entry.category || 'Study Notes');
    return 'rc:type:' + groupKey(entry.type || 'Basics');
  }
  function rcGroupLabelForEntry(entry){
    return state.type ? (entry.category || 'Study Notes') : (entry.type || 'Basics');
  }
  function rcNestedCategoryKey(typeLabel, categoryLabel){
    return 'rc:typecat:' + groupKey(typeLabel || 'Basics') + ':' + groupKey(categoryLabel || 'Study Notes');
  }
  function rcSortEntries(a,b){
    return Number(a.display_order || 0) - Number(b.display_order || 0) || String(a.title_en || '').localeCompare(String(b.title_en || ''));
  }
  function rcCategorySort(a,b, groups){
    var ae = (groups && groups[a] && groups[a][0]) || {};
    var be = (groups && groups[b] && groups[b][0]) || {};
    return Number(ae.display_order || 0) - Number(be.display_order || 0) || String(a || '').localeCompare(String(b || ''));
  }
  function currentRcGroupKeys(){
    var keys = {};
    var entries = rcFilteredEntries();
    entries.forEach(function(e){
      keys[rcGroupKeyForEntry(e)] = true;
      if(!state.type) keys[rcNestedCategoryKey(e.type || 'Basics', e.category || 'Study Notes')] = true;
    });
    return Object.keys(keys);
  }
  function renderRcNestedCategoryGroup(typeLabel, categoryLabel, entries, searchActive){
    entries = (entries || []).slice().sort(rcSortEntries);
    if(!entries.length) return '';
    var key = rcNestedCategoryKey(typeLabel, categoryLabel);
    var isOpen = !!searchActive || !!state.openGroups[key];
    rememberDirectoryGroup(key, { type:'rc', title:categoryLabel, entries:entries.slice() });
    var html = '<section class="tydLib__group tydLib__rcNestedGroup '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
    html += '<button type="button" class="tydLib__groupBtn tydLib__rcCategoryBtn" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName">'+escapeHtml(categoryLabel || 'Study Notes')+'</span></span><span class="tydLib__groupCount">'+entries.length+'</span></button>';
    html += '<div class="tydLib__groupBody">';
    if(isOpen){ html += renderDirectoryGroupBody(key); }
    html += '</div></section>';
    return html;
  }
  function renderRcEntryButton(entry){
    var active = entry.rc_id === state.selectedId;
    return '<div class="tydLib__itemRow tydLib__rcItemRow">' +
      '<button type="button" class="tydLib__item tydLib__rcItem '+(active?'active':'')+'" data-id="'+escapeHtml(entry.rc_id)+'">' +
        '<div class="tydLib__itemEn">'+escapeHtml(entry.title_en || entry.rc_id)+'</div>' +
        '<div class="tydLib__itemZh">'+escapeHtml(entry.title_zh || '')+'</div>' +
        '<div class="tydLib__rcMini">'+escapeHtml((entry.type || '') + (entry.category ? ' • ' + entry.category : ''))+'</div>' +
      '</button>' +
    '</div>';
  }
  function renderRcDirectory(searchActive){
    var entries = rcFilteredEntries();
    var byGroup = {};
    var groupLabels = {};
    entries.forEach(function(e){
      var key = rcGroupKeyForEntry(e);
      groupLabels[key] = rcGroupLabelForEntry(e);
      (byGroup[key] = byGroup[key] || []).push(e);
    });
    var html = '';
    var visibleCount = entries.length;
    Object.keys(byGroup).sort(function(a,b){
      var ae = byGroup[a][0] || {};
      var be = byGroup[b][0] || {};
      return Number(ae.display_order || 0) - Number(be.display_order || 0) || String(groupLabels[a] || '').localeCompare(String(groupLabels[b] || ''));
    }).forEach(function(key){
      var isOpen = searchActive || !!state.openGroups[key];
      if(state.type){
        rememberDirectoryGroup(key, { type:'rc', title:groupLabels[key], entries:byGroup[key].slice() });
      }else{
        // V88: In Type = All, RC first level is Type only. Its body must show
        // another collapsible category level (Overview / Palace / Hall / Courtyard),
        // instead of dumping all RC entries at once.
        rememberDirectoryGroup(key, { type:'rcType', title:groupLabels[key], entries:byGroup[key].slice(), searchActive:!!searchActive });
      }
      html += '<section class="tydLib__group '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
      html += '<button type="button" class="tydLib__groupBtn tydLib__rcGroupBtn" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName">'+escapeHtml(rcGroupTitle(groupLabels[key]))+'</span></span><span class="tydLib__groupCount">'+byGroup[key].length+'</span></button>';
      html += '<div class="tydLib__groupBody">';
      if(isOpen){ html += renderDirectoryGroupBody(key); }
      html += '</div></section>';
    });
    state._lastDirectoryCount = visibleCount;
    return html;
  }
  function rcFieldHtml(label, value){
    if(!value) return '';
    return '<section class="tydLib__rcStudyBlock"><h3>'+escapeHtml(label)+'</h3><p>'+escapeHtml(value)+'</p></section>';
  }

  function readerActionsMenuHtml(extraClass, buttonsHtml){
    return '<details class="tydLib__readerActionMenu '+escapeHtml(extraClass || '')+'">' +
      '<summary class="tydLib__btn secondary tydLib__actionsToggle" aria-label="Show reader actions" title="Show reader actions">☰ Actions</summary>' +
      '<div class="tydLib__readerActionPanel" role="group" aria-label="Reader actions">' + (buttonsHtml || '') + '</div>' +
      '</details>';
  }

  function rcShouldHideChineseTitle(entry){
    entry = entry || {};
    return String(entry.type || '').toLowerCase() === 'basics' || String(entry.category || '').toLowerCase() === 'lessons' || /^rc_basics_/i.test(String(entry.rc_id || ''));
  }
  function rcNormalizeEntryForDisplay(entry){
    entry = Object.assign({}, entry || {});
    if(rcShouldHideChineseTitle(entry)) entry.title_zh = '';
    return entry;
  }
  function rcReaderButtonsHtml(){
    return '<div class="tydLib__readerBtns tydLib__rcReaderBtns tydLib__readerBtns--collapsed">' +
      readerActionsMenuHtml('tydLib__rcReaderActionMenu',
        '<button class="tydLib__btn secondary tydLib__chantModeBtn" type="button" id="tydChantMode" aria-label="Open focused reading view" title="Focused view">👁</button>' +
        readerSizeButtonHtml() +
        '<button class="tydLib__btn secondary tydLib__copyBtn" type="button" id="tydCopyCurrent" aria-label="Copy study notes" title="Copy study notes">⧉</button>' +
        '<button class="tydLib__btn secondary tydLib__printBtn" type="button" id="tydPrintCurrent" aria-label="Print or save PDF" title="Print / Save PDF">🖨</button>' +
        '<button class="tydLib__btn secondary tydLib__kpdfBtn" type="button" id="tydKpdfCurrent" aria-label="Make Kindle PDF" title="K-PDF Kindle preview">K-PDF</button>' +
        '<button class="tydLib__btn secondary tydLib__deepLinkBtn" type="button" id="tydCopyDeepLink" aria-label="Copy deep link" title="Copy exact page link">Link</button>'
      ) +
      '</div>';
  }
  function rcCopyTextLines(entry){
    var out = [];
    if(!entry) return out;
    out.push(entry.title_en || entry.rc_id || 'RC Atlas');
    if(entry.short_summary){ out.push(''); out.push(entry.short_summary); }
    function add(label, value){ if(value){ out.push(''); out.push(label); out.push(value); } }
    add('Simple Meaning', entry.simple_meaning);
    add('What It Does', entry.what_it_does);
    add('Disciple Study Notes', entry.disciple_study_notes);
    add('Afterdeath Meaning', entry.afterdeath_meaning);
    add('Practice Usage', entry.practice_usage);
    if(entry.related_entries){ out.push(''); out.push('Related Entries'); out.push(entry.related_entries); }
    return out;
  }
  function rcFocusRows(entry){
    var rows = [];
    function add(label, value){
      if(value) rows.push({ chinese:'', saamlawnese:'', english_translation:label+'\n'+value, status:'approved' });
    }
    if(entry.short_summary) add('Summary', entry.short_summary);
    add('Simple Meaning', entry.simple_meaning);
    add('What It Does', entry.what_it_does);
    add('Disciple Study Notes', entry.disciple_study_notes);
    add('Afterdeath Meaning', entry.afterdeath_meaning);
    add('Practice Usage', entry.practice_usage);
    return rows;
  }
  function pushRcFocusPages(pages, entry){
    if(!entry) return;
    entry = rcNormalizeEntryForDisplay(entry);
    var rows = rcFocusRows(entry);
    if(!rows.length) return;
    var size = 2;
    for(var i=0;i<rows.length;i+=size){
      pages.push({
        bookLabel:'RC Atlas',
        sectionMain:entry.title_en || entry.rc_id || 'RC Atlas',
        sectionSub:'',
        lines:rows.slice(i, i + size),
        mode:'english',
        part:Math.floor(i / size) + 1,
        parts:Math.ceil(rows.length / size)
      });
    }
  }
  function renderRcRelated(entry){
    var ids = String(entry.related_entries || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
    if(!ids.length) return '';
    var links = ids.map(function(id){
      var e = rcEntryById(id);
      if(!e) return '<span class="tydLib__rcRelatedMissing">'+escapeHtml(id)+'</span>';
      return '<button type="button" class="tydLib__rcRelated" data-id="'+escapeHtml(e.rc_id)+'">'+escapeHtml(e.title_en || e.rc_id)+'</button>';
    }).join('');
    return '<section class="tydLib__rcStudyBlock"><h3>Related Entries</h3><div class="tydLib__rcRelatedList">'+links+'</div></section>';
  }
  function renderRcReader(entry){
    ++state._readerRenderToken;
    root.classList.remove('tydLib--readerRendering');
    entry = rcNormalizeEntryForDisplay(entry);
    if(!entry){
      els.reader.innerHTML = '<div class="tydLib__empty"><h2>Select an RC Atlas entry</h2><p>Choose an entry from the RC Atlas directory.</p></div>';
      setReaderMeta('');
      return;
    }
    els.reader.innerHTML =
      '<article class="tydLib__rcStudy">' +
        '<div class="tydLib__readerTop"><div>' +
          titleBlockHtml(entry.title_zh || '', entry.title_en || '', entry.rc_id || '') +
        '</div>'+rcReaderButtonsHtml()+'</div>' +
        (entry.short_summary ? '<div class="tydLib__rcSummary">'+escapeHtml(entry.short_summary)+'</div>' : '') +
        rcFieldHtml('Simple Meaning', entry.simple_meaning) +
        rcFieldHtml('What It Does', entry.what_it_does) +
        rcFieldHtml('Disciple Study Notes', entry.disciple_study_notes) +
        rcFieldHtml('Afterdeath Meaning', entry.afterdeath_meaning) +
        rcFieldHtml('Practice Usage', entry.practice_usage) +
        renderRcRelated(entry) +
        (entry.tags ? '<div class="tydLib__small">Tags: '+escapeHtml(entry.tags)+'</div>' : '') +
      '</article>';
    setReaderMeta('');
  }


  function rcAvailableTypes(){
    var seen = {}, out = [];
    RC_ATLAS_ENTRIES.forEach(function(e){
      var t = e && e.type ? String(e.type) : '';
      if(t && RC_ATLAS_TYPES.indexOf(t) !== -1 && !seen[t]){ seen[t] = true; out.push(t); }
    });
    return out.length ? out : RC_ATLAS_TYPES.slice();
  }
  function rcAvailableCategories(type){
    var seen = {}, out = [];
    RC_ATLAS_ENTRIES.forEach(function(e){
      if(type && e.type !== type) return;
      var c = e && e.category ? String(e.category) : '';
      if(c && !seen[c]){ seen[c] = true; out.push(c); }
    });
    return out;
  }

  /* God Atlas V103 Category Context Fix */
  /* God Atlas Phase 4 Link Hub */
  function godClean(v){ return String(v == null ? '' : v).trim(); }
  function godEntryById(id){
    id = String(id || '');
    for(var i=0;i<GOD_ATLAS_ENTRIES.length;i++){ if(GOD_ATLAS_ENTRIES[i].god_id === id) return GOD_ATLAS_ENTRIES[i]; }
    return null;
  }
  function isGodSelection(id){ return !!godEntryById(id); }
  function godSearchText(entry){
    var fields = ['god_id','type','name_en','name_zh','saamlawnese_name','aliases','short_summary','details_info','god_power','disciple_usage','source_notes','tags'];
    return fields.map(function(k){ return entry[k] || ''; }).join(' ').toLowerCase();
  }
  function godFilteredEntries(){
    var q = norm(state.query);
    return GOD_ATLAS_ENTRIES.filter(function(e){
      if(state.type && e.type !== state.type) return false;
      if(q && godSearchText(e).indexOf(q) === -1) return false;
      if(state.category) return godSectionHasContent(e, state.category);
      return godEntryHasAnyContent(e);
    }).sort(function(a,b){ return Number(a.display_order || 0) - Number(b.display_order || 0) || String(a.name_en || '').localeCompare(String(b.name_en || '')); });
  }
  function godGroupKeyForEntry(entry){ return 'god:type:' + groupKey((entry && entry.type) || 'Others'); }
  function currentGodGroupKeys(){
    var keys = {}, entries = godFilteredEntries();
    if(state.type){
      entries.forEach(function(e){ keys[godEntryGroupKey(e)] = true; });
      return Object.keys(keys);
    }
    entries.forEach(function(e){ keys[godGroupKeyForEntry(e)] = true; });
    return Object.keys(keys);
  }
  function renderGodEntryButton(entry){
    var active = entry.god_id === state.selectedId && !state.category && !state.godSection;
    return '<div class="tydLib__itemRow tydLib__godItemRow">' +
      '<button type="button" class="tydLib__item tydLib__godItem '+(active?'active':'')+'" data-id="'+escapeHtml(entry.god_id)+'">' +
        '<div class="tydLib__itemEn">'+escapeHtml(entry.name_en || entry.god_id)+'</div>' +
        '<div class="tydLib__itemZh">'+escapeHtml(entry.name_zh || '')+'</div>' +
        '<div class="tydLib__rcMini">'+escapeHtml((entry.type || '') + (entry.saamlawnese_name ? ' • ' + entry.saamlawnese_name : ''))+'</div>' +
      '</button>' +
    '</div>';
  }
  function godEntryGroupKey(entry){ return 'god:entry:' + String((entry && entry.god_id) || ''); }
  function godCategoryButtonLabel(section){
    if(section === 'God Spell') return 'God Spell';
    if(section === 'Details / Info') return 'Details / Info';
    return section || 'Section';
  }
  function renderGodCategoryButton(entry, section){
    if(!godSectionHasContent(entry, section)) return '';
    var currentGodSection = state.godSection || state.category || '';
    var active = entry && entry.god_id === state.selectedId && currentGodSection === section;
    var sub = '';
    if(section === 'Prayer') sub = entry && entry.prayer_item_ids ? 'Prayer linked' : 'Prayer auto matched';
    else if(section === 'FU Head') sub = entry && entry.fu_head_item_ids ? 'FU Head linked' : 'FU Head auto matched';
    else if(section === 'God Spell') sub = entry && entry.god_spell_item_ids ? 'God Spell linked' : 'God Spell auto matched';
    else if(section === 'Scriptures') sub = (entry && (entry.scripture_item_ids || entry.scripture_book_ids)) ? 'Scripture linked' : 'Scripture auto matched';
    else if(section === 'Art') sub = 'Art / CDN links';
    else if(section === 'Anniversary') sub = 'Anniversary linked';
    else sub = 'Details ready';
    return '<div class="tydLib__itemRow tydLib__godCategoryRow">' +
      '<button type="button" class="tydLib__item tydLib__godCategoryItem '+(active?'active':'')+'" data-god-category-select="'+escapeHtml((entry && entry.god_id) || '')+'" data-god-category="'+escapeHtml(section || '')+'">' +
        '<div class="tydLib__itemEn">'+escapeHtml(godCategoryButtonLabel(section))+'</div>' +
        '<div class="tydLib__rcMini">'+escapeHtml(sub)+'</div>' +
      '</button>' +
    '</div>';
  }
  function godSectionListSub(entry, section){
    if(section === 'Prayer') return entry && entry.prayer_item_ids ? 'Prayer linked' : 'Prayer auto matched';
    if(section === 'FU Head') return entry && entry.fu_head_item_ids ? 'FU Head linked' : 'FU Head auto matched';
    if(section === 'God Spell') return entry && entry.god_spell_item_ids ? 'God Spell linked' : 'God Spell auto matched';
    if(section === 'Scriptures') return entry && (entry.scripture_item_ids || entry.scripture_book_ids) ? 'Scripture linked' : 'Scripture auto matched';
    if(section === 'Art') return 'Art linked';
    if(section === 'Anniversary') return 'Anniversary linked';
    if(section === 'Details / Info') return 'Details ready';
    return section || 'Section';
  }
  function renderGodSectionEntryButton(entry, section){
    if(!entry || !entry.god_id || !godSectionHasContent(entry, section)) return '';
    var active = entry.god_id === state.selectedId && state.category === section;
    return '<div class="tydLib__itemRow tydLib__godItemRow tydLib__godSectionListRow">' +
      '<button type="button" class="tydLib__item tydLib__godItem tydLib__godSectionListItem '+(active?'active':'')+'" data-god-category-select="'+escapeHtml(entry.god_id)+'" data-god-category="'+escapeHtml(section || '')+'">' +
        '<div class="tydLib__itemEn">'+escapeHtml(entry.name_en || entry.god_id)+'</div>' +
        '<div class="tydLib__itemZh">'+escapeHtml(entry.name_zh || '')+'</div>' +
        '<div class="tydLib__rcMini">'+escapeHtml(godCategoryButtonLabel(section) + ' • ' + godSectionListSub(entry, section))+'</div>' +
      '</button>' +
    '</div>';
  }
  function renderGodNestedGroupForDirectory(entry, searchActive){
    if(!entry || !entry.god_id) return '';
    var visibleSections = godVisibleSections(entry);
    if(!visibleSections.length) return '';
    var key = godEntryGroupKey(entry);
    rememberDirectoryGroup(key, { type:'godEntry', entry:entry, sections:visibleSections.slice() });
    var isOpen = !!searchActive || !!state.openGroups[key];
    var html = '<section class="tydLib__group tydLib__godNestedGroup '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
    html += '<button type="button" class="tydLib__groupBtn tydLib__godNestedBtn '+(entry.god_id===state.selectedId?'active':'')+'" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName god"><b>'+escapeHtml(entry.name_en || entry.god_id)+'</b>'+(entry.name_zh ? '<small>'+escapeHtml(entry.name_zh)+'</small>' : '')+'</span></span><span class="tydLib__groupCount">'+visibleSections.length+'</span></button>';
    html += '<div class="tydLib__groupBody">';
    if(isOpen){ html += renderDirectoryGroupBody(key); }
    html += '</div></section>';
    return html;
  }
  function renderGodDirectory(searchActive){
    var entries = godFilteredEntries();
    var html = '', visibleCount = entries.length;
    if(state.category){
      entries.forEach(function(entry){ html += renderGodSectionEntryButton(entry, state.category); });
      state._lastDirectoryCount = visibleCount;
      return html;
    }
    if(state.type){
      entries.forEach(function(entry){ html += renderGodNestedGroupForDirectory(entry, !!searchActive); });
      state._lastDirectoryCount = visibleCount;
      return html;
    }
    var byType = {};
    entries.forEach(function(e){ var t = e.type || 'Others'; (byType[t] = byType[t] || []).push(e); });
    GOD_ATLAS_TYPES.forEach(function(t){
      var list = byType[t] || [];
      if(!list.length) return;
      var key = 'god:type:' + groupKey(t);
      var isOpen = searchActive || !!state.openGroups[key];
      rememberDirectoryGroup(key, { type:'godType', title:t, entries:list.slice(), searchActive:!!searchActive });
      html += '<section class="tydLib__group tydLib__godGroup '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
      html += '<button type="button" class="tydLib__groupBtn tydLib__godGroupBtn" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName">'+escapeHtml(t)+'</span></span><span class="tydLib__groupCount">'+list.length+'</span></button>';
      html += '<div class="tydLib__groupBody">';
      if(isOpen){ html += renderDirectoryGroupBody(key); }
      html += '</div></section>';
    });
    state._lastDirectoryCount = visibleCount;
    return html;
  }
  function godSectionAllowed(section){ var selected = state.godSection || state.category || ''; return !selected || selected === section; }
  function godSplitList(v){
    return String(v || '').split(/[|,]/).map(function(s){ return s.trim(); }).filter(Boolean);
  }

  /* V105/V111: hide empty sections and ensure Scripture category only counts true scripture links */
  function godLooksPlaceholderText(v){
    v = String(v || '').trim();
    if(!v) return true;
    var plain = v.toLowerCase().replace(/[‘’]/g, "'").replace(/[“”]/g, '"');
    var compact = plain.replace(/[^a-z0-9㐀-鿿]+/g, ' ').replace(/\s+/g, ' ').trim();
    if(!compact) return true;
    if(/^(animal guardian|saam ching animal guardian|god entry added from god spell prayer fu head matching)$/i.test(compact)) return true;
    var bad = [
      'not added yet',
      'pending',
      'placeholder',
      'to be added',
      'will be added',
      'will be filled',
      'will be expanded',
      'expanded later',
      'check the live god atlas sheet',
      'use the updated v97 fallback db',
      'god entry added from god spell prayer fu head matching',
      'this god atlas entry has approved artwork linked from the user provided god image upload',
      'detailed doctrine prayer notes spell notes and scripture links can be expanded later',
      'art is not linked',
      'no prayer of faith link is set',
      'no fu head link is set',
      'no god spell link is set',
      'no related scripture link is set',
      'no anniversary entry is linked'
    ];
    for(var i=0;i<bad.length;i++){
      if(compact.indexOf(bad[i]) !== -1) return true;
    }
    return false;
  }
  function godMeaningfulText(v){
    v = String(v || '').trim();
    return v && !godLooksPlaceholderText(v) ? v : '';
  }
  function godIsTrueScriptureItem(item){
    if(!item) return false;
    var t = String(item.type || '').trim().toLowerCase();
    if(t === 'scripture') return true;
    // Be conservative: a Prayer/FU/Spell that lives inside a scripture book is not a scripture.
    return false;
  }
  function godIsTrueScriptureBook(book){
    if(!book) return false;
    var lt = cleanTaxonomyLabel(book.library_type || '').toLowerCase();
    if(lt === 'scriptures/rite') return true;
    var txt = [book.book_id, book.book_title_english, book.book_title_chinese, book.file_name].join(' ').toLowerCase();
    return /scripture|經|经/.test(txt);
  }
  function godIsValidLinkedSectionItem(section, item){
    if(section === 'Scriptures') return godIsTrueScriptureItem(item);
    return !!item;
  }
  function godIsValidLinkedSectionBook(section, book){
    if(section === 'Scriptures') return godIsTrueScriptureBook(book);
    return !!book;
  }
  function godHasRealLinkedContent(entry, section, itemIds, bookIds){
    var found = false;
    var used = {};
    var itemList = godSplitList(itemIds);
    var bookList = godSplitList(bookIds);
    itemList.forEach(function(id){
      if(found || !id || used['item:'+id]) return;
      used['item:'+id] = true;
      var item = itemById(id);
      if(item && godIsValidLinkedSectionItem(section, item)) found = true;
    });
    bookList.forEach(function(id){
      if(found || !id || used['book:'+id]) return;
      used['book:'+id] = true;
      var book = bookById(id);
      if(book && godIsValidLinkedSectionBook(section, book)) found = true;
    });
    if(found) return true;

    // V111: Scripture must be an explicit scripture_book_ids/scripture_item_ids link.
    // Do not auto-count Prayer/FU/Spell rows just because they appear inside a scripture/rite book.
    if(section === 'Scriptures') return false;

    if(!itemList.length && !bookList.length){
      if(godFindAutoItems(entry, section).length) return true;
      if(godFindAutoBooks(entry, section).length) return true;
    }
    return false;
  }
  function godSectionHasContent(entry, section){
    if(!entry || !section) return false;
    if(section === 'Details / Info'){
      return !!(
        godMeaningfulText(entry.details_info) ||
        godMeaningfulText(entry.short_summary) ||
        godMeaningfulText(entry.god_power) ||
        godMeaningfulText(entry.disciple_usage) ||
        godMeaningfulText(entry.court_area) ||
        godMeaningfulText(entry.palace_hall_department)
      );
    }
    if(section === 'Prayer') return godHasRealLinkedContent(entry, section, entry.prayer_item_ids, '');
    if(section === 'FU Head') return godHasRealLinkedContent(entry, section, entry.fu_head_item_ids, '');
    if(section === 'God Spell') return godHasRealLinkedContent(entry, section, entry.god_spell_item_ids, '');
    if(section === 'Scriptures') return godHasRealLinkedContent(entry, section, entry.scripture_item_ids, entry.scripture_book_ids);
    if(section === 'Art') return godImageUrls(entry).length > 0;
    if(section === 'Anniversary') return !!godAnnivForEntry(entry);
    return false;
  }
  function godVisibleSections(entry){
    return GOD_ATLAS_CATEGORIES.filter(function(section){ return godSectionHasContent(entry, section); });
  }
  function godEntryHasAnyContent(entry){
    return godVisibleSections(entry).length > 0;
  }
  function godAvailableTypes(){
    var seen = {};
    GOD_ATLAS_ENTRIES.forEach(function(e){ if(godEntryHasAnyContent(e)) seen[e.type || 'Others'] = true; });
    return GOD_ATLAS_TYPES.filter(function(t){ return !!seen[t]; });
  }
  function godAvailableSections(){
    var seen = {};
    var q = norm(state.query);
    GOD_ATLAS_ENTRIES.forEach(function(e){
      if(state.type && e.type !== state.type) return;
      if(q && godSearchText(e).indexOf(q) === -1) return;
      GOD_ATLAS_CATEGORIES.forEach(function(section){ if(godSectionHasContent(e, section)) seen[section] = true; });
    });
    return GOD_ATLAS_CATEGORIES.filter(function(section){ return !!seen[section]; });
  }
  function godFallbackText(section){
    if(section === 'Prayer') return 'No Prayer of Faith link is set for this god yet.';
    if(section === 'FU Head') return 'No FU Head link is set for this god yet.';
    if(section === 'God Spell') return 'No God Spell link is set for this god yet.';
    if(section === 'Scriptures') return 'No related scripture link is set for this god yet.';
    if(section === 'Art') return 'God art and CDN image links will be added in the God_Assets sheet later.';
    if(section === 'Anniversary') return 'No anniversary entry is linked yet. This section reads from the SLB GOD_ANNIVERSARY system when available.';
    return 'Not added yet. This section will be filled from the God Atlas DB, linked library items, and approved source notes.';
  }
  function godParagraphsHtml(text){
    text = String(text || '').trim();
    if(!text) return '';
    return text.split(/\n{2,}/).map(function(p){ return '<p>'+escapeHtml(p.trim())+'</p>'; }).join('');
  }
  function godChipListHtml(values, prefix){
    values = godSplitList(values);
    if(!values.length) return '';
    return '<div class="tydLib__godChipList">' + values.map(function(v){
      return '<span class="tydLib__godChip" title="'+escapeHtml(prefix || '')+'">'+escapeHtml(v)+'</span>';
    }).join('') + '</div>';
  }

  function godCandidateNames(entry){
    var out = [];
    function push(v){ v = String(v || '').trim(); if(v && out.indexOf(v) === -1) out.push(v); }
    if(!entry) return out;
    push(entry.name_en); push(entry.name_zh); push(entry.saamlawnese_name);
    godSplitList(entry.aliases).forEach(push);
    return out;
  }
  function godTextMatchesEntry(entry, text){
    var hay = sourceNorm(text || '');
    if(!hay) return false;
    var names = godCandidateNames(entry);
    for(var i=0;i<names.length;i++){
      var n = sourceNorm(names[i]);
      if(n && (hay.indexOf(n) !== -1 || n.indexOf(hay) !== -1)) return true;
    }
    return false;
  }
  function godSectionHints(section){
    if(section === 'Prayer') return ['prayer of faith','faith prayer','prayer'];
    if(section === 'FU Head') return ['fu head','fu heads','fuhead','符頭','符头'];
    if(section === 'God Spell') return ['god spell','god spells','cheng sun','god invoking','請神','请神'];
    if(section === 'Scriptures') return ['scripture','scriptures','sutra','truth scripture','經','经'];
    return [];
  }
  function godRowText(row){
    if(!row) return '';
    return [row.item_id,row.book_id,row.type,row.category,row.chinese_title,row.english_title,row.book_title_chinese,row.book_title_english,row.first_source_book,row.source_book,row.file_name,row.notes,row.display_section].join(' ');
  }
  function godSectionHintMatch(section, text, row){
    var k = sourceNorm(text || '');
    var hints = godSectionHints(section);
    if(section === 'Prayer' && row && String(row.type || '').toLowerCase() === 'prayer') return true;
    if(section === 'Scriptures') return !!(row && String(row.type || '').toLowerCase() === 'scripture');
    for(var i=0;i<hints.length;i++){ if(k.indexOf(sourceNorm(hints[i])) !== -1) return true; }
    return false;
  }
  function godFindAutoItems(entry, section){
    var out = [], seen = {};
    if(!entry || !section) return out;
    (state.items || []).forEach(function(item){
      if(!item || !item.item_id || seen[item.item_id]) return;
      var raw = godRowText(item);
      if(!godSectionHintMatch(section, raw, item)) return;
      if(!godTextMatchesEntry(entry, raw)) return;
      seen[item.item_id] = true; out.push(item);
    });
    return out.slice(0, 8);
  }
  function godFindAutoBooks(entry, section){
    var out = [], seen = {};
    // V111: no auto-book matching for God Scriptures. Use God_Atlas scripture_book_ids/scripture_item_ids only.
    return out;
  }
  function godLabelForItem(item){
    if(!item) return '';
    var parts = [];
    if(item.english_title) parts.push(item.english_title);
    if(item.chinese_title) parts.push(item.chinese_title);
    return parts.join(' / ') || item.item_id || 'Item';
  }
  function godLabelForBook(book){
    var b = bookById(book && book.book_id ? book.book_id : book) || book;
    var parts = bookTitleParts(b || book || {});
    return (parts.en || parts.fallback || (b && b.book_id) || 'Book') + (parts.zh ? ' / ' + parts.zh : '');
  }
  function godLinkCardHtml(kind, id, label, sub, auto){
    var attr = kind === 'book' ? 'data-god-open-book' : (kind === 'rc' ? 'data-god-open-rc' : (kind === 'god' ? 'data-god-open-god' : 'data-god-open-item'));
    var icon = kind === 'book' ? '📖' : (kind === 'rc' ? 'RC' : (kind === 'god' ? '☯' : '↗'));
    return '<button type="button" class="tydLib__godLinkCard '+(auto?'auto':'')+'" '+attr+'="'+escapeHtml(id || '')+'">' +
      '<span class="tydLib__godLinkIcon">'+escapeHtml(icon)+'</span>' +
      '<span class="tydLib__godLinkText"><b>'+escapeHtml(label || id || 'Open')+'</b>' +
      (sub ? '<small>'+escapeHtml(sub)+'</small>' : '') +
      (auto ? '<em>auto matched</em>' : '') +
      '</span></button>';
  }
  function godMissingIdHtml(id, section){
    return '<span class="tydLib__godMissingLink"><b>'+escapeHtml(id || 'missing')+'</b><small>'+escapeHtml(section || 'link')+' ID not found in loaded library</small></span>';
  }
  function godLinkedCardsHtml(entry, section, itemIds, bookIds){
    var html = '', used = {}, found = 0;
    var itemList = godSplitList(itemIds);
    var bookList = godSplitList(bookIds);
    itemList.forEach(function(id){
      if(!id || used['item:'+id]) return; used['item:'+id] = true;
      var item = itemById(id);
      if(item && godIsValidLinkedSectionItem(section, item)){
        found++; html += godLinkCardHtml('item', item.item_id, godLabelForItem(item), [item.type, item.first_source_book].filter(Boolean).join(' · '), false);
      }else if(section !== 'Scriptures'){
        html += godMissingIdHtml(id, section);
      }
    });
    bookList.forEach(function(id){
      if(!id || used['book:'+id]) return; used['book:'+id] = true;
      var book = bookById(id);
      if(book && godIsValidLinkedSectionBook(section, book)){
        found++; html += godLinkCardHtml('book', book.book_id, godLabelForBook(book), 'Book', false);
      }else if(section !== 'Scriptures'){
        html += godMissingIdHtml(id, section + ' book');
      }
    });
    if(section !== 'Scriptures' && !found && !itemList.length && !bookList.length){
      godFindAutoItems(entry, section).forEach(function(item){
        if(!item || used['item:'+item.item_id]) return; used['item:'+item.item_id] = true; found++;
        html += godLinkCardHtml('item', item.item_id, godLabelForItem(item), [item.type, item.first_source_book].filter(Boolean).join(' · '), true);
      });
      godFindAutoBooks(entry, section).forEach(function(book){
        if(!book || used['book:'+book.book_id]) return; used['book:'+book.book_id] = true; found++;
        html += godLinkCardHtml('book', book.book_id, godLabelForBook(book), 'Book', true);
      });
    }
    return html ? '<div class="tydLib__godLinkGrid">'+html+'</div>' : '';
  }
  function godRelatedLinksHtml(entry, ids){
    var html = '', used = {};
    godSplitList(entry && entry.related_god_ids).forEach(function(id){
      if(!id || used['god:'+id]) return; used['god:'+id]=true;
      var g = godEntryById(id);
      if(g) html += godLinkCardHtml('god', g.god_id, g.name_en || g.god_id, g.name_zh || '', false);
      else html += godMissingIdHtml(id, 'related god');
    });
    godSplitList(entry && entry.related_rc_ids).forEach(function(id){
      if(!id || used['rc:'+id]) return; used['rc:'+id]=true;
      var r = rcEntryById(id);
      if(r) html += godLinkCardHtml('rc', r.rc_id, r.title_en || r.rc_id, [r.type,r.category].filter(Boolean).join(' · '), false);
      else html += godMissingIdHtml(id, 'related RC entry');
    });
    if(!html){
      godSplitList(ids).forEach(function(id){
        if(godEntryById(id)) html += godLinkCardHtml('god', id, godEntryById(id).name_en || id, godEntryById(id).name_zh || '', false);
        else if(rcEntryById(id)) html += godLinkCardHtml('rc', id, rcEntryById(id).title_en || id, [rcEntryById(id).type,rcEntryById(id).category].filter(Boolean).join(' · '), false);
      });
    }
    return html ? '<div class="tydLib__godLinkGrid">'+html+'</div>' : '';
  }
  function godImageUrls(entry){
    var urls = [];
    if(entry && entry.primary_image_url) urls.push(String(entry.primary_image_url).trim());
    godSplitList(entry && entry.gallery_image_urls).forEach(function(u){ if(u && urls.indexOf(u) === -1) urls.push(u); });
    godSplitList(entry && entry.download_file_urls).forEach(function(u){ if(u && urls.indexOf(u) === -1) urls.push(u); });
    return urls.filter(Boolean);
  }
  function godInitials(entry){
    var title = String((entry && entry.name_en) || (entry && entry.name_zh) || 'God');
    var words = title.split(/\s+/).filter(Boolean);
    if(words.length >= 2) return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    return title.slice(0,2).toUpperCase();
  }
  function godMainImageHtml(entry){
    var title = (entry && entry.name_en) || 'God';
    var url = String((entry && entry.primary_image_url) || '').trim();
    if(!url){
      return '';
    }
    return '<figure class="tydLib__godHeroArt"><img src="'+escapeHtml(url)+'" alt="'+escapeHtml(title)+'"><figcaption><a href="'+escapeHtml(url)+'" target="_blank" rel="noopener">Open image</a><button type="button" class="tydLib__miniIconBtn" data-copy-god-url="'+escapeHtml(url)+'" title="Copy image CDN link">⧉</button></figcaption></figure>';
  }
  function godArtSectionHtml(entry){
    if(!godSectionAllowed('Art')) return '';
    var urls = godImageUrls(entry);
    var body = '';
    if(urls.length){
      body += '<div class="tydLib__godAssetGrid">' + urls.map(function(url, idx){
        var isImg = /\.(png|jpe?g|webp|gif)(\?|#|$)/i.test(String(url || ''));
        return '<div class="tydLib__godAssetCard">' +
          '<a href="'+escapeHtml(url)+'" target="_blank" rel="noopener" class="tydLib__godAssetThumb">' + (isImg ? '<img src="'+escapeHtml(url)+'" alt="'+escapeHtml((entry && entry.name_en) || 'God art')+'">' : '<span>File</span>') + '</a>' +
          '<div class="tydLib__small">'+(idx===0?'Primary image':'Gallery / download')+'</div>' +
          '<div class="tydLib__godAssetActions"><a href="'+escapeHtml(url)+'" target="_blank" rel="noopener">Open</a><button type="button" data-copy-god-url="'+escapeHtml(url)+'">Copy CDN</button></div>' +
        '</div>';
      }).join('') + '</div>';
    }else{
      return '';
    }
    return '<section class="tydLib__godStudyBlock tydLib__godStudyBlock--art" data-god-section="Art"><h3>Art</h3>'+body+'</section>';
  }
  function godLinkedSectionHtml(section, title, ids, fallback, entry, bookIds){
    if(!godSectionAllowed(section) || !godSectionHasContent(entry, section)) return '';
    var cards = godLinkedCardsHtml(entry, section, ids, bookIds);
    if(!cards) return '';
    return '<section class="tydLib__godStudyBlock tydLib__godStudyBlock--linked" data-god-section="'+escapeHtml(section)+'"><h3>'+escapeHtml(title)+'</h3>'+cards+'</section>';
  }
  function godAnnivNorm(v){
    return String(v || '').trim().toLowerCase().replace(/[^a-z0-9]+/g,'_').replace(/^_+|_+$/g,'');
  }
  function godAnnivCacheRead(){
    try{
      if(window.SLB && window.SLB.storage && typeof window.SLB.storage.getJSON === 'function'){
        var pj = window.SLB.storage.getJSON('slb.anniv.items.v1', null);
        if(pj && pj.v) pj = pj.v;
        if(pj && Array.isArray(pj.items)) return pj.items;
        if(Array.isArray(pj)) return pj;
      }
    }catch(e0){}
    try{
      var raw = localStorage.getItem('slb.anniv.items.v1');
      if(!raw) return [];
      var p = JSON.parse(raw);
      if(p && p.v) p = p.v;
      if(p && Array.isArray(p.items)) return p.items;
      if(Array.isArray(p)) return p;
    }catch(e){}
    return [];
  }
  function godAnnivCacheWrite(items){
    try{ localStorage.setItem('slb.anniv.items.v1', JSON.stringify({ts:Date.now(), items:items || []})); }catch(e){}
  }
  function normalizeGodAnnivItems(items){
    return (items || []).filter(function(it){
      if(!it) return false;
      var active = String(it.activeFlag == null ? (it.isActive == null ? '1' : it.isActive) : it.activeFlag).trim().toLowerCase();
      if(active === '0' || active === 'false' || active === 'no' || active === 'inactive' || active === 'n') return false;
      // Do not over-filter by type. Older/newer SLB anniversary rows may use GOD, Deity,
      // blank type, or a custom label. If the row has a god key/name or lunar date fields,
      // it is useful for matching here.
      return !!(it.godKey || it.annivId || it.id || it.key || it.displayName || it.name || it.nameEn || it.nameZh || it.cn || it.en || it.lunarMonth || it.annivLunarMonth);
    });
  }
  function godAnnivCandidateKeys(entry){
    var out = [];
    function push(v){
      v = godAnnivNorm(v);
      if(!v) return;
      if(out.indexOf(v) === -1) out.push(v);
      var noGod = v.replace(/^god_+/, '');
      if(noGod && noGod !== v && out.indexOf(noGod) === -1) out.push(noGod);
    }
    if(!entry) return out;
    push(entry.anniv_god_key);
    push(entry.god_id);
    push(String(entry.god_id || '').replace(/^god_/,''));
    push(entry.name_en); push(entry.name_zh); push(entry.saamlawnese_name);
    godSplitList(entry.aliases).forEach(push);
    return out;
  }
  function godAnnivForEntry(entry){
    var keys = godAnnivCandidateKeys(entry);
    if(!keys.length) return null;
    var items = normalizeGodAnnivItems(state.godAnnivItems || []);
    for(var i=0;i<items.length;i++){
      var it = items[i] || {};
      var cand = [it.godKey, it.annivId, it.id, it.key, it.displayName, it.name, it.nameEn, it.nameZh, it.cn, it.en, it.title, it.label].map(godAnnivNorm);
      for(var j=0;j<cand.length;j++){
        if(!cand[j]) continue;
        var c0 = cand[j];
        var c1 = c0.replace(/^god_+/, '');
        if(keys.indexOf(c0) !== -1 || keys.indexOf(c1) !== -1) return it;
      }
    }
    return null;
  }
  function godAnnivDateText(it){
    if(!it) return '';
    var lm = String(it.lunarMonth || it.annivLunarMonth || it.month || '').trim();
    var ld = String(it.lunarDay || it.annivLunarDay || it.day || '').trim();
    var leap = String(it.isLeapMonth || it.annivIsLeapMonth || it.leap || '').trim();
    var parts = [];
    if(lm || ld) parts.push('Lunar '+(lm || '?')+'/'+(ld || '?')+(leap === '1' || leap.toLowerCase() === 'true' ? ' leap month' : ''));
    var solar = String(it.nextSolarYmd || it.nextSolarDate || it.solarYmd || it.solarDate || it.nextDate || '').trim();
    if(solar) parts.push('Next solar: '+solar);
    return parts.join(' · ');
  }
  function godAnniversarySectionHtml(entry){
    if(!godSectionAllowed('Anniversary')) return '';
    var key = entry && entry.anniv_god_key ? String(entry.anniv_god_key).trim() : '';
    var it = godAnnivForEntry(entry);
    var body = '';
    if(it){
      var title = it.displayName || it.name || entry.name_en || key;
      var date = godAnnivDateText(it);
      body += '<div class="tydLib__godAnnivCard"><b>'+escapeHtml(title || 'Anniversary')+'</b>';
      body += date ? '<span>'+escapeHtml(date)+'</span>' : '<span>Anniversary record found in SLB GOD_ANNIVERSARY.</span>';
      if(it.notes) body += '<small>'+escapeHtml(it.notes)+'</small>';
      if(it.url) body += '<a href="'+escapeHtml(it.url)+'" target="_blank" rel="noopener">Open anniversary page</a>';
      body += '<em>Live source: SLB GOD_ANNIVERSARY'+(key ? ' · '+escapeHtml(key) : '')+'</em></div>';
    }else{
      return '';
    }
    return '<section class="tydLib__godStudyBlock tydLib__godStudyBlock--anniv" data-god-section="Anniversary"><h3>Anniversary</h3>'+body+'</section>';
  }
  function godTryReadAnnivCache(){
    var cached = normalizeGodAnnivItems(godAnnivCacheRead());
    if(cached.length){ state.godAnnivItems = cached; state.godAnnivLoaded = true; }
  }
  function godRequestAnnivList(){
    if(state.godAnnivLoading) return;
    var rpc = null;
    try{ if(window.SLB && typeof window.SLB.rpc === 'function') rpc = window.SLB.rpc; }catch(e){}
    try{ if(!rpc && window.SLB_APP && window.SLB_APP.rpc && typeof window.SLB_APP.rpc === 'function') rpc = window.SLB_APP.rpc; }catch(e2){}
    if(!rpc && typeof slbApi === 'function'){
      rpc = function(action, args){ return slbApi(action, args || {}, (state.auth && state.auth.token) || ''); };
    }
    if(!rpc){ godTryReadAnnivCache(); return; }
    state.godAnnivLoading = true;
    Promise.resolve(rpc('annivList', {})).then(function(res){
      var items = normalizeGodAnnivItems((res && res.items) || (res && res.rows) || []);
      if(items.length){
        state.godAnnivItems = items;
        state.godAnnivLoaded = true;
        godAnnivCacheWrite(items);
      }else{
        godTryReadAnnivCache();
      }
      if(isGodDirectory() && isGodSelection(state.selectedId)) renderReader();
    }).catch(function(){
      godTryReadAnnivCache();
      if(isGodDirectory() && isGodSelection(state.selectedId)) renderReader();
    }).finally(function(){ state.godAnnivLoading = false; });
  }

  function godSectionHtml(section, title, body){
    if(!godSectionAllowed(section)) return '';
    body = godMeaningfulText(body);
    if(!body) return '';
    return '<section class="tydLib__godStudyBlock" data-god-section="'+escapeHtml(section)+'"><h3>'+escapeHtml(title)+'</h3>'+godParagraphsHtml(body)+'</section>';
  }
  function godInfoCardsHtml(entry){
    var cards = [];
    function add(label, value){ value = String(value || '').trim(); if(value) cards.push('<div class="tydLib__godInfoCard"><b>'+escapeHtml(label)+'</b><span>'+escapeHtml(value)+'</span></div>'); }
    add('Power', entry.god_power || '');
    add('Disciple Usage', entry.disciple_usage || '');
    add('Court Area', entry.court_area || '');
    add('Palace / Department', entry.palace_hall_department || '');
    return cards.length ? '<div class="tydLib__godInfoGrid">'+cards.join('')+'</div>' : '';
  }
  function godReaderButtonsHtml(){
    return '<div class="tydLib__readerBtns tydLib__godReaderBtns tydLib__readerBtns--collapsed">' +
      readerActionsMenuHtml('tydLib__godReaderActionMenu',
        '<button class="tydLib__btn secondary tydLib__chantModeBtn" type="button" id="tydChantMode" aria-label="Open focused God reader" title="Focused view">👁</button>' +
        readerSizeButtonHtml() +
        '<button class="tydLib__btn secondary tydLib__copyBtn" type="button" id="tydCopyCurrent" aria-label="Copy God page" title="Copy God page">⧉</button>' +
        '<button class="tydLib__btn secondary tydLib__printBtn" type="button" id="tydPrintCurrent" aria-label="Print or save PDF" title="Print / Save PDF">🖨</button>' +
        '<button class="tydLib__btn secondary tydLib__kpdfBtn" type="button" id="tydKpdfCurrent" aria-label="Make Kindle PDF" title="K-PDF Kindle preview">K-PDF</button>' +
        '<button class="tydLib__btn secondary tydLib__deepLinkBtn" type="button" id="tydCopyDeepLink" aria-label="Copy deep link" title="Copy exact page link">Link</button>'
      ) +
      '</div>';
  }
  function godCopyTextLines(entry){
    var out = [];
    if(!entry) return out;
    out.push(entry.name_en || entry.god_id || 'God');
    if(entry.name_zh) out.push(entry.name_zh);
    if(entry.saamlawnese_name) out.push('Saamlawnese: ' + entry.saamlawnese_name);
    if(entry.type) out.push('Type: ' + entry.type);
    function add(label, value){ value = String(value || '').trim(); if(value){ out.push(''); out.push(label); out.push(value); } }
    add('Summary', godMeaningfulText(entry.short_summary));
    add('Details / Info', godMeaningfulText(entry.details_info));
    add('God Power', godMeaningfulText(entry.god_power));
    add('Disciple Usage', godMeaningfulText(entry.disciple_usage));
    add('Prayer IDs', entry.prayer_item_ids);
    add('FU Head IDs', entry.fu_head_item_ids);
    add('God Spell IDs', entry.god_spell_item_ids);
    add('Scripture Book IDs', entry.scripture_book_ids);
    add('Scripture Item IDs', entry.scripture_item_ids);
    add('Art CDN', godImageUrls(entry).join('\n'));
    add('Anniversary Key', entry.anniv_god_key);
    return out;
  }
  function godFocusRows(entry){
    var rows = [];
    function add(label, value){ value = String(value || '').trim(); if(value) rows.push({ chinese:'', saamlawnese:'', english_translation:label+'\n'+value, status:'approved' }); }
    if(godMeaningfulText(entry && entry.short_summary)) add('Summary', entry && entry.short_summary);
    if(godMeaningfulText(entry && entry.details_info)) add('Details / Info', entry && entry.details_info);
    if(godMeaningfulText(entry && entry.god_power)) add('God Power', entry && entry.god_power);
    if(godMeaningfulText(entry && entry.disciple_usage)) add('Disciple Usage', entry && entry.disciple_usage);
    if(godSectionHasContent(entry, 'Prayer')) add('Prayer', entry && entry.prayer_item_ids);
    if(godSectionHasContent(entry, 'FU Head')) add('FU Head', entry && entry.fu_head_item_ids);
    if(godSectionHasContent(entry, 'God Spell')) add('God Spell', entry && entry.god_spell_item_ids);
    if(godSectionHasContent(entry, 'Scriptures')) add('Scriptures', [entry && entry.scripture_book_ids, entry && entry.scripture_item_ids].filter(Boolean).join(' / '));
    if(godSectionHasContent(entry, 'Art')) add('Art CDN', godImageUrls(entry).join(' / '));
    if(godSectionHasContent(entry, 'Anniversary')) add('Anniversary', entry && entry.anniv_god_key);
    return rows;
  }
  function pushGodFocusPages(pages, entry){
    if(!entry) return;
    var rows = godFocusRows(entry);
    if(!rows.length) return;
    var size = 2;
    for(var i=0;i<rows.length;i+=size){
      pages.push({
        bookLabel:'Gods',
        sectionMain:entry.name_en || entry.god_id || 'God',
        sectionSub:entry.name_zh || '',
        lines:rows.slice(i, i + size),
        mode:'english',
        part:Math.floor(i / size) + 1,
        parts:Math.ceil(rows.length / size)
      });
    }
  }
  function godSingleSectionHtml(entry, section){
    if(section === 'Details / Info') return godSectionHtml('Details / Info', 'Details / Info', entry.details_info || entry.short_summary || '');
    if(section === 'Prayer') return godLinkedSectionHtml('Prayer', 'Prayer', entry.prayer_item_ids, godFallbackText('Prayer'), entry, '');
    if(section === 'FU Head') return godLinkedSectionHtml('FU Head', 'FU Head', entry.fu_head_item_ids, godFallbackText('FU Head'), entry, '');
    if(section === 'God Spell') return godLinkedSectionHtml('God Spell', 'God Spell', entry.god_spell_item_ids, godFallbackText('God Spell'), entry, '');
    if(section === 'Scriptures') return godLinkedSectionHtml('Scriptures', 'Scriptures', entry.scripture_item_ids, godFallbackText('Scriptures'), entry, entry.scripture_book_ids);
    if(section === 'Art') return godArtSectionHtml(entry);
    if(section === 'Anniversary') return godAnniversarySectionHtml(entry);
    if(section === 'Related' || section === 'Source Notes') return '';
    return '';
  }
  function godAllSectionsHtml(entry){
    return godSectionHtml('Details / Info', 'Details / Info', entry.details_info || entry.short_summary || '') +
      godLinkedSectionHtml('Prayer', 'Prayer', entry.prayer_item_ids, godFallbackText('Prayer'), entry, '') +
      godLinkedSectionHtml('FU Head', 'FU Head', entry.fu_head_item_ids, godFallbackText('FU Head'), entry, '') +
      godLinkedSectionHtml('God Spell', 'God Spell', entry.god_spell_item_ids, godFallbackText('God Spell'), entry, '') +
      godLinkedSectionHtml('Scriptures', 'Scriptures', entry.scripture_item_ids, godFallbackText('Scriptures'), entry, entry.scripture_book_ids) +
      godArtSectionHtml(entry) +
      godAnniversarySectionHtml(entry);
  }

  function godHeroHtml(entry){
    var art = godMainImageHtml(entry);
    var summary = godMeaningfulText(entry && entry.short_summary) ? '<div class="tydLib__godSummary">'+escapeHtml(entry.short_summary)+'</div>' : '';
    var info = godInfoCardsHtml(entry);
    if(!art && !summary && !info) return '';
    return '<div class="tydLib__godHero">' + art + '<div class="tydLib__godHeroText">' + summary + info + '</div></div>';
  }
  function renderGodReader(entry){
    ++state._readerRenderToken;
    root.classList.remove('tydLib--readerRendering');
    if(!entry){
      els.reader.innerHTML = '<div class="tydLib__empty"><h2>Select a god</h2><p>Choose a god from the Gods directory.</p></div>';
      setReaderMeta('');
      return;
    }
    var title = entry.name_en || entry.god_id || 'God';
    var zh = entry.name_zh || '';
    var saam = entry.saamlawnese_name || '';
    var selectedSection = state.godSection || state.category || '';
    if(selectedSection && !godSectionHasContent(entry, selectedSection)){
      selectedSection = '';
      state.godSection = '';
    }
    var html = '';
    if(selectedSection){
      html = '<article class="tydLib__godPage tydLib__godPage--sectionOnly">' +
        '<div class="tydLib__readerTop tydLib__godReaderTop tydLib__godReaderTop--compact"><div class="tydLib__godTitleBlock">' +
          (zh ? '<div class="tydLib__titleZh">'+escapeHtml(zh)+'</div>' : '') +
          '<div class="tydLib__titleEn '+(!zh?'tydLib__titleSolo':'')+'">'+escapeHtml(title)+'</div>' +
          '<div class="tydLib__godSubline">'+escapeHtml(selectedSection)+'</div>' +
        '</div>'+godReaderButtonsHtml()+'</div>' +
        '<div class="tydLib__godSectionGrid tydLib__godSectionGrid--single">' +
          godSingleSectionHtml(entry, selectedSection) +
        '</div>' +
      '</article>';
      els.reader.innerHTML = html;
      setReaderMeta(readerMetaHtml([entry.type || 'Gods', selectedSection, saam ? 'Saamlawnese name set' : '']));
      return;
    }
    html = '<article class="tydLib__godPage">' +
      '<div class="tydLib__readerTop tydLib__godReaderTop"><div class="tydLib__godTitleBlock">' +
        (zh ? '<div class="tydLib__titleZh">'+escapeHtml(zh)+'</div>' : '') +
        '<div class="tydLib__titleEn '+(!zh?'tydLib__titleSolo':'')+'">'+escapeHtml(title)+'</div>' +
        (saam ? '<div class="tydLib__godSubline">Saamlawnese: '+escapeHtml(saam)+'</div>' : '') +
        (entry.aliases ? '<div class="tydLib__godSubline">Aliases: '+escapeHtml(entry.aliases)+'</div>' : '') +
      '</div>'+godReaderButtonsHtml()+'</div>' +
      godHeroHtml(entry) +
      '<div class="tydLib__godSectionGrid">' + godAllSectionsHtml(entry) + '</div>' +
    '</article>';
    els.reader.innerHTML = html;
    setReaderMeta(readerMetaHtml([entry.type || 'Gods', 'Visible sections', saam ? 'Saamlawnese name set' : '', godImageUrls(entry).length ? 'art linked' : '']));
  }

  function populateFilters(){
    normalizeDirectoryView();
    var types = [], typeSeen = {}, cats = [], catSeen = {};
    if(isQuickShelfDirectory()){
      state.type = ''; state.category = '';
      els.type.innerHTML = '<option value="">Quick Shelf</option>';
      els.category.innerHTML = '<option value="">Saved full copies</option>';
      return;
    }
    if(isVideoDirectory()){
      var videoTypes=[], videoTypeSeen={};
      state.collections.forEach(function(r){
        if(r.kind!=='video') return;
        if(r.access_scope==='bcm' && !state.bcmAccess) return;
        if(!state.isAdmin && r.access_scope==='full' && state.acgAccess!=='full') return;
        var t=String(r.title||'').trim();
        if(t && !videoTypeSeen[t]){videoTypeSeen[t]=1;videoTypes.push(t);}
      });
      videoTypes.sort(function(a,b){return a.localeCompare(b);});
      if(state.type && videoTypes.indexOf(state.type)===-1) state.type='';
      els.type.innerHTML='<option value="">All teaching types</option>'+videoTypes.map(function(t){return '<option value="'+escapeHtml(t)+'" '+(state.type===t?'selected':'')+'>'+escapeHtml(t)+'</option>';}).join('');

      // Categories belong to the selected teaching Type. Never mix ACM years,
      // BCM topics, KAD/archive labels, and unrelated teaching series together.
      if(!state.type){
        state.category='';
        els.category.disabled=true;
        els.category.innerHTML='<option value="">Choose a type first</option>';
        return;
      }
      els.category.disabled=false;
      var selectedVideoType=String(state.type||'').trim(), selectedVideoTypeUpper=selectedVideoType.toUpperCase();
      var videoCats=[], videoCatSeen={};
      if(selectedVideoTypeUpper==='BCM'){
        // Keep both BCM topic choices visible even while one has no lessons yet.
        videoCats=['CHI KUNG','KAD']; videoCatSeen={'CHI KUNG':1,'KAD':1};
      }
      state.collections.forEach(function(r){
        if(r.kind!=='video' || String(r.title||'').trim()!==selectedVideoType) return;
        if(r.access_scope==='bcm' && !state.bcmAccess) return;
        if(!state.isAdmin && r.access_scope==='full' && state.acgAccess!=='full') return;
        var c=collectionVideoCategory_(r).trim();
        if(c && !videoCatSeen[c]){videoCatSeen[c]=1;videoCats.push(c);}
      });
      if(selectedVideoTypeUpper==='ACM') videoCats.sort(function(a,b){return b.localeCompare(a);});
      else if(selectedVideoTypeUpper!=='BCM') videoCats.sort(function(a,b){
        var ay=/^\d{4}$/.test(a), by=/^\d{4}$/.test(b);
        if(ay&&by) return b.localeCompare(a);
        if(ay!==by) return ay?-1:1;
        return a.localeCompare(b);
      });
      if(state.category && videoCats.indexOf(state.category)===-1) state.category='';
      els.category.innerHTML='<option value="">All '+escapeHtml(selectedVideoType)+' categories</option>'+videoCats.map(function(c){return '<option value="'+escapeHtml(c)+'" '+(state.category===c?'selected':'')+'>'+escapeHtml(c)+'</option>';}).join('');
      return;
    }
    if(isFunWatchDirectory()){
      state.type='';
      var funCats=['KJ','Movies','Resources','Others'], funSeen={KJ:1,Movies:1,Resources:1,Others:1};
      state.collections.forEach(function(r){ if(r.kind==='fun' && r.category && !funSeen[r.category]){funSeen[r.category]=1;funCats.push(r.category);} });
      if(state.category && funCats.indexOf(state.category)===-1) state.category='';
      els.type.innerHTML='<option value="">Fun Watch</option>';
      els.category.innerHTML='<option value="">All Fun Watch categories</option>'+funCats.map(function(c){return '<option value="'+escapeHtml(c)+'" '+(state.category===c?'selected':'')+'>'+escapeHtml(c)+'</option>';}).join('');
      return;
    }
    if(isArticleDirectory()){
      var articleTypes=['Core Concepts','Mindsets','Applications'], articleCats=['All'], articleCatSeen={All:1};
      state.collections.forEach(function(r){ if(r.kind==='article' && r.category && !articleCatSeen[r.category]){articleCatSeen[r.category]=1;articleCats.push(r.category);} });
      if(state.type && articleTypes.indexOf(state.type)===-1) state.type='';
      if(state.category && articleCats.indexOf(state.category)===-1) state.category='';
      els.type.innerHTML='<option value="">All article types</option>'+articleTypes.map(function(t){return '<option value="'+escapeHtml(t)+'" '+(state.type===t?'selected':'')+'>'+escapeHtml(t)+'</option>';}).join('');
      els.category.innerHTML='<option value="">All categories</option>'+articleCats.map(function(c){return '<option value="'+escapeHtml(c)+'" '+(state.category===c?'selected':'')+'>'+escapeHtml(c)+'</option>';}).join('');
      return;
    }
    if(isSupplyDirectory()){
      state.type='';
      var supplyCats=[], supplySeen={}; state.collections.forEach(function(r){ if(r.kind==='supply' && r.category && !supplySeen[r.category]){supplySeen[r.category]=1;supplyCats.push(r.category);} });
      supplyCats.sort(function(a,b){return a.localeCompare(b);}); if(state.category && supplyCats.indexOf(state.category)===-1) state.category='';
      els.type.innerHTML='<option value="">Supplies</option>';
      els.category.innerHTML='<option value="">All supply categories</option>'+supplyCats.map(function(c){return '<option value="'+escapeHtml(c)+'" '+(state.category===c?'selected':'')+'>'+escapeHtml(c)+'</option>';}).join('');
      return;
    }
    if(isGodDirectory()){
      var godTypes = godAvailableTypes();
      if(state.type && godTypes.indexOf(state.type) === -1) state.type = '';
      var godCats = godAvailableSections();
      if(state.category && godCats.indexOf(state.category) === -1) state.category = '';
      els.type.innerHTML = '<option value="">All god groups</option>' + godTypes.map(function(t){return '<option value="'+escapeHtml(t)+'" '+(state.type===t?'selected':'')+'>'+escapeHtml(t)+'</option>';}).join('');
      els.category.innerHTML = '<option value="">All sections</option>' + godCats.map(function(t){return '<option value="'+escapeHtml(t)+'" '+(state.category===t?'selected':'')+'>'+escapeHtml(t)+'</option>';}).join('');
      return;
    }
    if(isRcDirectory()){
      // V84: do not show empty static RC categories such as Purpose/Gods unless real entries exist.
      // This avoids blank directory panels. When new RC entries are added, their categories appear automatically.
      types = rcAvailableTypes();
      if(state.type && types.indexOf(state.type) === -1) state.type = '';
      cats = rcAvailableCategories(state.type || '');
      if(state.category && cats.indexOf(state.category) === -1) state.category = '';
      els.type.innerHTML = '<option value="">All RC areas</option>' + types.map(function(t){return '<option value="'+escapeHtml(t)+'" '+(state.type===t?'selected':'')+'>'+escapeHtml(t)+'</option>';}).join('');
      els.category.innerHTML = '<option value="">All categories</option>' + cats.map(function(t){return '<option value="'+escapeHtml(t)+'" '+(state.category===t?'selected':'')+'>'+escapeHtml(t)+'</option>';}).join('');
      return;
    }
    if(state.directoryView === 'book'){
      var bookIds = allBookIdsForDirectory();
      bookIds.forEach(function(bookId){
        var t = bookLibraryTypeForDirectory(bookId);
        addUnique(types, typeSeen, t);
        if(state.type && t !== state.type) return;
        var catForBook = bookCategoryForDirectory(bookId);
        if(isScriptureRiteLabel(state.type)) catForBook = normalizeScriptureRiteCategory(catForBook);
        addUnique(cats, catSeen, catForBook);
      });
    } else {
      state.items.forEach(function(i){
        var t = itemLibraryTypeForDirectory(i);
        addUnique(types, typeSeen, t);
        if(state.type && t !== state.type) return;
        itemBrowseCategoriesForDirectory(i).forEach(function(cat){ addUnique(cats, catSeen, cat); });
      });
    }
    types = types.filter(Boolean).sort(function(a,b){ return prettyCategory(a).localeCompare(prettyCategory(b)); });
    cats = cats.filter(Boolean);
    if(state.directoryView === 'book' && isScriptureRiteLabel(state.type)){
      var normSeen = {}, normCats = [];
      cats.forEach(function(c){ c = normalizeScriptureRiteCategory(c); if(c && !normSeen[c]){ normSeen[c] = true; normCats.push(c); } });
      cats = normCats.sort(function(a,b){ return scriptureRiteCategoryRank(a) - scriptureRiteCategoryRank(b); });
    }else{
      cats = cats.sort(function(a,b){ return prettyCategory(a).localeCompare(prettyCategory(b)); });
    }
    els.type.innerHTML = '<option value="">All types</option>' + types.map(function(t){return '<option value="'+escapeHtml(t)+'" '+(state.type===t?'selected':'')+'>'+escapeHtml(t)+'</option>';}).join('');
    els.category.innerHTML = '<option value="">All categories</option>' + cats.map(function(t){return '<option value="'+escapeHtml(t)+'" '+(state.category===t?'selected':'')+'>'+escapeHtml(t)+'</option>';}).join('');
  }

  function prettyCategory(cat){
    return String(cat || 'uncategorized').replace(/[_-]+/g, ' ');
  }
  function groupKey(cat){ return String(cat || 'uncategorized'); }
  function bookGroupKey(bookId){ return 'book:' + String(bookId || ''); }

  var QUICK_SHELF_MAX = 10;
  var QUICK_SHELF_DB = 'tydLineageQuickShelfV1';
  var QUICK_SHELF_STORE = 'state';
  var QUICK_SHELF_KEY = 'entries';
  var QUICK_SHELF_LS = 'tydLineageQuickShelfFallbackV1';
  function quickShelfNow(){ try{ return new Date().toISOString(); }catch(e){ return ''; } }
  function quickShelfEntryId(kind, id){ return String(kind || '') + ':' + String(id || ''); }
  function quickShelfSelectionId(entryId){ return 'qs:' + String(entryId || ''); }
  function quickShelfItemSelectionId(entryId, itemId){ return 'qsi:' + encodeURIComponent(String(entryId || '')) + '|' + encodeURIComponent(String(itemId || '')); }
  function quickShelfItemSelectionParts(id){
    id = String(id || '');
    if(id.indexOf('qsi:') !== 0) return null;
    var raw = id.slice(4);
    var cut = raw.indexOf('|');
    if(cut < 0) return null;
    try{ return { entryId:decodeURIComponent(raw.slice(0, cut)), itemId:decodeURIComponent(raw.slice(cut + 1)) }; }catch(e){ return { entryId:raw.slice(0, cut), itemId:raw.slice(cut + 1) }; }
  }
  function quickShelfItemIdFromSelection(id){ var p = quickShelfItemSelectionParts(id); return p && p.itemId ? p.itemId : ''; }
  function quickShelfEntryIdFromSelection(id){
    id = String(id || '');
    if(id.indexOf('qs:') === 0) return id.slice(3);
    var p = quickShelfItemSelectionParts(id);
    return p && p.entryId ? p.entryId : '';
  }
  function isQuickShelfSelection(id){ return !!quickShelfEntryBySelection(id); }
  function quickShelfCopyObj(obj){ try{ return JSON.parse(JSON.stringify(obj || {})); }catch(e){ return {}; } }
  function quickShelfEntries(){ return (state.quickShelf || []).filter(function(e){ return e && e.entry_id; }).filter(quickShelfAllowed); }
  function quickShelfAllowed(entry){
    if(acgFullAccess_()) return true;
    var txt = [entry && entry.entry_id, entry && entry.id, entry && entry.title_en, entry && entry.title_zh, entry && entry.kind, entry && entry.book && entry.book.book_title_english, entry && entry.book && entry.book.book_title_chinese, entry && entry.book && entry.book.file_name].map(function(x){ return String(x || ''); }).join(' ');
    return acgDailyTextAllowed_(txt);
  }
  function quickShelfEntryById(entryId){
    entryId = String(entryId || '');
    var list = quickShelfEntries();
    for(var i=0;i<list.length;i++){ if(String(list[i].entry_id || '') === entryId) return list[i]; }
    return null;
  }
  function quickShelfEntryBySelection(id){ return quickShelfEntryById(quickShelfEntryIdFromSelection(id)); }
  function quickShelfIsSaved(kind, id){ return !!quickShelfEntryById(quickShelfEntryId(kind, id)); }
  function quickShelfSort(entries){
    return (entries || []).filter(function(e){ return e && e.entry_id; }).sort(function(a,b){ return String(b.saved_at || '').localeCompare(String(a.saved_at || '')); }).slice(0, QUICK_SHELF_MAX);
  }
  function mergeQuickShelfEntries(a, b){
    var map = {};
    (a || []).concat(b || []).forEach(function(entry){
      if(!entry || !entry.entry_id) return;
      var id = String(entry.entry_id);
      var prev = map[id];
      if(!prev || String(entry.saved_at || '') >= String(prev.saved_at || '')) map[id] = entry;
    });
    return quickShelfSort(Object.keys(map).map(function(id){ return map[id]; }));
  }
  function openQuickShelfDb(){
    return new Promise(function(resolve, reject){
      if(!window.indexedDB){ reject(new Error('IndexedDB unavailable')); return; }
      var settled = false;
      var timer = setTimeout(function(){
        if(settled) return;
        settled = true;
        reject(new Error('Quick Shelf cache open timed out'));
      }, TYD_IDB_OPEN_TIMEOUT_MS);
      var req;
      try{ req = indexedDB.open(QUICK_SHELF_DB, 1); }
      catch(err){ clearTimeout(timer); settled = true; reject(err); return; }
      req.onupgradeneeded = function(){
        var db = req.result;
        if(!db.objectStoreNames.contains(QUICK_SHELF_STORE)) db.createObjectStore(QUICK_SHELF_STORE, { keyPath:'id' });
      };
      req.onsuccess = function(){
        if(settled){ try{ req.result.close(); }catch(e){} return; }
        settled = true;
        clearTimeout(timer);
        resolve(req.result);
      };
      req.onerror = function(){
        if(settled) return;
        settled = true;
        clearTimeout(timer);
        reject(req.error || new Error('Quick Shelf open failed'));
      };
      req.onblocked = function(){
        if(settled) return;
        settled = true;
        clearTimeout(timer);
        reject(new Error('Quick Shelf cache is blocked by another tab'));
      };
    });
  }
  function readQuickShelfFallback(){
    try{ var raw = localStorage.getItem(QUICK_SHELF_LS); var obj = raw ? JSON.parse(raw) : null; return quickShelfSort((obj && obj.entries) || []); }catch(e){ return []; }
  }
  function writeQuickShelfFallback(entries){
    try{ localStorage.setItem(QUICK_SHELF_LS, JSON.stringify({ saved_at:quickShelfNow(), entries:quickShelfSort(entries || []) })); }catch(e){}
  }
  function readQuickShelf(){
    var fallbackEntries = readQuickShelfFallback();
    return openQuickShelfDb().then(function(db){
      return new Promise(function(resolve){
        var settled = false;
        var timer = setTimeout(function(){ finish(fallbackEntries); }, TYD_IDB_READ_TIMEOUT_MS);
        function finish(entries){
          if(settled) return;
          settled = true;
          clearTimeout(timer);
          try{ db.close(); }catch(e){}
          resolve(mergeQuickShelfEntries(fallbackEntries, entries || []));
        }
        try{
          var tx = db.transaction(QUICK_SHELF_STORE, 'readonly');
          var store = tx.objectStore(QUICK_SHELF_STORE);
          var req = store.get(QUICK_SHELF_KEY);
          req.onsuccess = function(){ finish((req.result && req.result.entries) || []); };
          req.onerror = function(){ finish(fallbackEntries); };
          tx.onabort = function(){ finish(fallbackEntries); };
          tx.onerror = function(){ finish(fallbackEntries); };
        }catch(e){ finish(fallbackEntries); }
      });
    }).catch(function(){ return fallbackEntries; });
  }
  function saveQuickShelf(entries){
    entries = quickShelfSort(entries || []);
    writeQuickShelfFallback(entries);
    return openQuickShelfDb().then(function(db){
      return new Promise(function(resolve){
        var settled = false;
        var timer = setTimeout(function(){ finish(false); }, TYD_IDB_WRITE_TIMEOUT_MS);
        function finish(ok){
          if(settled) return;
          settled = true;
          clearTimeout(timer);
          try{ db.close(); }catch(e){}
          resolve(!!ok);
        }
        try{
          var tx = db.transaction(QUICK_SHELF_STORE, 'readwrite');
          var store = tx.objectStore(QUICK_SHELF_STORE);
          store.put({ id:QUICK_SHELF_KEY, saved_at:quickShelfNow(), entries:entries });
          tx.oncomplete = function(){ finish(true); };
          tx.onerror = function(){ finish(false); };
          tx.onabort = function(){ finish(false); };
        }catch(e){ finish(false); }
      });
    }).catch(function(){ return false; });
  }
  function loadQuickShelfToState(renderAfter){
    return readQuickShelf().then(function(entries){
      state.quickShelf = quickShelfSort(entries || []);
      state.quickShelfLoaded = true;
      if(renderAfter && isQuickShelfDirectory() && els.list){ populateFilters(); renderList(); if(isQuickShelfSelection(state.selectedId)) renderReader(); }
      return state.quickShelf;
    });
  }
  function quickShelfHasEntries(){ return quickShelfEntries().length > 0; }
  function quickShelfBootFromLocalStorage(){
    if(state.quickShelfLoaded && quickShelfHasEntries()) return true;
    // Read the tiny localStorage mirror first for instant paint.
    // The full IndexedDB Quick Shelf load still runs right after this.
    var entries = readQuickShelfFallback();
    if(!entries || !entries.length) return false;
    state.quickShelf = quickShelfSort(entries);
    state.quickShelfLoaded = true;
    return true;
  }
  function quickShelfShouldOwnFirstPaint(){
    if(state.auditMode) return false;
    if(location.hash) return false;
    var v = qs.get('view');
    if(v && normalizeDirectoryViewValue(v) !== 'quick') return false;
    return quickShelfHasEntries();
  }
  function renderQuickShelfFirstPaint(){
    if(!quickShelfShouldOwnFirstPaint() || !els.list || !els.reader) return false;
    state.directoryView = 'quick';
    state.type = '';
    state.category = '';
    state.godSection = '';
    state.openGroups = state.openGroups || {};
    state.openGroups['qs:books'] = true;
    state.openGroups['qs:items'] = true;
    try{ if(els.directoryView) els.directoryView.value = 'quick'; }catch(e0){}
    populateFilters();
    renderList();
    if(!state.selectedId || !isQuickShelfSelection(state.selectedId)){
      renderQuickShelfReader(null);
    }else{
      renderReader();
    }
    clearLibraryLoading();
    state.quickShelfFirstPaint = true;
    root.classList.add('tydLib--quickShelfFirstPaint');
    setStatus('Quick Shelf ready — the main directory opens without downloading all text.', 'ok');
    return true;
  }
  function quickShelfBookTitleParts(entry){
    entry = entry || {};
    return { zh:entry.title_zh || '', en:entry.title_en || '', fallback:entry.title_en || entry.id || 'Quick Shelf Book' };
  }
  function quickShelfItemTitleParts(entry){
    entry = entry || {};
    var item = entry.item || {};
    return { zh:entry.title_zh || item.chinese_title || '', en:entry.title_en || item.english_title || '', fallback:entry.title_en || item.item_id || entry.id || 'Quick Shelf Item' };
  }
  function quickShelfTotalLines(linesByItem){
    var n = 0; linesByItem = linesByItem || {};
    Object.keys(linesByItem).forEach(function(k){ n += (linesByItem[k] || []).length; });
    return n;
  }
  function makeQuickShelfBookSnapshot(bookId){
    var book = bookById(bookId);
    if(!book) return null;
    var items = indexedItemsForBook(bookId, state.items || []);
    if(!items.length) return null;
    var parts = bookTitleParts(book);
    var linesByItem = {};
    items.forEach(function(item){ linesByItem[item.item_id] = lineRows(item.item_id).map(quickShelfCopyObj); });
    return { entry_id:quickShelfEntryId('book', bookId), kind:'book', id:String(bookId || ''), title_zh:parts.zh || '', title_en:parts.en || parts.fallback || String(bookId || ''), book:quickShelfCopyObj(book), items:items.map(quickShelfCopyObj), lines_by_item:linesByItem, item_count:items.length, line_count:quickShelfTotalLines(linesByItem), saved_at:quickShelfNow(), source_updated_at:book.updated_at || book.updated_date || '' };
  }
  function makeQuickShelfItemSnapshot(itemId){
    var item = itemById(itemId);
    if(!item) return null;
    var lines = {}; lines[item.item_id] = lineRows(item.item_id).map(quickShelfCopyObj);
    return { entry_id:quickShelfEntryId('item', item.item_id), kind:'item', id:String(item.item_id || ''), title_zh:item.chinese_title || '', title_en:item.english_title || item.item_id || '', item:quickShelfCopyObj(item), lines_by_item:lines, item_count:1, line_count:(lines[item.item_id] || []).length, saved_at:quickShelfNow(), source_updated_at:item.updated_at || item.updated_date || '' };
  }
  function quickShelfEnsureLines(itemIds){
    itemIds = Array.from(new Set((itemIds || []).filter(Boolean).map(String)));
    if(!itemIds.length || itemIdsLinesAreReady(itemIds)) return Promise.resolve(true);
    setStatus('Opening text once before saving Quick Shelf copy...', 'loading');
    return readLineCacheForItems(itemIds).then(function(res){
      installLazyLines(res.map || {});
      if(itemIdsLinesAreReady(itemIds)) return true;
      return fallbackOpenFullCacheForLines().then(function(ok){ return !!ok && itemIdsLinesAreReady(itemIds); }).catch(function(){ return false; });
    }).catch(function(){ return false; });
  }
  function quickShelfUpsert(entry){
    if(!entry || !entry.entry_id) return Promise.resolve(false);
    var list = (state.quickShelf || []).filter(function(e){ return e && e.entry_id !== entry.entry_id; });
    list.unshift(entry);
    if(list.length > QUICK_SHELF_MAX){
      var removed = list.slice(QUICK_SHELF_MAX).map(function(e){ return e.title_en || e.id || 'old item'; }).join(', ');
      list = list.slice(0, QUICK_SHELF_MAX);
      if(removed) setStatus('Quick Shelf limit is '+QUICK_SHELF_MAX+'. Removed oldest: '+removed, 'bad');
    }
    state.quickShelf = quickShelfSort(list);
    state._directoryRenderCache = {};
    return saveQuickShelf(state.quickShelf).then(function(){
      renderList(); updateDirectoryActiveDom();
      return true;
    });
  }
  function addBookToQuickShelf(bookId){
    var book = bookById(bookId);
    if(!book){ setStatus('Book not found for Quick Shelf.', 'bad'); return; }
    var items = indexedItemsForBook(bookId, state.items || []);
    var ids = items.map(function(i){ return i && i.item_id; }).filter(Boolean);
    quickShelfEnsureLines(ids).then(function(ok){
      if(!ok){ setStatus('Could not open full book text. Refresh/Supercharge once, then try the heart again.', 'bad'); return; }
      var entry = makeQuickShelfBookSnapshot(bookId);
      if(!entry){ setStatus('Could not build Quick Shelf copy.', 'bad'); return; }
      quickShelfUpsert(entry).then(function(){ setStatus('Added full book copy to Quick Shelf: '+(entry.title_en || bookId), 'ok'); if(state.selectedId === bookGroupKey(bookId)) renderReader(); });
    });
  }
  function addItemToQuickShelf(itemId){
    var item = itemById(itemId);
    if(!item){ setStatus('Item not found for Quick Shelf.', 'bad'); return; }
    quickShelfEnsureLines([item.item_id]).then(function(ok){
      if(!ok){ setStatus('Could not open item text. Refresh/Supercharge once, then try the heart again.', 'bad'); return; }
      var entry = makeQuickShelfItemSnapshot(item.item_id);
      if(!entry){ setStatus('Could not build Quick Shelf copy.', 'bad'); return; }
      quickShelfUpsert(entry).then(function(){ setStatus('Added full item copy to Quick Shelf: '+(entry.title_en || item.item_id), 'ok'); if(state.selectedId === item.item_id) renderReader(); });
    });
  }
  function refreshQuickShelfEntry(entryId){
    var entry = quickShelfEntryById(entryId);
    if(!entry){ setStatus('Quick Shelf entry not found.', 'bad'); return; }
    if(entry.kind === 'book') addBookToQuickShelf(entry.id);
    else if(entry.kind === 'item') addItemToQuickShelf(entry.id);
  }
  function removeQuickShelfEntry(entryId){
    entryId = String(entryId || '').trim();
    if(!entryId){ setStatus('Quick Shelf remove target missing.', 'bad'); return; }
    var beforeList = (state.quickShelf || []).filter(function(e){ return e && e.entry_id; });
    var before = beforeList.length;
    var next = beforeList.filter(function(e){ return String(e.entry_id || '') !== entryId; });
    if(before === next.length){ setStatus('Quick Shelf entry was already removed.', 'ok'); return; }
    state.quickShelf = quickShelfSort(next);
    state._directoryRenderCache = {};
    saveQuickShelf(state.quickShelf).then(function(){
      if(quickShelfEntryIdFromSelection(state.selectedId) === entryId) state.selectedId = null;
      if(isQuickShelfDirectory()){ renderList(); renderReader(); }
      else { renderList(); updateDirectoryActiveDom(); }
      setStatus('Removed one Quick Shelf entry.', 'ok');
    });
  }
  function removeQuickShelfSection(entryId, itemId){
    entryId = String(entryId || '').trim();
    itemId = String(itemId || '').trim();
    if(!entryId || !itemId){ setStatus('Quick Shelf section remove target missing.', 'bad'); return; }
    var list = (state.quickShelf || []).filter(function(e){ return e && e.entry_id; });
    var changed = false;
    list = list.map(function(entry){
      if(String(entry.entry_id || '') !== entryId) return entry;
      if(entry.kind !== 'book'){ changed = true; return null; }
      var copy = quickShelfCopyObj(entry);
      var oldItems = copy.items || [];
      var items = oldItems.filter(function(item){ return String(item && item.item_id || '') !== itemId; });
      if(items.length === oldItems.length){ return entry; }
      changed = true;
      copy.items = items;
      if(copy.lines_by_item && Object.prototype.hasOwnProperty.call(copy.lines_by_item, itemId)){ delete copy.lines_by_item[itemId]; }
      copy.item_count = items.length;
      copy.line_count = quickShelfTotalLines(copy.lines_by_item || {});
      copy.saved_at = quickShelfNow();
      return copy.item_count > 0 ? copy : null;
    }).filter(Boolean);
    if(!changed){ setStatus('Quick Shelf section was already removed.', 'ok'); return; }
    state.quickShelf = quickShelfSort(list);
    state._directoryRenderCache = {};
    saveQuickShelf(state.quickShelf).then(function(){
      var p = quickShelfItemSelectionParts(state.selectedId);
      if(p && p.entryId === entryId && p.itemId === itemId) state.selectedId = quickShelfEntryById(entryId) ? quickShelfSelectionId(entryId) : null;
      if(isQuickShelfDirectory()){ renderList(); renderReader(); }
      else { renderList(); updateDirectoryActiveDom(); }
      setStatus('Removed one saved section from Quick Shelf.', 'ok');
    });
  }
  function quickShelfCurrentTarget(){
    if(isBookSelection(state.selectedId)) return { kind:'book', id:selectedBookId() };
    if(state.selectedId && itemById(state.selectedId)) return { kind:'item', id:state.selectedId };
    if(isQuickShelfSelection(state.selectedId)){ var e = quickShelfEntryBySelection(state.selectedId); if(e) return { kind:e.kind, id:e.id, entry:e }; }
    return null;
  }
  function quickShelfCurrentIcon(){
    var t = quickShelfCurrentTarget();
    if(!t) return '♡';
    return quickShelfIsSaved(t.kind, t.id) ? '♥' : '♡';
  }
  function quickShelfCurrentTitle(){
    var t = quickShelfCurrentTarget();
    if(!t) return 'Add to Quick Shelf';
    return quickShelfIsSaved(t.kind, t.id) ? 'Refresh Quick Shelf full copy' : 'Add full copy to Quick Shelf';
  }
  function bookIdForItem(itemId){
    itemId = String(itemId || '');
    if(!itemId) return '';
    var best = '';
    try{
      var rows = (state.index || []).filter(function(x){ return String(x && x.item_id || '') === itemId && String(x.book_id || '').trim(); });
      if(rows.length){
        rows.sort(function(a,b){ return Number(a.order_no||0)-Number(b.order_no||0); });
        best = String(rows[0].book_id || '');
      }
    }catch(e){}
    if(!best){
      try{
        var item = itemById(itemId);
        var label = firstUnmatchedSourceLabel(item || {});
        if(label){
          var ids = allBookIdsForDirectory();
          for(var i=0;i<ids.length;i++){ if(itemSourceMatchesBook(item, ids[i])){ best = ids[i]; break; } }
        }
      }catch(e2){}
    }
    return best;
  }
  function quickShelfBookTargetForCurrent(){
    if(isBookSelection(state.selectedId)) return selectedBookId();
    if(state.selectedId && itemById(state.selectedId)) return bookIdForItem(state.selectedId);
    return '';
  }
  function quickShelfBookCurrentButtonHtml(){
    var bookId = quickShelfBookTargetForCurrent();
    if(!bookId) return '';
    var saved = quickShelfIsSaved('book', bookId);
    return '<button class="tydLib__btn secondary tydLib__quickShelfBookCurrentBtn '+(saved?'active':'')+'" type="button" id="tydQuickShelfBookCurrent" aria-label="Save whole book to Quick Shelf" title="Save whole book with all items to Quick Shelf">Book '+(saved?'♥':'♡')+'</button>';
  }
  function toggleCurrentQuickShelf(){
    var t = quickShelfCurrentTarget();
    if(!t){ setStatus('Open a book or item first, then heart it into Quick Shelf.', 'bad'); return; }
    if(t.kind === 'book') addBookToQuickShelf(t.id);
    else if(t.kind === 'item') addItemToQuickShelf(t.id);
  }
  function quickShelfSearchText(entry){
    entry = entry || {};
    return [entry.entry_id, entry.kind, entry.id, entry.title_en, entry.title_zh, entry.saved_at, entry.source_updated_at].join(' ').toLowerCase();
  }
  function quickShelfFilteredEntries(kind){
    var q = norm(state.query);
    return quickShelfEntries().filter(function(e){
      if(kind && e.kind !== kind) return false;
      if(q && quickShelfSearchText(e).indexOf(q) === -1) return false;
      return true;
    });
  }
  function quickShelfSelectionIsActive(selectionId){ return String(state.selectedId || '') === String(selectionId || ''); }
  function quickShelfBookGroupKey(entry){ return 'qsbook:' + String(entry && entry.entry_id || ''); }
  function quickShelfEntryRow(entry){
    var selectionId = quickShelfSelectionId(entry.entry_id);
    var active = quickShelfSelectionIsActive(selectionId);
    var meta = [entry.kind === 'book' ? ((entry.item_count || 0)+' items') : 'item', (entry.line_count || 0)+' lines', entry.saved_at ? ('saved '+String(entry.saved_at).slice(0,10)) : 'saved'].join(' • ');
    return '<div class="tydLib__itemRow tydLib__quickShelfRow">' +
      '<button type="button" class="tydLib__item tydLib__quickShelfItem '+(active?'active':'')+'" data-quick-open-selection="'+escapeHtml(selectionId)+'" data-quick-open="'+escapeHtml(entry.entry_id)+'">' +
        '<div class="tydLib__itemEn">'+escapeHtml(entry.title_en || entry.id || 'Quick Shelf')+'</div>' +
        '<div class="tydLib__itemZh">'+escapeHtml(entry.title_zh || '')+'</div>' +
        '<div class="tydLib__quickShelfMeta">'+escapeHtml(meta)+'</div>' +
      '</button>' +
      '<button type="button" class="tydLib__quickShelfMini" data-quick-refresh="'+escapeHtml(entry.entry_id)+'" title="Refresh full copy from current DB">↻</button>' +
      '<button type="button" class="tydLib__quickShelfMini danger" data-quick-remove="'+escapeHtml(entry.entry_id)+'" title="Remove from Quick Shelf">×</button>' +
    '</div>';
  }
  function quickShelfBookReadRow(entry){
    var selectionId = quickShelfSelectionId(entry.entry_id);
    var active = quickShelfSelectionIsActive(selectionId);
    var meta = [(entry.item_count || 0)+' items', (entry.line_count || 0)+' lines', entry.saved_at ? ('saved '+String(entry.saved_at).slice(0,10)) : 'saved'].join(' • ');
    return '<div class="tydLib__bookReadRow tydLib__quickShelfBookReadRow">' +
      '<button type="button" class="tydLib__bookRead tydLib__quickShelfBookRead '+(active?'active':'')+'" data-quick-open-selection="'+escapeHtml(selectionId)+'">Read whole saved book<div class="tydLib__quickShelfMeta">'+escapeHtml(meta)+'</div></button>' +
      '<button type="button" class="tydLib__quickShelfMini" data-quick-refresh="'+escapeHtml(entry.entry_id)+'" title="Refresh full book copy from current DB">↻</button>' +
    '</div>';
  }
  function quickShelfSubItemRow(entry, item){
    item = item || {};
    var itemId = String(item.item_id || '');
    var selectionId = quickShelfItemSelectionId(entry.entry_id, itemId);
    var active = quickShelfSelectionIsActive(selectionId);
    var rows = (entry.lines_by_item && entry.lines_by_item[itemId]) || [];
    return '<div class="tydLib__itemRow tydLib__quickShelfSubRow">' +
      '<button type="button" class="tydLib__item tydLib__quickShelfSubItem '+(active?'active':'')+'" data-quick-open-selection="'+escapeHtml(selectionId)+'">' +
        '<div class="tydLib__itemEn">'+escapeHtml(item.english_title || item.item_id || 'Saved section')+'</div>' +
        '<div class="tydLib__itemZh">'+escapeHtml(item.chinese_title || '')+'</div>' +
        '<div class="tydLib__quickShelfMeta">'+escapeHtml(rows.length+' lines · saved inside this book')+'</div>' +
      '</button>' +
      '<button type="button" class="tydLib__quickShelfMini danger" data-quick-remove-section-entry="'+escapeHtml(entry.entry_id)+'" data-quick-remove-section-item="'+escapeHtml(itemId)+'" title="Remove this saved section from Quick Shelf">×</button>' +
    '</div>';
  }
  function renderQuickShelfBookBody(entry){
    entry = entry || {};
    var html = quickShelfBookReadRow(entry);
    (entry.items || []).forEach(function(item){ html += quickShelfSubItemRow(entry, item); });
    return html;
  }
  function quickShelfBookGroupRow(entry){
    var key = quickShelfBookGroupKey(entry);
    var isOpen = !!state.openGroups[key] || quickShelfEntryIdFromSelection(state.selectedId) === entry.entry_id;
    var activeWhole = quickShelfSelectionIsActive(quickShelfSelectionId(entry.entry_id));
    rememberDirectoryGroup(key, { type:'quickShelfBook', entry_id:entry.entry_id, entry:entry });
    var title = entry.title_en || entry.id || 'Saved book';
    var zh = entry.title_zh || '';
    var html = '<section class="tydLib__group tydLib__quickShelfBookGroup '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
    html += '<div class="tydLib__quickShelfBookHeadRow">';
    html += '<button type="button" class="tydLib__groupBtn tydLib__quickShelfBookBtn '+(activeWhole?'active':'')+'" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName book"><b>'+escapeHtml(title)+'</b>'+(zh ? '<small>'+escapeHtml(zh)+'</small>' : '')+'</span></span><span class="tydLib__groupCount">'+(entry.item_count || (entry.items || []).length || 0)+'</span></button>';
    html += '<button type="button" class="tydLib__quickShelfMini" data-quick-refresh="'+escapeHtml(entry.entry_id)+'" title="Refresh full book copy from current DB">↻</button>';
    html += '<button type="button" class="tydLib__quickShelfMini danger" data-quick-remove="'+escapeHtml(entry.entry_id)+'" title="Remove this saved book from Quick Shelf">×</button>';
    html += '</div>';
    html += '<div class="tydLib__groupBody" style="display:'+(isOpen?'block':'none')+'">';
    if(isOpen) html += renderQuickShelfBookBody(entry);
    html += '</div></section>';
    return html;
  }
  function quickShelfRenderEntryForDirectory(entry){ return entry && entry.kind === 'book' ? quickShelfBookGroupRow(entry) : quickShelfEntryRow(entry); }
  function renderQuickShelfDirectory(searchActive){
    var books = quickShelfFilteredEntries('book');
    var items = quickShelfFilteredEntries('item');
    var visibleCount = books.length + items.length;
    state._lastDirectoryCount = visibleCount;
    if(!state.quickShelfLoaded){ return '<div class="tydLib__empty"><p>Opening Quick Shelf...</p></div>'; }
    if(!visibleCount){ return '<div class="tydLib__empty"><h2>Quick Shelf is empty</h2><p>Open a book or item and tap the heart button. It saves a full local copy so it can open fast next time.</p><p class="tydLib__small">Limit: '+QUICK_SHELF_MAX+' saved copies on this device.</p></div>'; }
    function groupHtml(key, title, entries){
      if(!entries.length) return '';
      var isOpen = searchActive || !!state.openGroups[key];
      var html = '<section class="tydLib__group tydLib__quickShelfGroup '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
      html += '<button type="button" class="tydLib__groupBtn" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName book">'+escapeHtml(title)+'</span></span><span class="tydLib__groupCount">'+entries.length+'</span></button>';
      html += '<div class="tydLib__groupBody" style="display:'+(isOpen?'block':'none')+'">';
      if(isOpen) html += entries.map(quickShelfRenderEntryForDirectory).join('');
      html += '</div></section>';
      state._directoryGroupData = state._directoryGroupData || {};
      state._directoryGroupData[key] = { type:'quickShelf', entries:entries.slice() };
      return html;
    }
    return groupHtml('qs:books', 'Quick Shelf Books', books) + groupHtml('qs:items', 'Quick Shelf Items', items);
  }
  function renderQuickShelfGroupBody(key){
    var data = state._directoryGroupData && state._directoryGroupData[key];
    if(!data || data.type !== 'quickShelf') return '';
    return (data.entries || []).map(quickShelfRenderEntryForDirectory).join('');
  }
  function quickShelfSectionHtml(item, rows){
    var section = '<section class="tydLib__bookSection">';
    section += sectionTitleHtml(item || {});
    var readerNote = readerNoteText(item || {});
    if(readerNote && state.mode === 'dictionary' && !itemHasImage(item || {})) section += '<div class="tydLib__note">'+escapeHtml(readerNote)+'</div>';
    section += itemImageHtml(item || {});
    section += itemImageDetailHtml(item || {});
    if(state.mode === 'dictionary') section += '<div class="tydLib__dictLines">' + (rows || []).map(renderDictionaryLine).join('') + '</div>';
    else section += (rows || []).map(function(l){ return renderBookLine(l, state.mode); }).join('');
    section += '</section>';
    return section;
  }
  function quickShelfReaderButtonsHtml(entry){
    entry = entry || {};
    var p = quickShelfItemSelectionParts(state.selectedId);
    var removeBtn = '';
    if(p && p.entryId === entry.entry_id && p.itemId){
      removeBtn = '<button class="tydLib__btn secondary tydLib__quickShelfRemoveBtn" type="button" data-quick-remove-section-entry="'+escapeHtml(entry.entry_id || '')+'" data-quick-remove-section-item="'+escapeHtml(p.itemId || '')+'" aria-label="Remove this saved section from Quick Shelf" title="Remove this saved section only">×</button>';
    }else{
      removeBtn = '<button class="tydLib__btn secondary tydLib__quickShelfRemoveBtn" type="button" data-quick-remove="'+escapeHtml(entry.entry_id || '')+'" aria-label="Remove from Quick Shelf" title="Remove this saved Quick Shelf entry">×</button>';
    }
    return '<div class="tydLib__readerBtns tydLib__quickShelfReaderBtns tydLib__readerBtns--collapsed">' +
      readerActionsMenuHtml('tydLib__quickShelfReaderActionMenu',
        '<button class="tydLib__btn secondary tydLib__chantModeBtn" type="button" id="tydChantMode" aria-label="Open focused Quick Shelf reader" title="Focused view">👁</button>' +
        readModeButtonHtml() + zhFontButtonHtml() + readerSizeButtonHtml() +
        '<button class="tydLib__btn secondary tydLib__quickShelfHeartBtn active" type="button" id="tydQuickShelfCurrent" aria-label="Refresh Quick Shelf copy" title="Refresh Quick Shelf full copy">♥</button>' +
        '<button class="tydLib__btn secondary tydLib__copyBtn" type="button" id="tydCopyCurrent" aria-label="Copy current Quick Shelf text" title="Copy current text">⧉</button>' +
        '<button class="tydLib__btn secondary tydLib__printBtn" type="button" id="tydPrintCurrent" aria-label="Print or save PDF" title="Print / Save PDF">🖨</button>' +
        '<button class="tydLib__btn secondary tydLib__kpdfBtn" type="button" id="tydKpdfCurrent" aria-label="Make Kindle PDF" title="K-PDF Kindle preview">K-PDF</button>' +
        '<button class="tydLib__btn secondary tydLib__deepLinkBtn" type="button" id="tydCopyDeepLink" aria-label="Copy Quick Shelf deep link" title="Copy exact Quick Shelf link">Link</button>' +
        removeBtn
      ) +
      '</div>';
  }
  function renderQuickShelfReader(entry){
    if(!entry){
      els.reader.innerHTML = '<div class="tydLib__empty"><h2>Quick Shelf</h2><p>Choose a saved full-copy book or item from the Quick Shelf directory.</p></div>';
      setReaderMeta(readerMetaHtml(['local full copies','ready before full DB']));
      return;
    }
    var html = '';
    if(entry.kind === 'book'){
      var parts = quickShelfBookTitleParts(entry);
      var items = entry.items || [];
      var linesByItem = entry.lines_by_item || {};
      var qsItemId = quickShelfItemIdFromSelection(state.selectedId);
      if(qsItemId){
        var qsItem = items.filter(function(it){ return String(it && it.item_id || '') === String(qsItemId); })[0];
        if(qsItem){
          var rowsForItem = linesByItem[qsItem.item_id] || [];
          var ip = { zh:qsItem.chinese_title || '', en:qsItem.english_title || '', fallback:qsItem.item_id || qsItemId };
          html = '<div class="tydLib__readerTop tydLib__quickShelfReaderTop"><div>'+titleBlockHtml(ip.zh || '', ip.en || '', ip.fallback || qsItemId)+'</div>'+quickShelfReaderButtonsHtml(entry)+'</div>' +
            '<div class="tydLib__quickShelfNotice">Quick Shelf book section · saved inside '+escapeHtml(parts.en || parts.fallback || entry.id)+' · opens without waiting for the full library DB.</div>' +
            quickShelfSectionHtml(qsItem, rowsForItem) + '<div class="tydLib__small">Saved: '+escapeHtml(String(entry.saved_at || '').replace('T',' ').slice(0,19))+'</div>';
          els.reader.innerHTML = html;
          setReaderMeta(readerMetaHtml(['Quick Shelf book section', (rowsForItem.length || 0)+' lines', readerModeLabel()]));
          return;
        }
      }
      html = '<div class="tydLib__readerTop tydLib__quickShelfReaderTop"><div>'+titleBlockHtml(parts.zh || '', parts.en || '', parts.fallback || entry.id)+'</div>'+quickShelfReaderButtonsHtml(entry)+'</div>' +
        '<div class="tydLib__quickShelfNotice">Quick Shelf full copy · saved on this device · opens without waiting for the full library DB.</div>' +
        '<div class="tydLib__book tydLib__quickShelfBook">' + items.map(function(item){ return quickShelfSectionHtml(item, linesByItem[item.item_id] || []); }).join('') + '</div>' +
        '<div class="tydLib__small">Saved: '+escapeHtml(String(entry.saved_at || '').replace('T',' ').slice(0,19))+'</div>';
      els.reader.innerHTML = html;
      setReaderMeta(readerMetaHtml(['Quick Shelf book', (entry.item_count || items.length)+' items', (entry.line_count || quickShelfTotalLines(linesByItem))+' lines', readerModeLabel()]));
      return;
    }
    var iparts = quickShelfItemTitleParts(entry);
    var item = entry.item || { item_id:entry.id, english_title:entry.title_en || entry.id, chinese_title:entry.title_zh || '' };
    var rows = (entry.lines_by_item && entry.lines_by_item[item.item_id]) || [];
    html = '<div class="tydLib__readerTop tydLib__quickShelfReaderTop"><div>'+titleBlockHtml(iparts.zh || '', iparts.en || '', iparts.fallback || entry.id)+'</div>'+quickShelfReaderButtonsHtml(entry)+'</div>' +
      '<div class="tydLib__quickShelfNotice">Quick Shelf full copy · saved on this device · opens without waiting for the full library DB.</div>' +
      quickShelfSectionHtml(item, rows) + '<div class="tydLib__small">Saved: '+escapeHtml(String(entry.saved_at || '').replace('T',' ').slice(0,19))+'</div>';
    els.reader.innerHTML = html;
    setReaderMeta(readerMetaHtml(['Quick Shelf item', (rows.length || entry.line_count || 0)+' lines', readerModeLabel()]));
  }
  function quickShelfCopyTextLines(entry, kind){
    if(kind === 'current') kind = (MODE_ORDER.indexOf(state.mode) !== -1 ? state.mode : 'chant');
    var out = [];
    if(!entry) return out;
    if(entry.kind === 'book'){
      var parts = quickShelfBookTitleParts(entry);
      var qsItemId = quickShelfItemIdFromSelection(state.selectedId);
      if(qsItemId){
        var qsItem = (entry.items || []).filter(function(it){ return String(it && it.item_id || '') === String(qsItemId); })[0];
        if(qsItem){
          out.push(copyHeaderText(qsItem.chinese_title || '', qsItem.english_title || '', qsItem.item_id || qsItemId, kind));
          ((entry.lines_by_item && entry.lines_by_item[qsItem.item_id]) || []).forEach(function(l){ out.push(''); pushCopyLine(out, l, kind); });
          return out;
        }
      }
      out.push(copyHeaderText(parts.zh || '', parts.en || '', parts.fallback || entry.id, kind));
      (entry.items || []).forEach(function(item){
        out.push(''); out.push(copyHeaderText(item.chinese_title || '', item.english_title || '', item.item_id || '', kind));
        ((entry.lines_by_item && entry.lines_by_item[item.item_id]) || []).forEach(function(l){ out.push(''); pushCopyLine(out, l, kind); });
      });
      return out;
    }
    var item = entry.item || { item_id:entry.id, english_title:entry.title_en || entry.id, chinese_title:entry.title_zh || '' };
    out.push(copyHeaderText(item.chinese_title || '', item.english_title || '', item.item_id || entry.id, kind));
    ((entry.lines_by_item && entry.lines_by_item[item.item_id]) || []).forEach(function(l){ out.push(''); pushCopyLine(out, l, kind); });
    return out;
  }
  function sourceGroupKey(label){ return 'source:' + sourceNorm(label || 'unknown'); }
  function unassignedGroupKey(){ return 'misc:unassigned'; }
  function titleCaseFromBookSlug(v){
    v = String(v || '').replace(/_book$/i, '').replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
    if(!v) return '';
    return v.replace(/\b([a-z])/g, function(m){ return m.toUpperCase(); });
  }

  function genericTruthScriptureFallback(book){
    // Generic DB-driven fallback for rebuilt scripture/rite books.
    // If a browser has Book_Index / Items rows before the matching Books row is
    // refreshed, derive the public title and taxonomy from the linked main item
    // instead of showing a machine-key book_id or dropping the book into All.
    book = (typeof book === 'object' && book) ? book : { book_id: book };
    var id = String(book.book_id || '').trim();
    var derivedId = id.replace(/_book$/i, '');

    // This fallback runs while raw Books/Items rows are still being hydrated.
    // Never call itemById() here: that helper enforces disciple access, which
    // asks for the item's books, which asks for these book-title fallbacks again.
    // Limited accounts could therefore recurse forever before the directory
    // painted, while admin accounts bypassed the access check and appeared fine.
    function rawItemById(id){
      id = String(id || '');
      return (state._itemsById && state._itemsById[id]) || (state.items || []).find(function(row){ return String(row && row.item_id || '') === id; }) || null;
    }

    function candidateMainItemFromIndex(){
      var rows = (state._indexByBook && state._indexByBook[id]) || (state.index || []).filter(function(x){ return x && x.book_id === id; });
      rows = rows.slice().sort(function(a,b){ return Number(a.order_no||0)-Number(b.order_no||0); });
      for(var i=0;i<rows.length;i++){
        var it = rawItemById(rows[i].item_id);
        if(!it || !it.item_id) continue;
        var rawItem = [it.item_id, it.type, it.chinese_title, it.english_title, it.category, it.first_source_book, it.notes].join(' ');
        var kItem = sourceNorm(rawItem);
        if(it.type === 'scripture' || /scripture|sutra|ging/.test(kItem) || /經|经/.test(rawItem)) return it;
      }
      return null;
    }

    var item = (derivedId ? rawItemById(derivedId) : null) || candidateMainItemFromIndex();
    var raw = [
      id, book.book_title_chinese, book.book_title_english, book.file_name, book.source_book, book.notes,
      item && item.item_id, item && item.type, item && item.chinese_title, item && item.english_title, item && item.category, item && item.first_source_book, item && item.notes
    ].join(' ');
    var k = sourceNorm(raw);
    var isScriptureOrRite = /scripture|sutra|rite|ging|truth scripture/.test(k) || /經|经|功課|功课/.test(raw) || (item && item.type === 'scripture') || /_scripture(?:_book)?$/i.test(id);
    if(!isScriptureOrRite) return null;

    var zh = String(book.book_title_chinese || '').trim();
    if(looksLikeMachineBookTitle(zh, book)) zh = String((item && item.chinese_title) || '').trim() || chineseTitleFromFileName(book.file_name);

    var en = String(book.book_title_english || '').trim();
    if(looksLikeMachineBookTitle(en, book)) en = String((item && item.english_title) || '').trim() || titleCaseFromBookSlug(derivedId || id);

    var libraryType = cleanTaxonomyLabel(book.library_type || (item && item.category) || '') || 'Scriptures/Rite';
    var cat = cleanTaxonomyLabel(book.category_group || book.browse_category || book.book_category || '');
    if(!cat){
      if(/morning|noon|evening|daily|日常|早壇|早坛|午壇|午坛|晚壇|晚坛|功課|功课/.test(k) || /日常|早壇|早坛|午壇|午坛|晚壇|晚坛|功課|功课/.test(raw)) cat = 'Daily';
      else if(/blood lake|hell|ghost king|ground official|salvation|exorcism|地官|血湖|地獄|地狱|鬼王|普渡|滅邪|灭邪/.test(k) || /地官|血湖|地獄|地狱|鬼王|普渡|滅邪|灭邪/.test(raw)) cat = 'Dei';
      else if(/daai|human world|true merit|virtue|human|repenting|quitting evil|harmony|amnesty|heart scripture|five virtues|filial piety|etiquettes|elder lord|tao te|一善|功德|善/.test(k) || /一善|功德|善|懺罪|忏罪|戒邪|和合|赦罪|心經|心经|五德|孝經|孝经|禮經|礼经|老君|道德經|道德经/.test(raw)) cat = 'Daai';
      else cat = libraryType === 'Scriptures/Rite' ? 'Tin' : 'All';
    }

    var dir = cleanTaxonomyLabel(book.directory_group || '');
    if(!dir){
      if(cat === 'Daily') dir = 'Daily Rites';
      else if(cat === 'Dei') dir = 'Dei / Salvation';
      else if(cat === 'Daai') dir = 'Daai / Human World';
      else if(cat === 'Tin') dir = 'Tin Scriptures';
      else dir = cat || 'All';
    }

    return {
      zh: zh,
      en: en || titleCaseFromBookSlug(derivedId || id) || 'Scripture',
      library_type: libraryType,
      category_group: cat,
      directory_group: dir,
      display_order: cleanTaxonomyLabel(book.display_order || '')
    };
  }

  function canonicalBookTitleFallback(book){
    book = (typeof book === 'object' && book) ? book : { book_id: book };
    var keys = [book.book_id, book.book_title_chinese, book.book_title_english, book.file_name, book.source_book, book.notes].map(sourceNorm);
    function hasAny(list){
      return keys.some(function(k){
        if(!k) return false;
        return list.some(function(v){ return k === v || k.indexOf(v) !== -1; });
      });
    }

    // Last-resort public titles for the corrected rite book IDs. These are the
    // same long Chinese titles used in the Books tab / DOCX file names. They are
    // only used when Google's response gives a blank or machine-key title.
    // Hard correction for the Tin Si Divine Fu image book. Some older browser caches
    // or partial Books responses can accidentally expose the first FU item title
    // (Personal Protection FU) as the directory group title. The book itself is
    // 天師神符 / Tin Si Divine Fu.
    if(hasAny(['tin si divine fu','tin_si_divine_fu','天師神符','2025 jg3l fu writing guide'])){
      return { zh:'天師神符', en:'Tin Si Divine Fu', library_type:'FU', category_group:'Tin Si Divine Fu', directory_group:'Tin Si Divine Fu', display_order:'710' };
    }

    if(hasAny(['k morning rite','saam law morning rite','morning rite'])){
      return { zh:'三羅早壇功課', en:'Saam Law Morning Rite', library_type:'Scriptures/Rite', category_group:'Daily', directory_group:'Daily Rites', display_order:'10' };
    }
    if(hasAny(['k noon rite','saam law noon rite','noon rite'])){
      return { zh:'三羅午壇功課', en:'Saam Law Noon Rite', library_type:'Scriptures/Rite', category_group:'Daily', directory_group:'Daily Rites', display_order:'20' };
    }
    if(hasAny(['k evening rite','saam law evening rite','evening rite'])){
      return { zh:'三羅晚壇功課', en:'Saam Law Evening Rite', library_type:'Scriptures/Rite', category_group:'Daily', directory_group:'Daily Rites', display_order:'30' };
    }
    if(hasAny(['k daily rite','saam law daily rite','daily rite'])){
      return { zh:'三羅日常功課', en:'Saam Law Daily Rite', library_type:'Scriptures/Rite', category_group:'Daily', directory_group:'Daily Rites', display_order:'40' };
    }

    // Fallbacks for rebuilt legacy scripture books. These prevent a row-level
    // Supercharge/cache race from showing the raw book_id as the public title or
    // dropping the book into the generic All category if the Books row arrives
    // after Book_Index/Items.
    if(hasAny(['saam law truth scripture','saam_law_truth_scripture','saam_law_truth_scripture_book','三羅真經'])){
      return { zh:'三羅真經', en:'Saam Law Truth Scripture', library_type:'Scriptures/Rite', category_group:'Tin', directory_group:'Tin Scriptures', display_order:'200' };
    }
    if(hasAny(['celestial medic truth scripture','celestial_medic_truth_scripture','celestial_medic_truth_scripture_book','天醫真經'])){
      return { zh:'天醫真經', en:'Celestial Medic Truth Scripture', library_type:'Scriptures/Rite', category_group:'Tin', directory_group:'Tin Scriptures', display_order:'180' };
    }
    if(hasAny(['sword sage truth scripture','sword_sage_truth_scripture','sword_sage_truth_scripture_book','劍聖真經'])){
      return { zh:'劍聖真經', en:'Sword Sage Truth Scripture', library_type:'Scriptures/Rite', category_group:'Tin', directory_group:'Tin Scriptures', display_order:'190' };
    }
    if(hasAny(['nine gods celestial powers scripture','nine god celestial scripture','nine_gods_celestial_powers_scripture','nine_gods_celestial_powers_scripture_book','九真天罡經'])){
      return { zh:'九真天罡經', en:'Nine Gods Celestial Powers Scripture', library_type:'Scriptures/Rite', category_group:'Tin', directory_group:'Tin Scriptures', display_order:'210' };
    }

    if(hasAny(['elder lord tao te scripture','elder_lord_tao_te_scripture','elder_lord_tao_te_scripture_book','太上老君道德經','道德經'])){
      return { zh:'太上老君道德經', en:'Elder Lord Tao Te Scripture', library_type:'Scriptures/Rite', category_group:'Daai', directory_group:'Daai / Human World', display_order:'390' };
    }

    // Generic DB-driven fallback for new legacy Truth Scripture books.
    // If the Books row is temporarily stale/missing from the browser cache,
    // derive the public title/category from the matching main Items row instead
    // of showing a machine key or falling into All. This avoids a new frontend
    // rescue rule every time another legacy 真經 book is imported.
    var genericTruth = genericTruthScriptureFallback(book);
    if(genericTruth) return genericTruth;
    return null;
  }

  function chineseTitleFromFileName(v){
    v = String(v || '').replace(/\.[a-z0-9]{1,8}$/i, '');
    var matches = v.match(/[\u3400-\u9FFF]{2,}/g);
    return matches && matches.length ? matches[matches.length - 1] : '';
  }

  function looksLikeMachineBookTitle(v, book){
    v = String(v || '').trim();
    if(!v) return true;
    var vk = sourceNorm(v);
    var bk = sourceNorm(book && book.book_id);
    if(bk && vk === bk) return true;
    return /^[a-z0-9]+(?:_[a-z0-9]+)+$/i.test(v);
  }

  function bookTitleParts(book){
    book = (typeof book === 'object' && book) ? book : (bookById(book) || { book_id: book });
    var cacheKey = String((book && book.book_id) || '');
    if(cacheKey && state._bookTitlePartsCache && state._bookTitlePartsCache[cacheKey]) return state._bookTitlePartsCache[cacheKey];
    var fallback = canonicalBookTitleFallback(book);
    var zh = String(book.book_title_chinese || book.chinese_title || book.title_chinese || '').trim();
    var en = String(book.book_title_english || book.english_title || book.title_english || '').trim();

    // Prefer the actual Books tab Chinese title. If it is blank, a machine key,
    // or Google gviz failed to expose that column, recover it from the DOCX file
    // name and finally from the known corrected rite title map above.
    if(fallback && fallback.en === 'Tin Si Divine Fu'){
      zh = fallback.zh || zh || '';
      en = fallback.en;
    }else{
      if(looksLikeMachineBookTitle(zh, book)){
        zh = chineseTitleFromFileName(book.file_name) || (fallback && fallback.zh) || '';
      }

      // English can safely fall back from a machine key to a public title.
      if(fallback && fallback.en && looksLikeMachineBookTitle(en, book)){
        en = fallback.en;
      }
    }

    var out = {
      zh: zh,
      en: en,
      fallback: (fallback && fallback.en) || String(book.book_id || 'Book')
    };
    if(cacheKey){ state._bookTitlePartsCache = state._bookTitlePartsCache || {}; state._bookTitlePartsCache[cacheKey] = out; }
    return out;
  }

  function bookTitle(book){
    if(!book) return 'Book';
    var parts = bookTitleParts(book);
    var en = parts.en || parts.fallback || 'Book';
    var zh = parts.zh ? ' ' + parts.zh : '';
    return en + zh;
  }

  function bookTitleHtml(book){
    if(!book) return 'Book';
    var parts = bookTitleParts(book);
    var en = parts.en || parts.fallback || 'Book';
    var html = '<span class="tydLib__bookEn">'+escapeHtml(en)+'</span>';
    if(parts.zh){
      html += '<span class="tydLib__bookZh">'+escapeHtml(parts.zh)+'</span>';
    }
    return html;
  }
  function hydrateBookTitleFields(book){
    if(!book) return book;
    var fallback = canonicalBookTitleFallback(book);
    var parts = bookTitlePartsRaw(book);
    if(parts.zh && (!book.book_title_chinese || looksLikeMachineBookTitle(book.book_title_chinese, book))) book.book_title_chinese = parts.zh;
    if(parts.en && (!book.book_title_english || looksLikeMachineBookTitle(book.book_title_english, book))) book.book_title_english = parts.en;
    if(fallback){
      if(fallback.en === 'Tin Si Divine Fu'){
        book.book_title_chinese = fallback.zh || book.book_title_chinese || '';
        book.book_title_english = fallback.en;
        book.library_type = fallback.library_type || book.library_type || '';
        book.category_group = fallback.category_group || book.category_group || '';
        book.directory_group = fallback.directory_group || book.directory_group || '';
        book.display_order = fallback.display_order || book.display_order || '';
      }else{
        if(!book.library_type) book.library_type = fallback.library_type || '';
        if(!book.category_group) book.category_group = fallback.category_group || '';
        if(!book.directory_group) book.directory_group = fallback.directory_group || '';
        if(!book.display_order) book.display_order = fallback.display_order || '';
      }
    }
    return book;
  }

  function bookTitlePartsRaw(book){
    book = (typeof book === 'object' && book) ? book : { book_id: book };
    var fallback = canonicalBookTitleFallback(book);
    var zh = String(book.book_title_chinese || book.chinese_title || book.title_chinese || '').trim();
    var en = String(book.book_title_english || book.english_title || book.title_english || '').trim();
    if(fallback && fallback.en === 'Tin Si Divine Fu'){
      zh = fallback.zh || zh || '';
      en = fallback.en;
    }else{
      if(looksLikeMachineBookTitle(zh, book)) zh = chineseTitleFromFileName(book.file_name) || (fallback && fallback.zh) || '';
      if(fallback && fallback.en && looksLikeMachineBookTitle(en, book)) en = fallback.en;
    }
    return { zh:zh, en:en, fallback:(fallback && fallback.en) || String(book.book_id || 'Book') };
  }

  function itemById(id){
    var found = (state._itemsById && state._itemsById[String(id || '')]) || state.items.find(function(i){ return i.item_id === id; });
    return (found && itemAllowedByAcg_(found)) ? found : null;
  }
  function bookById(id){
    var found = (state._booksById && state._booksById[String(id || '')]) || state.books.find(function(b){ return b.book_id === id; });
    if(found){
      if(!bookAllowedByAcg_(found)) return null;
      return hydrateBookTitleFields(found);
    }
    var fallback = canonicalBookTitleFallback({ book_id:id });
    var fbObj = fallback ? {
      book_id:id,
      book_title_chinese:fallback.zh || '',
      book_title_english:fallback.en || '',
      library_type:fallback.library_type || '',
      category_group:fallback.category_group || '',
      directory_group:fallback.directory_group || '',
      display_order:fallback.display_order || ''
    } : null;
    return (fbObj && bookAllowedByAcg_(fbObj)) ? fbObj : null;
  }
  function isBookSelection(id){ return String(id || '').indexOf('book:') === 0; }
  function selectedBookId(){ return isBookSelection(state.selectedId) ? String(state.selectedId).slice(5) : ''; }

  function addUnique(arr, seen, v){
    v = String(v || '').trim();
    if(!v || seen[v]) return;
    seen[v] = true;
    arr.push(v);
  }

  function allBookIdsForDirectory(){
    if(state._allBookIdsCache) return state._allBookIdsCache.slice();
    var ids = [], seen = {};
    state.books.forEach(function(b){ if(!isLegacyBook(b) && bookAllowedByAcg_(b)) addUnique(ids, seen, b.book_id); });
    state.index.forEach(function(x){ if(!isLegacyBook(x.book_id) && !indexRowIsLegacy(x) && bookAllowedByAcg_(x.book_id)) addUnique(ids, seen, x.book_id); });
    state._allBookIdsCache = ids.slice();
    return ids;
  }

  function bookSortTitle(book){
    var parts = bookTitleParts(book || {});
    return sourceNorm([parts.en || parts.fallback || '', parts.zh || '', book && book.book_id || ''].join(' '));
  }

  function bookUpdatedTime(book){
    if(!book) return 0;
    var raw = String(book.updated_date || book.updated || book.last_modified || book.modified_date || '').trim();
    if(!raw) return 0;
    var t = Date.parse(raw);
    if(!isNaN(t)) return t;
    var m = raw.match(/^(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})$/);
    if(m) return new Date(Number(m[1]), Number(m[2])-1, Number(m[3])).getTime();
    return 0;
  }

  function bookDisplayOrder(book){
    book = book || {};
    var fallback = canonicalBookTitleFallback(book) || null;
    var raw = String(book.display_order || book.order_no || (fallback && fallback.display_order) || '').trim();
    if(!raw) return null;
    var n = Number(raw);
    return isFinite(n) ? n : null;
  }

  function sortedBookIdsForDirectory(){
    var cacheKey = String(state.directorySort || 'sheet');
    if(state._sortedBookIdsCache && state._sortedBookIdsCache[cacheKey]) return state._sortedBookIdsCache[cacheKey].slice();
    var ids = allBookIdsForDirectory();
    var order = {};
    ids.forEach(function(id, idx){ order[id] = idx; });
    var out;
    if(state.directorySort === 'sheet') out = ids.slice().sort(function(a,b){
      var ba = bookById(a) || { book_id:a };
      var bb = bookById(b) || { book_id:b };
      var oa = bookDisplayOrder(ba), ob = bookDisplayOrder(bb);
      if(oa != null && ob != null && oa !== ob) return oa - ob;
      if(oa != null && ob == null) return -1;
      if(oa == null && ob != null) return 1;
      return order[a] - order[b];
    });
    else out = ids.slice().sort(function(a,b){
      var ba = bookById(a) || { book_id:a };
      var bb = bookById(b) || { book_id:b };
      if(state.directorySort === 'updated_new' || state.directorySort === 'updated_old'){
        var da = bookUpdatedTime(ba), db = bookUpdatedTime(bb);
        if(da !== db) return state.directorySort === 'updated_new' ? db - da : da - db;
        return bookSortTitle(ba).localeCompare(bookSortTitle(bb)) || (order[a] - order[b]);
      }
      var cmp = bookSortTitle(ba).localeCompare(bookSortTitle(bb)) || (order[a] - order[b]);
      return state.directorySort === 'title_za' ? -cmp : cmp;
    });
    state._sortedBookIdsCache = state._sortedBookIdsCache || {};
    state._sortedBookIdsCache[cacheKey] = out.slice();
    return out;
  }

  function bookMatchKeys(book){
    book = book || {};
    var cacheKey = String(book.book_id || '');
    if(cacheKey && state._bookMatchKeysCache && state._bookMatchKeysCache[cacheKey]) return state._bookMatchKeysCache[cacheKey].slice();
    var fallback = canonicalBookTitleFallback(book);
    var vals = [book.book_id, book.book_title_chinese, book.book_title_english, book.file_name, book.notes];
    if(fallback){ vals.push(fallback.zh, fallback.en); }
    var out = [], seen = {};
    vals.forEach(function(v){
      var k = sourceNorm(v);
      if(k) addUnique(out, seen, k);
    });
    if(cacheKey){ state._bookMatchKeysCache = state._bookMatchKeysCache || {}; state._bookMatchKeysCache[cacheKey] = out.slice(); }
    return out;
  }

  function sourceLabelsForItem(item){
    item = item || {};
    var labels = [], seen = {};
    function add(v){
      v = String(v || '').trim();
      if(!v || isLooseBucket(v) || isLegacySourceText(v)) return;
      addUnique(labels, seen, v);
    }
    add(item.first_source_book);
    add(item.source_book);
    lineRows(item.item_id).forEach(function(l){ add(l.source_book); });
    return labels;
  }

  function sourceMatchesBook(label, book){
    var lk = sourceNorm(label);
    if(!lk) return false;
    var bid = String((book && book.book_id) || '');
    var cacheKey = bid ? (lk + '\u001f' + bid) : '';
    if(cacheKey && state._sourceMatchesBookCache && state._sourceMatchesBookCache[cacheKey] != null) return !!state._sourceMatchesBookCache[cacheKey];
    var keys = bookMatchKeys(book);
    var matched = false;
    for(var i=0;i<keys.length;i++){ if(keys[i] === lk){ matched = true; break; } }
    if(!matched){
      for(var j=0;j<keys.length;j++){
        var k = keys[j];
        if(k.length >= 6 && lk.length >= 6 && (lk.indexOf(k) !== -1 || k.indexOf(lk) !== -1)){ matched = true; break; }
      }
    }
    if(cacheKey){ state._sourceMatchesBookCache = state._sourceMatchesBookCache || {}; state._sourceMatchesBookCache[cacheKey] = matched; }
    return matched;
  }

  function itemSourceMatchesBook(item, bookId){
    var book = bookById(bookId) || { book_id:bookId };
    return sourceLabelsForItem(item).some(function(label){ return sourceMatchesBook(label, book); });
  }

  function bookIdsForItem(item){
    var ids = [], seen = {};
    if(!item || !item.item_id) return ids;
    var cacheKey = String(item.item_id);
    if(state._bookIdsForItemCache && state._bookIdsForItemCache[cacheKey]) return state._bookIdsForItemCache[cacheKey].slice();
    var idxRows = (state._indexByItem && state._indexByItem[cacheKey]) || state.index.filter(function(x){ return x.item_id === item.item_id; });
    idxRows.forEach(function(x){
      if(x.item_id === item.item_id && !isLegacyBook(x.book_id) && !indexRowIsLegacy(x)) addUnique(ids, seen, x.book_id);
    });
    allBookIdsForDirectory().forEach(function(bookId){
      if(!seen[bookId] && itemSourceMatchesBook(item, bookId)) addUnique(ids, seen, bookId);
    });
    state._bookIdsForItemCache = state._bookIdsForItemCache || {};
    state._bookIdsForItemCache[cacheKey] = ids.slice();
    return ids;
  }

  function firstUnmatchedSourceLabel(item){
    var labels = sourceLabelsForItem(item);
    for(var i=0;i<labels.length;i++){
      var label = labels[i];
      var matched = allBookIdsForDirectory().some(function(bookId){
        var book = bookById(bookId) || { book_id:bookId };
        return sourceMatchesBook(label, book);
      });
      if(!matched) return label;
    }
    return '';
  }

  function bookHasIndexRows(bookId){
    var rows = (state._indexByBook && state._indexByBook[String(bookId || '')]) || state.index.filter(function(x){ return x.book_id === bookId; });
    return rows.some(function(x){
      return x.book_id === bookId && x.item_id && !indexRowIsLegacy(x);
    });
  }

  function mainScriptureItemIdForBook(bookId){
    var book = bookById(bookId) || { book_id: bookId };
    var k = sourceNorm([book && book.book_id, book && book.book_title_chinese, book && book.book_title_english, book && book.file_name, book && book.notes].join(' '));

    // Rebuilt legacy scripture books must be assembled from Book_Index, not by
    // loose source_book matching. If an older cache or partial incremental load
    // appends the main scripture at the end, this map lets us put it back between
    // Scripture Opening Spell and Scripture Closing Spell.
    if(k.indexOf('saam law truth scripture') !== -1 || k.indexOf('saam_law_truth_scripture') !== -1 || k.indexOf('三羅真經') !== -1) return 'saam_law_truth_scripture';
    if(k.indexOf('celestial medic truth scripture') !== -1 || k.indexOf('celestial_medic_truth_scripture') !== -1 || k.indexOf('天醫真經') !== -1) return 'celestial_medic_truth_scripture';
    if(k.indexOf('sword sage truth scripture') !== -1 || k.indexOf('sword_sage_truth_scripture') !== -1 || k.indexOf('劍聖真經') !== -1) return 'sword_sage_truth_scripture';

    if(k.indexOf('nine gods celestial powers scripture') !== -1 || k.indexOf('nine god celestial scripture') !== -1 || k.indexOf('nine_gods_celestial_powers_scripture') !== -1 || k.indexOf('九真天罡經') !== -1) return 'nine_gods_celestial_powers_scripture';

    var derived = String(bookId || '').replace(/_book$/, '');
    if(derived && itemById(derived) && /truth scripture|真經/.test(k)) return derived;
    return '';
  }

  function mandatoryAfterScriptureItemIdsForBook(bookId){
    var book = bookById(bookId) || { book_id: bookId };
    var k = sourceNorm([book && book.book_id, book && book.book_title_chinese, book && book.book_title_english, book && book.file_name, book && book.notes].join(' '));

    // Legacy scripture books may have a required spell after the main scripture.
    // Keep these inside the Book_Index sandwich instead of letting source_book
    // rescue append them at the end of the reader.
    if(k.indexOf('nine gods celestial powers scripture') !== -1 || k.indexOf('nine god celestial scripture') !== -1 || k.indexOf('nine_gods_celestial_powers_scripture') !== -1 || k.indexOf('九真天罡經') !== -1){
      return ['nine_gods_protection_spell'];
    }
    return [];
  }

  function enforceMainScriptureSandwich(bookId, items, allowed){
    items = (items || []).filter(Boolean);
    var mainId = mainScriptureItemIdForBook(bookId);
    if(!mainId) return items;
    if(allowed && !allowed[mainId] && !items.some(function(i){ return i && i.item_id === mainId; })) return items;

    var main = itemById(mainId);
    if(!main || itemIsHiddenLegacy(main)) return items;

    var afterIds = mandatoryAfterScriptureItemIdsForBook(bookId);
    var afterItems = [];
    afterIds.forEach(function(id){
      var it = itemById(id);
      if(it && !itemIsHiddenLegacy(it) && (!allowed || allowed[id] || items.some(function(row){ return row && row.item_id === id; }))){
        afterItems.push(it);
      }
    });

    var removeIds = {};
    removeIds[mainId] = true;
    afterIds.forEach(function(id){ removeIds[id] = true; });

    var hasMain = false;
    var out = [];
    items.forEach(function(item){
      if(!item || !item.item_id) return;
      if(item.item_id === mainId){ hasMain = true; return; }
      if(removeIds[item.item_id]) return;
      out.push(item);
    });
    if(!hasMain && allowed && !allowed[mainId]) return items;

    var closeIdx = out.findIndex(function(i){ return i && i.item_id === 'scripture_closing_spell'; });
    var openIdx = out.findIndex(function(i){ return i && i.item_id === 'scripture_opening_spell'; });
    var insertAt = out.length;
    if(closeIdx >= 0) insertAt = closeIdx;
    else if(openIdx >= 0) insertAt = openIdx + 1;
    var sandwich = [main].concat(afterItems);
    out.splice.apply(out, [insertAt, 0].concat(sandwich));
    return out;
  }

  function bookUsesStrictIndex(bookId){
    var book = bookById(bookId) || { book_id: bookId };
    var k = sourceNorm([book.book_id, book.book_title_english, book.file_name, book.notes].join(' '));

    // Corrected updated rites should show ONLY their Book_Index order.
    // Old source_book labels such as "K Morning Rite" are legacy extraction
    // hints and must not append removed rows like Incense Blessing Spell.
    if(/\bk (morning|noon|evening|daily) rite\b/.test(k)) return true;
    if(k.indexOf('corrected') !== -1 && k.indexOf('rite') !== -1) return true;

    // Rebuilt scripture books must also be strict. The main scripture is a book
    // section, not a loose item to rescue at the end of the directory/reader.
    if(mainScriptureItemIdForBook(bookId)) return true;
    return false;
  }

  function indexedItemsForBook(bookId, sourceItems){
    if(isLegacyBook(bookId)) return [];
    var sourceList = sourceItems || state._validItemsCache || state.items;
    var useFullCache = (!sourceItems || sourceItems === state.items || sourceItems === state._validItemsCache);
    var cacheKey = String(bookId || '');
    if(useFullCache && state._bookItemsFullCache && state._bookItemsFullCache[cacheKey]) return state._bookItemsFullCache[cacheKey].slice();
    var allowed = null;
    if(!useFullCache){
      allowed = {};
      (sourceList || []).forEach(function(i){ if(i && i.item_id) allowed[i.item_id] = true; });
    }
    var seen = {};
    var indexRows = (state._indexByBook && state._indexByBook[String(bookId || '')]) || state.index.filter(function(x){ return x.book_id === bookId; }).sort(function(a,b){ return Number(a.order_no||0)-Number(b.order_no||0); });
    var out = indexRows.filter(function(x){ return x.book_id === bookId && (!allowed || allowed[x.item_id]) && !indexRowIsLegacy(x); })
      .map(function(x){
        var item = itemById(x.item_id);
        if(item && !itemIsHiddenLegacy(item) && !seen[item.item_id]){ seen[item.item_id] = true; return item; }
        return null;
      })
      .filter(Boolean);

    // Rescue only for loose/incomplete books that do not have a strict corrected index.
    // Updated rites and rebuilt scriptures must not append old source-matched rows
    // after the real Book_Index.
    if(!bookUsesStrictIndex(bookId)){
      (sourceList || []).forEach(function(item){
        if(!item || !item.item_id || itemIsHiddenLegacy(item) || (allowed && !allowed[item.item_id]) || seen[item.item_id]) return;
        if(itemSourceMatchesBook(item, bookId)){
          seen[item.item_id] = true;
          out.push(item);
        }
      });
    }

    // Final guard: even with stale/partial cache, the main scripture must sit
    // immediately before Scripture Closing Spell, never at the tail after the
    // closing/ordains/wishes.
    out = enforceMainScriptureSandwich(bookId, out, allowed);

    if(useFullCache){ state._bookItemsFullCache = state._bookItemsFullCache || {}; state._bookItemsFullCache[cacheKey] = out.slice(); }
    return out;
  }

  function markItemsUsed(map, items){
    (items || []).forEach(function(i){ if(i && i.item_id) map[i.item_id] = true; });
  }

  function itemsUsedByBookGroups(items){
    var useFullCache = (!items || items === state.items);
    if(useFullCache && state._itemsUsedByBookGroupsCache) return Object.assign({}, state._itemsUsedByBookGroupsCache);
    var used = {};
    allBookIdsForDirectory().forEach(function(bookId){ markItemsUsed(used, indexedItemsForBook(bookId, items)); });
    if(useFullCache) state._itemsUsedByBookGroupsCache = Object.assign({}, used);
    return used;
  }

  function currentGroupKeys(items){
    if(isQuickShelfDirectory()) return ['qs:books','qs:items'];
    if(isGodDirectory()) return currentGodGroupKeys();
    if(isRcDirectory()) return currentRcGroupKeys();
    if(state.directoryView === 'book'){
      var keys = [];
      if(isScriptureRiteLabel(state.type) && !state.category){
        var seenCatKeys = {};
        sortedBookIdsForDirectory().forEach(function(bookId){
          if(!bookMatchesDirectoryFilters(bookId)) return;
          if(!indexedItemsForBook(bookId, items).length) return;
          var c = normalizeScriptureRiteCategory(bookCategoryForDirectory(bookId));
          if(!c) return;
          var ck = scriptureRiteCategoryGroupKey(c);
          if(!seenCatKeys[ck]){ seenCatKeys[ck] = true; keys.push(ck); }
        });
        return keys.sort(function(a,b){ return scriptureRiteCategoryRank(a.replace(/^bookcat:/,'')) - scriptureRiteCategoryRank(b.replace(/^bookcat:/,'')); });
      }
      sortedBookIdsForDirectory().forEach(function(bookId){
        if(!bookMatchesDirectoryFilters(bookId)) return;
        if(indexedItemsForBook(bookId, items).length) keys.push(bookGroupKey(bookId));
      });
      // When a library type/category is selected, the Book directory is book-first.
      // Do not add loose source/unassigned repair buckets under filtered views such as Spells.
      if(!repairBucketsAllowedInBookView()) return keys;

      var used = itemsUsedByBookGroups(items);
      var sourceKeys = {};
      items.forEach(function(i){
        if(used[i.item_id]) return;
        var label = firstUnmatchedSourceLabel(i);
        if(label) sourceKeys[sourceGroupKey(label)] = true;
      });
      Object.keys(sourceKeys).sort().forEach(function(k){ keys.push(k); });
      if(items.some(function(i){ return !used[i.item_id] && !firstUnmatchedSourceLabel(i); })) keys.push(unassignedGroupKey());
      return keys;
    }
    var catKeys = {};
    items.forEach(function(i){ itemBrowseCategoriesForDirectory(i).forEach(function(cat){ catKeys['cat:' + groupKey(cat)] = true; }); });
    return Object.keys(catKeys);
  }

  function initOpenGroups(){
    currentGroupKeys(state.items).forEach(function(key){ if(state.openGroups[key] == null) state.openGroups[key] = false; });
  }

  function renderItemButton(item){
    if(!displayableDirectoryItem(item)) return '';
    var active = item.item_id === state.selectedId;
    return '<div class="tydLib__itemRow">' +
      '<button type="button" class="tydLib__item '+(active?'active':'')+'" data-id="'+escapeHtml(item.item_id)+'">' +
        '<div class="tydLib__itemEn">'+escapeHtml(item.english_title || item.item_id || '')+'</div>' +
        '<div class="tydLib__itemZh">'+escapeHtml(item.chinese_title || '')+'</div>' +
      '</button>' +
      '<button type="button" class="tydLib__quickShelfBtn '+(quickShelfIsSaved('item', item.item_id)?'active':'')+'" data-quick-shelf-item="'+escapeHtml(item.item_id)+'" aria-label="Add full item copy to Quick Shelf" title="Add full item copy to Quick Shelf">'+(quickShelfIsSaved('item', item.item_id)?'♥':'♡')+'</button>' +
      '<button type="button" class="tydLib__addItemBtn" data-builder-add="'+escapeHtml(item.item_id)+'" aria-label="Add to Book Builder" title="Add to Book Builder">+</button>' +
    '</div>';
  }

  function rememberDirectoryGroup(key, data){
    state._directoryGroupData = state._directoryGroupData || {};
    state._directoryGroupData[key] = data || {};
  }

  function renderBookEntryButton(bookId, labelMode){
    var key = bookGroupKey(bookId);
    var activeBook = state.selectedId === key;
    var book = bookById(bookId) || { book_id:bookId };
    var label = labelMode === 'title' ? bookTitle(book) : 'Read whole book in order';
    return '<div class="tydLib__bookReadRow"><button type="button" class="tydLib__bookRead '+(activeBook?'active':'')+'" data-book-read="'+escapeHtml(bookId || '')+'">'+escapeHtml(label)+'</button>' +
      '<button type="button" class="tydLib__quickShelfBtn '+(quickShelfIsSaved('book', bookId)?'active':'')+'" data-quick-shelf-book="'+escapeHtml(bookId || '')+'" aria-label="Add full book copy to Quick Shelf" title="Add full book copy to Quick Shelf">'+(quickShelfIsSaved('book', bookId)?'♥':'♡')+'</button>' +
      '<button type="button" class="tydLib__addBookBtn" data-builder-add-book="'+escapeHtml(bookId || '')+'" aria-label="Add whole book to Book Builder" title="Add whole book to Book Builder">+</button></div>';
  }
  function renderBookHeaderHeart(bookId){
    var saved = quickShelfIsSaved('book', bookId);
    return '<button type="button" class="tydLib__quickShelfBtn tydLib__bookGroupHeart '+(saved?'active':'')+'" data-quick-shelf-book="'+escapeHtml(bookId || '')+'" aria-label="Save whole book to Quick Shelf" title="Save whole book with all items to Quick Shelf">'+(saved?'♥':'♡')+'</button>';
  }

  function renderNestedBookGroupForDirectory(bookId, items, searchActive){
    items = validItemRows(items || state.items || []);
    var bookItems = indexedItemsForBook(bookId, items);
    if(!bookItems.length) return '';
    var key = bookGroupKey(bookId);
    var book = bookById(bookId) || { book_id:bookId };
    rememberDirectoryGroup(key, { type:'book', bookId:bookId, items:bookItems.slice() });
    var isOpen = !!searchActive || !!state.openGroups[key];
    var html = '<section class="tydLib__group tydLib__nestedBookGroup '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
    html += '<div class="tydLib__bookHeadRow"><button type="button" class="tydLib__groupBtn tydLib__nestedBookBtn" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName book">'+bookTitleHtml(book)+'</span></span><span class="tydLib__groupCount">'+bookItems.length+'</span></button>' + renderBookHeaderHeart(bookId) + '</div>';
    html += '<div class="tydLib__groupBody">';
    if(isOpen){ html += renderDirectoryGroupBody(key); }
    html += '</div></section>';
    return html;
  }

  function renderDirectoryGroupBody(key){
    var data = state._directoryGroupData && state._directoryGroupData[key];
    if(!data) return '';
    var html = '';
    if(data.type === 'book'){
      html += renderBookEntryButton(data.bookId || '', 'read');
    }
    if(data.type === 'quickShelfBook'){
      return renderQuickShelfBookBody(data.entry || quickShelfEntryById(data.entry_id));
    }
    if(data.type === 'quickShelf'){
      return renderQuickShelfGroupBody(key);
    }
    if(data.type === 'bookCategory'){
      (data.bookIds || []).forEach(function(bookId){ html += renderNestedBookGroupForDirectory(bookId, data.items || state.items || [], !!data.searchActive); });
      return html;
    }
    if(data.type === 'rcType'){
      var grouped = {};
      (data.entries || []).forEach(function(entry){
        var cat = entry.category || 'Study Notes';
        (grouped[cat] = grouped[cat] || []).push(entry);
      });
      Object.keys(grouped).sort(function(a,b){ return rcCategorySort(a,b,grouped); }).forEach(function(cat){
        html += renderRcNestedCategoryGroup(data.title || '', cat, grouped[cat], !!data.searchActive);
      });
      return html;
    }
    if(data.type === 'rc'){
      (data.entries || []).sort(rcSortEntries).forEach(function(entry){ html += renderRcEntryButton(entry); });
      return html;
    }
    if(data.type === 'godType' || data.type === 'god'){
      (data.entries || []).slice().sort(function(a,b){ return Number(a.display_order || 0) - Number(b.display_order || 0) || String(a.name_en || '').localeCompare(String(b.name_en || '')); }).forEach(function(entry){ html += renderGodNestedGroupForDirectory(entry, !!data.searchActive); });
      return html;
    }
    if(data.type === 'godEntry'){
      var ge = data.entry || null;
      (data.sections || godVisibleSections(ge)).forEach(function(section){ html += renderGodCategoryButton(ge, section); });
      return html;
    }
    displayableDirectoryItems(data.items || []).forEach(function(item){ html += renderItemButton(item); });
    return html;
  }

  function updateDirectoryGroupDom(key){
    var section = els.list && els.list.querySelector('[data-group="'+CSS.escape(key)+'"]');
    if(!section) return false;
    var isOpen = !!state.openGroups[key];
    section.classList.toggle('open', isOpen);
    var arrow = null;
    try{ arrow = section.querySelector(':scope > .tydLib__groupBtn .tydLib__groupArrow'); }catch(scopeErr){ arrow = section.querySelector('.tydLib__groupArrow'); }
    if(arrow) arrow.textContent = isOpen ? '▾' : '▸';
    var body = null;
    try{ body = section.querySelector(':scope > .tydLib__groupBody'); }catch(scopeErr2){ body = section.querySelector('.tydLib__groupBody'); }
    if(body){
      // V100: force only THIS group's direct body to show/hide.
      // The old descendant CSS rule made nested God groups look stuck open whenever
      // their parent Type group was open.
      body.style.display = isOpen ? 'block' : 'none';
      if(isOpen && !String(body.innerHTML || '').trim()){
        body.innerHTML = renderDirectoryGroupBody(key);
      }
    }
    return true;
  }

  function updateDirectoryActiveDom(){
    if(!els.list) return;
    els.list.querySelectorAll('.tydLib__item.active,.tydLib__bookRead.active').forEach(function(n){ n.classList.remove('active'); });
    if(isQuickShelfDirectory() || isQuickShelfSelection(state.selectedId)){
      els.list.querySelectorAll('[data-quick-open-selection]').forEach(function(n){ n.classList.toggle('active', String(n.getAttribute('data-quick-open-selection') || '') === String(state.selectedId || '')); });
      els.list.querySelectorAll('[data-quick-open]').forEach(function(n){ n.classList.toggle('active', quickShelfSelectionId(n.getAttribute('data-quick-open')) === state.selectedId); });
      return;
    }
    if(isGodDirectory() && isGodSelection(state.selectedId)){
      els.list.querySelectorAll('[data-id="'+CSS.escape(state.selectedId)+'"]').forEach(function(n){ n.classList.add('active'); });
      var activeGodSection = state.godSection || state.category || '';
      if(activeGodSection){
        els.list.querySelectorAll('[data-god-category-select="'+CSS.escape(state.selectedId)+'"]').forEach(function(n){
          if(n.getAttribute('data-god-category') === activeGodSection) n.classList.add('active');
        });
      }
      els.list.querySelectorAll('[data-group="'+CSS.escape(godEntryGroupKey(godEntryById(state.selectedId)))+'"] > .tydLib__groupBtn').forEach(function(n){ n.classList.add('active'); });
      return;
    }
    if(isRcDirectory() && isRcSelection(state.selectedId)){
      els.list.querySelectorAll('[data-id="'+CSS.escape(state.selectedId)+'"]').forEach(function(n){ n.classList.add('active'); });
      return;
    }
    if(isBookSelection(state.selectedId)){
      var bookId = selectedBookId();
      var b = els.list.querySelector('[data-book-read="'+CSS.escape(bookId)+'"]');
      if(b) b.classList.add('active');
    }else if(state.selectedId){
      els.list.querySelectorAll('[data-id="'+CSS.escape(state.selectedId)+'"]').forEach(function(n){ n.classList.add('active'); });
    }
  }

  function openSelectedDirectoryGroup(){
    if(!state.selectedId) return;
    if(isQuickShelfSelection(state.selectedId)){
      var qe = quickShelfEntryBySelection(state.selectedId);
      if(qe){
        state.openGroups[qe.kind === 'book' ? 'qs:books' : 'qs:items'] = true;
        if(qe.kind === 'book') state.openGroups[quickShelfBookGroupKey(qe)] = true;
      }
      return;
    }
    if(isBookSelection(state.selectedId)){
      var sbid = selectedBookId();
      if(isScriptureRiteLabel(state.type) && !state.category){
        var sc = normalizeScriptureRiteCategory(bookCategoryForDirectory(sbid));
        if(sc){ state.openGroups[scriptureRiteCategoryGroupKey(sc)] = true; return; }
      }
      state.openGroups[state.selectedId] = true; return;
    }
    var godEntry = godEntryById(state.selectedId);
    if(godEntry){
      state.openGroups[godGroupKeyForEntry(godEntry)] = true;
      state.openGroups[godEntryGroupKey(godEntry)] = true;
      return;
    }
    var rcEntry = rcEntryById(state.selectedId);
    if(rcEntry){
      state.openGroups[rcGroupKeyForEntry(rcEntry)] = true;
      return;
    }
    var item = itemById(state.selectedId);
    if(!item) return;
    if(state.directoryView === 'book'){
      var idxRows = (state._indexByItem && state._indexByItem[String(item.item_id)]) || [];
      if(idxRows.length && idxRows[0].book_id) state.openGroups[bookGroupKey(idxRows[0].book_id)] = true;
    }else{
      var cats = itemBrowseCategoriesForDirectory(item);
      if(cats && cats.length) state.openGroups['cat:' + groupKey(cats[0])] = true;
    }
  }

  function renderSimpleItemGroup(key, title, groupItems, searchActive){
    groupItems = displayableDirectoryItems(groupItems);
    if(!groupItems || !groupItems.length) return '';
    rememberDirectoryGroup(key, { type:'items', title:title, items:groupItems.slice() });
    var isOpen = searchActive || !!state.openGroups[key];
    var html = '<section class="tydLib__group '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
    html += '<button type="button" class="tydLib__groupBtn" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName book">'+escapeHtml(title)+'</span></span><span class="tydLib__groupCount">'+groupItems.length+'</span></button>';
    html += '<div class="tydLib__groupBody">';
    if(isOpen){ html += renderDirectoryGroupBody(key); }
    html += '</div></section>';
    return html;
  }

  function renderScriptureRiteCategoryDirectory(items, searchActive){
    items = validItemRows(items);
    var byCat = {}, visibleCount = 0;
    sortedBookIdsForDirectory().forEach(function(bookId){
      if(!bookMatchesDirectoryFilters(bookId)) return;
      var cat = normalizeScriptureRiteCategory(bookCategoryForDirectory(bookId));
      if(!cat) return;
      var bookItems = indexedItemsForBook(bookId, items);
      if(!bookItems.length) return;
      (byCat[cat] = byCat[cat] || []).push(bookId);
      visibleCount += bookItems.length;
    });
    var html = '';
    Object.keys(byCat).sort(function(a,b){ return scriptureRiteCategoryRank(a) - scriptureRiteCategoryRank(b); }).forEach(function(cat){
      var key = scriptureRiteCategoryGroupKey(cat);
      var isOpen = searchActive || !!state.openGroups[key];
      rememberDirectoryGroup(key, { type:'bookCategory', title:cat, bookIds:byCat[cat].slice(), items:items.slice(), searchActive:!!searchActive });
      html += '<section class="tydLib__group '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
      html += '<button type="button" class="tydLib__groupBtn" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName book">'+escapeHtml(cat)+'</span></span><span class="tydLib__groupCount">'+byCat[cat].length+'</span></button>';
      html += '<div class="tydLib__groupBody">';
      if(isOpen){ html += renderDirectoryGroupBody(key); }
      html += '</div></section>';
    });
    state._lastDirectoryCount = visibleCount;
    return html;
  }

  function renderBookDirectory(items, searchActive){
    items = validItemRows(items);
    if(isScriptureRiteLabel(state.type) && !state.category){
      return renderScriptureRiteCategoryDirectory(items, searchActive);
    }
    var html = '';
    var used = {};
    var visibleCount = 0;
    sortedBookIdsForDirectory().forEach(function(bookId){
      if(!bookMatchesDirectoryFilters(bookId)) return;
      var bookItems = indexedItemsForBook(bookId, items);
      if(!bookItems.length) return;
      bookItems.forEach(function(i){ used[i.item_id] = true; });
      visibleCount += bookItems.length;
      var key = bookGroupKey(bookId);
      var isOpen = searchActive || !!state.openGroups[key];
      var book = bookById(bookId) || { book_id:bookId };
      rememberDirectoryGroup(key, { type:'book', bookId:bookId, items:bookItems.slice() });
      html += '<section class="tydLib__group '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
      html += '<button type="button" class="tydLib__groupBtn" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName book">'+bookTitleHtml(book)+'</span></span><span class="tydLib__groupCount">'+bookItems.length+'</span></button>' + renderBookHeaderHeart(bookId);
      html += '<div class="tydLib__groupBody">';
      if(isOpen){ html += renderDirectoryGroupBody(key); }
      html += '</div></section>';
    });

    // In Book view, type/category filters are book-first. Repair buckets are only
    // useful in the unfiltered All view; they should not appear under Spells,
    // Songs, Teachings, or a selected category.
    if(!repairBucketsAllowedInBookView()){
      state._lastDirectoryCount = visibleCount;
      return html;
    }

    var sourceGroups = {};
    var sourceTitles = {};
    items.forEach(function(item){
      if(used[item.item_id]) return;
      var label = firstUnmatchedSourceLabel(item);
      if(!label) return;
      var key = sourceGroupKey(label);
      sourceTitles[key] = label;
      (sourceGroups[key] = sourceGroups[key] || []).push(item);
      used[item.item_id] = true;
    });
    Object.keys(sourceGroups).sort().forEach(function(key){
      visibleCount += sourceGroups[key].length;
      html += renderSimpleItemGroup(key, 'Needs Book_Index: ' + (sourceTitles[key] || 'source book'), sourceGroups[key], searchActive);
    });

    var unassigned = displayableDirectoryItems(items.filter(function(i){ return i && i.item_id && !used[i.item_id]; }));
    if(unassigned.length){
      visibleCount += unassigned.length;
      html += renderSimpleItemGroup(unassignedGroupKey(), 'Unassigned — needs book/rite link', unassigned, searchActive);
    }
    state._lastDirectoryCount = visibleCount;
    return html;
  }

  function renderCategoryDirectory(items, searchActive){
    items = displayableDirectoryItems(items);
    var byCat = {};
    items.forEach(function(item){
      itemBrowseCategoriesForDirectory(item).forEach(function(cat){
        if(state.category && cat !== state.category) return;
        var k = groupKey(cat);
        (byCat[k] = byCat[k] || []).push(item);
      });
    });
    var html = '';
    var visibleCount = 0;
    Object.keys(byCat).sort().forEach(function(cat){
      visibleCount += byCat[cat].length;
      var key = 'cat:' + cat;
      var isOpen = searchActive || !!state.openGroups[key];
      rememberDirectoryGroup(key, { type:'items', title:prettyCategory(cat), items:byCat[cat].slice() });
      html += '<section class="tydLib__group '+(isOpen?'open':'')+'" data-group="'+escapeHtml(key)+'">';
      html += '<button type="button" class="tydLib__groupBtn" data-toggle-group="'+escapeHtml(key)+'"><span><span class="tydLib__groupArrow">'+(isOpen?'▾':'▸')+'</span><span class="tydLib__groupName">'+escapeHtml(prettyCategory(cat))+'</span></span><span class="tydLib__groupCount">'+byCat[cat].length+'</span></button>';
      html += '<div class="tydLib__groupBody">';
      if(isOpen){ html += renderDirectoryGroupBody(key); }
      html += '</div></section>';
    });
    state._lastDirectoryCount = visibleCount;
    return html;
  }

  function directoryClosedCacheKey(){
    if(norm(state.query)) return '';
    var openKeys = Object.keys(state.openGroups || {}).filter(function(k){ return !!state.openGroups[k]; });
    if(openKeys.length) return '';
    return [state.directoryView || 'book', state.directorySort || 'sheet', state.type || '', state.category || ''].join('\u001f');
  }

  function saveDirectoryRenderCache(key, html, count, groupData){
    if(!key) return;
    state._directoryRenderCache = state._directoryRenderCache || {};
    state._directoryRenderCacheOrder = state._directoryRenderCacheOrder || [];
    if(!state._directoryRenderCache[key]) state._directoryRenderCacheOrder.push(key);
    state._directoryRenderCache[key] = { html:html || '', count:Number(count || 0), groupData:Object.assign({}, groupData || {}) };
    while(state._directoryRenderCacheOrder.length > 24){
      var oldKey = state._directoryRenderCacheOrder.shift();
      if(oldKey) delete state._directoryRenderCache[oldKey];
    }
  }


  function ensureDirectorySelection(){
    normalizeDirectoryView();
    if(isQuickShelfDirectory()){
      if(state.selectedId && isQuickShelfSelection(state.selectedId)) return;
      var entries = quickShelfEntries();
      state.selectedId = (entries[0] && quickShelfSelectionId(entries[0].entry_id)) || null;
      return;
    }
    if(isCollectionDirectory()){
      var collectionRows=collectionVisibleRows_(), current=collectionBySelection_(state.selectedId), visibleCurrent=current && collectionRows.some(function(r){return r.collection_id===current.collection_id;});
      if(!visibleCurrent) state.selectedId=(collectionRows[0]&&collectionSelectionId_(collectionRows[0].collection_id))||null;
      return;
    }
    if(isGodDirectory()){
      var visibleGods = godFilteredEntries();
      var selectedVisible = false;
      if(isGodSelection(state.selectedId)){
        selectedVisible = visibleGods.some(function(g){ return g.god_id === state.selectedId; });
      }
      if(!selectedVisible){
        state.selectedId = (visibleGods[0] && visibleGods[0].god_id) || ((GOD_ATLAS_ENTRIES.filter(godEntryHasAnyContent)[0] || {}).god_id) || null;
      }
      return;
    }
    if(isRcDirectory()){
      if(!isRcSelection(state.selectedId)) state.selectedId = (RC_ATLAS_ENTRIES[0] && RC_ATLAS_ENTRIES[0].rc_id) || null;
      return;
    }
    if(isRcSelection(state.selectedId) || isGodSelection(state.selectedId)){
      state.selectedId = state.books[0] ? bookGroupKey(state.books[0].book_id) : ((state.items[0] && state.items[0].item_id) || null);
    }
  }

  function renderList(){
    ensureDirectorySelection();
    var cacheKey = directoryClosedCacheKey();
    var cached = cacheKey && state._directoryRenderCache && state._directoryRenderCache[cacheKey];
    if(cached){
      state._directoryGroupData = Object.assign({}, cached.groupData || {});
      state._lastDirectoryCount = Number(cached.count || 0);
      els.count.textContent = state._lastDirectoryCount + (state._lastDirectoryCount === 1 ? ' item' : ' items');
      els.list.innerHTML = cached.html || '<div class="tydLib__empty"><p>No matching item.</p></div>';
      return;
    }
    var searchActive = !!norm(state.query);
    state._directoryGroupData = {};
    state._lastDirectoryCount = 0;
    if(isQuickShelfDirectory()){
      var qsHtml = renderQuickShelfDirectory(searchActive);
      var qsCount = Number(state._lastDirectoryCount || 0);
      els.count.textContent = qsCount + (qsCount === 1 ? ' saved' : ' saved');
      els.list.innerHTML = qsHtml;
      return;
    }
    if(isCollectionDirectory()){
      var collectionHtml=renderCollectionDirectory_(), collectionCount=Number(state._lastDirectoryCount||0);
      els.count.textContent=collectionCount+(collectionCount===1?' entry':' entries');
      if(!collectionHtml) collectionHtml='<div class="tydLib__empty"><p>No '+(isVideoDirectory()?'teaching videos':(isFunWatchDirectory()?'Fun Watch entries':(isArticleDirectory()?'articles':'supply items')))+' yet.</p></div>';
      els.list.innerHTML=collectionHtml;
      return;
    }
    if(isGodDirectory()){
      var godHtml = renderGodDirectory(searchActive);
      var godCount = Number(state._lastDirectoryCount || 0);
      els.count.textContent = godCount + (godCount === 1 ? ' god' : ' gods');
      if(!godHtml) godHtml = '<div class="tydLib__empty"><p>No matching God entry yet.</p></div>';
      els.list.innerHTML = godHtml;
      saveDirectoryRenderCache(cacheKey, godHtml, godCount, state._directoryGroupData);
      return;
    }
    if(isRcDirectory()){
      var rcHtml = renderRcDirectory(searchActive);
      var rcCount = Number(state._lastDirectoryCount || 0);
      els.count.textContent = rcCount + (rcCount === 1 ? ' RC entry' : ' RC entries');
      if(!rcHtml) rcHtml = '<div class="tydLib__empty"><p>No matching RC Atlas entry.</p></div>';
      els.list.innerHTML = rcHtml;
      saveDirectoryRenderCache(cacheKey, rcHtml, rcCount, state._directoryGroupData);
      return;
    }
    var items = state.directoryView === 'book' ? filteredItems({ useCategory:false, useType:false }) : filteredItems();
    items = validItemRows(items);
    var html = state.directoryView === 'book' ? renderBookDirectory(items, searchActive) : renderCategoryDirectory(items, searchActive);
    var visibleCount = Number(state._lastDirectoryCount || 0);
    els.count.textContent = visibleCount + (visibleCount === 1 ? ' item' : ' items');
    if(!html){
      html = '<div class="tydLib__empty"><p>No matching item.</p></div>';
      els.list.innerHTML = html;
      saveDirectoryRenderCache(cacheKey, html, visibleCount, state._directoryGroupData);
      return;
    }
    els.list.innerHTML = html;
    saveDirectoryRenderCache(cacheKey, html, visibleCount, state._directoryGroupData);
  }

  function renderBookLine(l, mode){
    var review = String(l.status||'').toLowerCase() === 'review';
    var html = '<div class="tydLib__chantLine '+(review?'review':'')+' '+escapeHtml('mode-'+mode)+'">';
    if(mode === 'chinese'){
      html += '<div class="tydLib__zh">'+escapeHtml(cleanLineText(l.chinese || ''))+'</div>';
      html += '</div>';
      return html;
    }
    if(mode === 'english'){
      if(l.english_translation) html += '<div class="tydLib__en tydLib__enOnly">'+escapeHtml(cleanLineText(l.english_translation || ''))+'</div>';
      else html += '<div class="tydLib__missing">English translation needs review.</div>';
      html += '</div>';
      return html;
    }
    html += '<div class="tydLib__zh">'+escapeHtml(cleanLineText(l.chinese || ''))+'</div>';
    if(mode !== 'study') html += '<div class="tydLib__saam">'+escapeHtml(cleanLineText(l.saamlawnese || ''))+'</div>';
    if(mode !== 'chant'){
      if(l.english_translation) html += '<div class="tydLib__en">'+escapeHtml(cleanLineText(l.english_translation || ''))+'</div>';
      else if(review) html += '<div class="tydLib__missing">English translation needs review.</div>';
    }
    // Line notes stay in dictionary mode only.
    html += '</div>';
    return html;
  }

  function modeIsSingleLanguage(){
    return state.mode === 'chinese' || state.mode === 'english';
  }

  function readerModeLabel(){
    if(state.mode === 'chinese') return 'Chinese only';
    if(state.mode === 'english') return 'English translation only';
    if(state.mode === 'study') return 'Chinese + English';
    if(state.mode === 'full') return 'Chinese + Saamlawnese + English';
    if(state.mode === 'dictionary') return 'dictionary';
    return 'Chinese + Saamlawnese';
  }

  var MODE_ORDER = ['chant','full','study','chinese','english','dictionary'];
  var MODE_ICONS = { chant:'M', full:'M', study:'M', chinese:'M', english:'M', dictionary:'M' };
  function readModeButtonHtml(){
    var label = readerModeLabel();
    return '<button class="tydLib__btn secondary tydLib__modeCycleBtn" type="button" id="tydModeCycle" aria-label="Switch read mode. Current: '+escapeHtml(label)+'" title="Read mode: '+escapeHtml(label)+' — tap to switch">'+escapeHtml(MODE_ICONS[state.mode] || '↻')+'</button>';
  }
  function cycleReadMode(){
    var idx = MODE_ORDER.indexOf(state.mode);
    state.mode = MODE_ORDER[(idx + 1) % MODE_ORDER.length] || 'chant';
    renderReader();
    setStatus('Read mode: '+readerModeLabel(), 'ok');
  }

  var ZH_FONT_ORDER = ['safe','safeLight','kai','kaiBold','system'];
  var ZH_FONT_LABEL = {
    kai:'Nice light Chinese font',
    kaiBold:'Nice bold Chinese font',
    safeLight:'Blocky light Chinese font',
    safe:'Blocky bold Chinese font',
    system:'System default Chinese font'
  };
  function readStoredZhFont(){
    try{
      var saved = localStorage.getItem('tydLineageLibraryZhFont');
      if(ZH_FONT_ORDER.indexOf(saved) !== -1) return saved;
    }catch(e){}
    return 'safe';
  }
  function saveStoredZhFont(font){ try{ localStorage.setItem('tydLineageLibraryZhFont', font); }catch(e){} }
  function applyZhFont(font, save){
    if(ZH_FONT_ORDER.indexOf(font) === -1) font = 'safe';
    state.zhFont = font;
    root.setAttribute('data-zh-font', font);
    if(save) saveStoredZhFont(font);
  }
  function zhFontButtonHtml(){
    var label = ZH_FONT_LABEL[state.zhFont] || ZH_FONT_LABEL.safe;
    return '<button class="tydLib__btn secondary tydLib__zhFontBtn" type="button" id="tydZhFontCycle" aria-label="Switch Chinese font. Current: '+escapeHtml(label)+'" title="Chinese font: '+escapeHtml(label)+' — tap to switch">字</button>';
  }
  function cycleZhFont(){
    var idx = ZH_FONT_ORDER.indexOf(state.zhFont || 'safe');
    var next = ZH_FONT_ORDER[(idx + 1) % ZH_FONT_ORDER.length] || 'safe';
    applyZhFont(next, true);
    renderReader();
  }
  applyZhFont(readStoredZhFont(), false);

  var READER_SIZE_ORDER = ['small','normal','large','xlarge'];
  var READER_SIZE_META = {
    small:{label:'Smaller reader text', scale:.9, icon:'A−'},
    normal:{label:'Normal reader text', scale:1, icon:'A'},
    large:{label:'Large reader text', scale:1.12, icon:'A+'},
    xlarge:{label:'Extra large reader text', scale:1.25, icon:'A++'}
  };
  function readStoredReaderSize(){
    try{
      var saved = localStorage.getItem('tydLineageLibraryReaderSize');
      if(READER_SIZE_ORDER.indexOf(saved) !== -1) return saved;
    }catch(e){}
    return 'normal';
  }
  function saveStoredReaderSize(size){ try{ localStorage.setItem('tydLineageLibraryReaderSize', size); }catch(e){} }
  function applyReaderSize(size, save){
    if(READER_SIZE_ORDER.indexOf(size) === -1) size = 'normal';
    state.readerSize = size;
    var meta = READER_SIZE_META[size] || READER_SIZE_META.normal;
    root.setAttribute('data-reader-size', size);
    root.style.setProperty('--tyd-reader-scale', meta.scale);
    if(save) saveStoredReaderSize(size);
  }
  function readerSizeButtonHtml(){
    var meta = READER_SIZE_META[state.readerSize] || READER_SIZE_META.normal;
    return '<button class="tydLib__btn secondary tydLib__readerSizeBtn" type="button" id="tydReaderSizeCycle" aria-label="Switch reader text size. Current: '+escapeHtml(meta.label)+'" title="Reader text size: '+escapeHtml(meta.label)+' — tap to switch">'+escapeHtml(meta.icon)+'</button>';
  }
  function cycleReaderSize(){
    var idx = READER_SIZE_ORDER.indexOf(state.readerSize || 'normal');
    var next = READER_SIZE_ORDER[(idx + 1) % READER_SIZE_ORDER.length] || 'normal';
    applyReaderSize(next, true);
    renderReader();
    setStatus('Reader text size: '+((READER_SIZE_META[next] || {}).label || next), 'ok');
  }
  applyReaderSize(readStoredReaderSize(), false);

  function titleBlockHtml(zh, en, fallback){
    zh = zh || ''; en = en || ''; fallback = fallback || '';
    if(state.mode === 'chinese') return '<div class="tydLib__titleZh">'+escapeHtml(zh || fallback || 'Book')+'</div>';
    if(state.mode === 'english') return '<div class="tydLib__titleEn tydLib__titleSolo">'+escapeHtml(en || fallback || 'Book')+'</div>';
    if(!zh && en) return '<div class="tydLib__titleEn tydLib__titleSolo">'+escapeHtml(en || fallback || 'Book')+'</div>';
    return '<div class="tydLib__titleZh">'+escapeHtml(zh || '')+'</div>' +
      '<div class="tydLib__titleEn">'+escapeHtml(en || fallback || '')+'</div>';
  }

  function sectionTitleHtml(item){
    if(state.mode === 'chinese') return '<h3 class="tydLib__sectionTitleZh">'+escapeHtml(item.chinese_title || item.item_id || '')+'</h3>';
    if(state.mode === 'english') return '<div class="tydLib__sectionTitleEn tydLib__sectionTitleSolo">'+escapeHtml(item.english_title || item.item_id || '')+'</div>';
    return '<h3 class="tydLib__sectionTitleZh">'+escapeHtml(item.chinese_title || '')+'</h3>' +
      '<div class="tydLib__sectionTitleEn">'+escapeHtml(item.english_title || item.item_id || '')+'</div>';
  }

  function renderDictionaryLine(l){
    var review = String(l.status||'').toLowerCase() === 'review';
    var fields = '';
    fields += '<div class="tydLib__field"><div class="tydLib__label">Chinese</div><div class="tydLib__zh">'+escapeHtml(cleanLineText(l.chinese))+'</div></div>';
    fields += '<div class="tydLib__field"><div class="tydLib__label">Saamlawnese</div><div class="tydLib__saam">'+escapeHtml(cleanLineText(l.saamlawnese || ''))+'</div></div>';
    fields += '<div class="tydLib__field"><div class="tydLib__label">English</div><div class="tydLib__en">'+escapeHtml(cleanLineText(l.english_translation || ''))+'</div></div>';
    if(l.notes) fields += '<div class="tydLib__field"><div class="tydLib__label">Notes</div><div class="tydLib__en">'+escapeHtml(l.notes)+'</div></div>';
    return '<article class="tydLib__dictLine '+(review?'review':'')+'"><div class="tydLib__lineHead"><span>Line '+escapeHtml(l.line_no || '')+'</span><span>'+escapeHtml(l.status || '')+'</span></div><div class="tydLib__lineBody">'+fields+'</div></article>';
  }

  function readerNoteText(item){
    var note = item && item.notes ? cleanDisplayText(item.notes) : '';
    if(!note) return '';
    // Legacy bookkeeping notes are for admin cleanup only; keep them out of the public reader.
    if(/Legacy shared item/i.test(note) || /Removed from corrected/i.test(note)) return '';
    return note;
  }

  function itemHasImage(item){
    var src = cleanDisplayText(item && item.image_url || '').trim();
    return !!(src && /^https?:\/\//i.test(src));
  }

  function itemImageDetailHtml(item){
    if(!item || !itemHasImage(item)) return '';
    var code = cleanDisplayText(item.item_id || '').trim();
    var zh = cleanDisplayText(item.chinese_title || '').trim();
    var en = cleanDisplayText(item.english_title || '').trim();
    var note = readerNoteText(item);
    var cap = cleanDisplayText(item.image_caption || '').trim();
    var rows = [];
    function add(label, value, cls){
      value = cleanDisplayText(value || '').trim();
      if(!value) return;
      rows.push('<div class="tydLib__itemDetailRow '+escapeHtml(cls || '')+'"><div class="tydLib__itemDetailLabel">'+escapeHtml(label)+'</div><div class="tydLib__itemDetailValue">'+escapeHtml(value)+'</div></div>');
    }
    add('Code', code, 'code');
    if(state.mode !== 'english') add('Chinese Name', zh, 'zh');
    if(state.mode !== 'chinese') add('Name', en, 'en');
    if(note) add('Description / Notes', note, 'notes');
    else if(cap && cap !== zh && cap !== en) add('Caption', cap, 'caption');
    if(!rows.length) return '';
    return '<div class="tydLib__itemDetails" data-print-allow-split="1">'+rows.join('')+'</div>';
  }

  function itemImageHtml(item){
    var src = cleanDisplayText(item && item.image_url || '').trim();
    if(!src || !/^https?:\/\//i.test(src)) return '';
    var alt = cleanDisplayText((item && item.image_alt) || (item && item.english_title) || (item && item.chinese_title) || 'Stepping diagram');
    var cap = cleanDisplayText((item && item.image_caption) || '');
    var isHandsign = String(item && item.type || '').toLowerCase() === 'handsign';
    var imgClass = 'tydLib__itemImage' + (isHandsign ? ' tydLib__itemImage--handsign tydLib__itemImage--rotateCwFit' : '');
    var imgTag = '<img src="'+escapeHtml(src)+'" alt="'+escapeHtml(alt)+'" loading="lazy" decoding="async" fetchpriority="low">';
    if(isHandsign){
      imgTag = '<div class="tydLib__handsignFitStage">'+imgTag+'</div>';
    }
    return '<figure class="'+imgClass+'">'+imgTag+(cap?'<figcaption>'+escapeHtml(cap)+'</figcaption>':'')+'</figure>';
  }

  function itemImageData(item){
    var src = cleanDisplayText(item && item.image_url || '').trim();
    if(!src || !/^https?:\/\//i.test(src)) return null;
    return {
      src: src,
      alt: cleanDisplayText((item && item.image_alt) || (item && item.english_title) || (item && item.chinese_title) || 'Stepping diagram'),
      caption: cleanDisplayText((item && item.image_caption) || ''),
      titleZh: cleanDisplayText((item && item.chinese_title) || ''),
      titleEn: cleanDisplayText((item && item.english_title) || (item && item.item_id) || '')
    };
  }

  function chantImagePageHtml(p){
    var img = p && p.image ? p.image : {};
    if(!img.src) return '';
    var cap = img.caption || img.titleZh || img.titleEn || 'Diagram';
    return '<figure class="tydLib__chantImageFigure">' +
      '<img src="'+escapeHtml(img.src)+'" alt="'+escapeHtml(img.alt || cap)+'" loading="eager" decoding="async">' +
      (cap ? '<figcaption>'+escapeHtml(cap)+'</figcaption>' : '') +
      '</figure>';
  }

  function renderSection(item, rows){
    if(!item) return '';
    var section = '<section class="tydLib__bookSection">';
    section += sectionTitleHtml(item);
    var readerNote = readerNoteText(item);
    if(readerNote && state.mode === 'dictionary' && !itemHasImage(item)) section += '<div class="tydLib__note">'+escapeHtml(readerNote)+'</div>';
    section += itemImageHtml(item);
    section += itemImageDetailHtml(item);
    if(state.mode === 'dictionary'){
      section += '<div class="tydLib__dictLines">' + rows.map(renderDictionaryLine).join('') + '</div>';
    }else{
      section += rows.map(function(l){ return renderBookLine(l, state.mode); }).join('');
    }
    section += '</section>';
    return section;
  }



  var BUILDER_SELECTION_ID = '__tyd_builder_book__';
  var BUILDER_STORAGE_KEY = 'tydLineageLibraryBookBuilderV1';
  var BUILDER_LIBRARY_STORAGE_KEY = 'tydLineageLibraryBookBuilderLibraryV2';
  var BUILDER_ACTIVE_STORAGE_KEY = 'tydLineageLibraryBookBuilderActiveIdV2';
  var BUILDER_FILE_TYPE = 'TYD_BOOK_BUILDER';
  var BUILDER_LIBRARY_FILE_TYPE = 'TYD_BOOK_BUILDER_LIBRARY';
  function isBuilderSelection(id){ return String(id || '') === BUILDER_SELECTION_ID; }
  function builderUid(){ return 'sec_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2,8); }
  function builderBookUid(){ return 'book_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2,8); }
  function builderNowIso(){ try{ return new Date().toISOString(); }catch(e){ return ''; } }
  function builderHasCjk(s){ return /[㐀-鿿]/.test(String(s || '')); }
  function builderSlug(s){ return String(s || 'custom-book').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,54) || 'custom-book'; }
  function builderTemplateIdFromTitle(s){ return ('tpl_' + builderSlug(s || 'custom-book')).replace(/-/g,'_').slice(0,70) || 'tpl_custom_book'; }
  function builderCleanTemplateId(s){
    s = String(s || '').toLowerCase().replace(/[^a-z0-9_]+/g,'_').replace(/^_+|_+$/g,'').replace(/_{2,}/g,'_');
    if(!s) s = builderTemplateIdFromTitle(state.builder && state.builder.title || 'custom-book');
    if(!/^tpl_/.test(s)) s = 'tpl_' + s;
    return s.slice(0,80);
  }
  function builderDeepClone(obj){ try{ return JSON.parse(JSON.stringify(obj || {})); }catch(e){ return {}; } }

  function builderLayoutPresetValue(v){
    v = cleanDisplayText(v || '').replace(/_/g,'-');
    if(v === 'compact') return 'compact';
    if(v === 'chant-large' || v === 'large' || v === 'large-chant') return 'chant-large';
    return 'normal';
  }
  function builderLayoutClass(){ return 'tydLib__builderLayout--' + builderLayoutPresetValue(state.builder && state.builder.layoutPreset); }
  function builderLayoutLabel(v){
    v = builderLayoutPresetValue(v || (state.builder && state.builder.layoutPreset));
    if(v === 'compact') return 'compact print';
    if(v === 'chant-large') return 'large chanting print';
    return 'normal print';
  }
  function builderPageKindValue(v){
    v = cleanDisplayText(v || '').replace(/_/g,'-');
    if(v === 'cover') return 'cover';
    if(v === 'divider') return 'divider';
    if(v === 'toc' || v === 'table-of-contents') return 'toc';
    return 'custom';
  }
  function builderKindLabel(kind){
    kind = builderPageKindValue(kind);
    if(kind === 'cover') return 'cover page';
    if(kind === 'divider') return 'divider page';
    if(kind === 'toc') return 'table of contents';
    return 'custom page';
  }
  function compactBuilderItem(item){
    item = item || {};
    var out = {};
    ['item_id','type','category','chinese_title','english_title','notes','first_source_book','source_book','image_url','image_alt','image_caption','updated_at','updated_date'].forEach(function(k){ if(item[k] != null) out[k] = item[k]; });
    return out;
  }
  function compactBuilderLine(line){
    line = line || {};
    var out = {};
    ['item_id','line_no','chinese','saamlawnese','english_translation','notes','status','source_book','updated_at'].forEach(function(k){ if(line[k] != null) out[k] = line[k]; });
    return out;
  }
  function snapshotForItemId(itemId){
    var item = itemById(itemId) || { item_id:itemId, english_title:itemId };
    return { item:compactBuilderItem(item), lines:lineRows(itemId).map(compactBuilderLine), saved_at:builderNowIso() };
  }
  function normalizeBuilderSection(sec){
    sec = sec || {};
    var type = sec.type === 'custom_page' ? 'custom_page' : 'library_item';
    var out = {
      uid: sec.uid || builderUid(),
      type: type,
      title_override: cleanDisplayText(sec.title_override || ''),
      page_break_before: !!sec.page_break_before
    };
    if(type === 'library_item'){
      out.item_id = cleanDisplayText(sec.item_id || (sec.snapshot && sec.snapshot.item && sec.snapshot.item.item_id) || '');
      out.saved_updated_at = cleanDisplayText(sec.saved_updated_at || (sec.snapshot && sec.snapshot.item && (sec.snapshot.item.updated_at || sec.snapshot.item.updated_date)) || '');
      out.snapshot = sec.snapshot || null;
    }else{
      out.page_kind = builderPageKindValue(sec.page_kind || sec.pageKind || sec.kind || 'custom');
      out.title_zh = cleanDisplayText(sec.title_zh || sec.chinese_title || '');
      out.title_en = cleanDisplayText(sec.title_en || sec.english_title || sec.title || (out.page_kind === 'toc' ? 'Table of Contents' : (out.page_kind === 'cover' ? 'Cover Page' : (out.page_kind === 'divider' ? 'Divider Page' : 'Custom Page'))));
      out.content = sec.content || {};
      out.content.chinese = cleanDisplayText(out.content.chinese || sec.chinese || '');
      out.content.saamlawnese = cleanDisplayText(out.content.saamlawnese || sec.saamlawnese || '');
      out.content.english = cleanDisplayText(out.content.english || sec.english || '');
      out.content.notes = cleanDisplayText(out.content.notes || sec.notes || '');
    }
    return out;
  }
  function blankBuilderBook(title){
    var now = builderNowIso();
    return normalizeBuilderFile({ id:builderBookUid(), title:title || 'Custom Saam Law Book', description:'', versionMode:'latest', defaultMode:'chant', createdAt:now, updatedAt:now, sections:[] });
  }
  function normalizeBuilderFile(raw, preferredId){
    raw = raw || {};
    var b = {
      id: cleanDisplayText(raw.id || raw.builder_id || raw.book_id || preferredId || builderBookUid()),
      open:false,
      title: cleanDisplayText(raw.title || raw.book_title || 'Custom Saam Law Book'),
      description: cleanDisplayText(raw.description || raw.notes || ''),
      versionMode: raw.versionMode || raw.version_mode || 'latest',
      defaultMode: raw.defaultMode || raw.default_mode || 'chant',
      layoutPreset: builderLayoutPresetValue(raw.layoutPreset || raw.layout_preset || (raw.layout && (raw.layout.preset || raw.layout.print_preset)) || 'normal'),
      createdAt: raw.createdAt || raw.created_at || builderNowIso(),
      updatedAt: raw.updatedAt || raw.updated_at || builderNowIso(),
      sections: (raw.sections || []).map(normalizeBuilderSection).filter(function(sec){ return sec.type === 'custom_page' || sec.item_id; })
    };
    if(['latest','snapshot'].indexOf(b.versionMode) === -1) b.versionMode = 'latest';
    if(['chant','full','study','chinese','english','dictionary'].indexOf(b.defaultMode) === -1) b.defaultMode = 'chant';
    b.layoutPreset = builderLayoutPresetValue(b.layoutPreset);
    return b;
  }
  function normalizeBuilderLibrary(raw){
    raw = raw || {};
    var sourceBooks = raw.books || raw.saved_books || raw.builder_books || [];
    if(!sourceBooks.length && raw.sections) sourceBooks = [raw];
    var seen = {};
    var books = [];
    (sourceBooks || []).forEach(function(book){
      var b = normalizeBuilderFile(book);
      if(!b.id || seen[b.id]) b.id = builderBookUid();
      seen[b.id] = true;
      books.push(b);
    });
    var active = cleanDisplayText(raw.activeId || raw.active_id || '');
    if(!active){ try{ active = localStorage.getItem(BUILDER_ACTIVE_STORAGE_KEY) || ''; }catch(e){} }
    if(!books.some(function(b){ return b.id === active; })) active = books[0] && books[0].id || '';
    return { activeId:active, books:books, version:2, updatedAt:raw.updatedAt || raw.updated_at || builderNowIso() };
  }
  function ensureBuilderLibrary(){
    if(!state.builderLibrary) state.builderLibrary = { activeId:'', books:[] };
    state.builderLibrary = normalizeBuilderLibrary(state.builderLibrary);
    if(!state.builderLibrary.books.length){
      var b = blankBuilderBook('Custom Saam Law Book');
      state.builderLibrary.books.push(b);
      state.builderLibrary.activeId = b.id;
    }
    var active = state.builderLibrary.books.filter(function(b){ return b.id === state.builderLibrary.activeId; })[0] || state.builderLibrary.books[0];
    var wasOpen = !!(state.builder && state.builder.open);
    state.builder = normalizeBuilderFile(active);
    state.builder.open = wasOpen;
    state.builderLibrary.activeId = state.builder.id;
  }
  function builderBookLabel(book){
    book = normalizeBuilderFile(book || {});
    var t = book.title || 'Custom Saam Law Book';
    var n = (book.sections || []).length;
    return t + ' (' + n + (n === 1 ? ' section' : ' sections') + ')';
  }
  function syncBuilderBookSelect(){
    if(!els.builderBookSelect || !state.builderLibrary) return;
    var books = state.builderLibrary.books || [];
    els.builderBookSelect.innerHTML = books.map(function(book){
      var selected = book.id === state.builderLibrary.activeId ? ' selected' : '';
      return '<option value="'+escapeHtml(book.id)+'"'+selected+'>'+escapeHtml(builderBookLabel(book))+'</option>';
    }).join('');
  }

  function builderTemplateTitle(book){
    book = (typeof book === 'object' && book) ? book : (bookById(book) || { book_id:book });
    var parts = bookTitleParts(book);
    var en = parts.en || parts.fallback || String(book.book_id || 'Official Template');
    var zh = parts.zh || '';
    return zh ? (zh + ' / ' + en) : en;
  }
  function builderOfficialTemplateIds(){
    var ids = [];
    try{ ids = allBookIdsForDirectory(); }catch(e){ ids = []; }
    ids = (ids || []).filter(function(id){ return id && indexedItemsForBook(id, state.items).length; });
    ids.sort(function(a,b){
      var ba = bookById(a) || { book_id:a };
      var bb = bookById(b) || { book_id:b };
      var ga = cleanDisplayText(ba.directory_group || ba.category_group || ba.library_type || '');
      var gb = cleanDisplayText(bb.directory_group || bb.category_group || bb.library_type || '');
      var ta = (ga + ' ' + builderTemplateTitle(ba)).toLowerCase();
      var tb = (gb + ' ' + builderTemplateTitle(bb)).toLowerCase();
      return ta < tb ? -1 : (ta > tb ? 1 : 0);
    });
    return ids;
  }
  function builderTemplateLabel(bookId){
    var book = bookById(bookId) || { book_id:bookId };
    var title = builderTemplateTitle(book);
    var group = cleanDisplayText(book.directory_group || book.category_group || book.library_type || '');
    var count = indexedItemsForBook(bookId, state.items).length;
    return (group ? group + ' · ' : '') + title + ' (' + count + (count === 1 ? ' item' : ' items') + ')';
  }
  function syncBuilderTemplateSelect(){
    if(!els.builderTemplateSelect) return;
    var oldVal = els.builderTemplateSelect.value || '';
    var ids = builderOfficialTemplateIds();
    if(!ids.length){
      els.builderTemplateSelect.innerHTML = '<option value="">Official templates load after the library database is ready</option>';
      if(els.builderLoadTemplate) els.builderLoadTemplate.disabled = true;
      return;
    }
    els.builderTemplateSelect.innerHTML = '<option value="">Choose official template...</option>' + ids.map(function(id){
      var selected = id === oldVal ? ' selected' : '';
      return '<option value="'+escapeHtml(id)+'"'+selected+'>'+escapeHtml(builderTemplateLabel(id))+'</option>';
    }).join('');
    if(els.builderLoadTemplate) els.builderLoadTemplate.disabled = !els.builderTemplateSelect.value;
  }
  function loadOfficialTemplateIntoBuilder(bookId){
    bookId = cleanDisplayText(bookId || (els.builderTemplateSelect && els.builderTemplateSelect.value) || '');
    if(!bookId){ setStatus('Choose an official template first.', 'bad'); return; }
    var items = indexedItemsForBook(bookId, state.items);
    if(!items.length){ setStatus('This template has no loaded items yet.', 'bad'); return; }
    saveBuilderLocal();
    var book = bookById(bookId) || { book_id:bookId };
    var parts = bookTitleParts(book);
    var title = (parts.zh && parts.en) ? (parts.zh + ' / ' + parts.en) : (parts.zh || parts.en || parts.fallback || 'Official Template');
    var b = blankBuilderBook(title);
    b.description = 'Loaded from official Library template: ' + title;
    b.versionMode = 'latest';
    b.defaultMode = state.builder && state.builder.defaultMode || 'chant';
    b.layoutPreset = state.builder && state.builder.layoutPreset || 'normal';
    b.sections = items.map(function(item){
      return normalizeBuilderSection({ type:'library_item', item_id:item.item_id, snapshot:snapshotForItemId(item.item_id), saved_updated_at:item.updated_at || item.updated_date || '' });
    });
    b.updatedAt = builderNowIso();
    state.builderLibrary.books.push(normalizeBuilderFile(b));
    state.builderLibrary.activeId = b.id;
    state.builder = normalizeBuilderFile(b);
    state.builder.open = true;
    clearBuilderExpandedState();
    saveBuilderLocal();
    renderBuilder();
    setBuilderOpen(true);
    setStatus('Official template loaded as a new saved book: ' + title, 'ok');
  }
  function syncBuilderAdminTemplateUI(){
    if(els.builderAdminBlock) els.builderAdminBlock.hidden = !state.isAdmin;
    if(!state.isAdmin) return;
    if(els.builderTemplateId){
      var auto = builderTemplateIdFromTitle(state.builder && state.builder.title || 'Custom Saam Law Book');
      if(!els.builderTemplateId.value || els.builderTemplateId.getAttribute('data-auto-template-id') === '1'){
        els.builderTemplateId.value = auto;
        els.builderTemplateId.setAttribute('data-auto-template-id','1');
      }
    }
  }
  function builderTemplatePatchObject(){
    saveBuilderLocal();
    var rawId = els.builderTemplateId ? els.builderTemplateId.value : '';
    var templateId = builderCleanTemplateId(rawId || (state.builder && state.builder.title));
    if(els.builderTemplateId) els.builderTemplateId.value = templateId;
    var parts = builderTitleParts();
    var now = builderNowIso();
    var date = now.slice(0,10);
    var sections = (state.builder.sections || []).map(normalizeBuilderSection);
    var librarySections = sections.filter(function(sec){ return sec.type === 'library_item' && sec.item_id; });
    var customSections = sections.filter(function(sec){ return sec.type === 'custom_page'; }).map(function(sec, idx){ return { order_no:idx+1, page_kind:sec.page_kind || 'custom', title_zh:sec.title_zh || '', title_en:sec.title_en || '', note:'Custom pages are not part of the current Books/Book_Index structure. Convert to library items first if this page must become official.' }; });
    var bookRow = {
      book_id: templateId,
      book_title_chinese: parts.zh || '',
      book_title_english: parts.en || state.builder.title || 'Custom Saam Law Book',
      file_name: 'Generated by TYD Book Builder',
      updated_date: date,
      status: 'active',
      notes: 'Official template generated from TYD Book Builder. It points to existing Items through Book_Index.',
      library_type: 'Builder Template',
      category_group: 'Official Templates',
      directory_group: 'Official Templates',
      display_order: '',
      updated_at: now
    };
    var indexRows = librarySections.map(function(sec, idx){
      var t = sectionTitleForBuilder(sec);
      return {
        book_id: templateId,
        order_no: idx + 1,
        item_id: sec.item_id,
        display_section: sec.title_override || t.zh || t.en || '',
        source_book: state.builder.title || templateId,
        notes: sec.page_break_before ? 'page_break_before' : '',
        updated_at: now
      };
    });
    return {
      file_type:'TYD_OFFICIAL_TEMPLATE_PATCH',
      version:1,
      exported_at:now,
      source:'TYD Book Builder v68',
      spreadsheet_id: root.getAttribute('data-sheet-id') || CFG.sheetId,
      template_id:templateId,
      title:state.builder.title || 'Custom Saam Law Book',
      description:state.builder.description || '',
      warning: customSections.length ? 'This builder book has custom pages. The patch includes only existing library_item sections. Convert custom pages to Items/Lines first if they must become official.' : '',
      sheets:{ Books:[bookRow], Book_Index:indexRows },
      custom_pages_not_included:customSections
    };
  }
  function builderTemplatePatchCsv(obj){
    obj = obj || builderTemplatePatchObject();
    function csvRow(arr){ return arr.map(csvEscape).join(','); }
    var booksCols = ['book_id','book_title_chinese','book_title_english','file_name','updated_date','status','notes','library_type','category_group','directory_group','display_order','updated_at'];
    var indexCols = ['book_id','order_no','item_id','display_section','source_book','notes','updated_at'];
    var lines = [];
    lines.push('BOOKS_CSV_START');
    lines.push(csvRow(booksCols));
    (obj.sheets.Books || []).forEach(function(r){ lines.push(csvRow(booksCols.map(function(k){ return r[k] || ''; }))); });
    lines.push('BOOKS_CSV_END');
    lines.push('');
    lines.push('BOOK_INDEX_CSV_START');
    lines.push(csvRow(indexCols));
    (obj.sheets.Book_Index || []).forEach(function(r){ lines.push(csvRow(indexCols.map(function(k){ return r[k] || ''; }))); });
    lines.push('BOOK_INDEX_CSV_END');
    return lines.join('\n');
  }
  function builderOfficialTemplatePrompt(){
    var obj = builderTemplatePatchObject();
    var csv = builderTemplatePatchCsv(obj);
    return [
      'TYD_BOOK_BUILDER_PUBLISH_OFFICIAL_TEMPLATE_PROMPT',
      '',
      'ChatGPT, apply this official Builder template patch to the TYD Lineage Content Library Google Sheet.',
      'Spreadsheet ID: ' + (obj.spreadsheet_id || ''),
      '',
      'Rules:',
      '1. Add or update the Books row by book_id = ' + obj.template_id + '.',
      '2. Replace the Book_Index rows for this book_id with the order below.',
      '3. Do not change Items or Lines for this patch. This template points to existing library items only.',
      '4. Keep updated_at values so the Library Supercharge can detect the change.',
      '5. After writing, read back the Books row and all Book_Index rows to verify the template appears in Official Templates and loads in the Builder.',
      obj.warning ? ('6. Important: ' + obj.warning) : '6. No custom pages are included in this patch.',
      '',
      'PATCH_JSON_START',
      JSON.stringify(obj, null, 2),
      'PATCH_JSON_END',
      '',
      csv
    ].join('\n');
  }
  function copyBuilderOfficialTemplatePrompt(){
    if(!state.isAdmin){ setStatus('Admin only.', 'bad'); return; }
    if(!state.builder.sections.length){ setStatus('Builder is empty. Add sections first.', 'bad'); return; }
    var txt = builderOfficialTemplatePrompt();
    if(navigator.clipboard){ navigator.clipboard.writeText(txt).then(function(){ setStatus('Official template publish prompt copied.', 'ok'); }).catch(function(){ downloadTextFile('tyd-official-template-publish-prompt.txt', txt, 'text/plain;charset=utf-8'); setStatus('Clipboard blocked. Prompt downloaded instead.', 'ok'); }); }
    else { downloadTextFile('tyd-official-template-publish-prompt.txt', txt, 'text/plain;charset=utf-8'); setStatus('Publish prompt downloaded.', 'ok'); }
  }
  function downloadBuilderTemplatePatch(){
    if(!state.isAdmin){ setStatus('Admin only.', 'bad'); return; }
    if(!state.builder.sections.length){ setStatus('Builder is empty. Add sections first.', 'bad'); return; }
    var obj = builderTemplatePatchObject();
    downloadTextFile(builderCleanTemplateId(obj.template_id) + '-official-template-patch.json', JSON.stringify(obj, null, 2), 'application/json;charset=utf-8');
    setStatus('Official template patch downloaded.', 'ok');
  }

  function syncBuilderInputs(){
    if(els.builderTitle && els.builderTitle.value !== state.builder.title) els.builderTitle.value = state.builder.title || '';
    if(els.builderDesc && els.builderDesc.value !== state.builder.description) els.builderDesc.value = state.builder.description || '';
    if(els.builderVersionMode) els.builderVersionMode.value = state.builder.versionMode || 'latest';
    if(els.builderDefaultMode) els.builderDefaultMode.value = state.builder.defaultMode || 'chant';
    if(els.builderLayoutPreset) els.builderLayoutPreset.value = builderLayoutPresetValue(state.builder.layoutPreset || 'normal');
    syncBuilderBookSelect();
    syncBuilderTemplateSelect();
    syncBuilderAdminTemplateUI();
  }
  function builderPersistCurrentIntoLibrary(){
    if(!state.builderLibrary) state.builderLibrary = { activeId:'', books:[] };
    state.builderLibrary = normalizeBuilderLibrary(state.builderLibrary);
    var wasOpen = !!(state.builder && state.builder.open);
    var b = normalizeBuilderFile(state.builder || {});
    b.open = false;
    b.updatedAt = builderNowIso();
    if(!b.id) b.id = builderBookUid();
    var found = false;
    for(var i=0;i<state.builderLibrary.books.length;i++){
      if(state.builderLibrary.books[i].id === b.id){ state.builderLibrary.books[i] = b; found = true; break; }
    }
    if(!found) state.builderLibrary.books.push(b);
    state.builderLibrary.activeId = b.id;
    state.builderLibrary.updatedAt = b.updatedAt;
    state.builder = normalizeBuilderFile(b);
    state.builder.open = wasOpen;
  }
  function builderLibraryExportObject(refreshActiveSnapshots){
    if(refreshActiveSnapshots) refreshBuilderSnapshotsForExport();
    builderPersistCurrentIntoLibrary();
    return {
      file_type: BUILDER_LIBRARY_FILE_TYPE,
      version: 3,
      exported_at: builderNowIso(),
      active_id: state.builderLibrary.activeId,
      source: 'Saam Law Magic Library',
      books: (state.builderLibrary.books || []).map(function(book){ return normalizeBuilderFile(book); })
    };
  }
  function saveBuilderLocal(){
    try{
      builderPersistCurrentIntoLibrary();
      var lib = builderLibraryExportObject(false);
      localStorage.setItem(BUILDER_LIBRARY_STORAGE_KEY, JSON.stringify(lib));
      localStorage.setItem(BUILDER_ACTIVE_STORAGE_KEY, state.builderLibrary.activeId || '');
      localStorage.setItem(BUILDER_STORAGE_KEY, JSON.stringify(builderExportObject(false)));
      syncBuilderBookSelect();
    }catch(e){
      try{ console.warn('[TYD Library] Book Builder local save failed:', e); }catch(_e){}
    }
  }
  function loadBuilderLocal(){
    var loaded = false;
    try{
      var rawLib = localStorage.getItem(BUILDER_LIBRARY_STORAGE_KEY);
      if(rawLib){ state.builderLibrary = normalizeBuilderLibrary(JSON.parse(rawLib)); loaded = true; }
    }catch(e){}
    if(!loaded){
      try{
        var raw = localStorage.getItem(BUILDER_STORAGE_KEY);
        if(raw){
          var oldBook = normalizeBuilderFile(JSON.parse(raw));
          state.builderLibrary = normalizeBuilderLibrary({ active_id:oldBook.id, books:[oldBook] });
          loaded = true;
          setStatus('Old Book Builder save upgraded to Saved Books.', 'ok');
        }
      }catch(e2){}
    }
    ensureBuilderLibrary();
    saveBuilderLocal();
    syncBuilderInputs();
  }
  function setBuilderOpen(open){
    state.builder.open = !!open;
    if(els.builderPanel) els.builderPanel.hidden = !state.builder.open;
    if(els.builderBackdrop) els.builderBackdrop.hidden = !state.builder.open;
    root.classList.toggle('tydLibBuilderOpen', state.builder.open);
    if(state.builder.open) renderBuilder();
  }
  function switchBuilderBook(bookId){
    bookId = cleanDisplayText(bookId || '');
    if(!bookId || !state.builderLibrary) return;
    saveBuilderLocal();
    var next = (state.builderLibrary.books || []).filter(function(book){ return book.id === bookId; })[0];
    if(!next) return;
    var wasOpen = !!state.builder.open;
    state.builderLibrary.activeId = next.id;
    state.builder = normalizeBuilderFile(next);
    state.builder.open = wasOpen;
    clearBuilderExpandedState();
    try{ localStorage.setItem(BUILDER_ACTIVE_STORAGE_KEY, next.id); }catch(e){}
    syncBuilderInputs();
    renderBuilder();
    if(isBuilderSelection(state.selectedId)) renderReader();
    setStatus('Opened saved book: ' + (state.builder.title || 'Custom Book'), 'ok');
  }
  function createNewBuilderBook(){
    saveBuilderLocal();
    var title = 'Custom Saam Law Book';
    if(window.prompt){
      var entered = window.prompt('New book title:', title);
      if(entered === null) return;
      title = cleanDisplayText(entered || title);
    }
    var b = blankBuilderBook(title);
    state.builderLibrary.books.push(b);
    state.builderLibrary.activeId = b.id;
    state.builder = normalizeBuilderFile(b);
    state.builder.open = true;
    clearBuilderExpandedState();
    saveBuilderLocal();
    renderBuilder();
    setStatus('New saved book created.', 'ok');
  }
  function saveAsBuilderBook(){
    saveBuilderLocal();
    var base = builderExportObject(false);
    base.id = builderBookUid();
    base.created_at = builderNowIso();
    base.updated_at = base.created_at;
    var suggested = (state.builder.title || 'Custom Book') + ' Copy';
    if(window.prompt){
      var entered = window.prompt('Save copy as:', suggested);
      if(entered === null) return;
      suggested = cleanDisplayText(entered || suggested);
    }
    base.title = suggested;
    var copy = normalizeBuilderFile(base, base.id);
    state.builderLibrary.books.push(copy);
    state.builderLibrary.activeId = copy.id;
    state.builder = normalizeBuilderFile(copy);
    state.builder.open = true;
    clearBuilderExpandedState();
    saveBuilderLocal();
    renderBuilder();
    setStatus('Saved as a new copy.', 'ok');
  }
  function renameBuilderBook(){
    var oldTitle = state.builder.title || 'Custom Saam Law Book';
    if(!window.prompt){ setStatus('Rename needs browser prompt support.', 'bad'); return; }
    var entered = window.prompt('Rename this saved book:', oldTitle);
    if(entered === null) return;
    state.builder.title = cleanDisplayText(entered || oldTitle);
    saveBuilderLocal();
    renderBuilder();
    if(isBuilderSelection(state.selectedId)) renderReader();
    setStatus('Saved book renamed.', 'ok');
  }
  function deleteBuilderBook(){
    if(window.confirm && !window.confirm('Delete this saved book from this browser? Export a backup first if you need it later.')) return;
    var id = state.builder.id;
    state.builderLibrary.books = (state.builderLibrary.books || []).filter(function(book){ return book.id !== id; });
    if(!state.builderLibrary.books.length){
      var b = blankBuilderBook('Custom Saam Law Book');
      state.builderLibrary.books.push(b);
    }
    state.builderLibrary.activeId = state.builderLibrary.books[0].id;
    state.builder = normalizeBuilderFile(state.builderLibrary.books[0]);
    state.builder.open = true;
    clearBuilderExpandedState();
    saveBuilderLocal();
    renderBuilder();
    if(isBuilderSelection(state.selectedId)) renderReader();
    setStatus('Saved book deleted.', 'ok');
  }
  function builderSourceForSection(sec){
    sec = normalizeBuilderSection(sec);
    if(sec.type !== 'library_item') return null;
    var liveItem = itemById(sec.item_id);
    var useSnapshot = state.builder.versionMode === 'snapshot' || !liveItem;
    var snap = sec.snapshot || {};
    var item = useSnapshot ? ((snap && snap.item) || liveItem || { item_id:sec.item_id, english_title:sec.item_id }) : liveItem;
    var rows = useSnapshot && snap && snap.lines ? snap.lines : lineRows(sec.item_id);
    return { item:item || { item_id:sec.item_id, english_title:sec.item_id }, rows:(rows || []).map(function(x){ return Object.assign({}, x); }), live:!!liveItem, snapshot:!!(snap && snap.item) };
  }

  function builderLiveVersion(item){
    item = item || {};
    return cleanDisplayText(item.updated_at || item.updated_date || item.last_updated || item.modified_at || item.version || '');
  }
  function builderSavedVersion(sec){
    sec = sec || {};
    var snapItem = sec.snapshot && sec.snapshot.item ? sec.snapshot.item : {};
    return cleanDisplayText(sec.saved_updated_at || snapItem.updated_at || snapItem.updated_date || snapItem.last_updated || snapItem.modified_at || snapItem.version || '');
  }
  function builderSnapshotLineCount(sec){
    return sec && sec.snapshot && sec.snapshot.lines && sec.snapshot.lines.length ? sec.snapshot.lines.length : 0;
  }
  function builderSnapshotTitleChanged(sec, liveItem){
    if(!sec || !sec.snapshot || !sec.snapshot.item || !liveItem) return false;
    var snap = sec.snapshot.item || {};
    return cleanDisplayText(snap.chinese_title || '') !== cleanDisplayText(liveItem.chinese_title || '') || cleanDisplayText(snap.english_title || '') !== cleanDisplayText(liveItem.english_title || '');
  }
  function builderUpdateReport(){
    var rows = [];
    var out = { total:0, libraryItems:0, current:0, changed:0, missing:0, noSnapshot:0, unknown:0, rows:rows };
    (state.builder.sections || []).forEach(function(rawSec, idx){
      var sec = normalizeBuilderSection(rawSec);
      out.total++;
      if(sec.type !== 'library_item') return;
      out.libraryItems++;
      var live = itemById(sec.item_id);
      var snap = sec.snapshot || null;
      var savedV = builderSavedVersion(sec);
      var liveV = builderLiveVersion(live);
      var liveCount = live ? lineRows(sec.item_id).length : 0;
      var snapCount = builderSnapshotLineCount(sec);
      var status = 'current';
      var reason = 'OK';
      if(!live){ status = 'missing'; reason = 'Missing from current Library database'; out.missing++; }
      else if(!snap || !snap.item){ status = 'noSnapshot'; reason = 'No saved snapshot inside this Builder section'; out.noSnapshot++; }
      else if(savedV && liveV && savedV !== liveV){ status = 'changed'; reason = 'Library updated: saved '+savedV+' → current '+liveV; out.changed++; }
      else if(snapCount && liveCount && snapCount !== liveCount){ status = 'changed'; reason = 'Line count changed: saved '+snapCount+' → current '+liveCount; out.changed++; }
      else if(builderSnapshotTitleChanged(sec, live)){ status = 'changed'; reason = 'Title changed in current Library database'; out.changed++; }
      else if(!savedV && !liveV){ status = 'unknown'; reason = 'No version date found; line/title check looks OK'; out.unknown++; }
      else { out.current++; }
      rows.push({ idx:idx, section:sec, live:live, status:status, reason:reason, savedVersion:savedV, liveVersion:liveV, savedLineCount:snapCount, liveLineCount:liveCount });
    });
    return out;
  }
  function builderUpdateStatusHtml(report){
    report = report || builderUpdateReport();
    if(!report.libraryItems) return '<b>Update check:</b> This saved book has no official Library items yet.';
    var cls = report.changed ? 'warn' : (report.missing ? 'bad' : 'ok');
    var parts = [];
    parts.push('<span class="tydLib__builderUpdateBadge '+cls+'">'+(report.changed ? report.changed+' newer' : (report.missing ? report.missing+' missing' : 'Current'))+'</span>');
    parts.push('<span>'+report.libraryItems+' Library sections checked</span>');
    if(report.changed) parts.push('<span>'+report.changed+' can refresh saved snapshots</span>');
    if(report.noSnapshot) parts.push('<span>'+report.noSnapshot+' need snapshots</span>');
    if(report.missing) parts.push('<span>'+report.missing+' missing from current database</span>');
    if(report.unknown && !report.changed && !report.missing) parts.push('<span>'+report.unknown+' without version date but title/line count looks OK</span>');
    var details = report.rows.filter(function(r){ return r.status === 'changed' || r.status === 'missing' || r.status === 'noSnapshot'; }).slice(0,8);
    var html = '<div class="tydLib__builderUpdateSummary">' + parts.join(' · ') + '</div>';
    if(details.length){
      html += '<div class="tydLib__builderUpdateList">' + details.map(function(r){
        var t = sectionTitleForBuilder(r.section);
        return '<div class="tydLib__builderUpdateRow '+escapeHtml(r.status)+'"><b>#'+(r.idx+1)+'</b> '+escapeHtml((t.zh ? t.zh+' / ' : '') + (t.en || r.section.item_id || 'Section'))+'<br><span>'+escapeHtml(r.reason)+'</span></div>';
      }).join('') + '</div>';
    }
    return html;
  }
  function renderBuilderUpdateStatus(){
    if(!els.builderUpdateStatus) return;
    var report = builderUpdateReport();
    els.builderUpdateStatus.innerHTML = builderUpdateStatusHtml(report);
    if(els.builderApplyUpdates) els.builderApplyUpdates.disabled = !(report.changed || report.noSnapshot);
  }
  function checkBuilderUpdates(){
    var report = builderUpdateReport();
    renderBuilderUpdateStatus();
    if(!report.libraryItems) setStatus('No official Library sections to check in this saved book.', 'bad');
    else if(report.changed) setStatus(report.changed+' Builder section snapshots can be refreshed.', '');
    else if(report.noSnapshot) setStatus(report.noSnapshot+' Builder sections need saved snapshots.', '');
    else if(report.missing) setStatus('Some Builder sections are missing from the current Library database.', 'bad');
    else setStatus('Builder saved book is current.', 'ok');
  }
  function refreshBuilderChangedSnapshots(){
    var report = builderUpdateReport();
    var changed = 0;
    state.builder.sections = (state.builder.sections || []).map(function(rawSec, idx){
      var sec = normalizeBuilderSection(rawSec);
      var row = report.rows.filter(function(r){ return r.idx === idx; })[0];
      if(sec.type === 'library_item' && row && row.live && (row.status === 'changed' || row.status === 'noSnapshot')){
        sec.snapshot = snapshotForItemId(sec.item_id);
        sec.saved_updated_at = builderLiveVersion(row.live);
        changed++;
      }
      return sec;
    });
    saveBuilderLocal();
    renderBuilder();
    if(isBuilderSelection(state.selectedId)) renderReader();
    setStatus(changed ? ('Refreshed '+changed+' saved Builder snapshots.') : 'No Builder snapshots needed refreshing.', changed ? 'ok' : '');
  }
  function sectionTitleForBuilder(sec){
    sec = normalizeBuilderSection(sec);
    if(sec.type === 'custom_page') return { zh:sec.title_zh || '', en:sec.title_en || (sec.page_kind === 'toc' ? 'Table of Contents' : (sec.page_kind === 'cover' ? 'Cover Page' : (sec.page_kind === 'divider' ? 'Divider Page' : 'Custom Page'))), sub:builderKindLabel(sec.page_kind) };
    var src = builderSourceForSection(sec);
    var item = src && src.item || {};
    return { zh:item.chinese_title || '', en:item.english_title || sec.item_id || '', sub:sec.item_id || '' };
  }
  function builderSectionKey(sec, idx){
    sec = sec || {};
    return cleanDisplayText(sec.uid || sec.item_id || ('idx_' + idx));
  }
  function isBuilderSectionExpanded(sec, idx){
    if(!state.builderExpanded) state.builderExpanded = {};
    return !!state.builderExpanded[builderSectionKey(sec, idx)];
  }
  function setBuilderSectionExpanded(idx, expanded){
    var sec = state.builder.sections && state.builder.sections[idx];
    if(!sec) return;
    if(!state.builderExpanded) state.builderExpanded = {};
    var key = builderSectionKey(sec, idx);
    if(expanded) state.builderExpanded[key] = true;
    else delete state.builderExpanded[key];
    renderBuilder();
  }
  function clearBuilderExpandedState(){
    state.builderExpanded = {};
  }
  function addItemToBuilder(itemId, opts){
    opts = opts || {};
    var item = itemById(itemId);
    if(!item){ setStatus('Cannot add item. It is not loaded.', 'bad'); return; }
    var sec = normalizeBuilderSection({ type:'library_item', item_id:item.item_id, snapshot:snapshotForItemId(item.item_id), saved_updated_at:item.updated_at || item.updated_date || '' });
    state.builder.sections.push(sec);
    saveBuilderLocal();
    renderBuilder();
    if(!opts.silent) setStatus('Added to Book Builder: ' + (item.english_title || item.chinese_title || item.item_id), 'ok');
  }
  function addBookToBuilder(bookId){
    var items = indexedItemsForBook(bookId, state.items);
    if(!items.length){ setStatus('No items found in this book.', 'bad'); return; }
    items.forEach(function(item){ addItemToBuilder(item.item_id, { silent:true }); });
    var book = bookById(bookId);
    var parts = bookTitleParts(book || bookId);
    if((state.builder.title || '') === 'Custom Saam Law Book') state.builder.title = parts.en || parts.zh || state.builder.title;
    saveBuilderLocal();
    renderBuilder();
    setBuilderOpen(true);
    setStatus('Added whole book: '+(parts.en || parts.zh || bookId), 'ok');
  }
  function addCurrentToBuilder(){
    if(isBuilderSelection(state.selectedId)){ setStatus('This custom book is already the Builder preview.', 'bad'); return; }
    if(isBookSelection(state.selectedId)){ addBookToBuilder(selectedBookId()); return; }
    if(state.selectedId) addItemToBuilder(state.selectedId);
    else setStatus('Select an item first, then add it.', 'bad');
  }
  function addCustomPageToBuilder(){
    var sec = normalizeBuilderSection({ type:'custom_page', title_en:'Custom Page', content:{ english:'Type your custom text here.' }, page_break_before:false });
    state.builder.sections.push(sec);
    if(!state.builderExpanded) state.builderExpanded = {}; state.builderExpanded[builderSectionKey(sec, state.builder.sections.length - 1)] = true;
    saveBuilderLocal();
    renderBuilder();
    setStatus('Custom page added to Builder.', 'ok');
  }

  function addBuilderSpecialPage(kind){
    kind = builderPageKindValue(kind);
    var titleEn = kind === 'cover' ? (state.builder.title || 'Cover Page') : (kind === 'divider' ? 'Divider Page' : (kind === 'toc' ? 'Table of Contents' : 'Custom Page'));
    var content = { english:'' };
    if(kind === 'cover') content.english = cleanDisplayText(state.builder.description || '');
    if(kind === 'divider') content.english = 'Type divider note here.';
    var sec = normalizeBuilderSection({ type:'custom_page', page_kind:kind, title_en:titleEn, content:content, page_break_before:(kind === 'cover' ? false : true) });
    state.builder.sections.push(sec);
    if(!state.builderExpanded) state.builderExpanded = {}; state.builderExpanded[builderSectionKey(sec, state.builder.sections.length - 1)] = true;
    saveBuilderLocal();
    renderBuilder();
    setStatus(builderKindLabel(kind).replace(/^./, function(c){ return c.toUpperCase(); }) + ' added to Builder.', 'ok');
  }
  function addCoverPageToBuilder(){ addBuilderSpecialPage('cover'); }
  function addDividerPageToBuilder(){ addBuilderSpecialPage('divider'); }
  function addTocPageToBuilder(){ addBuilderSpecialPage('toc'); }
  function setAllBuilderPageBreaks(on){
    state.builder.sections = (state.builder.sections || []).map(function(sec, idx){
      sec = normalizeBuilderSection(sec);
      sec.page_break_before = !!on && idx > 0;
      return sec;
    });
    saveBuilderLocal();
    renderBuilder();
    if(isBuilderSelection(state.selectedId)) renderReader();
    setStatus(on ? 'Page breaks added before every section.' : 'Page breaks cleared.', 'ok');
  }
  function duplicateBuilderSection(idx){
    var sec = state.builder.sections[idx];
    if(!sec) return;
    var copy = normalizeBuilderSection(builderDeepClone(sec));
    copy.uid = builderUid();
    state.builder.sections.splice(idx + 1, 0, copy);
    saveBuilderLocal(); renderBuilder();
  }
  function moveBuilderSection(idx, delta){
    var j = idx + delta;
    if(j < 0 || j >= state.builder.sections.length) return;
    var a = state.builder.sections.splice(idx, 1)[0];
    state.builder.sections.splice(j, 0, a);
    saveBuilderLocal(); renderBuilder();
    if(isBuilderSelection(state.selectedId)) renderReader();
  }
  function removeBuilderSection(idx){
    if(idx < 0 || idx >= state.builder.sections.length) return;
    state.builder.sections.splice(idx, 1);
    saveBuilderLocal(); renderBuilder();
    if(isBuilderSelection(state.selectedId)) renderReader();
  }

  function moveBuilderSectionTo(fromIdx, toIdx){
    fromIdx = Number(fromIdx); toIdx = Number(toIdx);
    var list = state.builder.sections || [];
    if(!isFinite(fromIdx) || !isFinite(toIdx) || fromIdx < 0 || toIdx < 0 || fromIdx >= list.length || toIdx >= list.length || fromIdx === toIdx) return;
    var sec = list.splice(fromIdx, 1)[0];
    list.splice(toIdx, 0, sec);
    state.builder.sections = list;
    saveBuilderLocal();
    renderBuilder();
    if(isBuilderSelection(state.selectedId)) renderReader();
    setStatus('Builder section moved.', 'ok');
  }
  function builderDragStart(e){
    var handle = e.target && e.target.closest && e.target.closest('[data-builder-drag-handle]');
    if(!handle){ e.preventDefault(); return; }
    var card = handle.closest('[data-builder-idx]');
    if(!card){ e.preventDefault(); return; }
    var idx = Number(card.getAttribute('data-builder-idx'));
    state.builderDragIdx = idx;
    card.classList.add('isDragging');
    try{ e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', String(idx)); }catch(err){}
  }
  function builderDragOver(e){
    var card = e.target && e.target.closest && e.target.closest('[data-builder-idx]');
    if(!card || state.builderDragIdx == null) return;
    e.preventDefault();
    try{ e.dataTransfer.dropEffect = 'move'; }catch(err){}
    var idx = Number(card.getAttribute('data-builder-idx'));
    Array.prototype.forEach.call(els.builderList ? els.builderList.querySelectorAll('.tydLib__builderCard.isDragOver') : [], function(el){ if(el !== card) el.classList.remove('isDragOver'); });
    if(idx !== state.builderDragIdx) card.classList.add('isDragOver');
  }
  function builderDrop(e){
    var card = e.target && e.target.closest && e.target.closest('[data-builder-idx]');
    if(!card || state.builderDragIdx == null) return;
    e.preventDefault();
    var toIdx = Number(card.getAttribute('data-builder-idx'));
    var fromIdx = state.builderDragIdx;
    state.builderDragIdx = null;
    moveBuilderSectionTo(fromIdx, toIdx);
    builderDragEnd();
  }
  function builderDragEnd(){
    state.builderDragIdx = null;
    if(els.builderList) Array.prototype.forEach.call(els.builderList.querySelectorAll('.tydLib__builderCard.isDragging,.tydLib__builderCard.isDragOver'), function(el){ el.classList.remove('isDragging'); el.classList.remove('isDragOver'); });
  }
  function refreshBuilderSnapshotsForExport(){
    state.builder.sections = (state.builder.sections || []).map(function(sec){
      sec = normalizeBuilderSection(sec);
      if(sec.type === 'library_item' && itemById(sec.item_id)) sec.snapshot = snapshotForItemId(sec.item_id);
      return sec;
    });
  }
  function builderExportObject(refreshSnapshots){
    if(refreshSnapshots) refreshBuilderSnapshotsForExport();
    return {
      file_type: BUILDER_FILE_TYPE,
      version: 2,
      id: state.builder.id || builderBookUid(),
      title: state.builder.title || 'Custom Saam Law Book',
      description: state.builder.description || '',
      created_at: state.builder.createdAt || builderNowIso(),
      updated_at: builderNowIso(),
      version_mode: state.builder.versionMode || 'latest',
      default_mode: state.builder.defaultMode || 'chant',
      layout_preset: builderLayoutPresetValue(state.builder.layoutPreset || 'normal'),
      source: 'Saam Law Magic Library',
      sections: (state.builder.sections || []).map(function(sec){ return normalizeBuilderSection(sec); })
    };
  }
  function downloadTextFile(name, text, mime){
    try{
      var blob = new Blob([text], { type:mime || 'text/plain;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = name;
      document.body.appendChild(a); a.click();
      setTimeout(function(){ URL.revokeObjectURL(url); if(a.parentNode) a.parentNode.removeChild(a); }, 600);
    }catch(err){ setStatus('Download failed: '+(err && err.message ? err.message : err), 'bad'); }
  }
  function exportBuilderFile(){
    if(!state.builder.sections.length){ setStatus('Builder is empty.', 'bad'); return; }
    var obj = builderExportObject(true);
    saveBuilderLocal();
    downloadTextFile(builderSlug(obj.title) + '.tydbook', JSON.stringify(obj, null, 2), 'application/json;charset=utf-8');
    setStatus('Current saved book downloaded.', 'ok');
  }
  function exportBuilderLibraryFile(){
    var obj = builderLibraryExportObject(true);
    downloadTextFile('tyd-builder-saved-books-backup.tydbooks', JSON.stringify(obj, null, 2), 'application/json;charset=utf-8');
    setStatus('All saved Builder books downloaded.', 'ok');
  }
  function builderImportAsNewBook(obj){
    var b = normalizeBuilderFile(obj);
    b.id = builderBookUid();
    b.createdAt = b.createdAt || builderNowIso();
    b.updatedAt = builderNowIso();
    state.builderLibrary.books.push(b);
    state.builderLibrary.activeId = b.id;
    state.builder = normalizeBuilderFile(b);
    state.builder.open = true;
    clearBuilderExpandedState();
    saveBuilderLocal();
    renderBuilder();
    setBuilderOpen(true);
    setStatus('Imported as new saved book: '+state.builder.title, 'ok');
  }
  function builderReplaceCurrentBook(obj){
    var wasOpen = !!state.builder.open;
    var currentId = state.builder.id || builderBookUid();
    var b = normalizeBuilderFile(obj, currentId);
    b.id = currentId;
    b.updatedAt = builderNowIso();
    state.builder = b;
    state.builder.open = wasOpen;
    clearBuilderExpandedState();
    saveBuilderLocal();
    renderBuilder();
    setBuilderOpen(true);
    if(isBuilderSelection(state.selectedId)) renderReader();
    setStatus('Current saved book replaced from import.', 'ok');
  }
  function builderImportLibrary(obj){
    var incoming = normalizeBuilderLibrary(obj).books || [];
    if(!incoming.length){ throw new Error('No saved books found in backup.'); }
    incoming.forEach(function(book){
      var b = normalizeBuilderFile(book);
      b.id = builderBookUid();
      b.updatedAt = builderNowIso();
      state.builderLibrary.books.push(b);
    });
    state.builderLibrary.activeId = state.builderLibrary.books[state.builderLibrary.books.length - incoming.length].id;
    state.builder = normalizeBuilderFile(state.builderLibrary.books.filter(function(book){ return book.id === state.builderLibrary.activeId; })[0]);
    state.builder.open = true;
    clearBuilderExpandedState();
    saveBuilderLocal();
    renderBuilder();
    setBuilderOpen(true);
    setStatus('Imported '+incoming.length+' saved books into Builder.', 'ok');
  }
  function importBuilderText(text){
    var obj = JSON.parse(text);
    if(obj.file_type === BUILDER_LIBRARY_FILE_TYPE || obj.books || obj.saved_books){ builderImportLibrary(obj); return; }
    if(obj.file_type && obj.file_type !== BUILDER_FILE_TYPE) throw new Error('This is not a TYD Book Builder file.');
    var asNew = true;
    if(window.confirm){ asNew = window.confirm('Import this .tydbook as a new saved book? Press Cancel to replace the currently opened saved book.'); }
    if(asNew) builderImportAsNewBook(obj); else builderReplaceCurrentBook(obj);
  }
  function importBuilderFile(file){
    if(!file) return;
    var reader = new FileReader();
    reader.onload = function(){ try{ importBuilderText(String(reader.result || '')); }catch(err){ setStatus('Import failed: '+(err && err.message ? err.message : err), 'bad'); } };
    reader.readAsText(file);
  }
  function splitBuilderTextLines(text){
    return String(text || '').replace(/\r\n/g,'\n').split('\n').map(function(x){ return cleanDisplayText(x).trim(); }).filter(Boolean);
  }
  function customRowsForSection(sec){
    sec = normalizeBuilderSection(sec);
    if(sec.page_kind === 'toc') return [];
    var c = sec.content || {};
    var zh = splitBuilderTextLines(c.chinese);
    var saam = splitBuilderTextLines(c.saamlawnese);
    var en = splitBuilderTextLines(c.english || c.notes);
    var n = Math.max(zh.length, saam.length, en.length);
    var rows = [];
    for(var i=0;i<n;i++) rows.push({ item_id:sec.uid, line_no:i+1, chinese:zh[i] || '', saamlawnese:saam[i] || '', english_translation:en[i] || '' });
    return rows;
  }
  function renderCustomBuilderLine(l, mode){
    mode = mode || state.mode || 'chant';
    var html = '<div class="tydLib__chantLine mode-'+escapeHtml(mode)+'">';
    if(mode === 'chinese'){
      if(l.chinese) html += '<div class="tydLib__zh">'+escapeHtml(cleanLineText(l.chinese || ''))+'</div>';
      html += '</div>'; return html;
    }
    if(mode === 'english'){
      if(l.english_translation) html += '<div class="tydLib__en tydLib__enOnly">'+escapeHtml(cleanLineText(l.english_translation || ''))+'</div>';
      html += '</div>'; return html;
    }
    if(l.chinese) html += '<div class="tydLib__zh">'+escapeHtml(cleanLineText(l.chinese || ''))+'</div>';
    if(mode !== 'study' && l.saamlawnese) html += '<div class="tydLib__saam">'+escapeHtml(cleanLineText(l.saamlawnese || ''))+'</div>';
    if(mode !== 'chant' && l.english_translation) html += '<div class="tydLib__en">'+escapeHtml(cleanLineText(l.english_translation || ''))+'</div>';
    if(mode === 'chant' && !l.chinese && !l.saamlawnese && l.english_translation) html += '<div class="tydLib__en tydLib__enOnly">'+escapeHtml(cleanLineText(l.english_translation || ''))+'</div>';
    html += '</div>'; return html;
  }

  function builderSectionTitleText(sec, idx){
    sec = normalizeBuilderSection(sec);
    var t = sectionTitleForBuilder(sec);
    var label = (t.zh && t.en) ? (t.zh + ' / ' + t.en) : (t.zh || t.en || ('Section ' + (idx + 1)));
    return cleanDisplayText(label || ('Section ' + (idx + 1)));
  }
  function builderTocHtml(currentUid){
    var rows = (state.builder.sections || []).map(function(sec, idx){ return { sec:normalizeBuilderSection(sec), idx:idx }; }).filter(function(x){ return x.sec.uid !== currentUid && !(x.sec.type === 'custom_page' && x.sec.page_kind === 'cover'); });
    if(!rows.length) return '<div class="tydLib__customPageNote">No sections yet.</div>';
    return '<ol class="tydLib__builderTocList">' + rows.map(function(x){ return '<li><span class="tydLib__builderTocNum">'+(x.idx+1)+'</span><span>'+escapeHtml(builderSectionTitleText(x.sec, x.idx))+'</span></li>'; }).join('') + '</ol>';
  }
  function renderCustomBuilderSection(sec){
    sec = normalizeBuilderSection(sec);
    var kind = builderPageKindValue(sec.page_kind);
    var fake = { chinese_title:sec.title_zh || '', english_title:sec.title_en || (kind === 'toc' ? 'Table of Contents' : (kind === 'cover' ? (state.builder.title || 'Cover Page') : (kind === 'divider' ? 'Divider Page' : 'Custom Page'))), item_id:sec.uid };
    var sectionClass = 'tydLib__bookSection' + (sec.page_break_before?' pageBreakBefore':'') + (kind !== 'custom' ? ' tydLib__builderSpecialPage tydLib__builderSpecialPage--'+kind : '');
    var section = '<section class="'+sectionClass+'">';
    if(kind === 'cover'){
      var parts = builderTitleParts();
      var coverZh = sec.title_zh || parts.zh || '';
      var coverEn = sec.title_en || parts.en || state.builder.title || 'Custom Saam Law Book';
      section += '<div class="tydLib__builderCoverInner">' + titleBlockHtml(coverZh, coverEn, 'Custom Book') + '<div class="tydLib__builderCoverMeta">Tin Yat Lineage · Saam Law Magic Library</div>';
      var coverRows = customRowsForSection(sec);
      if(coverRows.length) section += '<div class="tydLib__builderCoverNotes">' + coverRows.map(function(l){ return renderCustomBuilderLine(l, state.mode); }).join('') + '</div>';
      else if(state.builder.description) section += '<div class="tydLib__builderCoverNotes"><div class="tydLib__en tydLib__enOnly">'+escapeHtml(state.builder.description)+'</div></div>';
      section += '</div></section>';
      return section;
    }
    if(kind === 'divider'){
      section += '<div class="tydLib__builderDividerInner">' + sectionTitleHtml(fake);
      var dividerRows = customRowsForSection(sec);
      if(dividerRows.length) section += dividerRows.map(function(l){ return renderCustomBuilderLine(l, state.mode); }).join('');
      section += '</div></section>';
      return section;
    }
    if(kind === 'toc'){
      section += sectionTitleHtml(fake) + builderTocHtml(sec.uid) + '</section>';
      return section;
    }
    var rows = customRowsForSection(sec);
    section += sectionTitleHtml(fake);
    if(rows.length){ section += rows.map(function(l){ return renderCustomBuilderLine(l, state.mode); }).join(''); }
    else { section += '<div class="tydLib__customPageNote">Blank custom page.</div>'; }
    section += '</section>';
    return section;
  }
  function renderBuilderLibrarySection(sec){
    sec = normalizeBuilderSection(sec);
    var src = builderSourceForSection(sec);
    var item = Object.assign({}, src && src.item || { item_id:sec.item_id, english_title:sec.item_id });
    var rows = src && src.rows || [];
    if(sec.title_override){
      if(builderHasCjk(sec.title_override)) item.chinese_title = sec.title_override;
      else item.english_title = sec.title_override;
    }
    var html = renderSection(item, rows);
    if(sec.page_break_before) html = html.replace('tydLib__bookSection', 'tydLib__bookSection pageBreakBefore');
    return html;
  }
  function builderSectionHtml(sec){
    sec = normalizeBuilderSection(sec);
    return sec.type === 'custom_page' ? renderCustomBuilderSection(sec) : renderBuilderLibrarySection(sec);
  }
  function builderSectionsHtml(){ return (state.builder.sections || []).map(builderSectionHtml).join(''); }
  function builderLineCount(){
    return (state.builder.sections || []).reduce(function(n, sec){
      sec = normalizeBuilderSection(sec);
      if(sec.type === 'custom_page') return n + customRowsForSection(sec).length;
      var src = builderSourceForSection(sec); return n + ((src && src.rows && src.rows.length) || 0);
    }, 0);
  }
  function builderTitleParts(){
    var t = cleanDisplayText(state.builder.title || 'Custom Saam Law Book');
    return builderHasCjk(t) ? { zh:t, en:'Custom Book' } : { zh:'', en:t || 'Custom Saam Law Book' };
  }
  function renderBuilderReader(){
    ++state._readerRenderToken;
    root.classList.remove('tydLib--readerRendering');
    if(!state.builder.sections.length){
      els.reader.innerHTML = '<div class="tydLib__empty"><h2>Book Builder is empty</h2><p>Search the library and click + to add items, or open Builder and add a custom page.</p></div>';
      setReaderMeta(''); return;
    }
    var parts = builderTitleParts();
    var desc = cleanDisplayText(state.builder.description || '');
    var contentHtml = '<div class="tydLib__book tydLib__builderBook '+builderLayoutClass()+'">' + (desc ? '<div class="tydLib__note">'+escapeHtml(desc)+'</div>' : '') + builderSectionsHtml() + '</div>';
    els.reader.innerHTML = '<div class="tydLib__readerTop"><div>' + titleBlockHtml(parts.zh, parts.en, 'Custom Book') + '</div>'+readerButtonsHtml()+'</div>' + contentHtml + '<div class="tydLib__small">Source: TYD Book Builder local saved book</div>';
    setReaderMeta(readerMetaHtml(['saved custom book', state.builder.sections.length+' sections', builderLineCount()+' lines', readerModeLabel(), builderLayoutLabel(), state.builder.versionMode === 'snapshot' ? 'saved snapshot text' : 'latest library text']));
  }
  function previewBuilder(){
    if(!state.builder.sections.length){ setStatus('Builder is empty. Add some items first.', 'bad'); setBuilderOpen(true); return; }
    if(state.builder.defaultMode && MODE_ORDER.indexOf(state.builder.defaultMode) !== -1) state.mode = state.builder.defaultMode;
    saveBuilderLocal();
    state.selectedId = BUILDER_SELECTION_ID;
    setBuilderOpen(false);
    renderReader();
    setStatus('Showing saved custom Builder book.', 'ok');
    try{ history.replaceState(null,'','#'+encodeURIComponent(BUILDER_SELECTION_ID)); }catch(err){}
  }
  function renderBuilder(){
    syncBuilderInputs();
    renderBuilderUpdateStatus();
    if(!els.builderList) return;
    var sections = state.builder.sections || [];
    if(els.builderCount){
      var total = state.builderLibrary && state.builderLibrary.books ? state.builderLibrary.books.length : 1;
      els.builderCount.textContent = total + (total === 1 ? ' saved book · ' : ' saved books · ') + sections.length + (sections.length === 1 ? ' section' : ' sections') + ' · ' + builderLayoutLabel();
    }
    if(!sections.length){
      els.builderList.innerHTML = '<div class="tydLib__builderEmpty">No sections yet. Search the library and click + beside an item, or add a custom page.</div>';
      return;
    }
    els.builderList.innerHTML = sections.map(function(sec, idx){
      sec = normalizeBuilderSection(sec);
      var title = sectionTitleForBuilder(sec);
      var expanded = isBuilderSectionExpanded(sec, idx);
      var cardClass = 'tydLib__builderCard' + (expanded ? ' isExpanded' : ' isCollapsed');
      var zhTitle = title.zh || (sec.type === 'custom_page' ? 'Custom Page' : '');
      var enTitle = title.en || title.sub || 'Section';
      var html = '<article class="'+cardClass+'" data-builder-idx="'+idx+'">';
      html += '<div class="tydLib__builderCardHead" data-builder-toggle="1" title="Click to expand/collapse" aria-expanded="'+(expanded?'true':'false')+'"><button type="button" class="tydLib__builderDragHandle" data-builder-drag-handle="1" draggable="true" title="Drag to sort" aria-label="Drag to sort">☰</button><div class="tydLib__builderIndex">'+(idx+1)+'</div><div class="tydLib__builderCardTitle" title="'+escapeHtml((zhTitle ? zhTitle + ' / ' : '') + enTitle)+'"><div class="tydLib__builderCardZh">'+escapeHtml(zhTitle)+'</div><div class="tydLib__builderCardEn">'+escapeHtml(enTitle)+'</div></div>';
      html += '<div class="tydLib__builderMiniActions"><button type="button" data-builder-action="up" title="Move up">↑</button><button type="button" data-builder-action="down" title="Move down">↓</button><button type="button" data-builder-action="duplicate" title="Duplicate">⧉</button><button type="button" data-builder-action="remove" title="Remove">×</button></div></div>';
      html += '<div class="tydLib__builderCardBody" '+(expanded?'':'hidden')+'>';
      html += '<label>Section title override</label><input type="text" data-builder-field="title_override" value="'+escapeHtml(sec.title_override || '')+'" placeholder="Optional custom title for this section">';
      html += '<label class="tydLib__builderCheck"><input type="checkbox" data-builder-field="page_break_before" '+(sec.page_break_before?'checked':'')+'> Start on new printed page</label>';
      if(sec.type === 'custom_page'){
        html += '<div class="tydLib__meta"><span class="tydLib__tag">'+escapeHtml(builderKindLabel(sec.page_kind))+'</span></div>';
        html += '<label>Page type</label><select data-builder-field="page_kind"><option value="custom" '+(sec.page_kind==='custom'?'selected':'')+'>Custom page</option><option value="cover" '+(sec.page_kind==='cover'?'selected':'')+'>Cover page</option><option value="divider" '+(sec.page_kind==='divider'?'selected':'')+'>Divider page</option><option value="toc" '+(sec.page_kind==='toc'?'selected':'')+'>Table of contents</option></select>';
        html += '<div class="tydLib__builderSmallGrid"><div><label>Chinese title</label><input type="text" data-builder-field="title_zh" value="'+escapeHtml(sec.title_zh || '')+'"></div><div><label>English title</label><input type="text" data-builder-field="title_en" value="'+escapeHtml(sec.title_en || '')+'"></div></div>';
        if(sec.page_kind === 'toc'){
          html += '<div class="tydLib__builderHint mini">The table of contents is generated from the current section order when you read, print, or download the book.</div>';
        }else{
          html += '<label>Chinese text</label><textarea rows="3" data-builder-field="content.chinese">'+escapeHtml(sec.content && sec.content.chinese || '')+'</textarea>';
          html += '<label>Saamlawnese text</label><textarea rows="3" data-builder-field="content.saamlawnese">'+escapeHtml(sec.content && sec.content.saamlawnese || '')+'</textarea>';
          html += '<label>English text / notes</label><textarea rows="3" data-builder-field="content.english">'+escapeHtml(sec.content && sec.content.english || '')+'</textarea>';
        }
      }else{
        html += '<div class="tydLib__builderHint mini">Library item loaded from the Saam Law Magic Library. Use title override only if you want this section to display a different title in your custom book.</div>';
      }
      html += '</div></article>';
      return html;
    }).join('');
  }
  function handleBuilderFieldInput(target){
    if(!target) return;
    if(target === els.builderBookSelect){ return; }
    if(target === els.builderTitle){ state.builder.title = cleanDisplayText(target.value || ''); if(els.builderTemplateId && els.builderTemplateId.getAttribute('data-auto-template-id') === '1') els.builderTemplateId.value = builderTemplateIdFromTitle(state.builder.title || 'Custom Saam Law Book'); saveBuilderLocal(); if(isBuilderSelection(state.selectedId)) scheduleRenderCurrent(180); return; }
    if(target === els.builderDesc){ state.builder.description = cleanDisplayText(target.value || ''); saveBuilderLocal(); if(isBuilderSelection(state.selectedId)) scheduleRenderCurrent(180); return; }
    if(target === els.builderVersionMode){ state.builder.versionMode = target.value === 'snapshot' ? 'snapshot' : 'latest'; saveBuilderLocal(); if(isBuilderSelection(state.selectedId)) renderReader(); return; }
    if(target === els.builderDefaultMode){ state.builder.defaultMode = target.value || 'chant'; saveBuilderLocal(); return; }
    if(target === els.builderLayoutPreset){ state.builder.layoutPreset = builderLayoutPresetValue(target.value || 'normal'); saveBuilderLocal(); renderBuilder(); if(isBuilderSelection(state.selectedId)) renderReader(); return; }
    var card = target.closest && target.closest('[data-builder-idx]');
    if(!card) return;
    var idx = Number(card.getAttribute('data-builder-idx'));
    var sec = state.builder.sections[idx];
    if(!sec) return;
    var field = target.getAttribute('data-builder-field');
    if(!field) return;
    if(field === 'page_break_before') sec.page_break_before = !!target.checked;
    else if(field === 'page_kind') sec.page_kind = builderPageKindValue(target.value || 'custom');
    else if(field.indexOf('content.') === 0){ sec.content = sec.content || {}; sec.content[field.split('.')[1]] = cleanDisplayText(target.value || ''); }
    else sec[field] = cleanDisplayText(target.value || '');
    state.builder.sections[idx] = normalizeBuilderSection(sec);
    saveBuilderLocal();
    if(isBuilderSelection(state.selectedId)) scheduleRenderCurrent(220);
  }
  function builderHtmlDocument(){
    if(!state.builder.sections.length) return '';
    var oldMode = state.mode;
    if(state.builder.defaultMode && MODE_ORDER.indexOf(state.builder.defaultMode) !== -1) state.mode = state.builder.defaultMode;
    var parts = builderTitleParts();
    var title = parts.zh || parts.en || 'Custom Saam Law Book';
    var desc = cleanDisplayText(state.builder.description || '');
    var body = (desc ? '<div class="note">'+escapeHtml(desc)+'</div>' : '') + builderSectionsHtml();
    var modeLabel = readerModeLabel();
    var layout = builderLayoutPresetValue(state.builder.layoutPreset || 'normal');
    var layoutClass = 'layout-' + layout;
    state.mode = oldMode;
    return '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>'+escapeHtml(title)+'</title><style>body{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;max-width:880px;margin:0 auto;padding:28px 18px;color:#151515;background:#fff}h1{text-align:center;font-size:32px;margin:0 0 6px}.sub{text-align:center;color:#666;margin-bottom:24px}.note{border:1px solid #ddd;background:#fff8ef;border-radius:14px;padding:14px;margin:0 0 20px;white-space:pre-wrap}.tydLib__bookSection{break-inside:avoid-page;page-break-inside:avoid;margin:0 0 26px;padding:0 0 16px;border-bottom:1px solid #ddd;text-align:center}.tydLib__bookSection.pageBreakBefore{break-before:page;page-break-before:always}.tydLib__sectionTitleZh{font-size:30px;line-height:1.2;margin:0 0 4px;letter-spacing:.08em}.tydLib__sectionTitleEn{font-size:17px;color:#555;font-weight:700;margin:0 0 10px}.tydLib__chantLine{padding:7px 0 10px;border-bottom:1px solid #eee;text-align:center}.tydLib__zh{font-size:28px;line-height:1.35;font-weight:750;white-space:pre-wrap;letter-spacing:.05em}.tydLib__saam{font-size:19px;line-height:1.38;font-weight:700;color:#7b2c05;white-space:pre-wrap}.tydLib__en,.tydLib__enOnly{font-size:17px;line-height:1.48;color:#222;white-space:pre-wrap}.tydLib__itemImage{max-width:420px;margin:12px auto}.tydLib__itemImage img{max-width:100%;height:auto;border-radius:12px}.tydLib__builderSpecialPage--cover{min-height:78vh;display:flex;align-items:center;justify-content:center;border-bottom:0}.tydLib__builderCoverMeta{margin-top:16px;font-weight:700;color:#777}.tydLib__builderSpecialPage--divider{min-height:55vh;display:flex;align-items:center;justify-content:center;border-bottom:0}.tydLib__builderTocList{max-width:680px;margin:18px auto;text-align:left;font-size:16px;line-height:1.45}.tydLib__builderTocList li{display:grid;grid-template-columns:42px 1fr;gap:10px;padding:8px 0;border-bottom:1px solid #eee}.layout-compact .tydLib__bookSection{margin-bottom:14px;padding-bottom:8px}.layout-compact .tydLib__chantLine{padding:3px 0 5px}.layout-compact .tydLib__zh{font-size:23px;line-height:1.22}.layout-compact .tydLib__saam{font-size:15px;line-height:1.25}.layout-compact .tydLib__en{font-size:14px;line-height:1.32}.layout-compact .tydLib__sectionTitleZh{font-size:24px}.layout-chant-large .tydLib__zh{font-size:34px}.layout-chant-large .tydLib__saam{font-size:23px}.layout-chant-large .tydLib__chantLine{padding:10px 0 13px}@media print{@page{margin:.5in}body{max-width:none;padding:0}.tydLib__bookSection{margin-bottom:20px}.layout-compact .tydLib__bookSection{break-inside:auto;page-break-inside:auto}}</style></head><body class="'+escapeHtml(layoutClass)+'"><h1>'+escapeHtml(title)+'</h1><div class="sub">Tin Yat Lineage · Saam Law Magic Library · '+escapeHtml(modeLabel)+' · '+escapeHtml(builderLayoutLabel(layout))+'</div>'+body+'</body></html>';
  }
  function downloadBuilderHtml(){
    if(!state.builder.sections.length){ setStatus('Builder is empty.', 'bad'); return; }
    saveBuilderLocal();
    var html = builderHtmlDocument();
    downloadTextFile(builderSlug(state.builder.title || 'custom-book') + '.html', html, 'text/html;charset=utf-8');
    setStatus('Standalone HTML book downloaded.', 'ok');
  }


  function readerMetaHtml(parts){
    return '<div class="tydLib__meta">' + (parts || []).filter(Boolean).map(function(part){
      var cls = part.warn ? 'tydLib__tag warn' : 'tydLib__tag';
      return '<span class="'+cls+'">'+escapeHtml(part.text || part)+'</span>';
    }).join('') + '</div>';
  }

  function setReaderMeta(html){
    if(!els.readerMeta) return;
    if(!html){ els.readerMeta.innerHTML = ''; els.readerMeta.hidden = true; return; }
    els.readerMeta.innerHTML = html;
    els.readerMeta.hidden = false;
  }

  function readerButtonsHtml(){
    return '<div class="tydLib__readerBtns tydLib__readerBtns--collapsed">' +
      readerActionsMenuHtml('tydLib__mainReaderActionMenu',
        '<button class="tydLib__btn secondary tydLib__chantModeBtn" type="button" id="tydChantMode" aria-label="Open focused view" title="Focused view">👁</button>' +
        readModeButtonHtml() + zhFontButtonHtml() + readerSizeButtonHtml() +
        '<button class="tydLib__btn secondary tydLib__readerAddBtn" type="button" id="tydBuilderAddCurrent" aria-label="Add current reader content to Book Builder" title="Add to Book Builder">+</button>' +
        '<button class="tydLib__btn secondary tydLib__quickShelfHeartBtn '+(quickShelfCurrentIcon()==='♥'?'active':'')+'" type="button" id="tydQuickShelfCurrent" aria-label="'+escapeHtml(quickShelfCurrentTitle())+'" title="'+escapeHtml(quickShelfCurrentTitle())+'">'+quickShelfCurrentIcon()+'</button>' +
        quickShelfBookCurrentButtonHtml() +
        '<button class="tydLib__btn secondary tydLib__copyBtn" type="button" id="tydCopyCurrent" aria-label="Copy current reading mode" title="Copy current reading mode">⧉</button>' +
        '<button class="tydLib__btn secondary tydLib__printBtn" type="button" id="tydPrintCurrent" aria-label="Print or save PDF" title="Print / Save PDF">🖨</button>' +
        '<button class="tydLib__btn secondary tydLib__kpdfBtn" type="button" id="tydKpdfCurrent" aria-label="Make Kindle PDF" title="K-PDF Kindle preview">K-PDF</button>' +
        '<button class="tydLib__btn secondary tydLib__deepLinkBtn" type="button" id="tydCopyDeepLink" aria-label="Copy deep link" title="Copy exact page link">Link</button>'
      ) +
      '</div>';
  }

  function bookSectionsHtml(items, start, end){
    return (items || []).slice(start || 0, end == null ? undefined : end).map(function(item){
      try{
        return renderSection(item, lineRows(item && item.item_id));
      }catch(err){
        try{ console.warn('[TYD Library] Section render skipped:', item && item.item_id, err); }catch(e){}
        return '<section class="tydLib__bookSection tydLib__bookSection--error">' +
          '<div class="tydLib__note warn">This section could not render cleanly. Item: '+escapeHtml(item && item.item_id || 'unknown')+'</div>' +
          '</section>';
      }
    }).join('');
  }
  function shouldProgressivelyRenderBook(items, totalLines){
    // v115 hard fix: no progressive/chunked reader for scriptures/books.
    // Long books must render as one full reader view so disciples can scroll the whole book.
    return false;
  }
  function appendBookSectionChunks(token, body, progress, items, start, totalLines){
    // v115 safety fallback: even if old code accidentally calls the chunk appender,
    // finish the remaining book immediately instead of leaving the reader stuck at the first chunk.
    try{
      var list = items || [];
      var pos = Math.max(0, Number(start || 0));
      if(body && body.isConnected && pos < list.length){
        var html = bookSectionsHtml(list, pos, list.length);
        if(html) body.insertAdjacentHTML('beforeend', html);
      }
    }catch(err){
      try{ console.error('[TYD Library] Full-book fallback render failed:', err); }catch(e){}
    }
    try{ if(progress && progress.parentNode) progress.parentNode.removeChild(progress); }catch(e2){}
    if(token === state._readerRenderToken) root.classList.remove('tydLib--readerRendering');
  }

  function renderBookReader(bookId){
    var book = bookById(bookId);
    var items = indexedItemsForBook(bookId, state.items);
    var needIds = items.map(function(item){ return item && item.item_id; }).filter(Boolean);
    if(!ensureLinesForItems(needIds, 'Opening book text...', bookId)) return;
    var token = ++state._readerRenderToken;
    var totalLines = items.reduce(function(n, item){ return n + lineRows(item.item_id).length; }, 0);
    var bookParts = bookTitleParts(book || bookId);
    var contentHtml = '<div class="tydLib__book" data-book-render-body="1">' + bookSectionsHtml(items, 0, items.length) + '</div>';
    root.classList.remove('tydLib--readerRendering');
    els.reader.innerHTML = '<div class="tydLib__readerTop"><div>' +
      titleBlockHtml(bookParts.zh || '', bookParts.en || '', bookParts.fallback || bookId) +
      '</div>'+readerButtonsHtml()+'</div>' +
      contentHtml + '<div class="tydLib__small">Source: '+escapeHtml(book && book.file_name ? book.file_name : 'Google Sheet')+'</div>';
    setReaderMeta(readerMetaHtml(['whole book', items.length+' items', totalLines+' lines', readerModeLabel(), 'full-book mode']));
  }

  function renderReader(){
    if(isQuickShelfDirectory() || isQuickShelfSelection(state.selectedId)){
      renderQuickShelfReader(quickShelfEntryBySelection(state.selectedId));
      return;
    }
    if(isCollectionDirectory()){
      renderCollectionReader_(collectionBySelection_(state.selectedId));
      return;
    }
    if(isBuilderSelection(state.selectedId)){
      renderBuilderReader();
      return;
    }
    if(isBookSelection(state.selectedId)){
      if(!bookAllowedByAcg_(selectedBookId())){
        els.reader.innerHTML = acgLimitedReaderHtml_();
        setReaderMeta('Daily Rite only');
        return;
      }
      renderBookReader(selectedBookId());
      return;
    }
    if(isGodDirectory() && isGodSelection(state.selectedId)){
      renderGodReader(godEntryById(state.selectedId));
      return;
    }
    if(isRcDirectory() && isRcSelection(state.selectedId)){
      renderRcReader(rcEntryById(state.selectedId));
      return;
    }
    ++state._readerRenderToken;
    root.classList.remove('tydLib--readerRendering');
    var item = itemById(state.selectedId);
    if(!item){
      els.reader.innerHTML = '<div class="tydLib__empty"><h2>Select an item</h2><p>Choose something from the directory or search directly.</p></div>';
      setReaderMeta('');
      return;
    }
    if(!ensureLinesForItems([item.item_id], 'Opening item text from local cache...')) return;
    var rows = lineRows(item.item_id);
    var readerNote = readerNoteText(item);
    var notes = (readerNote && state.mode === 'dictionary' && !itemHasImage(item)) ? '<div class="tydLib__note">'+escapeHtml(readerNote)+'</div>' : '';
    var contentHtml = '';
    if(state.mode === 'dictionary'){
      contentHtml = '<div class="tydLib__dictLines">' + rows.map(renderDictionaryLine).join('') + '</div>';
    }else{
      contentHtml = '<div class="tydLib__book">' + rows.map(function(l){ return renderBookLine(l, state.mode); }).join('') + '</div>';
    }
    els.reader.innerHTML = '<div class="tydLib__readerTop"><div>' +
      titleBlockHtml(item.chinese_title || '', item.english_title || '', item.item_id || '') +
      '</div>'+readerButtonsHtml()+'</div>' +
      notes + itemImageHtml(item) + itemImageDetailHtml(item) + contentHtml + '<div class="tydLib__small">Source: '+escapeHtml(item.first_source_book || 'Google Sheet')+'</div>';
    setReaderMeta(readerMetaHtml([
      item.type || '',
      prettyCategory(categoryForItem(item)),
      rows.length+' lines',
      readerModeLabel(),
      hasReview(item.item_id) ? {text:'review lines', warn:true} : ''
    ]));
  }

  function chantModeForCurrentReader(){
    var mode = state.mode || 'chant';
    if(mode === 'dictionary') mode = 'chant';
    if(['chant','full','study','chinese','english'].indexOf(mode) === -1) mode = 'chant';
    return mode;
  }

  function chantChunkSize(mode){
    if(mode === 'full') return 4;
    if(mode === 'english') return 5;
    if(mode === 'chinese') return 7;
    if(mode === 'study') return 5;
    return 5;
  }

  function titleForChant(zh, en, fallback, mode){
    zh = zh || ''; en = en || ''; fallback = fallback || '';
    if(mode === 'chinese') return { main: zh || fallback || 'Book', sub: '' };
    if(mode === 'english') return { main: en || fallback || 'Book', sub: '' };
    return { main: zh || fallback || 'Book', sub: en || '' };
  }

  function pushChantPagesForItem(pages, item, rows, bookLabel, mode){
    if(!item) return;
    rows = rows || [];
    var size = chantChunkSize(mode);
    var title = titleForChant(item.chinese_title || '', item.english_title || '', item.item_id || '', mode);
    var image = itemImageData(item);
    if(image){
      pages.push({
        bookLabel: bookLabel || '', sectionMain: title.main, sectionSub: title.sub,
        image: image, lines: [], mode: mode, part: 0, parts: Math.max(1, Math.ceil(rows.length / size))
      });
    }
    if(!rows.length) return;
    for(var i=0;i<rows.length;i+=size){
      pages.push({
        bookLabel: bookLabel || '', sectionMain: title.main, sectionSub: title.sub,
        lines: rows.slice(i, i + size), mode: mode,
        part: Math.floor(i / size) + 1,
        parts: Math.ceil(rows.length / size)
      });
    }
  }

  function pushQuickShelfChantPages(pages, entry, mode){
    if(!entry) return false;
    var linesByItem = entry.lines_by_item || {};
    if(entry.kind === 'book'){
      var parts = quickShelfBookTitleParts(entry);
      var labelObj = titleForChant(parts.zh || '', parts.en || '', parts.fallback || entry.id || 'Quick Shelf Book', mode);
      var bookLabel = labelObj.main + (labelObj.sub ? ' / ' + labelObj.sub : '');
      var qsItemId = quickShelfItemIdFromSelection(state.selectedId);
      var items = entry.items || [];
      if(qsItemId){
        var qsItem = items.filter(function(it){ return String(it && it.item_id || '') === String(qsItemId); })[0];
        if(qsItem){
          pushChantPagesForItem(pages, qsItem, linesByItem[qsItem.item_id] || [], bookLabel, mode);
          return true;
        }
      }
      items.forEach(function(item){
        if(item) pushChantPagesForItem(pages, item, linesByItem[item.item_id] || [], bookLabel, mode);
      });
      return true;
    }
    var iparts = quickShelfItemTitleParts(entry);
    var item = Object.assign({}, entry.item || { item_id:entry.id, english_title:entry.title_en || entry.id, chinese_title:entry.title_zh || '' });
    if(!item.chinese_title && iparts.zh) item.chinese_title = iparts.zh;
    if(!item.english_title && iparts.en) item.english_title = iparts.en;
    var itemId = item.item_id || entry.id;
    pushChantPagesForItem(pages, item, linesByItem[itemId] || [], '', mode);
    return true;
  }

  function buildChantPages(){
    var mode = chantModeForCurrentReader();
    var pages = [];
    if(isBuilderSelection(state.selectedId)){
      var bp = builderTitleParts();
      var labelObj0 = titleForChant(bp.zh || '', bp.en || '', 'Custom Book', mode);
      var builderLabel = labelObj0.main + (labelObj0.sub ? ' / ' + labelObj0.sub : '');
      (state.builder.sections || []).forEach(function(sec){
        sec = normalizeBuilderSection(sec);
        if(sec.type === 'custom_page'){
          var fake = { item_id:sec.uid, chinese_title:sec.title_zh || '', english_title:sec.title_en || 'Custom Page' };
          pushChantPagesForItem(pages, fake, customRowsForSection(sec), builderLabel, mode);
        }else{
          var src = builderSourceForSection(sec);
          var item = Object.assign({}, (src && src.item) || { item_id:sec.item_id, english_title:sec.item_id });
          if(sec.title_override){ if(builderHasCjk(sec.title_override)) item.chinese_title = sec.title_override; else item.english_title = sec.title_override; }
          pushChantPagesForItem(pages, item, (src && src.rows) || [], builderLabel, mode);
        }
      });
      return pages;
    }
    if(isGodDirectory() && isGodSelection(state.selectedId)){
      pushGodFocusPages(pages, godEntryById(state.selectedId));
      return pages;
    }
    if(isRcDirectory() && isRcSelection(state.selectedId)){
      pushRcFocusPages(pages, rcEntryById(state.selectedId));
      return pages;
    }
    if(isQuickShelfSelection(state.selectedId)){
      pushQuickShelfChantPages(pages, quickShelfEntryBySelection(state.selectedId), mode);
      return pages;
    }
    if(isBookSelection(state.selectedId)){
      var bookId = selectedBookId();
      var book = bookById(bookId);
      var parts = bookTitleParts(book || bookId);
      var labelObj = titleForChant(parts.zh || '', parts.en || '', parts.fallback || bookId, mode);
      var bookLabel = labelObj.main + (labelObj.sub ? ' / ' + labelObj.sub : '');
      indexedItemsForBook(bookId, state.items).forEach(function(item){ pushChantPagesForItem(pages, item, lineRows(item.item_id), bookLabel, mode); });
      return pages;
    }
    var item = state.items.find(function(i){ return i.item_id === state.selectedId; });
    if(item) pushChantPagesForItem(pages, item, lineRows(item.item_id), '', mode);
    return pages;
  }

  function renderChantPage(){
    if(!els.chantPageEl) return;
    var total = state.chantPages.length;
    if(!total){
      els.chantPageEl.innerHTML = '<div class="tydLib__empty"><h2>No chant content</h2><p>Select a book or item first.</p></div>';
      if(els.chantProgress) els.chantProgress.innerHTML = '<div class="tydLib__chantProgressTrack"><span style="width:0%"></span></div><span class="tydLib__chantProgressText">0 / 0</span>';
      return;
    }
    state.chantPage = Math.max(0, Math.min(total - 1, state.chantPage));
    var p = state.chantPages[state.chantPage];
    var top = p.bookLabel || 'Focused Reader';
    if(els.chantTopTitle) els.chantTopTitle.textContent = top;
    if(els.chantProgress){
      var pct = Math.max(0, Math.min(100, Math.round(((state.chantPage + 1) / total) * 100)));
      els.chantProgress.innerHTML = '<div class="tydLib__chantProgressTrack" aria-hidden="true"><span style="width:'+pct+'%"></span></div><span class="tydLib__chantProgressText">'+(state.chantPage + 1)+' / '+total+'</span>';
    }
    var html = '<div class="tydLib__chantPageHead">';
    html += '<div class="tydLib__chantSectionZh">'+escapeHtml(p.sectionMain || '')+'</div>';
    if(p.sectionSub) html += '<div class="tydLib__chantSectionEn">'+escapeHtml(p.sectionSub)+'</div>';
    if(p.image){
      html += '</div><div class="tydLib__chantPageBody tydLib__chantPageBody--image">' + chantImagePageHtml(p) + '</div>';
    }else{
      html += '</div><div class="tydLib__chantPageBody">' + (p.lines || []).map(function(l){ return renderBookLine(l, p.mode); }).join('') + '</div>';
    }
    els.chantPageEl.innerHTML = html;
    els.chantPageEl.scrollTop = 0;
    if(els.chantOverlay){
      Array.prototype.forEach.call(els.chantOverlay.querySelectorAll('[data-chant-prev]'), function(btn){ btn.disabled = state.chantPage <= 0; });
      Array.prototype.forEach.call(els.chantOverlay.querySelectorAll('[data-chant-next]'), function(btn){ btn.disabled = state.chantPage >= total - 1; });
    }
    setTimeout(fitChantPageText, 0);
  }

  function fitChantElement(el){
    if(!el) return;
    el.style.fontSize = '';
    if(!el.clientWidth) return;
    var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
    if(!cs) return;
    var current = parseFloat(cs.fontSize || '0') || 0;
    if(!current) return;
    var min = el.classList.contains('tydLib__zh') ? 15 : (el.classList.contains('tydLib__saam') ? 11 : 10);
    var tries = 0;
    while(el.scrollWidth > el.clientWidth + 2 && current > min && tries < 8){
      current = Math.max(min, current * (el.clientWidth / Math.max(el.scrollWidth, 1)) * .98);
      el.style.fontSize = current.toFixed(2) + 'px';
      tries++;
    }
  }

  function fitChantPageText(){
    if(!state.chantActive || !els.chantPageEl) return;
    Array.prototype.forEach.call(els.chantPageEl.querySelectorAll('.tydLib__chantSectionZh,.tydLib__chantSectionEn,.tydLib__zh,.tydLib__saam,.tydLib__en,.tydLib__enOnly'), fitChantElement);
  }

  function openChantMode(){
    if(state.auditMode){ setStatus('Chant mode is for the reader, not audit mode.', 'bad'); return; }
    state.chantPages = buildChantPages();
    if(!state.chantPages.length){ setStatus('Select a book or item first.', 'bad'); return; }
    state.chantPage = 0;
    state.chantActive = true;
    root.classList.add('chantModeActive');
    document.documentElement.classList.add('tydLibNoScroll');
    if(document.body) document.body.classList.add('tydLibNoScroll');
    if(els.chantOverlay){
      els.chantOverlay.hidden = false;
      els.chantOverlay.setAttribute('aria-hidden', 'false');
    }
    applyChantTheme(state.chantTheme || readStoredChantTheme(), false);
    setChantScale(state.chantScale || readStoredChantScale(), false);
    renderChantPage();
  }

  function closeChantMode(){
    state.chantActive = false;
    root.classList.remove('chantModeActive');
    document.documentElement.classList.remove('tydLibNoScroll');
    if(document.body) document.body.classList.remove('tydLibNoScroll');
    if(els.chantOverlay){
      els.chantOverlay.hidden = true;
      els.chantOverlay.setAttribute('aria-hidden', 'true');
    }
  }

  function changeChantPage(delta){
    if(!state.chantActive || !state.chantPages.length) return;
    state.chantPage = Math.max(0, Math.min(state.chantPages.length - 1, state.chantPage + delta));
    renderChantPage();
  }


  function readerModeForPrintLabel(){
    var mode = state.mode || 'chant';
    if(mode === 'chinese') return 'Chinese only';
    if(mode === 'english') return 'English translation only';
    if(mode === 'study') return 'Chinese + English';
    if(mode === 'full') return 'Chinese + Saamlawnese + English';
    return 'Chinese + Saamlawnese';
  }

  function textFromSelector(parent, selector){
    var el = parent && parent.querySelector ? parent.querySelector(selector) : null;
    return el ? (el.textContent || '').trim() : '';
  }

  function printKindProfile(kind){
    kind = String(kind || '').toLowerCase() === 'kpdf' ? 'kpdf' : 'paper';
    if(kind === 'kpdf'){
      return {
        kind:'kpdf',
        stageClass:'tydPrintStage--kpdf',
        label:'K-PDF',
        actionLabel:'Download K-PDF',
        pageLabel:'Kindle Paperwhite 3:4 pages',
        pageCss:'3.6in 4.8in',
        pageW:346,
        pageH:461,
        pagePad:14,
        pdfPageW:259.2,
        pdfPageH:345.6,
        pdfScale:1.72,
        pdfQuality:0.88,
        defaultScale:0.92,
        minScale:0.72,
        maxScale:1.22,
        storageKey:'tydLineageLibraryKpdfScale',
        help:'K-PDF preview uses small Kindle-style pages. Tune English and Chinese fonts separately, then click Download K-PDF to export the actual Kindle-ready PDF file. Per-page A buttons still adjust only one page.'
      };
    }
    return {
      kind:'paper',
      stageClass:'tydPrintStage--paper',
      label:'Print',
      actionLabel:'Print / Save PDF',
      pageLabel:'Letter-size paper pages',
      pageCss:'letter',
      pageW:816,
      pageH:1056,
      pagePad:48,
      defaultScale:1.15,
      minScale:0.85,
      maxScale:1.6,
      storageKey:'tydLineageLibraryPrintScale',
      help:'Preview uses page boxes so you can see roughly where each printed page begins and ends before opening the browser print dialog. Tune English and Chinese fonts separately. Use the small page tools to nudge only one page.'
    };
  }

  function currentPrintKind(stage){
    stage = stage || document.getElementById('tydLibPrintStage');
    return stage ? (stage.getAttribute('data-print-kind') || 'paper') : 'paper';
  }

  function getStoredPrintScale(kind){
    var profile = printKindProfile(kind);
    try{
      var n = Number(localStorage.getItem(profile.storageKey) || profile.defaultScale);
      if(isFinite(n)) return Math.max(profile.minScale, Math.min(profile.maxScale, n));
    }catch(e){}
    return profile.defaultScale;
  }

  function saveStoredPrintScale(v, kind){
    var profile = printKindProfile(kind);
    try{ localStorage.setItem(profile.storageKey, String(v)); }catch(e){}
  }

  var PRINT_TYPOGRAPHY_KEYS = {
    kpdf:'tydLineageLibraryKpdfTypographyV1',
    paper:'tydLineageLibraryPrintTypographyV1'
  };
  var PRINT_TYPOGRAPHY_DEFAULTS = {
    kpdf:{
      enSize:1.10,
      zhSize:0.96,
      enWeight:700,
      zhWeight:650,
      enFont:'system',
      zhFont:'site'
    },
    paper:{
      enSize:1.00,
      zhSize:1.00,
      enWeight:600,
      zhWeight:850,
      enFont:'system',
      zhFont:'site'
    }
  };

  function clampNum(v, min, max, fallback){
    v = Number(v);
    if(!isFinite(v)) v = fallback;
    return Math.max(min, Math.min(max, v));
  }

  function printTypographyDefault(kind){
    kind = String(kind || '').toLowerCase() === 'kpdf' ? 'kpdf' : 'paper';
    return PRINT_TYPOGRAPHY_DEFAULTS[kind] || PRINT_TYPOGRAPHY_DEFAULTS.paper;
  }

  function printTypographyStorageKey(kind){
    kind = String(kind || '').toLowerCase() === 'kpdf' ? 'kpdf' : 'paper';
    return PRINT_TYPOGRAPHY_KEYS[kind] || PRINT_TYPOGRAPHY_KEYS.paper;
  }

  function sanitizePrintTypography(raw, kind){
    var defaults = printTypographyDefault(kind);
    raw = raw || {};
    var out = {
      enSize:clampNum(raw.enSize, 0.78, 1.45, defaults.enSize),
      zhSize:clampNum(raw.zhSize, 0.78, 1.35, defaults.zhSize),
      enWeight:Math.round(clampNum(raw.enWeight, 400, 900, defaults.enWeight) / 50) * 50,
      zhWeight:Math.round(clampNum(raw.zhWeight, 400, 900, defaults.zhWeight) / 50) * 50,
      enFont:String(raw.enFont || defaults.enFont),
      zhFont:String(raw.zhFont || defaults.zhFont)
    };
    var enFonts = kpdfFontKeys('en');
    var zhFonts = kpdfFontKeys('zh');
    if(enFonts.indexOf(out.enFont) < 0) out.enFont = defaults.enFont;
    if(zhFonts.indexOf(out.zhFont) < 0) out.zhFont = defaults.zhFont;
    return out;
  }

  function getPrintTypography(kind){
    try{
      var raw = localStorage.getItem(printTypographyStorageKey(kind));
      if(raw) return sanitizePrintTypography(JSON.parse(raw), kind);
    }catch(e){}
    return sanitizePrintTypography(printTypographyDefault(kind), kind);
  }

  function savePrintTypography(t, kind){
    t = sanitizePrintTypography(t, kind);
    try{ localStorage.setItem(printTypographyStorageKey(kind), JSON.stringify(t)); }catch(e){}
    return t;
  }

  function sanitizeKpdfTypography(raw){ return sanitizePrintTypography(raw, 'kpdf'); }
  function getKpdfTypography(){ return getPrintTypography('kpdf'); }
  function saveKpdfTypography(t){ return savePrintTypography(t, 'kpdf'); }

  function kpdfFontOptions(role){
    if(role === 'zh'){
      return [
        ['site','Website Chinese font'],
        ['kai','Kai / brush style'],
        ['jhenghei','JhengHei clean bold'],
        ['ming','Ming / book style'],
        ['notoSans','Noto sans Chinese'],
        ['notoSerif','Noto serif Chinese']
      ];
    }
    return [
      ['system','Website / system font'],
      ['arial','Arial'],
      ['verdana','Verdana'],
      ['tahoma','Tahoma'],
      ['trebuchet','Trebuchet'],
      ['georgia','Georgia']
    ];
  }

  function kpdfFontKeys(role){
    return kpdfFontOptions(role).map(function(o){ return o[0]; });
  }

  function kpdfFontCss(role, key){
    key = String(key || '');
    if(role === 'zh'){
      if(key === 'kai') return '"DFKai-SB","BiauKai","KaiTi","STKaiti","Noto Serif TC","Microsoft JhengHei",serif';
      if(key === 'jhenghei') return '"Microsoft JhengHei","PingFang TC","Noto Sans TC",sans-serif';
      if(key === 'ming') return 'PMingLiU,MingLiU,"Noto Serif TC",serif';
      if(key === 'notoSans') return '"Noto Sans TC","Source Han Sans TC","Microsoft JhengHei",sans-serif';
      if(key === 'notoSerif') return '"Noto Serif TC","Source Han Serif TC",PMingLiU,serif';
      return 'var(--tyd-zh-font,"DFKai-SB","BiauKai","KaiTi","STKaiti","Noto Serif TC","Microsoft JhengHei",serif)';
    }
    if(key === 'arial') return 'Arial,Helvetica,sans-serif';
    if(key === 'verdana') return 'Verdana,Geneva,sans-serif';
    if(key === 'tahoma') return 'Tahoma,Geneva,sans-serif';
    if(key === 'trebuchet') return '"Trebuchet MS",Arial,sans-serif';
    if(key === 'georgia') return 'Georgia,"Times New Roman",serif';
    return 'var(--tyd-kpdf-site-en-font,-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif)';
  }

  function applyKpdfTypography(stage){
    if(!stage) return getKpdfTypography();
    var kind = currentPrintKind(stage);
    var t = stage._tydKpdfTypography || getPrintTypography(kind);
    t = sanitizePrintTypography(t, kind);
    stage._tydKpdfTypography = t;
    stage.style.setProperty('--tyd-kpdf-en-scale', String(t.enSize));
    stage.style.setProperty('--tyd-kpdf-zh-scale', String(t.zhSize));
    stage.style.setProperty('--tyd-kpdf-en-weight', String(t.enWeight));
    stage.style.setProperty('--tyd-kpdf-zh-weight', String(t.zhWeight));
    stage.style.setProperty('--tyd-kpdf-en-font', kpdfFontCss('en', t.enFont));
    stage.style.setProperty('--tyd-kpdf-zh-font', kpdfFontCss('zh', t.zhFont));
    return t;
  }

  function kpdfFontSelect(role, current){
    return kpdfFontOptions(role).map(function(opt){
      return '<option value="' + escapeHtml(opt[0]) + '"' + (opt[0] === current ? ' selected' : '') + '>' + escapeHtml(opt[1]) + '</option>';
    }).join('');
  }

  function kpdfWeightOptions(current){
    var weights = [400,500,600,650,700,750,800,850,900];
    return weights.map(function(w){ return '<option value="' + w + '"' + (Number(current) === w ? ' selected' : '') + '>' + w + '</option>'; }).join('');
  }

  function buildKpdfTypographyControls(t, kind){
    kind = String(kind || '').toLowerCase() === 'kpdf' ? 'kpdf' : 'paper';
    t = sanitizePrintTypography(t, kind);
    var title = kind === 'kpdf' ? 'K-PDF font tuning' : 'Print font tuning';
    var hint = kind === 'kpdf' ? 'These settings only affect K-PDF preview/export. Good starting point: English 110% / 700, Chinese 96% / 650.' : 'These settings only affect normal Print preview/output. K-PDF keeps its own separate settings.';
    return '<div class="tydPrintKpdfTypePanel" id="tydKpdfTypePanel">' +
      '<div class="tydPrintKpdfTypeTitle">' + escapeHtml(title) + '</div>' +
      '<div class="tydPrintKpdfTypeRow"><span>English</span>' +
        '<button type="button" data-kpdf-typo-action="enSizeDown" title="Smaller English / western text">A−</button>' +
        '<span class="tydKpdfTypeValue" data-kpdf-typo-label="enSize">' + Math.round(t.enSize * 100) + '%</span>' +
        '<button type="button" data-kpdf-typo-action="enSizeUp" title="Bigger English / western text">A+</button>' +
        '<select data-kpdf-typo-field="enWeight" title="English weight">' + kpdfWeightOptions(t.enWeight) + '</select>' +
        '<select data-kpdf-typo-field="enFont" title="English font">' + kpdfFontSelect('en', t.enFont) + '</select>' +
      '</div>' +
      '<div class="tydPrintKpdfTypeRow"><span>Chinese</span>' +
        '<button type="button" data-kpdf-typo-action="zhSizeDown" title="Smaller Chinese text">A−</button>' +
        '<span class="tydKpdfTypeValue" data-kpdf-typo-label="zhSize">' + Math.round(t.zhSize * 100) + '%</span>' +
        '<button type="button" data-kpdf-typo-action="zhSizeUp" title="Bigger Chinese text">A+</button>' +
        '<select data-kpdf-typo-field="zhWeight" title="Chinese weight">' + kpdfWeightOptions(t.zhWeight) + '</select>' +
        '<select data-kpdf-typo-field="zhFont" title="Chinese font">' + kpdfFontSelect('zh', t.zhFont) + '</select>' +
      '</div>' +
      '<div class="tydPrintKpdfTypeHint">' + escapeHtml(hint) + '</div>' +
    '</div>';
  }

  function syncKpdfTypographyControls(stage){
    if(!stage) return;
    var kind = currentPrintKind(stage);
    var t = sanitizePrintTypography(stage._tydKpdfTypography || getPrintTypography(kind), kind);
    var en = stage.querySelector('[data-kpdf-typo-label="enSize"]');
    var zh = stage.querySelector('[data-kpdf-typo-label="zhSize"]');
    if(en) en.textContent = Math.round(t.enSize * 100) + '%';
    if(zh) zh.textContent = Math.round(t.zhSize * 100) + '%';
    ['enWeight','zhWeight','enFont','zhFont'].forEach(function(k){
      var el = stage.querySelector('[data-kpdf-typo-field="' + k + '"]');
      if(el) el.value = String(t[k]);
    });
  }

  function updateKpdfTypography(patch){
    var stage = document.getElementById('tydLibPrintStage');
    if(!stage) return;
    var kind = currentPrintKind(stage);
    var t = sanitizePrintTypography(stage._tydKpdfTypography || getPrintTypography(kind), kind);
    Object.keys(patch || {}).forEach(function(k){ t[k] = patch[k]; });
    t = savePrintTypography(t, kind);
    stage._tydKpdfTypography = t;
    applyKpdfTypography(stage);
    syncKpdfTypographyControls(stage);
    paginatePrintStage(stage);
  }

  function printPageScaleMap(stage){
    if(!stage) return {};
    if(!stage._tydPageScales) stage._tydPageScales = {};
    return stage._tydPageScales;
  }

  function printPageLocalScale(stage, pageIndex){
    var map = printPageScaleMap(stage);
    var n = Number(map[String(pageIndex)] || 1);
    if(!isFinite(n)) n = 1;
    return Math.max(0.84, Math.min(1.16, n));
  }

  function setPrintPageLocalScale(stage, pageIndex, next){
    var map = printPageScaleMap(stage);
    next = Math.max(0.84, Math.min(1.16, Math.round(Number(next || 1) * 100) / 100));
    if(Math.abs(next - 1) < 0.005) delete map[String(pageIndex)];
    else map[String(pageIndex)] = next;
  }

  function applyPrintPageLocalScale(page, stage, pageIndex){
    if(!page || pageIndex == null) return;
    var global = Number(stage && stage.getAttribute ? stage.getAttribute('data-print-scale') : state.printScale) || 1;
    var local = printPageLocalScale(stage, pageIndex);
    var effective = Math.max(0.55, Math.min(1.9, Math.round(global * local * 10000) / 10000));
    page.style.setProperty('--tyd-print-scale', String(effective));
    page.setAttribute('data-page-local-scale', String(local));
  }

  function adjustPrintPageScale(pageIndex, delta){
    var stage = document.getElementById('tydLibPrintStage');
    if(!stage) return;
    var current = printPageLocalScale(stage, pageIndex);
    setPrintPageLocalScale(stage, pageIndex, current + delta);
    paginatePrintStage(stage);
    setStatus('Adjusted only this preview page. Use Reset on that page if the change is not needed.', 'ok');
  }

  function attachPrintPageTools(stage, pages){
    if(!stage || !pages) return;
    Array.prototype.slice.call(pages.querySelectorAll('.tydPrintPage--content[data-content-page-index]')).forEach(function(pg){
      var idx = Number(pg.getAttribute('data-content-page-index') || 0);
      var local = printPageLocalScale(stage, idx);
      var tools = document.createElement('div');
      tools.className = 'tydPrintPageTools';
      tools.innerHTML = '<span class="tydPrintPageToolLabel">This page ' + Math.round(local * 100) + '%</span>' +
        '<button type="button" data-page-scale-action="smaller" data-page-index="' + idx + '" title="Make this page slightly smaller">A−</button>' +
        '<button type="button" data-page-scale-action="reset" data-page-index="' + idx + '" title="Reset this page size">Reset</button>' +
        '<button type="button" data-page-scale-action="bigger" data-page-index="' + idx + '" title="Make this page slightly bigger">A+</button>' +
        (idx > 0 ? '<button type="button" data-page-scale-action="pull-prev" data-page-index="' + idx + '" title="Tighten the previous page to pull a short leftover line upward">Pull ↑</button>' : '');
      pg.appendChild(tools);
    });
  }

  function applyPrintStageProfile(stage, kind){
    var profile = printKindProfile(kind);
    if(!stage) return profile;
    stage.className = 'tydPrintStage ' + profile.stageClass;
    stage.setAttribute('data-print-kind', profile.kind);
    stage.style.setProperty('--tyd-preview-page-w', profile.pageW + 'px');
    stage.style.setProperty('--tyd-preview-page-h', profile.pageH + 'px');
    stage.style.setProperty('--tyd-preview-page-pad', profile.pagePad + 'px');
    stage.style.setProperty('--tyd-preview-content-h', Math.max(80, profile.pageH - profile.pagePad * 2) + 'px');
    applyKpdfTypography(stage);
    return profile;
  }

  function applyDynamicPrintPageStyle(kind){
    var profile = printKindProfile(kind);
    var old = document.getElementById('tydLibPrintDynamicPageStyle');
    if(old && old.parentNode) old.parentNode.removeChild(old);
    var style = document.createElement('style');
    style.id = 'tydLibPrintDynamicPageStyle';
    style.textContent = '@media print{@page{size:'+profile.pageCss+';margin:0}body.tydLibPrintActive #tydLibPrintStage .tydPrintControls{display:none!important}body.tydLibPrintActive #tydLibPrintStage .tydPrintPageTools{display:none!important}body.tydLibPrintActive #tydLibPrintStage .tydPrintSource{display:none!important}}';
    document.head.appendChild(style);
  }

  function updatePrintScale(delta){
    var stage = document.getElementById('tydLibPrintStage');
    if(!stage) return;
    var kind = currentPrintKind(stage);
    var profile = printKindProfile(kind);
    var current = Number(stage.getAttribute('data-print-scale') || state.printScale || getStoredPrintScale(kind));
    var next = Math.max(profile.minScale, Math.min(profile.maxScale, Math.round((current + delta) * 100) / 100));
    state.printScale = next;
    stage.setAttribute('data-print-scale', String(next));
    stage.style.setProperty('--tyd-print-scale', String(next));
    var label = stage.querySelector('.tydPrintSizeLabel');
    if(label) label.textContent = Math.round(next * 100) + '%';
    saveStoredPrintScale(next, kind);
    paginatePrintStage(stage);
  }

  function runPrintNow(){
    var stage = document.getElementById('tydLibPrintStage');
    if(!stage){ openPrintView('paper'); return; }
    var kind = currentPrintKind(stage);
    paginatePrintStage(stage);
    if(kind === 'kpdf'){ exportKpdfFromPreview(stage); return; }
    try{ window.focus(); window.print(); }
    catch(err){ setStatus('Print window could not open: '+err.message, 'bad'); }
  }

  function loadScriptOnce(src, globalName){
    return new Promise(function(resolve, reject){
      if(globalName && window[globalName]){ resolve(window[globalName]); return; }
      var existing = document.querySelector('script[data-tyd-src="' + src + '"]');
      if(existing){
        existing.addEventListener('load', function(){ resolve(globalName ? window[globalName] : true); });
        existing.addEventListener('error', reject);
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-tyd-src', src);
      script.onload = function(){ resolve(globalName ? window[globalName] : true); };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  async function ensureHtml2Canvas(){
    if(window.html2canvas) return window.html2canvas;
    try{ return await loadScriptOnce('https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js', 'html2canvas'); }
    catch(e){ return await loadScriptOnce('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js', 'html2canvas'); }
  }

  function waitForPrintImages(stage){
    var imgs = Array.prototype.slice.call((stage || document).querySelectorAll('img'));
    return Promise.all(imgs.map(function(img){
      return new Promise(function(resolve){
        try{ img.crossOrigin = img.crossOrigin || 'anonymous'; }catch(e){}
        if(img.complete && img.naturalWidth !== 0){ resolve(); return; }
        img.addEventListener('load', resolve, { once:true });
        img.addEventListener('error', resolve, { once:true });
        setTimeout(resolve, 2500);
      });
    }));
  }

  function asciiBytes(str){
    var out = new Uint8Array(str.length);
    for(var i=0;i<str.length;i++) out[i] = str.charCodeAt(i) & 255;
    return out;
  }

  function dataUrlToBytes(dataUrl){
    var b64 = String(dataUrl || '').split(',')[1] || '';
    var bin = atob(b64);
    var out = new Uint8Array(bin.length);
    for(var i=0;i<bin.length;i++) out[i] = bin.charCodeAt(i);
    return out;
  }

  function pdfHexText(str){
    str = cleanDisplayText(str || '').replace(/\s+/g, ' ').trim();
    var hex = 'FEFF';
    for(var i=0;i<str.length;i++){
      var code = str.charCodeAt(i);
      hex += ((code >> 8) & 255).toString(16).padStart(2, '0').toUpperCase();
      hex += (code & 255).toString(16).padStart(2, '0').toUpperCase();
    }
    return '<' + hex + '>';
  }

  function normalizePdfBookmarks(bookmarks, pageCount){
    var out = [];
    var seen = {};
    (bookmarks || []).forEach(function(b){
      var pageIndex = Math.floor(Number(b && b.pageIndex));
      var title = cleanDisplayText((b && b.title) || '').replace(/\s+/g, ' ').trim();
      if(!title || !isFinite(pageIndex) || pageIndex < 0 || pageIndex >= pageCount) return;
      if(title.length > 120) title = title.slice(0, 120).replace(/\s+\S*$/, '').trim() || title.slice(0, 120);
      var key = pageIndex + '|' + title;
      if(seen[key]) return;
      seen[key] = true;
      out.push({ title:title, pageIndex:pageIndex });
    });
    return out;
  }

  function buildImagePdf(pages, pageW, pageH, bookmarks){
    var parts = [];
    var offsets = [];
    var offset = 0;
    function add(part){
      if(typeof part === 'string') part = asciiBytes(part);
      parts.push(part);
      offset += part.length;
    }
    function obj(id, body){
      offsets[id] = offset;
      add(id + ' 0 obj\n');
      if(Array.isArray(body)) body.forEach(add); else add(body);
      add('\nendobj\n');
    }
    var n = pages.length;
    var bm = normalizePdfBookmarks(bookmarks, n);
    var imgStart = 3 + n;
    var contentStart = 3 + n * 2;
    var baseObjects = 2 + n * 3;
    var outlineRootObj = bm.length ? baseObjects + 1 : 0;
    var outlineFirstObj = bm.length ? outlineRootObj + 1 : 0;
    var totalObjects = baseObjects + (bm.length ? 1 + bm.length : 0);
    add('%PDF-1.4\n%\xe2\xe3\xcf\xd3\n');
    obj(1, '<< /Type /Catalog /Pages 2 0 R' + (bm.length ? ' /Outlines ' + outlineRootObj + ' 0 R /PageMode /UseOutlines' : '') + ' >>');
    obj(2, '<< /Type /Pages /Count ' + n + ' /Kids [' + pages.map(function(_, i){ return (3 + i) + ' 0 R'; }).join(' ') + '] >>');
    pages.forEach(function(page, i){
      var pageObj = 3 + i;
      var imgObj = imgStart + i;
      var contentObj = contentStart + i;
      obj(pageObj, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + pageW + ' ' + pageH + '] /Resources << /XObject << /Im0 ' + imgObj + ' 0 R >> >> /Contents ' + contentObj + ' 0 R >>');
    });
    pages.forEach(function(page, i){
      var imgBytes = dataUrlToBytes(page.dataUrl);
      obj(imgStart + i, ['<< /Type /XObject /Subtype /Image /Width ' + page.width + ' /Height ' + page.height + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + imgBytes.length + ' >>\nstream\n', imgBytes, '\nendstream']);
    });
    pages.forEach(function(page, i){
      var stream = 'q\n' + pageW + ' 0 0 ' + pageH + ' 0 0 cm\n/Im0 Do\nQ\n';
      obj(contentStart + i, '<< /Length ' + asciiBytes(stream).length + ' >>\nstream\n' + stream + 'endstream');
    });
    if(bm.length){
      var lastObj = outlineFirstObj + bm.length - 1;
      obj(outlineRootObj, '<< /Type /Outlines /First ' + outlineFirstObj + ' 0 R /Last ' + lastObj + ' 0 R /Count ' + bm.length + ' >>');
      bm.forEach(function(b, i){
        var thisObj = outlineFirstObj + i;
        var prev = i > 0 ? ' /Prev ' + (thisObj - 1) + ' 0 R' : '';
        var next = i < bm.length - 1 ? ' /Next ' + (thisObj + 1) + ' 0 R' : '';
        var pageObj = 3 + b.pageIndex;
        obj(thisObj, '<< /Title ' + pdfHexText(b.title) + ' /Parent ' + outlineRootObj + ' 0 R /Dest [' + pageObj + ' 0 R /Fit]' + prev + next + ' >>');
      });
    }
    var xrefOffset = offset;
    add('xref\n0 ' + (totalObjects + 1) + '\n');
    add('0000000000 65535 f \n');
    for(var id=1; id<=totalObjects; id++){
      add(String(offsets[id] || 0).padStart(10, '0') + ' 00000 n \n');
    }
    add('trailer\n<< /Size ' + (totalObjects + 1) + ' /Root 1 0 R >>\nstartxref\n' + xrefOffset + '\n%%EOF');
    var total = parts.reduce(function(sum, part){ return sum + part.length; }, 0);
    var out = new Uint8Array(total);
    var pos = 0;
    parts.forEach(function(part){ out.set(part, pos); pos += part.length; });
    return new Blob([out], { type:'application/pdf' });
  }

  function safePdfFileName(title){
    title = String(title || 'TYD_KPDF').replace(/[\\/:*?"<>|]+/g, ' ').replace(/\s+/g, '_').replace(/^_+|_+$/g, '');
    if(!title) title = 'TYD_KPDF';
    if(title.length > 72) title = title.slice(0, 72).replace(/_+$/,'');
    return title + '_KPDF.pdf';
  }

  function downloadBlob(blob, filename){
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function(){ try{ URL.revokeObjectURL(url); }catch(e){} if(a.parentNode) a.parentNode.removeChild(a); }, 1200);
  }

  function printBookmarkTitleFromNode(node){
    if(!node) return '';
    var zh = textFromSelector(node, '.tydLib__sectionTitleZh') || textFromSelector(node, '.tydLib__titleZh');
    var en = textFromSelector(node, '.tydLib__sectionTitleEn') || textFromSelector(node, '.tydLib__titleEn');
    var fallback = '';
    if(!zh && !en){
      var heading = node.querySelector ? node.querySelector('h1,h2,h3,h4,.tydLib__builderTocNum + span,.tydLib__godSectionTitle') : null;
      fallback = heading ? (heading.textContent || '') : '';
    }
    zh = cleanDisplayText(zh || '').replace(/\s+/g, ' ').trim();
    en = cleanDisplayText(en || '').replace(/\s+/g, ' ').trim();
    fallback = cleanDisplayText(fallback || '').replace(/\s+/g, ' ').trim();
    if(zh && en && zh !== en) return zh + ' / ' + en;
    return zh || en || fallback || '';
  }

  function collectKpdfBookmarksFromPreview(stage){
    var pages = Array.prototype.slice.call((stage || document).querySelectorAll('.tydPrintPage'));
    var out = [];
    pages.forEach(function(page, pageIndex){
      var starts = page.querySelectorAll('[data-print-item-start="1"]');
      Array.prototype.forEach.call(starts, function(node){
        var title = printBookmarkTitleFromNode(node);
        if(title) out.push({ title:title, pageIndex:pageIndex });
      });
    });
    return out;
  }

  async function exportKpdfFromPreview(stage){
    stage = stage || document.getElementById('tydLibPrintStage');
    if(!stage) return;
    var profile = printKindProfile('kpdf');
    var btn = stage.querySelector('#tydPrintNow');
    var oldText = btn ? btn.textContent : '';
    try{
      if(btn){ btn.disabled = true; btn.textContent = 'Building PDF…'; }
      setStatus('Building K-PDF file from the preview pages…', 'ok');
      if(document.fonts && document.fonts.ready){ try{ await document.fonts.ready; }catch(e){} }
      await waitForPrintImages(stage);
      var html2canvas = await ensureHtml2Canvas();
      var pageNodes = Array.prototype.slice.call(stage.querySelectorAll('.tydPrintPage'));
      if(!pageNodes.length){ throw new Error('No preview pages found.'); }
      var bookmarks = collectKpdfBookmarksFromPreview(stage);
      stage.classList.add('tydPrintStage--exporting');
      await new Promise(function(resolve){ requestAnimationFrame(function(){ requestAnimationFrame(resolve); }); });
      var rendered = [];
      for(var i=0;i<pageNodes.length;i++){
        if(btn) btn.textContent = 'Building ' + (i + 1) + '/' + pageNodes.length + '…';
        var canvas = await html2canvas(pageNodes[i], {
          backgroundColor:'#ffffff',
          scale:profile.pdfScale || 1.7,
          useCORS:true,
          allowTaint:false,
          logging:false,
          scrollX:0,
          scrollY:0,
          windowWidth:document.documentElement.clientWidth,
          windowHeight:document.documentElement.clientHeight
        });
        rendered.push({ dataUrl:canvas.toDataURL('image/jpeg', profile.pdfQuality || 0.88), width:canvas.width, height:canvas.height });
      }
      var blob = buildImagePdf(rendered, profile.pdfPageW || 259.2, profile.pdfPageH || 345.6, bookmarks);
      var title = textFromSelector(stage, '.tydPrintTitleEn') || textFromSelector(stage, '.tydPrintTitleZh') || 'TYD_Lineage_Library';
      downloadBlob(blob, safePdfFileName(title));
      setStatus('K-PDF downloaded with ' + bookmarks.length + ' index bookmarks. Send that PDF to the Kindle.', 'ok');
    }catch(err){
      setStatus('K-PDF export failed: ' + (err && err.message ? err.message : err) + '. Use Print / Save PDF as fallback.', 'bad');
    }finally{
      stage.classList.remove('tydPrintStage--exporting');
      if(btn){ btn.disabled = false; btn.textContent = oldText || profile.actionLabel; }
    }
  }

  function cleanupPrintStage(){
    document.body.classList.remove('tydLibPrintActive');
    var stage = document.getElementById('tydLibPrintStage');
    if(stage && stage.parentNode) stage.parentNode.removeChild(stage);
    var style = document.getElementById('tydLibPrintDynamicPageStyle');
    if(style && style.parentNode) style.parentNode.removeChild(style);
    window.removeEventListener('afterprint', cleanupPrintStage);
  }



  function splitKpdfStrongSentences(text){
    var parts = [];
    var start = 0;
    for(var i=0; i<text.length; i++){
      var ch = text.charAt(i);
      if(/[.!?;。！？；]/.test(ch)){
        var prev = text.charAt(i - 1);
        var next = text.charAt(i + 1);
        if(ch === '.' && /\d/.test(prev) && /\d/.test(next)) continue;
        var end = i + 1;
        while(/["'”’）)]/.test(text.charAt(end))) end++;
        var piece = text.slice(start, end).trim();
        if(piece) parts.push(piece);
        start = end;
      }
    }
    var tail = text.slice(start).trim();
    if(tail) parts.push(tail);
    return parts.length > 1 ? parts : [text];
  }

  function splitKpdfSaamlawnesePhrases(text){
    var pieces = [];
    var start = 0;
    for(var i=0; i<text.length; i++){
      var ch = text.charAt(i);
      if(ch === ',' || ch === '，' || ch === '、' || ch === ':' || ch === '：' || ch === ';' || ch === '；'){
        var piece = text.slice(start, i + 1).trim();
        if(piece) pieces.push(piece);
        start = i + 1;
      }
    }
    var tail = text.slice(start).trim();
    if(tail) pieces.push(tail);
    if(pieces.length > 1 && pieces.length <= 8){
      var useful = pieces.filter(function(x){ return x.replace(/[\s,，、:：;；]/g, '').length >= 2; });
      if(useful.length === pieces.length) return pieces;
    }
    return [text];
  }

  function splitKpdfWesternSentences(text, role){
    text = cleanDisplayText(text || '').replace(/[ \t\u00a0]+/g, ' ').trim();
    if(!text) return [];
    var fromNewlines = text.split(/\r?\n+/).map(function(x){ return x.trim(); }).filter(Boolean);
    if(fromNewlines.length > 1) return fromNewlines;

    var slashParts = text.split(/\s+(?:\/|\||•|·)\s+/).map(function(x){ return x.trim(); }).filter(Boolean);
    if(slashParts.length > 1) return slashParts;

    var strong = splitKpdfStrongSentences(text);
    if(strong.length > 1) return strong;

    if(role === 'saam'){
      var saamParts = splitKpdfSaamlawnesePhrases(text);
      if(saamParts.length > 1) return saamParts;
    }

    var len = text.length;
    if(len < 44) return [text];
    var candidates = [];
    for(var j=0; j<text.length; j++){
      var c = text.charAt(j);
      if(c === ',' || c === ':' || c === '，' || c === '：' || c === '、') candidates.push(j);
    }
    if(candidates.length){
      var mid = len / 2;
      candidates.sort(function(a,b){ return Math.abs(a - mid) - Math.abs(b - mid); });
      var cut = candidates[0] + 1;
      var a = text.slice(0, cut).trim();
      var b = text.slice(cut).trim();
      if(a.length >= 14 && b.length >= 14) return [a, b];
    }
    return [text];
  }

  function applyKpdfSentenceSplit(node){
    if(!node || !node.querySelectorAll) return node;
    var targets = node.querySelectorAll('.tydLib__chantLine .tydLib__saam,.tydLib__chantLine .tydLib__en,.tydLib__chantLine .tydLib__enOnly,.tydLib__line .tydLib__saam,.tydLib__line .tydLib__en,.tydLib__line .tydLib__enOnly');
    Array.prototype.forEach.call(targets, function(el){
      if(!el || el.getAttribute('data-kpdf-sentence-split') === '1') return;
      var original = (el.textContent || '').trim();
      var role = el.classList && el.classList.contains('tydLib__saam') ? 'saam' : 'en';
      var parts = splitKpdfWesternSentences(original, role);
      if(parts.length <= 1) return;
      el.textContent = '';
      el.setAttribute('data-kpdf-sentence-split', '1');
      el.setAttribute('data-kpdf-sentence-role', role);
      parts.forEach(function(part){
        var span = document.createElement('span');
        span.className = 'tydKpdfSentenceLine';
        span.textContent = part;
        el.appendChild(span);
      });
    });
    return node;
  }

  function stripPrintClone(node){
    if(!node || !node.querySelectorAll) return node;
    node.querySelectorAll('.tydLib__readerBtns,button,textarea,.tydLib__copyArea,script,style').forEach(function(n){ if(n && n.parentNode) n.parentNode.removeChild(n); });
    node.querySelectorAll('.tydLib__small').forEach(function(n){
      var txt = (n.textContent || '').trim();
      if(/^Source\s*:/i.test(txt) && n.parentNode) n.parentNode.removeChild(n);
    });
    node.querySelectorAll('[id]').forEach(function(n){ n.removeAttribute('id'); });
    node.querySelectorAll('img').forEach(function(img){
      try{ img.setAttribute('loading','eager'); img.setAttribute('decoding','sync'); img.removeAttribute('width'); img.removeAttribute('height'); }catch(e){}
    });
    return node;
  }

  function cloneForPrint(node){
    if(!node) return null;
    var c = node.cloneNode(true);
    return stripPrintClone(c);
  }

  function isPrintLineNode(el){
    if(!el || !el.classList) return false;
    return el.classList.contains('tydLib__chantLine') ||
      el.classList.contains('tydLib__line') ||
      el.classList.contains('tydLib__dictLine') ||
      el.classList.contains('tydLib__dictCard');
  }

  function isPrintContainerNode(el){
    if(!el || !el.classList) return false;
    return el.classList.contains('tydLib__book') || el.classList.contains('tydLib__dictLines');
  }

  function createSectionShell(section, isItemStart){
    var shell = document.createElement(section && section.tagName ? section.tagName.toLowerCase() : 'section');
    shell.className = (section && section.className ? section.className : 'tydLib__bookSection') + ' tydPrintSectionPart';
    if(isItemStart) shell.setAttribute('data-print-item-start', '1');
    if(section && section.getAttribute){
      ['data-item-id','data-section-id','data-god-section'].forEach(function(k){ var v = section.getAttribute(k); if(v) shell.setAttribute(k, v); });
    }
    return shell;
  }

  function isPrintOwnBlock(child){
    if(!child || !child.classList) return false;
    return child.classList.contains('tydLib__itemImage') ||
      child.classList.contains('tydLib__itemDetails') ||
      child.classList.contains('tydLib__chantImageFigure') ||
      String(child.tagName || '').toLowerCase() === 'figure';
  }

  function markPrintOwnBlock(block){
    if(!block || !block.classList) return block;
    block.classList.add('tydPrintOwnBlock');
    if(block.classList.contains('tydLib__itemImage') || block.classList.contains('tydLib__chantImageFigure') || String(block.tagName || '').toLowerCase() === 'figure'){
      block.classList.add('tydPrintImageBlock');
      block.setAttribute('data-print-fit-page', '1');
    }
    if(block.classList.contains('tydLib__itemDetails')) block.classList.add('tydPrintDetailsBlock');
    return block;
  }

  function collectSectionPrintBlocks(section, out){
    var header = createSectionShell(section, true);
    var headerHas = false;
    var itemStartPending = true;
    var prevOwnWasImage = false;
    function flushHeader(keepNext){
      if(!headerHas) return;
      if(keepNext) header.setAttribute('data-keep-next','1');
      if(itemStartPending) header.setAttribute('data-print-item-start', '1');
      out.push(stripPrintClone(header));
      itemStartPending = false;
      header = createSectionShell(section, false);
      headerHas = false;
    }
    Array.prototype.slice.call(section.children || []).forEach(function(child){
      if(isPrintLineNode(child)){
        flushHeader(true);
        var line = cloneForPrint(child);
        if(line && line.classList) line.classList.add('tydPrintLineBlock');
        if(line) out.push(line);
        prevOwnWasImage = false;
      }else if(isPrintOwnBlock(child)){
        flushHeader(true);
        var own = markPrintOwnBlock(cloneForPrint(child));
        if(own){
          if(itemStartPending){ own.setAttribute('data-print-item-start', '1'); itemStartPending = false; }
          if(prevOwnWasImage && own.classList && own.classList.contains('tydPrintDetailsBlock')) own.setAttribute('data-print-force-new-page', '1');
          out.push(own);
          prevOwnWasImage = !!(own.classList && own.classList.contains('tydPrintImageBlock'));
        }else{
          prevOwnWasImage = false;
        }
      }else{
        header.appendChild(cloneForPrint(child));
        headerHas = true;
        prevOwnWasImage = false;
      }
    });
    flushHeader(false);
  }

  function collectPrintBlocksFromNode(node, out){
    if(!node || !node.children) return;
    Array.prototype.slice.call(node.children).forEach(function(child){
      if(!child || !child.classList) return;
      if(child.classList.contains('tydLib__readerBtns') || child.classList.contains('tydLib__copyArea')) return;
      if(isPrintContainerNode(child)){
        Array.prototype.slice.call(child.children || []).forEach(function(grand){
          if(grand.classList && grand.classList.contains('tydLib__bookSection')) collectSectionPrintBlocks(grand, out);
          else if(grand.classList && isPrintContainerNode(grand)) collectPrintBlocksFromNode(grand, out);
          else {
            var g = cloneForPrint(grand);
            if(isPrintOwnBlock(grand)) g = markPrintOwnBlock(g);
            if(g) out.push(g);
          }
        });
      }else if(child.classList.contains('tydLib__bookSection')){
        collectSectionPrintBlocks(child, out);
      }else{
        var c = cloneForPrint(child);
        if(isPrintOwnBlock(child)) c = markPrintOwnBlock(c);
        if(c) out.push(c);
      }
    });
  }

  function collectPrintBlocks(readerClone){
    var out = [];
    collectPrintBlocksFromNode(readerClone, out);
    return out.filter(function(n){ return !!n; });
  }

  function makePrintPage(stage, profile, kind, contentPageIndex){
    var page = document.createElement('section');
    page.className = 'tydPrintPage tydPrintPage--' + (kind || 'content');
    if(kind === 'content' && contentPageIndex != null){
      page.setAttribute('data-content-page-index', String(contentPageIndex));
      applyPrintPageLocalScale(page, stage, contentPageIndex);
    }
    var inner = document.createElement('div');
    inner.className = kind === 'cover' ? 'tydPrintPageInner tydPrintCoverPageInner' : 'tydPrintPageInner tydPrintContent';
    page.appendChild(inner);
    return { page:page, inner:inner };
  }

  function printPageIsOverflowing(pg, profile){
    if(!pg || !pg.inner) return false;
    return pg.inner.scrollHeight > Math.max(80, profile.pageH - profile.pagePad * 2) + 6;
  }

  function blockWantsFreshPage(block){
    if(!block || !block.classList) return false;
    return block.classList.contains('pageBreakBefore') ||
      block.classList.contains('tydLib__builderSpecialPage--cover') ||
      block.classList.contains('tydLib__builderSpecialPage--divider');
  }

  function fitOversizedPrintBlock(block){
    if(!block || !block.classList) return false;
    if(!block.classList.contains('tydPrintImageBlock') && !block.getAttribute('data-print-fit-page')) return false;
    block.classList.add('tydPrintFitPageBlock');
    return true;
  }

  function paginatePrintStage(stage){
    stage = stage || document.getElementById('tydLibPrintStage');
    if(!stage) return;
    var kind = currentPrintKind(stage);
    var profile = applyPrintStageProfile(stage, kind);
    var pages = stage.querySelector('.tydPrintPages');
    var source = stage.querySelector('.tydPrintSource');
    if(!pages || !source) return;
    pages.innerHTML = '';

    var coverSource = source.querySelector('.tydPrintCover');
    if(coverSource){
      var coverPage = makePrintPage(stage, profile, 'cover');
      coverPage.inner.appendChild(cloneForPrint(coverSource));
      pages.appendChild(coverPage.page);
    }

    var readerSource = source.querySelector('.tydPrintReader');
    var blocks = collectPrintBlocks(readerSource);
    var contentPageIndex = 0;
    var current = makePrintPage(stage, profile, 'content', contentPageIndex++);
    pages.appendChild(current.page);

    function newPage(){
      current = makePrintPage(stage, profile, 'content', contentPageIndex++);
      pages.appendChild(current.page);
    }

    var seenItemStart = false;
    blocks.forEach(function(block){
      if(!block) return;
      var startsNewItem = !!(block.getAttribute && block.getAttribute('data-print-item-start') === '1');
      var forceNewPage = !!(block.getAttribute && block.getAttribute('data-print-force-new-page') === '1' && kind === 'kpdf');
      if(((blockWantsFreshPage(block)) || (startsNewItem && seenItemStart) || forceNewPage) && current.inner.children.length) newPage();
      current.inner.appendChild(block);
      if(startsNewItem) seenItemStart = true;
      if(printPageIsOverflowing(current, profile) && current.inner.children.length > 1){
        current.inner.removeChild(block);
        var carry = null;
        var last = current.inner.lastElementChild;
        if(last && last.getAttribute && last.getAttribute('data-keep-next') === '1'){
          carry = last;
          current.inner.removeChild(last);
        }
        newPage();
        if(carry) current.inner.appendChild(carry);
        current.inner.appendChild(block);
      }
      if(printPageIsOverflowing(current, profile) && current.inner.children.length === 1){
        if(fitOversizedPrintBlock(block)){
          // Image/FU pages should scale to the printable area instead of showing a warning bubble.
        }else{
          current.page.classList.add('tydPrintPage--overflow');
        }
      }
    });

    Array.prototype.slice.call(pages.querySelectorAll('.tydPrintPage')).forEach(function(pg, idx){
      if(!pg.querySelector('.tydPrintPageInner').children.length && idx > 0 && pg.parentNode) pg.parentNode.removeChild(pg);
    });
    attachPrintPageTools(stage, pages);
    var pageCount = pages.querySelectorAll('.tydPrintPage').length;
    var count = stage.querySelector('.tydPrintPageCount');
    if(count) count.textContent = pageCount + (pageCount === 1 ? ' page' : ' pages');
  }

  function openPrintView(kind){
    kind = String(kind || '').toLowerCase() === 'kpdf' ? 'kpdf' : 'paper';
    if(state.auditMode){ setStatus('Print view is for the reader, not audit mode.', 'bad'); return; }
    if(!state.selectedId){ setStatus('Select a book or item first.', 'bad'); return; }
    var reader = els.reader;
    if(!reader || !reader.querySelector || !reader.querySelector('.tydLib__readerTop')){ setStatus('Nothing loaded to print yet.', 'bad'); return; }
    if(root.classList.contains('tydLib--readerRendering')){ setStatus('Large book is still finishing the reader view. Try print again in a moment.', 'bad'); return; }

    cleanupPrintStage();
    var profile = printKindProfile(kind);
    applyDynamicPrintPageStyle(kind);

    var titleZh = textFromSelector(reader, '.tydLib__titleZh');
    var titleEn = textFromSelector(reader, '.tydLib__titleEn');
    var title = titleZh || titleEn || 'Tin Yat Lineage';
    var source = textFromSelector(reader, '.tydLib__small') || 'Tin Yat Lineage Library';
    var now = new Date();

    var stage = document.createElement('div');
    stage.id = 'tydLibPrintStage';
    stage._tydPageScales = {};
    stage._tydKpdfTypography = getPrintTypography(kind);
    applyPrintStageProfile(stage, kind);
    try{ stage.style.setProperty('--tyd-zh-font', getComputedStyle(root).getPropertyValue('--tyd-zh-font') || ''); }catch(e){}
    try{ stage.style.setProperty('--tyd-kpdf-site-en-font', (getComputedStyle(reader).fontFamily || getComputedStyle(root).fontFamily || '-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif')); }catch(e){}
    state.printScale = getStoredPrintScale(kind);
    stage.setAttribute('data-print-scale', String(state.printScale));
    stage.style.setProperty('--tyd-print-scale', String(state.printScale));

    var controls = document.createElement('div');
    controls.className = 'tydPrintControls';
    controls.innerHTML = '<button type="button" id="tydPrintSmaller" title="Smaller whole document">A−</button>' +
      '<span class="tydPrintSizeLabel">' + Math.round(state.printScale * 100) + '%</span>' +
      '<button type="button" id="tydPrintBigger" title="Bigger whole document">A+</button>' +
      '<span class="tydPrintProfile">' + escapeHtml(profile.pageLabel) + '</span>' +
      '<span class="tydPrintPageCount">0 pages</span>' +
      '<button type="button" id="tydPrintNow" class="primary">' + escapeHtml(profile.actionLabel) + '</button>' +
      '<button type="button" id="tydPrintClose">Close</button>' +
      buildKpdfTypographyControls(stage._tydKpdfTypography, kind) +
      '<div class="tydPrintHelp">' + escapeHtml(profile.help) + '</div>';
    controls.addEventListener('click', function(e){
      var actionBtn = e.target && e.target.closest ? e.target.closest('[data-kpdf-typo-action]') : null;
      if(actionBtn){
        var action = actionBtn.getAttribute('data-kpdf-typo-action');
        if(action === 'enSizeDown'){ updateKpdfTypography({ enSize:(stage._tydKpdfTypography.enSize || 1) - 0.04 }); return; }
        if(action === 'enSizeUp'){ updateKpdfTypography({ enSize:(stage._tydKpdfTypography.enSize || 1) + 0.04 }); return; }
        if(action === 'zhSizeDown'){ updateKpdfTypography({ zhSize:(stage._tydKpdfTypography.zhSize || 1) - 0.04 }); return; }
        if(action === 'zhSizeUp'){ updateKpdfTypography({ zhSize:(stage._tydKpdfTypography.zhSize || 1) + 0.04 }); return; }
      }
      var t = e.target;
      if(!t || !t.id) return;
      if(t.id === 'tydPrintSmaller'){ updatePrintScale(kind === 'kpdf' ? -0.06 : -0.1); return; }
      if(t.id === 'tydPrintBigger'){ updatePrintScale(kind === 'kpdf' ? 0.06 : 0.1); return; }
      if(t.id === 'tydPrintNow'){ runPrintNow(); return; }
      if(t.id === 'tydPrintClose'){ cleanupPrintStage(); return; }
    });
    controls.addEventListener('change', function(e){
      var t = e.target;
      if(!t || !t.getAttribute) return;
      var field = t.getAttribute('data-kpdf-typo-field');
      if(!field) return;
      var patch = {};
      patch[field] = (field === 'enWeight' || field === 'zhWeight') ? Number(t.value) : String(t.value || '');
      updateKpdfTypography(patch);
    });
    stage.addEventListener('click', function(e){
      var t = e.target && e.target.closest ? e.target.closest('[data-page-scale-action]') : null;
      if(!t) return;
      var idx = Number(t.getAttribute('data-page-index') || 0);
      var action = t.getAttribute('data-page-scale-action');
      if(action === 'smaller'){ adjustPrintPageScale(idx, kind === 'kpdf' ? -0.03 : -0.04); return; }
      if(action === 'bigger'){ adjustPrintPageScale(idx, kind === 'kpdf' ? 0.03 : 0.04); return; }
      if(action === 'reset'){ var st = document.getElementById('tydLibPrintStage'); setPrintPageLocalScale(st, idx, 1); paginatePrintStage(st); return; }
      if(action === 'pull-prev' && idx > 0){ adjustPrintPageScale(idx - 1, kind === 'kpdf' ? -0.03 : -0.04); return; }
    });
    stage.appendChild(controls);

    var sourceWrap = document.createElement('div');
    sourceWrap.className = 'tydPrintSource';
    sourceWrap.setAttribute('aria-hidden', 'true');

    var cover = document.createElement('section');
    cover.className = 'tydPrintCover';
    var brand = document.createElement('div');
    brand.className = 'tydPrintBrand';
    brand.textContent = 'Tin Yat Lineage';
    cover.appendChild(brand);
    if(titleZh){ var zh = document.createElement('div'); zh.className = 'tydPrintTitleZh'; zh.textContent = titleZh; cover.appendChild(zh); }
    if(titleEn){ var en = document.createElement('div'); en.className = 'tydPrintTitleEn'; en.textContent = titleEn; cover.appendChild(en); }
    var meta = document.createElement('div');
    meta.className = 'tydPrintMeta';
    meta.textContent = readerModeForPrintLabel() + ' · ' + profile.label + ' · Generated: ' + (now.toLocaleString ? now.toLocaleString() : String(now));
    cover.appendChild(meta);
    sourceWrap.appendChild(cover);

    var content = document.createElement('div');
    content.className = 'tydPrintSourceContent';
    var clone = reader.cloneNode(true);
    clone.classList.add('tydPrintReader');
    stripPrintClone(clone);
    applyKpdfSentenceSplit(clone);
    content.appendChild(clone);
    sourceWrap.appendChild(content);
    stage.appendChild(sourceWrap);

    var pages = document.createElement('div');
    pages.className = 'tydPrintPages';
    stage.appendChild(pages);

    var foot = document.createElement('div');
    foot.className = 'tydPrintFoot';
    foot.textContent = 'Tin Yat Lineage · Saam Law Magic Library';
    stage.appendChild(foot);

    document.body.appendChild(stage);
    document.body.classList.add('tydLibPrintActive');
    paginatePrintStage(stage);
    window.addEventListener('afterprint', cleanupPrintStage);
    setStatus((kind === 'kpdf' ? 'K-PDF preview ready. ' : 'Print preview ready. ') + 'Use top A buttons for the whole book or page A buttons for only one page, then click ' + profile.actionLabel + '.', 'ok');
    try{ stage.scrollIntoView({ block:'start' }); }catch(e){}
  }

  function pushCopyLine(out, l, kind){
    if(kind === 'chinese'){ out.push(cleanDisplayText(l.chinese || '')); return; }
    if(kind === 'english'){ out.push(cleanDisplayText(l.english_translation || '')); return; }
    out.push(cleanDisplayText(l.chinese || ''));
    if(kind === 'chant'){ out.push(cleanDisplayText(l.saamlawnese || '')); return; }
    if(kind === 'full' || kind === 'dictionary'){
      out.push(cleanDisplayText(l.saamlawnese || ''));
      out.push(cleanDisplayText(l.english_translation || ''));
      return;
    }
    out.push(cleanDisplayText(l.english_translation || ''));
  }

  function copyHeaderText(zh, en, fallback, kind){
    if(kind === 'chinese') return cleanDisplayText(zh || fallback || '');
    if(kind === 'english') return cleanDisplayText(en || fallback || '');
    return cleanDisplayText((zh || '') + ' / ' + (en || fallback || ''));
  }

  function copyText(kind){
    if(isQuickShelfSelection(state.selectedId)){
      var qsEntry = quickShelfEntryBySelection(state.selectedId);
      var qsOut = quickShelfCopyTextLines(qsEntry, kind);
      if(!qsOut.length) return;
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(qsOut.join('\n')).then(function(){ setStatus('Copied Quick Shelf text', 'ok'); });
      }else{
        window.prompt('Copy this Quick Shelf text:', qsOut.join('\n'));
      }
      return;
    }
    if(isGodDirectory() && isGodSelection(state.selectedId)){
      var godEntry = godEntryById(state.selectedId);
      var godOut = godCopyTextLines(godEntry);
      if(!godOut.length) return;
      navigator.clipboard && navigator.clipboard.writeText(godOut.join('\n')).then(function(){ setStatus('Copied God page', 'ok'); setTimeout(function(){ setStatus('Loaded '+state.items.length+' items / '+state.lines.length+' lines / '+state.rcAtlas.length+' RC entries / '+GOD_ATLAS_ENTRIES.length+' gods', 'ok'); }, 1200); });
      return;
    }
    if(isRcDirectory() && isRcSelection(state.selectedId)){
      var rcEntry = rcEntryById(state.selectedId);
      var rcOut = rcCopyTextLines(rcEntry);
      if(!rcOut.length) return;
      navigator.clipboard && navigator.clipboard.writeText(rcOut.join('\n')).then(function(){ setStatus('Copied RC study notes', 'ok'); setTimeout(function(){ setStatus('Loaded '+state.items.length+' items / '+state.lines.length+' lines / '+state.rcAtlas.length+' RC entries / '+GOD_ATLAS_ENTRIES.length+' gods', 'ok'); }, 1200); });
      return;
    }
    if(kind === 'current') kind = (MODE_ORDER.indexOf(state.mode) !== -1 ? state.mode : 'chant');
    var out = [];
    if(isBuilderSelection(state.selectedId)){
      var bp = builderTitleParts();
      out.push(copyHeaderText(bp.zh || '', bp.en || '', 'Custom Book', kind));
      (state.builder.sections || []).forEach(function(sec){
        sec = normalizeBuilderSection(sec);
        if(sec.type === 'custom_page'){
          out.push(''); out.push(copyHeaderText(sec.title_zh || '', sec.title_en || 'Custom Page', 'Custom Page', kind));
          customRowsForSection(sec).forEach(function(l){ out.push(''); pushCopyLine(out, l, kind); });
        }else{
          var src = builderSourceForSection(sec);
          var item = Object.assign({}, (src && src.item) || { item_id:sec.item_id, english_title:sec.item_id });
          if(sec.title_override){ if(builderHasCjk(sec.title_override)) item.chinese_title = sec.title_override; else item.english_title = sec.title_override; }
          out.push(''); out.push(copyHeaderText(item.chinese_title || '', item.english_title || '', item.item_id || '', kind));
          ((src && src.rows) || []).forEach(function(l){ out.push(''); pushCopyLine(out, l, kind); });
        }
      });
    }else if(isBookSelection(state.selectedId)){
      var bookId = selectedBookId();
      var book = bookById(bookId);
      var bookParts = bookTitleParts(book || bookId);
      out.push(copyHeaderText(bookParts.zh || '', bookParts.en || '', bookParts.fallback || bookId, kind));
      indexedItemsForBook(bookId, state.items).forEach(function(item){
        out.push(''); out.push(copyHeaderText(item.chinese_title || '', item.english_title || '', item.item_id || '', kind));
        lineRows(item.item_id).forEach(function(l){
          out.push(''); pushCopyLine(out, l, kind);
        });
      });
    }else{
      var item = state.items.find(function(i){ return i.item_id === state.selectedId; });
      if(!item) return;
      var rows = lineRows(item.item_id);
      out.push(copyHeaderText(item.chinese_title || '', item.english_title || '', item.item_id || '', kind));
      rows.forEach(function(l){
        out.push(''); pushCopyLine(out, l, kind);
      });
    }
    navigator.clipboard && navigator.clipboard.writeText(out.join('\n')).then(function(){ setStatus('Copied '+kind+' text', 'ok'); setTimeout(function(){ setStatus('Loaded '+state.items.length+' items / '+state.lines.length+' lines / '+state.rcAtlas.length+' RC entries / '+GOD_ATLAS_ENTRIES.length+' gods', 'ok'); }, 1200); });
  }

  function setAllGroups(open){
    var items = state.directoryView === 'book' ? filteredItems({ useCategory:false, useType:false }) : filteredItems();
    items = validItemRows(items);
    var keys = currentGroupKeys(items);
    keys.forEach(function(key){ state.openGroups[key] = open; });
    // V87: when the current directory is already on screen, expand/collapse in place.
    // This avoids a full list rebuild when repeatedly opening/closing Tin/Dei/Daai/Daily.
    if(els.list && keys.length){
      var allUpdated = true;
      keys.forEach(function(key){ if(!updateDirectoryGroupDom(key)) allUpdated = false; });
      if(allUpdated){ updateDirectoryActiveDom(); return; }
    }
    renderList();
  }


  function toTitleToken(t){
    t = String(t || '').trim().toLowerCase();
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : '';
  }
  function isCjk(ch){ return /[㐀-鿿]/.test(ch); }
  function hasCjkText(s){ return /[㐀-鿿]/.test(String(s || '')); }
  function isPunct(ch){ return /[，。！？；、,.;:!?]/.test(ch); }
  function stripAuditChineseInstructions(chinese){
    return String(chinese || '')
      .replace(/[（(][^）)]*(三稱|三称|[xX]?\s*\d+\s*[xX]?|repeat|section)[^）)]*[）)]/g, ' ')
      .replace(/\bX+\b/g, ' ');
  }
  function auditTokenSourceText(saam){
    return String(saam || '')
      .replace(/\(\s*\d+\s*x\s*\)/gi, ' ')
      .replace(/\(\s*x\s*\d+\s*\)/gi, ' ')
      .replace(/\b\d+\s*x\b/gi, ' ')
      .replace(/\bx\s*\d+\b/gi, ' ')
      .replace(/\bX+\b/g, ' ');
  }
  function currentTokens(saam){ return (auditTokenSourceText(saam).toLowerCase().match(/[a-z]+/g) || []); }
  function titleTokens(tokens){ return (tokens || []).map(toTitleToken).join(' '); }
  function isPrefixTokens(cur, master){
    if(!cur.length || cur.length >= master.length) return false;
    for(var i=0;i<cur.length;i++){ if(cur[i] !== master[i]) return false; }
    return true;
  }
  function tokensAppearInOrder(needles, haystack){
    var j = 0;
    needles = needles || []; haystack = haystack || [];
    for(var i=0;i<haystack.length && j<needles.length;i++){
      if(haystack[i] === needles[j]) j++;
    }
    return j === needles.length;
  }
  function isAuditPerformanceLine(line, item){
    line = line || {}; item = item || itemById(line.item_id) || {};
    var raw = [line.item_id, line.source_book, line.notes, item.english_title, item.chinese_title].join(' ').toLowerCase();
    return raw.indexOf('tao song') !== -1 || raw.indexOf('song_') !== -1 || raw.indexOf(' song') !== -1;
  }
  function isCantoneseAuditLine(line, item){
    line = line || {}; item = item || itemById(line.item_id) || {};
    var raw = [line.item_id, line.source_book, line.notes, item.english_title, item.chinese_title].join(' ').toLowerCase();
    return raw.indexOf('cantonese') !== -1;
  }
  function isAuditableSaamlawneseLine(line){
    var item = itemById(line && line.item_id) || {};
    if(isCantoneseAuditLine(line, item)) return false;
    return hasCjkText(stripAuditChineseInstructions(line && line.chinese));
  }
  function buildMasterMap(rows){
    var m = {};
    (rows || []).forEach(function(r){
      var ch = String(r.chinese_char || '').trim();
      var tok = String(r.token || '').trim().toLowerCase();
      if(ch && tok) m[ch] = tok;
    });
    return m;
  }
  function buildMasterFromChinese(chinese){
    chinese = stripAuditChineseInstructions(chinese);
    var chars = [];
    var tokens = [];
    var missing = [];
    var segments = [];
    var seg = [];
    String(chinese || '').split('').forEach(function(ch){
      if(isCjk(ch)){
        var tok = state.masterMap[ch];
        if(tok){ chars.push(ch); tokens.push(tok); seg.push(toTitleToken(tok)); }
        else { missing.push(ch); seg.push('['+ch+'?]'); }
      }else if(isPunct(ch)){
        if(seg.length){
          var mark = (ch === '。' || ch === '.' || ch === '！' || ch === '!' || ch === '？' || ch === '?') ? '.' : ',';
          segments.push(seg.join(' ') + mark);
          seg = [];
        }
      }
    });
    if(seg.length) segments.push(seg.join(' '));
    return { chars:chars, tokens:tokens, missing:uniq(missing), display:segments.join('\n') };
  }
  function exceptionKey(itemId, lineNo, ch, current, master){
    return [String(itemId||''), String(lineNo||''), String(ch||''), String(current||'').toLowerCase(), String(master||'').toLowerCase()].join('|');
  }
  function buildExceptionMap(rows){
    var map = {};
    (rows || []).forEach(function(r){
      var decision = String(r.decision || '').trim().toUpperCase();
      if(decision !== 'KEEP_CURRENT' && decision !== 'APPROVED_EXCEPTION' && decision !== 'IGNORE') return;
      var key = exceptionKey(r.item_id, r.line_no, r.chinese_char, r.current_token, r.master_token);
      map[key] = r;
    });
    return map;
  }
  function approvedExceptionForPattern(line, p){
    return state.exceptionMap[exceptionKey(line.item_id, line.line_no, p.char, p.current, p.master)] || null;
  }

  function auditLine(line){
    var item = itemById(line.item_id) || {};
    var master = buildMasterFromChinese(line.chinese || '');
    var cur = currentTokens(line.saamlawnese || '');
    var issues = [];
    var patterns = [];
    var approvedPatterns = [];
    var incomplete = isPrefixTokens(cur, master.tokens);
    var missingTokens = [];
    if(master.missing.length) issues.push('MISSING_MASTER_CHAR');
    if(isAuditPerformanceLine(line, item)){
      if(master.tokens.length && !tokensAppearInOrder(master.tokens, cur)){
        issues.push('MISMATCH');
      }
    }else if(incomplete){
      issues.push('INCOMPLETE_PINYIN');
      missingTokens = master.tokens.slice(cur.length);
    }else{
      var max = Math.max(master.tokens.length, cur.length);
      for(var i=0;i<max;i++){
        var mt = master.tokens[i] || '';
        var ct = cur[i] || '';
        if(mt && ct && mt !== ct){
          var pObj = { char: master.chars[i] || '', current: ct, master: mt, key:(master.chars[i]||'?')+'|'+ct+'|'+mt };
          if(approvedExceptionForPattern(line, pObj)){
            approvedPatterns.push(pObj);
          }else{
            issues.push('MISMATCH');
            patterns.push(pObj);
          }
        }else if(mt && !ct){
          issues.push('MISSING_PINYIN');
        }else if(!mt && ct){
          issues.push('EXTRA_PINYIN');
        }
      }
    }
    issues = uniq(issues);
    if(!issues.length){
      issues = approvedPatterns.length ? ['APPROVED_EXCEPTION'] : ['OK'];
    }
    var cls = issues.indexOf('OK') !== -1 ? 'ok' : (issues.indexOf('APPROVED_EXCEPTION') !== -1 ? 'exception' : (issues.indexOf('MISSING_MASTER_CHAR') !== -1 ? 'missing' : (issues.indexOf('INCOMPLETE_PINYIN') !== -1 ? 'incomplete' : 'mismatch')));
    return {
      id: String(line.item_id||'') + '__' + String(line.line_no||''),
      item_id: line.item_id || '', line_no: line.line_no || '', item:item, line:line,
      issues: issues, cls: cls, patterns: patterns, approvedPatterns: approvedPatterns, masterDisplay: master.display,
      currentTokens: cur.join(' '), masterTokens: master.tokens.join(' '), missingChars: master.missing,
      missingTokens: missingTokens, incompletePinyin: incomplete
    };
  }
  function runAudit(){
    state.masterMap = buildMasterMap(state.masterRows);
    state.exceptionMap = buildExceptionMap(state.exceptions);
    state.auditRows = state.lines.filter(function(l){ return String(l.item_id || '').trim() && isAuditableSaamlawneseLine(l); }).map(auditLine);
  }
  function auditIsProblem(a){ return a.issues.indexOf('OK') === -1 && a.issues.indexOf('APPROVED_EXCEPTION') === -1; }
  function auditFilterBaseRows(){
    var q = norm(state.query);
    return state.auditRows.filter(function(a){
      var item = a.item || {};
      if(state.type && item.type !== state.type) return false;
      if(state.category && !categoryMatchesItem(item, state.category)) return false;
      if(state.auditHideDecided && isAuditRowDecided(a)) return false;
      if(state.auditFilter === 'APPROVED_EXCEPTION') return a.issues.indexOf('APPROVED_EXCEPTION') !== -1;
      if(!state.auditShowExceptions && a.issues.indexOf('APPROVED_EXCEPTION') !== -1) return false;
      if(state.auditFilter === 'problem' && !auditIsProblem(a)) return false;
      if(state.auditFilter !== 'problem' && state.auditFilter !== 'all' && a.issues.indexOf(state.auditFilter) === -1) return false;
      if(q){
        var hay = norm([item.chinese_title,item.english_title,a.item_id,a.line_no,a.line.chinese,a.line.saamlawnese,a.line.english_translation,a.masterDisplay,a.issues.join(' ')].join(' '));
        if(hay.indexOf(q) === -1) return false;
      }
      return true;
    });
  }
  function auditFilteredRows(){
    return auditFilterBaseRows();
  }
  function auditPatternGroupsForRows(rows){
    return patternSummary(rows.filter(function(a){ return auditIsProblem(a) && a.patterns && a.patterns.length; }));
  }
  function auditNonPatternRowsForGroupedView(rows){
    return rows.filter(function(a){
      if(state.auditFilter === 'MISMATCH') return false;
      if(auditIsProblem(a) && a.patterns && a.patterns.length) return false;
      return true;
    });
  }
  function auditCounts(){
    var c = { all:state.auditRows.length, problem:0, OK:0, APPROVED_EXCEPTION:0, MISMATCH:0, MISSING_MASTER_CHAR:0, INCOMPLETE_PINYIN:0, MISSING_PINYIN:0, EXTRA_PINYIN:0 };
    state.auditRows.forEach(function(a){
      if(auditIsProblem(a)) c.problem++; else if(a.issues.indexOf('APPROVED_EXCEPTION') !== -1) c.APPROVED_EXCEPTION++; else c.OK++;
      a.issues.forEach(function(x){ c[x] = (c[x] || 0) + 1; });
    });
    return c;
  }
  function patternSummary(rows){
    var map = {};
    rows.forEach(function(a){
      a.patterns.forEach(function(p){
        if(!map[p.key]) map[p.key] = { key:p.key, char:p.char, current:p.current, master:p.master, count:0, ids:[] };
        map[p.key].count++; map[p.key].ids.push(a.id);
      });
    });
    return Object.values(map).sort(function(a,b){ return b.count - a.count; });
  }
  function decisionLabel(d){
    if(!d) return '';
    if(d.action === 'USE_MASTER') return 'USE MASTER VERSION';
    if(d.action === 'KEEP_CURRENT') return 'KEEP CURRENT';
    if(d.action === 'FLAG_REVIEW') return 'FLAG REVIEW';
    if(d.action === 'CUSTOM_MASTER_CHAR') return 'CUSTOM MASTER PINYIN: '+(d.chineseChar || '')+' = '+(d.customToken || '');
    return d.action || '';
  }
  function decisionClass(d){
    if(!d) return '';
    if(d.action === 'USE_MASTER') return 'use';
    if(d.action === 'KEEP_CURRENT') return 'keep';
    if(d.action === 'FLAG_REVIEW') return 'flag';
    if(d.action === 'CUSTOM_MASTER_CHAR') return 'custom';
    return '';
  }
  function decisionBadge(a){
    var d = state.auditDecisions[a.id];
    if(!d) return '';
    return '<span class="tydLib__decision '+decisionClass(d)+'">'+escapeHtml(decisionLabel(d))+'</span>';
  }
  function decisionBanner(a){
    var d = state.auditDecisions[a.id];
    if(!d) return '';
    var extra = '';
    if(d.action === 'CUSTOM_MASTER_CHAR') extra = '<div class="tydLib__customMini">This will tell me to update SLB master for '+escapeHtml(d.chineseChar || '')+' and then unify the affected book pinyin.</div>';
    return '<div class="tydLib__decisionBanner '+decisionClass(d)+'">DECISION MADE: '+escapeHtml(decisionLabel(d))+extra+'</div>';
  }
  function isAuditRowDecided(a){ return !!state.auditDecisions[a.id]; }

  function auditPanelTabs(){
    return '<div class="tydLib__auditTabs"><button type="button" class="tydLib__auditTab '+(state.auditPanel==='saamlawnese'?'active':'')+'" data-audit-panel="saamlawnese">Saamlawnese</button><button type="button" class="tydLib__auditTab '+(state.auditPanel==='review'?'active':'')+'" data-audit-panel="review">Review Log</button></div>';
  }

  function reviewStatus(r){ return String(r.status || '').trim().toLowerCase() || 'open'; }
  function reviewIsResolved(r){
    var st = reviewStatus(r);
    return st === 'resolved' || st === 'closed' || st === 'done' || st === 'fixed';
  }
  function reviewStatusClass(r){ return reviewIsResolved(r) ? 'resolved' : 'open'; }
  function reviewStatusLabel(r){ return reviewIsResolved(r) ? 'resolved' : (String(r.status || '').trim() || 'open'); }
  function reviewKey(r){
    return ['review', r._row_index != null ? r._row_index : '', r._sheet_row || '', r.date || '', r.book_id || '', r.item_id || '', r.line_no || '', r.problem || '', r.status || ''].join('||');
  }
  function reviewRowByKey(key){
    return state.review.find(function(r){ return reviewKey(r) === key; });
  }
  function reviewDecision(r){ return state.reviewDecisions[reviewKey(r)]; }
  function reviewDecisionClass(d){
    if(!d) return '';
    if(d.action === 'MARK_RESOLVED' || d.action === 'KEEP_RESOLVED') return 'resolve';
    if(d.action === 'KEEP_OPEN' || d.action === 'REOPEN') return 'open';
    if(d.action === 'NEEDS_EDIT') return 'edit';
    return '';
  }
  function reviewDecisionLabel(d){
    if(!d) return '';
    if(d.action === 'MARK_RESOLVED') return 'will mark resolved';
    if(d.action === 'KEEP_RESOLVED') return 'keep resolved';
    if(d.action === 'KEEP_OPEN') return 'keep open';
    if(d.action === 'REOPEN') return 'will reopen';
    if(d.action === 'NEEDS_EDIT') return 'needs edit/fix';
    return d.action || '';
  }
  function reviewDecisionBadge(r){
    var d = reviewDecision(r);
    if(!d) return '';
    return '<span class="tydLib__reviewDecision '+reviewDecisionClass(d)+'">'+escapeHtml(reviewDecisionLabel(d))+'</span>';
  }
  function reviewDecisionBanner(r){
    var d = reviewDecision(r);
    if(!d) return '';
    var msg = reviewDecisionLabel(d);
    if(d.action === 'MARK_RESOLVED') msg = 'APPROVE / RESOLVE: this Review_Log row will be marked resolved.';
    if(d.action === 'KEEP_OPEN') msg = 'KEEP OPEN: this issue stays open for later checking.';
    if(d.action === 'NEEDS_EDIT') msg = 'NEEDS EDIT / FIX: ChatGPT should fix the linked database row first, then mark this review row resolved after verifying.';
    if(d.action === 'REOPEN') msg = 'REOPEN: this resolved row will be changed back to open.';
    if(d.action === 'KEEP_RESOLVED') msg = 'KEEP RESOLVED: no database change needed for this row.';
    var detail = reviewFixSummary(d);
    return '<div class="tydLib__reviewDecisionBanner '+reviewDecisionClass(d)+'">DECISION MADE: '+escapeHtml(msg)+(detail?'<div style="font-size:13px;margin-top:6px;font-weight:850">'+escapeHtml(detail)+'</div>':'')+'</div>';
  }
  function reviewDecisionCounts(){
    var c = { total:0, MARK_RESOLVED:0, KEEP_OPEN:0, NEEDS_EDIT:0, REOPEN:0, KEEP_RESOLVED:0 };
    Object.keys(state.reviewDecisions).forEach(function(k){
      var d = state.reviewDecisions[k];
      if(!d || !d.action) return;
      c.total++;
      c[d.action] = (c[d.action] || 0) + 1;
    });
    return c;
  }
  function reviewFixClean(v){ return String(v == null ? '' : v).trim(); }
  function reviewFixSummary(d){
    if(!d) return '';
    var parts = [];
    if(d.fix_target) parts.push('Fix target: '+d.fix_target);
    if(d.correct_value) parts.push('Correct value: '+d.correct_value);
    if(d.fix_note) parts.push('Instruction: '+d.fix_note);
    if(d.fix_source) parts.push('Source choice: '+d.fix_source);
    return parts.join(' | ');
  }
  function collectReviewFixInputs(card){
    if(!card) return {};
    var target = card.querySelector('[data-review-fix-target]');
    var value = card.querySelector('[data-review-fix-value]');
    var note = card.querySelector('[data-review-fix-note]');
    var source = card.querySelector('[data-review-fix-source]');
    return {
      fix_target: target ? reviewFixClean(target.value) : '',
      correct_value: value ? reviewFixClean(value.value) : '',
      fix_note: note ? reviewFixClean(note.value) : '',
      fix_source: source ? reviewFixClean(source.value) : ''
    };
  }
  function hydrateReviewDecisionFromCard(card, action){
    var key = card ? card.getAttribute('data-review-key') : '';
    if(!key) return null;
    return setReviewDecisionByKey(key, action, collectReviewFixInputs(card));
  }
  function setReviewDecisionByKey(key, action, extra){
    var r = reviewRowByKey(key);
    if(!r) return null;
    var prev = state.reviewDecisions[key] || {};
    var d = { action:action, notes:'clicked in Review Log UI', sheet_row:r._sheet_row || '' };
    ['fix_target','correct_value','fix_note','fix_source'].forEach(function(k){
      var v = extra && extra[k] !== undefined ? extra[k] : prev[k];
      if(reviewFixClean(v)) d[k] = reviewFixClean(v);
    });
    var detail = reviewFixSummary(d);
    if(detail) d.notes = detail;
    state.reviewDecisions[key] = d;
    setStatus('Review decision saved: '+reviewDecisionLabel(state.reviewDecisions[key])+(detail?' with fix instruction':''), 'ok');
    return d;
  }
  function clearReviewDecisionByKey(key){
    if(state.reviewDecisions[key]) delete state.reviewDecisions[key];
    setStatus('Review decision cleared', 'ok');
  }
  function reviewRowsWithDecisions(){
    return state.review.filter(function(r){ return !!reviewDecision(r); });
  }
  function reviewDecisionIsApproved(d){
    return !!(d && (d.action === 'MARK_RESOLVED' || d.action === 'KEEP_RESOLVED'));
  }
  function reviewApprovedOrResolved(r){
    return reviewIsResolved(r) || reviewDecisionIsApproved(reviewDecision(r));
  }
  function reviewDuplicateKey(r){
    var nums = reviewLineNumbers(r.line_no);
    var lineKey = nums.length ? nums.join('-') : String(r.line_no || '').trim().toLowerCase();
    var problemKey = norm(String(r.problem || '').replace(/\s+/g, ' '));
    return norm([r.book_id || '', r.item_id || '', lineKey, problemKey].join(' || '));
  }
  function reviewHideApprovedFilter(rows){
    if(!state.reviewHideApproved || state.reviewFilter === 'resolved') return rows;
    return rows.filter(function(r){ return !reviewApprovedOrResolved(r); });
  }
  function reviewHideDuplicateFilter(rows){
    if(!state.reviewHideDuplicates) return rows;
    var seen = {};
    return rows.filter(function(r){
      var key = reviewDuplicateKey(r);
      if(!key) return true;
      if(seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }
  function reviewBaseRows(){
    var q = norm(state.query);
    return state.review.filter(function(r){
      var item = itemById(r.item_id) || {};
      if(state.type && item.type !== state.type) return false;
      if(state.category && !categoryMatchesItem(item, state.category)) return false;
      if(state.reviewFilter === 'open' && reviewIsResolved(r)) return false;
      if(state.reviewFilter === 'resolved' && !reviewIsResolved(r)) return false;
      if(q){
        var book = bookById(r.book_id) || {};
        var linked = linesForReview(r).map(function(l){ return [l.chinese,l.saamlawnese,l.english_translation,l.notes].join(' '); }).join(' ');
        var hay = norm([r.date,r.book_id,r.item_id,r.line_no,r.problem,r.fixed_by,r.status,item.chinese_title,item.english_title,book.book_title_chinese,book.book_title_english,linked].join(' '));
        if(hay.indexOf(q) === -1) return false;
      }
      return true;
    }).sort(function(a,b){
      if(reviewIsResolved(a) !== reviewIsResolved(b)) return reviewIsResolved(a) ? 1 : -1;
      return String(b.date || '').localeCompare(String(a.date || ''));
    });
  }
  function reviewDisplayStats(){
    var base = reviewBaseRows();
    var approvedFiltered = reviewHideApprovedFilter(base);
    var duplicateFiltered = reviewHideDuplicateFilter(approvedFiltered);
    return {
      base:base.length,
      shown:duplicateFiltered.length,
      hiddenApproved:base.length - approvedFiltered.length,
      hiddenDuplicates:approvedFiltered.length - duplicateFiltered.length
    };
  }
  function reviewCounts(){
    var c = { all:state.review.length, open:0, resolved:0 };
    state.review.forEach(function(r){ if(reviewIsResolved(r)) c.resolved++; else c.open++; });
    return c;
  }
  function reviewLineNumbers(raw){
    var text = String(raw || '').toLowerCase().replace(/line|lines/g,'');
    var nums = [];
    var re = /(\d+)\s*-\s*(\d+)|(\d+)/g;
    var m;
    while((m = re.exec(text))){
      if(m[1] && m[2]){
        var a = Number(m[1]), b = Number(m[2]);
        if(a && b){ for(var n=Math.min(a,b); n<=Math.max(a,b); n++) nums.push(String(n)); }
      }else if(m[3]){ nums.push(String(Number(m[3]))); }
    }
    return uniq(nums);
  }
  function linesForReview(r){
    var itemId = String(r.item_id || '').trim();
    if(!itemId) return [];
    var nums = reviewLineNumbers(r.line_no);
    var rows = lineRows(itemId);
    if(!nums.length) return rows.slice(0, 12);
    return rows.filter(function(l){ return nums.indexOf(String(Number(l.line_no || 0))) !== -1 || nums.indexOf(String(l.line_no || '')) !== -1; });
  }
  function reviewFixOptionsHtml(selected){
    var opts = [
      ['AUTO_DETECT','Auto detect from problem'],
      ['ITEM_CHINESE_TITLE','Item Chinese title'],
      ['ITEM_ENGLISH_TITLE','Item English title'],
      ['BOOK_CHINESE_TITLE','Book Chinese title'],
      ['BOOK_ENGLISH_TITLE','Book English title'],
      ['LINE_CHINESE','Line Chinese'],
      ['LINE_SAAMLAWNESE','Line Saamlawnese'],
      ['LINE_ENGLISH','Line English translation'],
      ['LINE_NOTES','Line notes'],
      ['REVIEW_PROBLEM_TEXT','Review problem wording'],
      ['STATUS_ONLY','Review status only'],
      ['OTHER','Other / explain in note']
    ];
    return opts.map(function(o){ return '<option value="'+escapeHtml(o[0])+'" '+(selected===o[0]?'selected':'')+'>'+escapeHtml(o[1])+'</option>'; }).join('');
  }
  function reviewQuickChoiceButtons(item, book, linkedLines){
    var first = linkedLines && linkedLines.length ? linkedLines[0] : {};
    var choices = [];
    function add(label, target, value){ if(value) choices.push({label:label,target:target,value:String(value)}); }
    add('Use item Chinese title', 'ITEM_CHINESE_TITLE', item.chinese_title);
    add('Use item English title', 'ITEM_ENGLISH_TITLE', item.english_title);
    add('Use book Chinese title', 'BOOK_CHINESE_TITLE', book.book_title_chinese);
    add('Use book English title', 'BOOK_ENGLISH_TITLE', book.book_title_english);
    add('Use line Chinese', 'LINE_CHINESE', first.chinese);
    add('Use line Saamlawnese', 'LINE_SAAMLAWNESE', first.saamlawnese);
    add('Use line English', 'LINE_ENGLISH', first.english_translation);
    if(!choices.length) return '';
    return '<div class="tydLib__reviewQuickChoices">'+choices.map(function(c){ return '<button type="button" data-review-fill="1" data-review-fill-target="'+escapeHtml(c.target)+'" data-review-fill-value="'+escapeHtml(c.value)+'">'+escapeHtml(c.label)+'</button>'; }).join('')+'</div>';
  }
  function renderReviewFixBox(r, item, book, linkedLines, d){
    d = d || {};
    var target = d.fix_target || 'AUTO_DETECT';
    var correct = d.correct_value || '';
    var note = d.fix_note || '';
    var source = d.fix_source || '';
    var quick = reviewQuickChoiceButtons(item || {}, book || {}, linkedLines || []);
    var saved = reviewFixSummary(d);
    return '<div class="tydLib__reviewFixBox">' +
      '<div class="tydLib__reviewFixTitle">Fix instruction / what should be right</div>' +
      '<div class="tydLib__small">Use this when the problem is something like title mismatch, wrong line content, wrong translation, wrong Saamlawnese, or duplicate/unclear issue. Type what should be kept or corrected, then click <b>Save Fix Instruction</b> or <b>Needs Edit / Fix</b>.</div>' +
      (saved ? '<div class="tydLib__reviewSavedFix">Saved: '+escapeHtml(saved)+'</div>' : '') +
      '<div class="tydLib__reviewFixGrid">' +
        '<div class="tydLib__reviewFixField"><label>What field/problem?</label><select data-review-fix-target="1">'+reviewFixOptionsHtml(target)+'</select></div>' +
        '<div class="tydLib__reviewFixField"><label>Correct value / what to keep</label><textarea data-review-fix-value="1" placeholder="Example: Keep the English title as: ... or Change the Chinese title to: ...">'+escapeHtml(correct)+'</textarea></div>' +
      '</div>' +
      '<div class="tydLib__reviewFixField"><label>Extra instruction for ChatGPT</label><textarea data-review-fix-note="1" placeholder="Example: The problem is saying the title differs. Keep the title from the Items tab and update the Review_Log row as resolved after checking.">'+escapeHtml(note)+'</textarea></div>' +
      '<input type="hidden" data-review-fix-source="1" value="'+escapeHtml(source)+'">' +
      (quick ? '<div><div class="tydLib__label">Quick fill from current linked data</div>'+quick+'</div>' : '') +
      '<div class="tydLib__reviewActions" style="padding:0"><button type="button" class="tydLib__btn secondary" data-review-save-fix="1">Save Fix Instruction</button><button type="button" class="tydLib__btn secondary" data-review-action="NEEDS_EDIT">Needs Edit / Fix</button></div>' +
    '</div>';
  }
  function filteredReviewRows(){
    return reviewHideDuplicateFilter(reviewHideApprovedFilter(reviewBaseRows()));
  }
  function renderReviewSidebar(){
    var c = reviewCounts();
    var rows = filteredReviewRows();
    var filters = [['open','Open',c.open], ['resolved','Resolved',c.resolved], ['all','All',c.all]];
    var html = auditPanelTabs();
    html += '<div class="tydLib__auditBackWrap"><a class="tydLib__btn secondary tydLib__auditBackBtn" href="/pages/tyd-lineage-library">← Back to Main Library</a></div>';
    var dc = reviewDecisionCounts();
    var ds = reviewDisplayStats();
    html += '<div class="tydLib__auditNotice">Review Log is the work queue from the database. Click decisions on each issue, then copy an apply prompt. The website itself still reads the Sheet only; ChatGPT applies the changes to the database.</div>';
    html += '<div class="tydLib__auditSummary"><div class="tydLib__auditStat"><strong>'+c.open+'</strong><span>Open</span></div><div class="tydLib__auditStat"><strong>'+c.resolved+'</strong><span>Resolved</span></div><div class="tydLib__auditStat"><strong>'+c.all+'</strong><span>Total</span></div><div class="tydLib__auditStat"><strong>'+dc.total+'</strong><span>Clicked</span></div></div>';
    html += '<div class="tydLib__auditControls"><label class="tydLib__auditToggle"><input type="checkbox" data-toggle-review-hide-approved="1" '+(state.reviewHideApproved?'checked':'')+'> Hide approved / resolved</label><label class="tydLib__auditToggle"><input type="checkbox" data-toggle-review-hide-duplicates="1" '+(state.reviewHideDuplicates?'checked':'')+'> Hide duplicate issues</label><div class="tydLib__decidedCount">'+ds.shown+' shown · '+ds.hiddenApproved+' approved hidden · '+ds.hiddenDuplicates+' duplicates hidden</div></div>';
    html += '<div class="tydLib__auditFilters">'+filters.map(function(f){ return '<button type="button" class="tydLib__auditFilter '+(state.reviewFilter===f[0]?'active':'')+'" data-review-filter="'+escapeHtml(f[0])+'">'+escapeHtml(f[1])+' <span style="float:right">'+f[2]+'</span></button>'; }).join('')+'</div>';
    html += '<div style="padding:8px"><button type="button" class="tydLib__copyBig" data-copy-review-decisions="1">COPY CLICKED DECISIONS ('+dc.total+')</button><button type="button" class="tydLib__btn secondary" style="width:100%;margin-top:8px" data-copy-review-log="1">Copy all shown review rows</button><div class="tydLib__small">Use the fix box on each card when you need to type the correct title/line/translation. Hidden approved rows are still included when you copy clicked decisions.</div></div>';
    els.list.innerHTML = html;
    els.count.textContent = rows.length + ' shown';
  }

  function renderAuditSidebar(){
    var c = auditCounts();
    var rows = auditFilteredRows();
    var decided = Object.keys(state.auditDecisions).length;
    var filters = [
      ['problem','Problems only',c.problem], ['INCOMPLETE_PINYIN','Incomplete pinyin',c.INCOMPLETE_PINYIN||0], ['MISMATCH','Token mismatch',c.MISMATCH||0], ['MISSING_MASTER_CHAR','Missing master char',c.MISSING_MASTER_CHAR||0],
      ['MISSING_PINYIN','Missing pinyin',c.MISSING_PINYIN||0], ['EXTRA_PINYIN','Extra pinyin',c.EXTRA_PINYIN||0], ['APPROVED_EXCEPTION','Approved exceptions',c.APPROVED_EXCEPTION||0], ['all','All rows',c.all]
    ];
    var html = auditPanelTabs();
    html += '<div class="tydLib__auditBackWrap"><a class="tydLib__btn secondary tydLib__auditBackBtn" href="/pages/tyd-lineage-library">← Back to Main Library</a></div>';
    html += '<div class="tydLib__auditNotice">Audit mode compares the library Saamlawnese against the SLB master. Approved KEEP_CURRENT exceptions are hidden by default, so choices like 關 = guan do not keep coming back.</div>';
    html += '<div class="tydLib__auditSummary"><div class="tydLib__auditStat"><strong>'+c.problem+'</strong><span>Problems</span></div><div class="tydLib__auditStat"><strong>'+c.OK+'</strong><span>OK rows</span></div><div class="tydLib__auditStat"><strong>'+c.APPROVED_EXCEPTION+'</strong><span>Exceptions</span></div><div class="tydLib__auditStat"><strong>'+Object.keys(state.masterMap).length+'</strong><span>Master chars</span></div></div>';
    html += '<div class="tydLib__auditNotice" style="background:#f5fff5;border-color:#b7ddb7;color:#245524">Master test: 三='+escapeHtml(state.masterMap['三']||'missing')+' · 羅='+escapeHtml(state.masterMap['羅']||'missing')+' · 神='+escapeHtml(state.masterMap['神']||'missing')+' · 法='+escapeHtml(state.masterMap['法']||'missing')+'</div>';
    html += '<div class="tydLib__auditControls"><label class="tydLib__auditToggle"><input type="checkbox" data-toggle-hide-decided="1" '+(state.auditHideDecided?'checked':'')+'> Hide decided rows</label><label class="tydLib__auditToggle"><input type="checkbox" data-toggle-group-duplicates="1" '+(state.auditGroupDuplicates?'checked':'')+'> Group duplicate word problems</label><label class="tydLib__auditToggle"><input type="checkbox" data-toggle-show-exceptions="1" '+(state.auditShowExceptions?'checked':'')+'> Show approved exceptions</label><div class="tydLib__decidedCount">'+decided+' decisions made</div></div>';
    html += '<div class="tydLib__auditFilters">'+filters.map(function(f){ return '<button type="button" class="tydLib__auditFilter '+(state.auditFilter===f[0]?'active':'')+'" data-audit-filter="'+escapeHtml(f[0])+'">'+escapeHtml(f[1])+' <span style="float:right">'+f[2]+'</span></button>'; }).join('')+'</div>';
    if((c.INCOMPLETE_PINYIN||0) > 0){
      html += '<div style="padding:8px"><button type="button" class="tydLib__copyBig" style="background:#d88a00" data-use-master-incomplete="1">USE MASTER FOR ALL INCOMPLETE PINYIN</button><div class="tydLib__small">This is for book line-wrap mistakes: current pinyin is only the first part, and the SLB master can rebuild the full line.</div></div>';
    }
    var patterns = patternSummary(state.auditRows.filter(auditIsProblem));
    if(patterns.length){
      html += '<div class="tydLib__panelHead"><h2>Repeated patterns</h2><span>top '+patterns.length+'</span></div><div class="tydLib__patternList">';
      patterns.forEach(function(p, idx){
        html += '<div class="tydLib__pattern"><div><strong>'+p.count+' places</strong> for <code>'+escapeHtml(p.char)+'</code></div><div>Current: <code>'+escapeHtml(p.current)+'</code></div><div>Master: <code>'+escapeHtml(p.master)+'</code></div><button type="button" class="tydLib__miniBtn" style="margin-top:7px" data-pattern-use="'+escapeHtml(p.key)+'">Use master for this pattern</button><div class="tydLib__patternCustom"><input type="text" data-pattern-custom-input="'+escapeHtml(p.key)+'" placeholder="custom pinyin"><button type="button" class="tydLib__miniBtn" data-pattern-custom="'+escapeHtml(p.key)+'">Use custom</button></div></div>';
      });
      html += '</div>';
    }
    html += '<div style="padding:8px"><button type="button" class="tydLib__copyBig" data-copy-fixes="1">COPY CHATGPT APPLY PROMPT</button><div class="tydLib__small">Approve rows or repeated patterns first, then copy the list and paste it back here.</div></div>';
    els.list.innerHTML = html;
    els.count.textContent = rows.length + ' shown';
  }
  function customRowsHtml(a){
    var patterns = a.patterns || [];
    var missing = (a.missingChars || []).map(function(ch){ return { char:ch, current:'', master:'' }; });
    var combined = patterns.map(function(p){ return { char:p.char, current:p.current, master:p.master, key:p.key }; }).concat(missing);
    if(!combined.length) return '';
    var rows = combined.map(function(p, idx){
      var key = p.key || ('missing|'+p.char);
      return '<div class="tydLib__customRow" data-custom-key="'+escapeHtml(key)+'" data-custom-char="'+escapeHtml(p.char)+'" data-current-token="'+escapeHtml(p.current || '')+'" data-master-token="'+escapeHtml(p.master || '')+'"><div><div class="tydLib__customChar">'+escapeHtml(p.char || '?')+'</div><div class="tydLib__customMini">Chinese char</div></div><div><div class="tydLib__customMini">Current: <strong>'+escapeHtml(p.current || 'none')+'</strong></div><div class="tydLib__customMini">Master: <strong>'+escapeHtml(p.master || 'missing')+'</strong></div></div><div><label>Custom pinyin</label><input type="text" data-custom-token="'+escapeHtml(key)+'" placeholder="type custom pinyin"></div><button type="button" class="tydLib__btn secondary" data-custom-char-apply="'+escapeHtml(key)+'">Use Custom</button></div>';
    }).join('');
    return '<div class="tydLib__customPanel"><div class="tydLib__label">Custom pinyin / update SLB master</div>'+rows+'</div>';
  }
  function patternDecisionStats(p){
    var decided = 0;
    p.ids.forEach(function(id){ if(state.auditDecisions[id]) decided++; });
    return { decided:decided, total:p.ids.length };
  }
  function renderAuditPatternCard(p){
    var stats = patternDecisionStats(p);
    var examples = p.ids.map(function(id){ return state.auditRows.find(function(a){ return a.id === id; }); }).filter(Boolean).slice(0,6);
    var decidedClass = stats.decided === stats.total && stats.total > 0 ? ' decided' : '';
    var exampleHtml = examples.map(function(a){
      var item = a.item || {};
      return '<div class="tydLib__small">• '+escapeHtml(item.chinese_title || a.item_id)+' · line '+escapeHtml(a.line_no)+' · '+escapeHtml(a.line.chinese || '')+'</div>';
    }).join('');
    var hiddenCount = Math.max(0, p.count - examples.length);
    if(hiddenCount) exampleHtml += '<div class="tydLib__small">+'+hiddenCount+' more places with the same word problem.</div>';
    return '<article class="tydLib__auditCard mismatch patternGrouped'+decidedClass+'" data-pattern-card="'+escapeHtml(p.key)+'">' +
      '<div class="tydLib__auditHead"><div><div class="tydLib__auditTitle">Grouped word problem: '+escapeHtml(p.char)+' </div><div class="tydLib__auditSub">'+p.count+' places · current '+escapeHtml(p.current)+' → master '+escapeHtml(p.master)+'</div></div><div><span class="tydLib__tag warn">GROUPED MISMATCH</span> <span class="tydLib__decision '+(stats.decided?'use':'')+'">'+stats.decided+'/'+stats.total+' decided</span></div></div>' +
      '<div class="tydLib__decisionBanner '+(stats.decided?'use':'')+'">ONE DECISION CAN FIX ALL: '+escapeHtml(p.char)+' current '+escapeHtml(p.current)+' → master '+escapeHtml(p.master)+'</div>' +
      '<div class="tydLib__auditBody">' +
        '<div class="tydLib__auditBox"><div class="tydLib__label">Problem Chinese word</div><div class="tydLib__zh">'+escapeHtml(p.char)+'</div></div>' +
        '<div class="tydLib__auditBox current"><div class="tydLib__label">Current in Library</div><div class="tydLib__saam">'+escapeHtml(p.current)+'</div></div>' +
        '<div class="tydLib__auditBox master"><div class="tydLib__label">SLB Master</div><div class="tydLib__saam">'+escapeHtml(p.master)+'</div></div>' +
        '<div class="tydLib__auditBox"><div class="tydLib__label">Examples</div>'+exampleHtml+'</div>' +
      '</div>' +
      '<div class="tydLib__auditActions"><button type="button" class="tydLib__btn" data-pattern-use-main="'+escapeHtml(p.key)+'">Use Master For All '+p.count+'</button><button type="button" class="tydLib__btn secondary" data-pattern-keep-main="'+escapeHtml(p.key)+'">Keep Current For All</button><button type="button" class="tydLib__btn secondary" data-pattern-flag-main="'+escapeHtml(p.key)+'">Flag All For Review</button></div>' +
      '<div class="tydLib__customPanel"><div class="tydLib__label">Custom pinyin / update SLB master for this word</div><div class="tydLib__customRow"><div><div class="tydLib__customChar">'+escapeHtml(p.char)+'</div><div class="tydLib__customMini">Chinese char</div></div><div><div class="tydLib__customMini">Current: <strong>'+escapeHtml(p.current)+'</strong></div><div class="tydLib__customMini">Master: <strong>'+escapeHtml(p.master)+'</strong></div></div><div><label>Custom pinyin</label><input type="text" data-pattern-custom-input-main="'+escapeHtml(p.key)+'" placeholder="type custom pinyin"></div><button type="button" class="tydLib__btn secondary" data-pattern-custom-main="'+escapeHtml(p.key)+'">Use Custom For All</button></div></div>' +
    '</article>';
  }
  function renderAuditCard(a){
    var item = a.item || {};
    var d = state.auditDecisions[a.id];
    var decision = decisionBadge(a);
    var issueTags = a.issues.map(function(x){ return '<span class="tydLib__tag '+(x==='OK'?'':'warn')+'">'+escapeHtml(x)+'</span>'; }).join('');
    var missing = a.missingChars && a.missingChars.length ? '<div class="tydLib__missing">Missing in master: '+escapeHtml(a.missingChars.join(', '))+'</div>' : '';
    var incomplete = a.incompletePinyin ? '<div class="tydLib__incomplete">Likely book line-wrap mistake. Current pinyin is missing the end: <code>'+escapeHtml(titleTokens(a.missingTokens))+'</code></div>' : '';
    var mismatchText = a.patterns.length ? '<div class="tydLib__small">'+a.patterns.map(function(p){ return escapeHtml(p.char)+' current '+escapeHtml(p.current)+' → master '+escapeHtml(p.master); }).join('<br>')+'</div>' : '';
    var selected = d ? d.action : '';
    return '<article class="tydLib__auditCard '+escapeHtml(a.cls)+' '+(d?'decided':'')+'" data-audit-id="'+escapeHtml(a.id)+'">' +
      '<div class="tydLib__auditHead"><div><div class="tydLib__auditTitle">'+escapeHtml(item.chinese_title || a.item_id)+' / '+escapeHtml(item.english_title || '')+'</div><div class="tydLib__auditSub">'+escapeHtml(a.item_id)+' · line '+escapeHtml(a.line_no)+' · '+escapeHtml(a.line.source_book || '')+'</div></div><div>'+issueTags+' '+decision+'</div></div>' +
      decisionBanner(a) +
      '<div class="tydLib__auditBody">' +
        '<div class="tydLib__auditBox"><div class="tydLib__label">Chinese</div><div class="tydLib__zh">'+escapeHtml(a.line.chinese || '')+'</div></div>' +
        '<div class="tydLib__auditBox current"><div class="tydLib__label">Current in Library</div><div class="tydLib__saam">'+escapeHtml(a.line.saamlawnese || '')+'</div></div>' +
        '<div class="tydLib__auditBox master"><div class="tydLib__label">Master Version from SLB</div><div class="tydLib__saam">'+escapeHtml(a.masterDisplay || '')+'</div>'+missing+incomplete+mismatchText+'</div>' +
      '</div>' +
      (a.issues.indexOf('OK') === -1 ? '<div class="tydLib__auditActions"><button type="button" class="tydLib__btn '+(selected==='USE_MASTER'?'selected':'')+'" data-audit-action="USE_MASTER">Use Master Version</button><button type="button" class="tydLib__btn secondary '+(selected==='KEEP_CURRENT'?'selected':'')+'" data-audit-action="KEEP_CURRENT">Keep Current</button><button type="button" class="tydLib__btn secondary '+(selected==='FLAG_REVIEW'?'selected':'')+'" data-audit-action="FLAG_REVIEW">Flag Review</button></div>'+customRowsHtml(a) : '') +
    '</article>';
  }
  function csvEscape(v){ v = String(v == null ? '' : v).replace(/"/g,'""'); return '"'+v+'"'; }
  function renderApprovedFixCsv(){
    var lines = ['action,target,item_id,line_no,chinese_char,current_token,master_token,custom_token,chinese,current_saamlawnese,master_saamlawnese,source_book,notes'];
    Object.keys(state.auditDecisions).sort().forEach(function(id){
      var d = state.auditDecisions[id];
      var a = state.auditRows.find(function(x){ return x.id === id; });
      if(!a) return;
      var target = d.action === 'CUSTOM_MASTER_CHAR' ? 'MASTER_CHAR_AND_LINES' : 'LINES';
      var row = [d.action,target,a.item_id,a.line_no,d.chineseChar || '',d.currentToken || '',d.masterToken || '',d.customToken || '',a.line.chinese,a.line.saamlawnese,a.masterDisplay,a.line.source_book,d.notes || ''];
      lines.push(row.map(csvEscape).join(','));
    });
    return lines.join('\n');
  }
  function renderApprovedFixText(){
    var csv = renderApprovedFixCsv();
    var decisionCount = Math.max(0, csv.split('\n').length - 1);
    return [
      'TYD_LINEAGE_LIBRARY_SAAMLAWNESE_AUDIT_APPLY_PROMPT',
      '',
      'ChatGPT, apply this to the Google Sheet database: TYD Lineage Content Library.',
      'Spreadsheet ID: '+root.getAttribute('data-sheet-id'),
      '',
      'IMPORTANT ACTION RULES:',
      '1. USE_MASTER = update Lines.saamlawnese to master_saamlawnese for that item_id + line_no. Also remove any matching Saamlawnese_Exceptions row for that same item_id + line_no + mismatch if it exists.',
      '2. KEEP_CURRENT = do NOT change Lines.saamlawnese. Add or keep this as a Saamlawnese_Exceptions row so the audit will treat it as approved exception.',
      '3. CUSTOM_MASTER_CHAR = update the SLB master character token using custom_token, then rebuild/update affected Lines from that custom master token.',
      '4. FLAG_REVIEW = do not change Lines. Add this to Review_Log for human checking.',
      '5. After applying, add a short resolved summary row to Review_Log and verify a few changed Lines cells.',
      '',
      'NOTE FOR JEE SIFU / CHATGPT:',
      'If Jee Sifu writes something like "use master for all", "fix all shown", or "change these to master", then override KEEP_CURRENT and treat the pasted visible rows as USE_MASTER. Otherwise follow the action column exactly.',
      '',
      'Decision rows: '+decisionCount,
      '',
      'CSV_START',
      csv,
      'CSV_END'
    ].join('\n');
  }
  function applyPatternDecision(key, action, custom){
    state.auditRows.forEach(function(a){
      var p = a.patterns.find(function(x){ return x.key === key; });
      if(!p) return;
      if(action === 'CUSTOM_MASTER_CHAR'){
        state.auditDecisions[a.id] = { action:'CUSTOM_MASTER_CHAR', chineseChar:p.char, currentToken:p.current, masterToken:p.master, customToken:custom || '', notes:'custom grouped pattern '+key };
      }else{
        state.auditDecisions[a.id] = { action:action, notes:'grouped pattern '+key };
      }
    });
  }
  function copyApprovedFixes(){
    var txt = renderApprovedFixText();
    if(navigator.clipboard){ navigator.clipboard.writeText(txt).then(function(){ setStatus('ChatGPT apply prompt copied', 'ok'); }); }
    els.reader.innerHTML = '<div class="tydLib__readerTop"><div><div class="tydLib__titleZh">Approved Decision List</div><div class="tydLib__titleEn">Copy this ChatGPT-ready prompt and paste it here if clipboard did not work.</div></div><div class="tydLib__readerBtns"><button class="tydLib__btn secondary" type="button" data-back-audit="1">Back to audit</button></div></div><textarea class="tydLib__copyArea" readonly>'+escapeHtml(txt)+'</textarea>';
  }
  function renderAuditView(){
    var rows = auditFilteredRows();
    renderAuditSidebar();
    var approved = Object.keys(state.auditDecisions).length;
    var useGrouped = state.auditGroupDuplicates && (state.auditFilter === 'problem' || state.auditFilter === 'MISMATCH' || state.auditFilter === 'all');
    var patternGroups = useGrouped ? auditPatternGroupsForRows(rows) : [];
    var displayRows = useGrouped ? auditNonPatternRowsForGroupedView(rows) : rows;
    var shownCount = useGrouped ? (patternGroups.length + displayRows.length) : rows.length;
    if(!shownCount){
      els.reader.innerHTML = '<div class="tydLib__auditEmpty"><h2>No audit rows to show</h2><p>Try changing the filter/search, or turn off Hide decided rows.</p><a class="tydLib__btn secondary tydLib__auditBackBtn" href="/pages/tyd-lineage-library">Back to Library</a><button type="button" class="tydLib__copyBig" data-copy-fixes-main="1">COPY CHATGPT APPLY PROMPT</button></div>';
      return;
    }
    var groupedNote = useGrouped ? '<div class="tydLib__auditNotice" style="margin-top:10px">Grouped mode is ON: the big list shows each repeated word problem once. Example: 關 appears as one grouped card instead of many repeated line cards.</div>' : '';
    els.reader.innerHTML = '<div class="tydLib__readerTop"><div><div class="tydLib__titleZh">Saamlawnese Audit</div><div class="tydLib__titleEn">Showing '+shownCount+' review cards · '+approved+' decisions made</div><div class="tydLib__meta"><span class="tydLib__tag">SLB master</span><span class="tydLib__tag">read only website</span><span class="tydLib__tag">grouping '+(state.auditGroupDuplicates?'on':'off')+'</span></div><label class="tydLib__auditToggle" style="margin-top:10px"><input type="checkbox" data-toggle-hide-decided="1" '+(state.auditHideDecided?'checked':'')+'> Hide decided rows</label><label class="tydLib__auditToggle" style="margin-top:8px"><input type="checkbox" data-toggle-group-duplicates="1" '+(state.auditGroupDuplicates?'checked':'')+'> Group duplicate word problems</label><label class="tydLib__auditToggle" style="margin-top:8px"><input type="checkbox" data-toggle-show-exceptions="1" '+(state.auditShowExceptions?'checked':'')+'> Show approved exceptions</label>'+groupedNote+'</div><div class="tydLib__readerBtns"><a class="tydLib__btn secondary" href="/pages/tyd-lineage-library">Back to Library</a></div></div>' +
      '<div class="tydLib__auditCards">' + patternGroups.map(renderAuditPatternCard).join('') + displayRows.map(renderAuditCard).join('') + '</div><button type="button" class="tydLib__copyBig" data-copy-fixes-main="1">COPY CHATGPT APPLY PROMPT</button><div class="tydLib__small">Paste the copied ChatGPT-ready prompt back here. It includes the rules for USE_MASTER, KEEP_CURRENT, CUSTOM_MASTER_CHAR, and FLAG_REVIEW.</div>';
  }
  function renderReviewLogCard(r, idx){
    var item = itemById(r.item_id) || {};
    var book = bookById(r.book_id) || {};
    var statusCls = reviewStatusClass(r);
    var statusLabel = reviewStatusLabel(r);
    var key = reviewKey(r);
    var d = reviewDecision(r);
    var selected = d ? d.action : '';
    var linkedLines = linesForReview(r);
    var lineHtml = '';
    if(linkedLines.length){
      lineHtml = linkedLines.map(function(l){
        return '<div class="tydLib__reviewLineBox"><div class="tydLib__lineHead"><span>Line '+escapeHtml(l.line_no || '')+'</span><span>'+escapeHtml(l.status || '')+'</span></div><div class="tydLib__field"><div class="tydLib__label">Chinese</div><div class="tydLib__zh">'+escapeHtml(cleanLineText(l.chinese || ''))+'</div></div><div class="tydLib__field"><div class="tydLib__label">Saamlawnese</div><div class="tydLib__saam">'+escapeHtml(cleanLineText(l.saamlawnese || ''))+'</div></div><div class="tydLib__field"><div class="tydLib__label">English</div><div class="tydLib__en">'+escapeHtml(cleanLineText(l.english_translation || ''))+'</div></div>'+(l.notes?'<div class="tydLib__field"><div class="tydLib__label">Line notes</div><div class="tydLib__en">'+escapeHtml(l.notes)+'</div></div>':'')+'</div>';
      }).join('');
    }else{
      lineHtml = '<div class="tydLib__reviewLineBox"><div class="tydLib__small">No matching Lines row found. This may be a whole-item or whole-book review note.</div></div>';
    }
    var title = item.chinese_title || r.item_id || 'Review note';
    var sub = [r.book_id || '', book.book_title_english || '', r.item_id || '', r.line_no ? ('line '+r.line_no) : ''].filter(Boolean).join(' · ');
    var actionBtns = '';
    if(reviewIsResolved(r)){
      actionBtns += '<button type="button" class="tydLib__btn '+(selected==='REOPEN'?'selected':'')+'" data-review-action="REOPEN">Reopen</button>';
      actionBtns += '<button type="button" class="tydLib__btn secondary '+(selected==='KEEP_RESOLVED'?'selected':'')+'" data-review-action="KEEP_RESOLVED">Keep Resolved</button>';
    }else{
      actionBtns += '<button type="button" class="tydLib__btn '+(selected==='MARK_RESOLVED'?'selected':'')+'" data-review-action="MARK_RESOLVED">Approve / Mark Resolved</button>';
      actionBtns += '<button type="button" class="tydLib__btn secondary '+(selected==='NEEDS_EDIT'?'selected':'')+'" data-review-action="NEEDS_EDIT">Needs Edit / Fix</button>';
      actionBtns += '<button type="button" class="tydLib__btn secondary '+(selected==='KEEP_OPEN'?'selected':'')+'" data-review-action="KEEP_OPEN">Keep Open</button>';
    }
    if(d) actionBtns += '<button type="button" class="tydLib__btn secondary" data-review-clear="1">Clear Choice</button>';
    return '<article class="tydLib__reviewCard '+statusCls+' '+(d?'decided':'')+'" data-review-index="'+idx+'" data-review-key="'+escapeHtml(key)+'">' +
      '<div class="tydLib__reviewHead"><div><div class="tydLib__auditTitle">'+escapeHtml(title)+' / '+escapeHtml(item.english_title || '')+'</div><div class="tydLib__auditSub">'+escapeHtml(sub)+'</div><div class="tydLib__reviewDecisionRow"><span class="tydLib__reviewStatus '+statusCls+'">current: '+escapeHtml(statusLabel)+'</span>'+reviewDecisionBadge(r)+'</div></div></div>' +
      reviewDecisionBanner(r) +
      '<div class="tydLib__reviewBody"><div class="tydLib__reviewProblem"><div class="tydLib__label">Review problem</div>'+escapeHtml(r.problem || '')+'</div>'+lineHtml+'</div>' +
      renderReviewFixBox(r, item, book, linkedLines, d) +
      '<div class="tydLib__reviewActions">'+actionBtns+'<a class="tydLib__btn secondary" href="/pages/tyd-lineage-library#'+encodeURIComponent(r.item_id || '')+'">Open Item</a><button type="button" class="tydLib__btn secondary" data-copy-review-one="'+idx+'">Copy This Issue</button></div>' +
    '</article>';
  }
  function reviewRowCsv(r){
    var d = reviewDecision(r);
    var row = [
      d && d.action ? d.action : '',
      r._sheet_row || '',
      r.date,r.book_id,r.item_id,r.line_no,r.problem,r.fixed_by,r.status,
      d && d.fix_target ? d.fix_target : '',
      d && d.correct_value ? d.correct_value : '',
      d && d.fix_note ? d.fix_note : '',
      d && d.fix_source ? d.fix_source : '',
      d && d.notes ? d.notes : ''
    ];
    return row.map(csvEscape).join(',');
  }
  function renderReviewLogCsv(rows){
    var out = ['decision,sheet_row,date,book_id,item_id,line_no,problem,fixed_by,current_status,fix_target,correct_value,fix_note,fix_source,decision_notes'];
    (rows || filteredReviewRows()).forEach(function(r){ out.push(reviewRowCsv(r)); });
    return out.join('\n');
  }
  function renderReviewLogText(rows){
    var csv = renderReviewLogCsv(rows);
    var rowCount = Math.max(0, csv.split('\n').length - 1);
    return [
      'TYD_LINEAGE_LIBRARY_REVIEW_LOG_PROMPT',
      '',
      'ChatGPT, this is a Review_Log export from the TYD Lineage Content Library website.',
      'Spreadsheet ID: '+root.getAttribute('data-sheet-id'),
      '',
      'TASK RULES:',
      '1. Read these Review_Log rows as database work-queue issues.',
      '2. Match by sheet_row first when available, otherwise match by book_id, item_id, line_no, problem, and current_status.',
      '3. decision=MARK_RESOLVED means mark that Review_Log row status as resolved; do not change Lines unless the problem text clearly says a data cell must be fixed first.',
      '4. decision=NEEDS_EDIT means inspect the linked Lines / Items / Books row, fix the actual database content if needed, verify it, and then mark that Review_Log row resolved.',
      '5. For NEEDS_EDIT rows, use fix_target, correct_value, fix_note, and fix_source as Jee Sifu direct instruction. If correct_value is filled, treat it as the value he wants kept or changed to.',
      '6. decision=KEEP_OPEN means leave the Review_Log row open. decision=REOPEN means change status back to open. decision=KEEP_RESOLVED means leave it resolved.',
      '7. If decision is blank, do not write changes unless Jee Sifu gives a direct instruction after this prompt.',
      '8. After any write, add a short resolved summary row to Review_Log and verify a few changed cells.',
      '',
      'Review rows: '+rowCount,
      'Clicked decisions: '+reviewDecisionCounts().total,
      '',
      'CSV_START',
      csv,
      'CSV_END'
    ].join('\n');
  }
  function copyReviewLog(rows){
    var txt = renderReviewLogText(rows);
    if(navigator.clipboard){ navigator.clipboard.writeText(txt).then(function(){ setStatus('Review prompt copied', 'ok'); }); }
    els.reader.innerHTML = '<div class="tydLib__readerTop"><div><div class="tydLib__titleZh">Review Log Copy</div><div class="tydLib__titleEn">Copy this ChatGPT-ready prompt and paste it here if clipboard did not work.</div></div><div class="tydLib__readerBtns"><button class="tydLib__btn secondary" type="button" data-back-review="1">Back to review log</button></div></div><textarea class="tydLib__copyArea" readonly>'+escapeHtml(txt)+'</textarea>';
  }
  function copyReviewDecisions(){
    var rows = reviewRowsWithDecisions();
    if(!rows.length){ setStatus('No Review Log decisions selected yet', 'bad'); return; }
    copyReviewLog(rows);
  }
  function renderReviewLogView(){
    var rows = filteredReviewRows();
    renderReviewSidebar();
    if(!rows.length){
      var ds0 = reviewDisplayStats();
      els.reader.innerHTML = '<div class="tydLib__auditEmpty"><h2>No review log rows to show</h2><p>Try changing the filter/search, or turn off Hide approved / Hide duplicate issues. Hidden now: '+ds0.hiddenApproved+' approved, '+ds0.hiddenDuplicates+' duplicates.</p></div>';
      return;
    }
    var dc = reviewDecisionCounts();
    var ds = reviewDisplayStats();
    els.reader.innerHTML = '<div class="tydLib__readerTop"><div><div class="tydLib__titleZh">Review Log</div><div class="tydLib__titleEn">Showing '+rows.length+' issue rows from Review_Log · '+dc.total+' clicked decisions</div><div class="tydLib__meta"><span class="tydLib__tag">database work queue</span><span class="tydLib__tag">click then copy</span><span class="tydLib__tag">'+escapeHtml(state.reviewFilter)+' filter</span><span class="tydLib__tag">'+ds.hiddenApproved+' approved hidden</span><span class="tydLib__tag">'+ds.hiddenDuplicates+' duplicates hidden</span></div><label class="tydLib__auditToggle" style="margin-top:10px"><input type="checkbox" data-toggle-review-hide-approved="1" '+(state.reviewHideApproved?'checked':'')+'> Hide approved / resolved rows</label><label class="tydLib__auditToggle" style="margin-top:8px"><input type="checkbox" data-toggle-review-hide-duplicates="1" '+(state.reviewHideDuplicates?'checked':'')+'> Hide duplicate issues</label><div class="tydLib__auditNotice" style="margin-top:10px">Click <b>Approve / Mark Resolved</b>, <b>Needs Edit / Fix</b>, or <b>Keep Open</b> on the cards below. When an issue needs correction, use the <b>Fix instruction</b> box to type what should be kept or changed. With hide approved on, approved cards disappear from the working list but still stay in the clicked-decision copy prompt.</div></div><div class="tydLib__readerBtns"><a class="tydLib__btn secondary" href="/pages/tyd-lineage-library">Back to Library</a></div></div>' +
      '<div class="tydLib__auditCards">' + rows.map(renderReviewLogCard).join('') + '</div><button type="button" class="tydLib__copyBig" data-copy-review-decisions="1">COPY CLICKED DECISIONS ('+dc.total+')</button><button type="button" class="tydLib__btn secondary" style="width:100%;margin-top:8px" data-copy-review-log="1">Copy all shown review rows</button><div class="tydLib__small">This page reads Review_Log and matching Lines from the Google Sheet. It cannot directly write back from Shopify, so the copy prompt carries your clicked decisions for ChatGPT to apply.</div>';
  }

  function scheduleRenderCurrent(delay){
    clearTimeout(state._renderTimer);
    state._renderTimer = setTimeout(function(){ renderCurrent(); }, delay == null ? 120 : delay);
  }

  function scheduleDirectoryRefresh(opts){
    opts = opts || {};
    clearTimeout(state._filterRenderTimer);
    root.classList.add('tydLib--directoryBusy');
    if(els.count) els.count.textContent = 'Updating…';
    setStatus('Updating directory…', '');
    state._filterRenderTimer = setTimeout(function(){
      var run = function(){
        try{
          if(opts.resetGroups) state.openGroups = {};
          if(opts.populate) populateFilters();
          if(state.auditMode || opts.renderReader){
            renderCurrent();
          }else{
            renderList();
            updateDirectoryActiveDom();
          }
          setStatus(state.auditMode ? 'Audit mode ready' : 'Directory updated from local cache — '+state.items.length+' items / '+state.lines.length+' lines / '+state.rcAtlas.length+' RC entries / '+GOD_ATLAS_ENTRIES.length+' gods', 'ok');
        }finally{
          root.classList.remove('tydLib--directoryBusy');
        }
      };
      if(window.requestAnimationFrame) requestAnimationFrame(function(){ setTimeout(run, 0); });
      else setTimeout(run, 0);
    }, opts.delay == null ? 20 : opts.delay);
  }

  function renderCurrent(){
    if(state.auditMode){
      if(state.auditPanel === 'review') renderReviewLogView();
      else renderAuditView();
    }else { ensureDirectorySelection(); renderList(); renderReader(); }
  }
  function setupAuditUI(){
    var h = document.querySelector('#tydLibraryApp .tydLib__listPanel .tydLib__panelHead h2');
    if(h) h.textContent = 'Audit';
    if(els.directoryView && els.directoryView.closest('div')) els.directoryView.closest('div').style.display = 'none';
    if(els.dirSort && els.dirSort.closest('.tydLib__dirSort')) els.dirSort.closest('.tydLib__dirSort').style.display = 'none';
    if(els.mode && els.mode.closest('div')) els.mode.closest('div').style.display = 'none';
  }


  function isMobileDrawerMode(){
    return window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
  }
  function setMobileDrawer(open){
    open = !!open;
    state.mobileDrawerOpen = open;
    root.classList.toggle('tydLibDrawerOpen', open);
    if(els.mobileDrawerOpen) els.mobileDrawerOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    if(els.mobileDrawerBackdrop) els.mobileDrawerBackdrop.hidden = !open;
  }
  function closeMobileDrawerAfterPick(){
    if(isMobileDrawerMode()) setMobileDrawer(false);
  }

  function copyAddBookPrompt(){
    var done = function(){ setStatus('Add-book prompt copied. Paste it in ChatGPT and attach the book file.', 'ok'); setTimeout(function(){ setStatus(state.auditMode ? 'Audit mode ready' : 'Loaded '+state.items.length+' items / '+state.lines.length+' lines / '+state.rcAtlas.length+' RC entries / '+GOD_ATLAS_ENTRIES.length+' gods', 'ok'); }, 2200); };
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(ADD_BOOK_PROMPT).then(done).catch(function(){
        window.prompt('Copy this add-book prompt, then paste it in ChatGPT with the book file attached:', ADD_BOOK_PROMPT);
      });
    }else{
      window.prompt('Copy this add-book prompt, then paste it in ChatGPT with the book file attached:', ADD_BOOK_PROMPT);
    }
  }


  function currentDeepLinkHash(){
    if(!state.selectedId) return '';
    var id = String(state.selectedId || '').trim();
    if(!id) return '';
    var hash = encodeURIComponent(id);
    if(isGodDirectory() && isGodSelection(id) && state.godSection){
      hash += '/' + encodeURIComponent(String(state.godSection || '').trim());
    }
    return hash;
  }

  function currentDeepLinkUrl(){
    var url;
    try{ url = new URL(window.location.href); }
    catch(err){ return window.location.href; }
    url.searchParams.delete('audit');
    url.searchParams.delete('review');
    url.searchParams.set('view', normalizeDeepLinkView(state.directoryView || 'book'));
    var hash = currentDeepLinkHash();
    if(hash) url.hash = hash;
    return url.toString();
  }

  function normalizeDeepLinkView(v){
    v = String(v || '').toLowerCase().trim();
    if(v === 'gods' || v === 'god' || v === 'god_atlas' || v === 'god atlas') return 'gods';
    if(v === 'rc' || v === 'rc_atlas' || v === 'rc atlas') return 'rc';
    if(v === 'quick' || v === 'quick_shelf' || v === 'quick shelf' || v === 'shelf') return 'quick';
    if(v === 'video' || v === 'videos' || v === 'teaching videos') return 'videos';
    if(v === 'supply' || v === 'supplies' || v === 'shopping' || v === 'shopping list') return 'supplies';
    return 'book';
  }

  function parseLibraryDeepLinkHash(){
    var raw = '';
    try{ raw = decodeURIComponent((location.hash || '').replace(/^#/,'')); }catch(err){ raw = (location.hash || '').replace(/^#/, ''); }
    raw = String(raw || '').trim();
    if(!raw) return { id:'', section:'' };
    var parts = raw.split('/');
    return { id:String(parts[0] || '').trim(), section:String(parts.slice(1).join('/') || '').trim() };
  }

  function copyCurrentDeepLink(){
    if(!state.selectedId){ setStatus('Select a page first, then copy the deep link.', 'bad'); return; }
    var link = currentDeepLinkUrl();
    var done = function(){
      setStatus('Deep link copied.', 'ok');
      setTimeout(function(){ setStatus(state.auditMode ? 'Audit mode ready' : 'Loaded '+state.items.length+' items / '+state.lines.length+' lines / '+state.rcAtlas.length+' RC entries / '+GOD_ATLAS_ENTRIES.length+' gods', 'ok'); }, 1800);
    };
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(link).then(done).catch(function(){ window.prompt('Copy this deep link:', link); done(); });
    }else{
      window.prompt('Copy this deep link:', link);
      done();
    }
  }

  function superShow(show){
    if(!els.superOverlay) return;
    els.superOverlay.hidden = !show;
    els.superOverlay.classList.toggle('is-running', !!show && !!state._superchargeRunning);
  }
  function superSetProgress(done, total){
    var pct = total ? Math.max(0, Math.min(100, Math.round((done / total) * 100))) : 0;
    if(els.superBar) els.superBar.style.width = pct + '%';
  }
  function superSetStatus(txt, cls){
    if(els.superStatus){ els.superStatus.textContent = txt || ''; els.superStatus.className = 'tydLib__superStatus' + (cls ? ' '+cls : ''); }
  }
  function superLog(txt, cls){
    if(!els.superLog) return;
    var div = document.createElement('div');
    div.className = cls || '';
    div.textContent = txt || '';
    els.superLog.appendChild(div);
    els.superLog.scrollTop = els.superLog.scrollHeight;
  }
  function slbBusyForOfflineCache_(){
    try{
      if(!window.SLBPostBridge || typeof window.SLBPostBridge.activity !== 'function') return null;
      var a = window.SLBPostBridge.activity();
      var shared = (a && a.shared) || [];
      return shared.length ? shared[0] : null;
    }catch(e){ return null; }
  }

  async function runLibrarySupercharge(){
    if(!state.authReady){ setStatus('Log in first, then run Supercharge', 'bad'); return; }
    if(state.auditMode){ setStatus('Supercharge is for the normal reader page, not audit mode', 'bad'); return; }
    if(state.acgAccess !== 'full' && !state.isAdmin){ setStatus('Supercharge is for ACG/full Library access.', 'bad'); return; }
    if(state._superchargeRunning){ setStatus('Supercharge is already running...', ''); return; }
    state._superchargeRunning = true;
    if(els.supercharge) els.supercharge.disabled = true;
    superShow(true);
    if(els.superOverlay) els.superOverlay.classList.add('is-running');
    if(els.superLog) els.superLog.innerHTML = '';
    superSetProgress(0, 5);
    superSetStatus('Preparing fast Library snapshot...');
    superLog('Downloading the complete Library directly in a few large requests. The directory remains usable.');
    try{
      if(state._fullSnapshotPromise){
        superLog('Finishing the background text download already in progress...');
        await state._fullSnapshotPromise;
      }
      superSetProgress(1,5);
      superSetStatus('Refreshing complete text...');
      var lines = state.fullLinesLoaded && state.lines.length ? state.lines : await loadSheet(CFG.sheets.lines);
      superLog('Complete text ready: '+(lines || []).length+' lines.', 'ok');
      superSetProgress(2,5);
      superSetStatus('Refreshing RC and God Atlas...');
      var atlases = await Promise.all([loadOptionalSheet(CFG.sheets.rc), loadOptionalSheet(CFG.sheets.gods)]);
      superLog('Atlas data ready.', 'ok');
      superSetProgress(3,5);
      superSetStatus('Saving one offline snapshot...');
      installFastFullSnapshot_(lines || [], atlases[0] || [], atlases[1] || [], 'Supercharged');
      superSetProgress(4,5);
      superSetStatus('Prefetching Teaching Videos, Fun Watch, Articles, and Supplies...');
      try{
        var collectionsReady=await loadLibraryCollections({quiet:true,force:true});
        if(collectionsReady){
          var articlePrefetch=await prefetchAllArticleBodies_();
          superLog('Teaching Videos, Fun Watch, Articles, and Supplies saved for instant local opening.', 'ok');
          if(articlePrefetch.total) superLog('Article bodies saved offline: '+articlePrefetch.saved+' / '+articlePrefetch.total+'.', articlePrefetch.saved===articlePrefetch.total?'ok':'bad');
        }else superLog('Main Library saved. Videos/Fun Watch/Articles/Supplies refresh will retry quietly later.', 'bad');
      }catch(_collectionErr){
        superLog('Main Library saved. Videos/Fun Watch/Articles/Supplies refresh will retry quietly later.', 'bad');
      }
      superSetProgress(5,5);
      if(els.superOverlay) els.superOverlay.classList.remove('is-running');
      superSetStatus('Done. Full Library saved.', 'ok');
      superLog('Done. Books, items, Teaching Videos, Fun Watch, Articles, and Supplies now open from local snapshots.', 'ok');
      setTimeout(function(){ superShow(false); }, 900);
    }catch(err){
      if(els.superOverlay) els.superOverlay.classList.remove('is-running');
      superSetStatus('Supercharge failed.', 'bad');
      setStatus('Supercharge failed', 'bad');
      superLog(err && err.message ? err.message : String(err || 'Unknown error'), 'bad');
      reportLibraryTelemetry_('supercharge_error', err && err.message ? err.message : String(err || 'Unknown error'), Date.now()-TYD_LIBRARY_BOOT_STARTED_AT);
    }finally{
      state._superchargeRunning = false;
      if(els.supercharge) els.supercharge.disabled = false;
    }
  }

  function bind(){
    markUserActivity();
    loadBuilderLocal();
    loadQuickShelfToState(false);
    ['pointerdown','keydown','wheel','touchstart','scroll'].forEach(function(evt){
      root.addEventListener(evt, markUserActivity, { passive:true });
    });
    els.search.addEventListener('input', function(){
      markUserActivity();
      state.query = this.value;
      if(state.auditMode){ scheduleRenderCurrent(180); return; }
      scheduleDirectoryRefresh({ delay:120, resetGroups:false });
    });
    els.type.addEventListener('change', function(){ state.type = this.value; state.category = ''; state.godSection = ''; state._directoryRenderCache = {}; ensureDirectorySelection(); scheduleDirectoryRefresh({ populate:true, resetGroups:true, renderReader:true }); });
    els.category.addEventListener('change', function(){ state.category = this.value; state.godSection = ''; state._directoryRenderCache = {}; ensureDirectorySelection(); scheduleDirectoryRefresh({ resetGroups:!isGodDirectory(), renderReader:true }); });
    if(els.directoryView) els.directoryView.addEventListener('change', function(){ state.directoryView = this.value || 'book'; normalizeDirectoryView(); this.value = state.directoryView; state.type = ''; state.category = ''; state.godSection = ''; state._directoryRenderCache = {}; if(isCollectionDirectory()) prefetchLibraryCollections_({force:false}); ensureDirectorySelection(); scheduleDirectoryRefresh({ populate:true, resetGroups:true, renderReader:true }); });
    if(els.dirSort) els.dirSort.addEventListener('change', function(){ state.directorySort = this.value || 'sheet'; scheduleDirectoryRefresh({ resetGroups:false }); });
    if(els.mode) els.mode.addEventListener('change', function(){ state.mode = this.value; renderReader(); });
    els.reload.addEventListener('click', function(){ loadAll({force:true}); loadLibraryCollections({quiet:false,force:true}); });
    if(els.resetCache) els.resetCache.addEventListener('click', clearLibraryCache);
    if(els.addPrompt) els.addPrompt.addEventListener('click', copyAddBookPrompt);
    if(els.addVideoCollection) els.addVideoCollection.addEventListener('click', function(){ openCollectionEditor_('video',null); });
    if(els.addFunCollection) els.addFunCollection.addEventListener('click', function(){ openCollectionEditor_('fun',null); });
    if(els.addArticleCollection) els.addArticleCollection.addEventListener('click', function(){ openCollectionEditor_('article',null); });
    if(els.addSupplyCollection) els.addSupplyCollection.addEventListener('click', function(){ openCollectionEditor_('supply',null); });
    if(els.themeToggle) els.themeToggle.addEventListener('click', function(){ applyTydTheme(state.theme === 'dark' ? 'light' : 'dark', true); });
    if(els.downloadToggle) els.downloadToggle.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); setDownloadsDrawer_(!state.downloadDrawerOpen); });
    if(els.downloadClose) els.downloadClose.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); setDownloadsDrawer_(false); });
    if(els.supercharge) els.supercharge.addEventListener('click', runLibrarySupercharge);
    if(els.superClose) els.superClose.addEventListener('click', function(){ superShow(false); });
    if(els.superOverlay) els.superOverlay.addEventListener('click', function(e){ if(e.target === els.superOverlay) superShow(false); });
    if(els.mobileDrawerOpen) els.mobileDrawerOpen.addEventListener('click', function(){ setMobileDrawer(true); });
    if(els.mobileDrawerClose) els.mobileDrawerClose.addEventListener('click', function(){ setMobileDrawer(false); });
    if(els.mobileDrawerBackdrop) els.mobileDrawerBackdrop.addEventListener('click', function(){ setMobileDrawer(false); });
    document.addEventListener('click', function(e){ if(!state.downloadDrawerOpen) return; var t=e.target; if((els.downloadDrawer && els.downloadDrawer.contains(t)) || (els.downloadToggle && els.downloadToggle.contains(t))) return; setDownloadsDrawer_(false); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && state.downloadDrawerOpen) setDownloadsDrawer_(false); });
    if(els.builderOpen) els.builderOpen.addEventListener('click', function(){ setBuilderOpen(true); });
    if(els.builderClose) els.builderClose.addEventListener('click', function(){ setBuilderOpen(false); });
    if(els.builderBackdrop) els.builderBackdrop.addEventListener('click', function(){ setBuilderOpen(false); });
    if(els.builderBookSelect) els.builderBookSelect.addEventListener('change', function(e){ switchBuilderBook(e.target.value); });
    if(els.builderTemplateSelect) els.builderTemplateSelect.addEventListener('change', function(){ if(els.builderLoadTemplate) els.builderLoadTemplate.disabled = !els.builderTemplateSelect.value; });
    if(els.builderTemplateId) els.builderTemplateId.addEventListener('input', function(){ els.builderTemplateId.setAttribute('data-auto-template-id','0'); });
    if(els.builderLoadTemplate) els.builderLoadTemplate.addEventListener('click', function(){ loadOfficialTemplateIntoBuilder(els.builderTemplateSelect && els.builderTemplateSelect.value); });
    if(els.builderCopyTemplatePrompt) els.builderCopyTemplatePrompt.addEventListener('click', copyBuilderOfficialTemplatePrompt);
    if(els.builderDownloadTemplatePatch) els.builderDownloadTemplatePatch.addEventListener('click', downloadBuilderTemplatePatch);
    if(els.builderCheckUpdates) els.builderCheckUpdates.addEventListener('click', checkBuilderUpdates);
    if(els.builderApplyUpdates) els.builderApplyUpdates.addEventListener('click', refreshBuilderChangedSnapshots);
    if(els.builderNew) els.builderNew.addEventListener('click', createNewBuilderBook);
    if(els.builderSave) els.builderSave.addEventListener('click', function(){ saveBuilderLocal(); renderBuilder(); setStatus('Saved current Builder book.', 'ok'); });
    if(els.builderSaveAs) els.builderSaveAs.addEventListener('click', saveAsBuilderBook);
    if(els.builderRename) els.builderRename.addEventListener('click', renameBuilderBook);
    if(els.builderDeleteBook) els.builderDeleteBook.addEventListener('click', deleteBuilderBook);
    if(els.builderTitle) els.builderTitle.addEventListener('input', function(e){ handleBuilderFieldInput(e.target); });
    if(els.builderDesc) els.builderDesc.addEventListener('input', function(e){ handleBuilderFieldInput(e.target); });
    if(els.builderVersionMode) els.builderVersionMode.addEventListener('change', function(e){ handleBuilderFieldInput(e.target); renderBuilder(); });
    if(els.builderDefaultMode) els.builderDefaultMode.addEventListener('change', function(e){ handleBuilderFieldInput(e.target); });
    if(els.builderLayoutPreset) els.builderLayoutPreset.addEventListener('change', function(e){ handleBuilderFieldInput(e.target); });
    if(els.builderPreview) els.builderPreview.addEventListener('click', previewBuilder);
    if(els.builderAddCustom) els.builderAddCustom.addEventListener('click', addCustomPageToBuilder);
    if(els.builderAddCover) els.builderAddCover.addEventListener('click', addCoverPageToBuilder);
    if(els.builderAddDivider) els.builderAddDivider.addEventListener('click', addDividerPageToBuilder);
    if(els.builderAddToc) els.builderAddToc.addEventListener('click', addTocPageToBuilder);
    if(els.builderBreakAll) els.builderBreakAll.addEventListener('click', function(){ setAllBuilderPageBreaks(true); });
    if(els.builderClearBreaks) els.builderClearBreaks.addEventListener('click', function(){ setAllBuilderPageBreaks(false); });
    if(els.builderClear) els.builderClear.addEventListener('click', function(){ if(!state.builder.sections.length) return; if(window.confirm && !window.confirm('Clear this Builder basket?')) return; state.builder.sections = []; clearBuilderExpandedState(); saveBuilderLocal(); renderBuilder(); if(isBuilderSelection(state.selectedId)) renderReader(); setStatus('Book Builder cleared.', 'ok'); });
    if(els.builderExport) els.builderExport.addEventListener('click', exportBuilderFile);
    if(els.builderExportAll) els.builderExportAll.addEventListener('click', exportBuilderLibraryFile);
    if(els.builderImportBtn) els.builderImportBtn.addEventListener('click', function(){ if(els.builderImportFile) els.builderImportFile.click(); });
    if(els.builderImportFile) els.builderImportFile.addEventListener('change', function(){ importBuilderFile(this.files && this.files[0]); this.value = ''; });
    if(els.builderDownloadHtml) els.builderDownloadHtml.addEventListener('click', downloadBuilderHtml);
    if(els.builderPanel){
      els.builderPanel.addEventListener('input', function(e){ handleBuilderFieldInput(e.target); });
      els.builderPanel.addEventListener('change', function(e){ handleBuilderFieldInput(e.target); });
      els.builderPanel.addEventListener('dragstart', builderDragStart);
      els.builderPanel.addEventListener('dragover', builderDragOver);
      els.builderPanel.addEventListener('drop', builderDrop);
      els.builderPanel.addEventListener('dragend', builderDragEnd);
      els.builderPanel.addEventListener('dragleave', function(e){ var card = e.target && e.target.closest && e.target.closest('[data-builder-idx]'); if(card) card.classList.remove('isDragOver'); });
      els.builderPanel.addEventListener('click', function(e){
        var btn = e.target.closest && e.target.closest('[data-builder-action]');
        if(btn){
          var actionCard = btn.closest('[data-builder-idx]');
          if(!actionCard) return;
          var actionIdx = Number(actionCard.getAttribute('data-builder-idx'));
          var action = btn.getAttribute('data-builder-action');
          if(action === 'up') moveBuilderSection(actionIdx, -1);
          else if(action === 'down') moveBuilderSection(actionIdx, 1);
          else if(action === 'duplicate') duplicateBuilderSection(actionIdx);
          else if(action === 'remove') removeBuilderSection(actionIdx);
          return;
        }
        if(e.target && e.target.closest && e.target.closest('input,select,textarea,a,[data-builder-drag-handle]')) return;
        var head = e.target.closest && e.target.closest('[data-builder-toggle]');
        if(!head) return;
        var card = head.closest('[data-builder-idx]');
        if(!card) return;
        var idx = Number(card.getAttribute('data-builder-idx'));
        setBuilderSectionExpanded(idx, !isBuilderSectionExpanded(state.builder.sections[idx], idx));
      });
    }
    root.addEventListener('click', function(e){
      var focusBtn=e.target && e.target.closest && e.target.closest('[data-article-focus]');
      if(!focusBtn) return;
      e.preventDefault();
      var cid=focusBtn.getAttribute('data-article-focus')||'';
      var entry=state.collections.find(function(x){return String(x.collection_id||'')===String(cid);})||collectionBySelection_(state.selectedId);
      openArticleFocus_(entry);
    });

    root.addEventListener('touchstart', function(e){
      if(state.chantActive || state.articleFocusActive) return;
      var t = e.changedTouches && e.changedTouches[0]; if(!t) return;
      state.mobileTouchStartX = t.clientX; state.mobileTouchStartY = t.clientY;
    }, {passive:true});
    root.addEventListener('touchend', function(e){
      if(state.chantActive || state.articleFocusActive || !isMobileDrawerMode()) return;
      var t = e.changedTouches && e.changedTouches[0]; if(!t) return;
      var dx = t.clientX - state.mobileTouchStartX;
      var dy = t.clientY - state.mobileTouchStartY;
      if(Math.abs(dx) < 65 || Math.abs(dx) < Math.abs(dy) * 1.35) return;
      if(dx > 0 && !state.mobileDrawerOpen){
        var targetReader = e.target && e.target.closest && e.target.closest('.tydLib__readerPanel');
        if(state.mobileTouchStartX < 80 || targetReader) setMobileDrawer(true);
      }else if(dx < 0 && state.mobileDrawerOpen){
        setMobileDrawer(false);
      }
    }, {passive:true});

    if(els.articleFocusOverlay){
      els.articleFocusOverlay.addEventListener('click', function(e){
        if(e.target.closest('[data-article-focus-exit]')){ closeArticleFocus_(); return; }
        var fontBtn=e.target.closest('[data-article-focus-font-size]');
        if(fontBtn){ setChantScale(state.chantScale+(fontBtn.getAttribute('data-article-focus-font-size')==='up'?.06:-.06),true); return; }
        if(e.target.closest('#tydArticleFocusThemeToggle')){ cycleChantTheme(); return; }
        if(e.target.closest('#tydArticleFocusFontToggle')){ cycleArticleFocusFont(); return; }
      });
    }
    if(els.articleFocusScroller) els.articleFocusScroller.addEventListener('scroll', updateArticleFocusProgress_, {passive:true});

    if(els.chantOverlay){
      els.chantOverlay.addEventListener('click', function(e){
        if(e.target.closest('[data-chant-exit]')){ closeChantMode(); return; }
        if(e.target.closest('[data-chant-prev]')){ changeChantPage(-1); return; }
        if(e.target.closest('[data-chant-next]')){ changeChantPage(1); return; }
        var fontBtn = e.target.closest('[data-chant-font]');
        if(fontBtn){ setChantScale(state.chantScale + (fontBtn.getAttribute('data-chant-font') === 'up' ? .06 : -.06), true); setTimeout(fitChantPageText, 0); return; }
        if(e.target.closest('#tydChantThemeToggle')){ cycleChantTheme(); setTimeout(fitChantPageText, 0); return; }
      });
    }
    if(els.chantStage){
      els.chantStage.addEventListener('touchstart', function(e){
        var t = e.changedTouches && e.changedTouches[0]; if(!t) return;
        state.chantTouchStartX = t.clientX; state.chantTouchStartY = t.clientY;
      }, {passive:true});
      els.chantStage.addEventListener('touchend', function(e){
        var t = e.changedTouches && e.changedTouches[0]; if(!t) return;
        var dx = t.clientX - state.chantTouchStartX;
        var dy = t.clientY - state.chantTouchStartY;
        if(Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25){ changeChantPage(dx < 0 ? 1 : -1); }
      }, {passive:true});
    }
    document.addEventListener('keydown', function(e){
      if(state.articleFocusActive){ if(e.key==='Escape'){ closeArticleFocus_(); } return; }
      if(!state.chantActive) return;
      if(e.key === 'Escape'){ closeChantMode(); return; }
      if(e.key === 'ArrowRight' || e.key === 'PageDown'){ changeChantPage(1); return; }
      if(e.key === 'ArrowLeft' || e.key === 'PageUp'){ changeChantPage(-1); return; }
    });
    window.addEventListener('resize', function(){
      if(state.chantActive) setTimeout(fitChantPageText, 80);
      if(!isMobileDrawerMode()) setMobileDrawer(false);
    });
    if(els.expandAll) els.expandAll.addEventListener('click', function(){ setAllGroups(true); });
    if(els.collapseAll) els.collapseAll.addEventListener('click', function(){ setAllGroups(false); });
    els.list.addEventListener('click', function(e){
      var godUrlBtn = e.target.closest && e.target.closest('[data-copy-god-url]');
      if(godUrlBtn){
        var godUrl = godUrlBtn.getAttribute('data-copy-god-url') || '';
        if(godUrl && navigator.clipboard){ navigator.clipboard.writeText(godUrl).then(function(){ setStatus('Copied image CDN link', 'ok'); }); }
        return;
      }
      if(state.auditMode){
        var panelBtn = e.target.closest('[data-audit-panel]');
        if(panelBtn){ state.auditPanel = panelBtn.getAttribute('data-audit-panel') || 'saamlawnese'; renderCurrent(); return; }
        var reviewFilterBtn = e.target.closest('[data-review-filter]');
        if(reviewFilterBtn){ state.reviewFilter = reviewFilterBtn.getAttribute('data-review-filter') || 'open'; renderReviewLogView(); return; }
        var copyReviewBtn = e.target.closest('[data-copy-review-log]');
        if(copyReviewBtn){ copyReviewLog(); return; }
        var copyReviewDecBtn = e.target.closest('[data-copy-review-decisions]');
        if(copyReviewDecBtn){ copyReviewDecisions(); return; }
        var reviewHideApprovedToggle = e.target.closest('[data-toggle-review-hide-approved]');
        if(reviewHideApprovedToggle){ state.reviewHideApproved = reviewHideApprovedToggle.checked; renderReviewLogView(); return; }
        var reviewHideDupToggle = e.target.closest('[data-toggle-review-hide-duplicates]');
        if(reviewHideDupToggle){ state.reviewHideDuplicates = reviewHideDupToggle.checked; renderReviewLogView(); return; }
        var hideToggle = e.target.closest('[data-toggle-hide-decided]');
        if(hideToggle){ state.auditHideDecided = hideToggle.checked; renderAuditView(); return; }
        var groupToggle = e.target.closest('[data-toggle-group-duplicates]');
        if(groupToggle){ state.auditGroupDuplicates = groupToggle.checked; renderAuditView(); return; }
        var showExToggle = e.target.closest('[data-toggle-show-exceptions]');
        if(showExToggle){ state.auditShowExceptions = showExToggle.checked; renderAuditView(); return; }
        var filterBtn = e.target.closest('[data-audit-filter]');
        if(filterBtn){ state.auditFilter = filterBtn.getAttribute('data-audit-filter'); renderAuditView(); return; }
        var incBtn = e.target.closest('[data-use-master-incomplete]');
        if(incBtn){
          state.auditRows.forEach(function(a){ if(a.issues.indexOf('INCOMPLETE_PINYIN') !== -1) state.auditDecisions[a.id] = { action:'USE_MASTER', notes:'incomplete pinyin line-wrap repair' }; });
          state.auditHideDecided = true;
          renderAuditView(); return;
        }
        var patBtn = e.target.closest('[data-pattern-use]');
        if(patBtn){
          var key = patBtn.getAttribute('data-pattern-use');
          applyPatternDecision(key, 'USE_MASTER');
          renderAuditView(); return;
        }
        var patCustomBtn = e.target.closest('[data-pattern-custom]');
        if(patCustomBtn){
          var pkey = patCustomBtn.getAttribute('data-pattern-custom');
          var input = els.list.querySelector('[data-pattern-custom-input="'+CSS.escape(pkey)+'"]');
          var custom = input ? String(input.value || '').trim().toLowerCase() : '';
          if(!custom){ setStatus('Type custom pinyin first', 'bad'); return; }
          applyPatternDecision(pkey, 'CUSTOM_MASTER_CHAR', custom);
          renderAuditView(); return;
        }
        var copyBtn = e.target.closest('[data-copy-fixes]');
        if(copyBtn){ copyApprovedFixes(); return; }
        return;
      }
      /* God Atlas item click hard stop v89 */
      if(isGodDirectory()){
        var godBtn = e.target.closest('[data-id]');
        if(godBtn && godEntryById(godBtn.getAttribute('data-id'))){
          e.preventDefault();
          e.stopPropagation();
          state.selectedId = godBtn.getAttribute('data-id');
          openSelectedDirectoryGroup();
          updateDirectoryActiveDom();
          renderReader();
          closeMobileDrawerAfterPick();
          try{ history.replaceState(null,'','#'+encodeURIComponent(state.selectedId)); }catch(err){}
          return;
        }
      }
      /* RC item click hard stop v80 */
      if(isRcDirectory()){
        var rcBtn = e.target.closest('[data-id]');
        if(rcBtn && rcEntryById(rcBtn.getAttribute('data-id'))){
          e.preventDefault();
          e.stopPropagation();
          state.selectedId = rcBtn.getAttribute('data-id');
          openSelectedDirectoryGroup();
          updateDirectoryActiveDom();
          renderReader();
          closeMobileDrawerAfterPick();
          try{ history.replaceState(null,'','#'+encodeURIComponent(state.selectedId)); }catch(err){}
          return;
        }
      }
      var qsBookBtn = e.target.closest('[data-quick-shelf-book]');
      if(qsBookBtn){
        e.preventDefault(); e.stopPropagation();
        addBookToQuickShelf(qsBookBtn.getAttribute('data-quick-shelf-book'));
        return;
      }
      var qsItemBtn = e.target.closest('[data-quick-shelf-item]');
      if(qsItemBtn){
        e.preventDefault(); e.stopPropagation();
        addItemToQuickShelf(qsItemBtn.getAttribute('data-quick-shelf-item'));
        return;
      }
      var qsOpenSelectionBtn = e.target.closest('[data-quick-open-selection]');
      if(qsOpenSelectionBtn){
        e.preventDefault(); e.stopPropagation();
        state.selectedId = qsOpenSelectionBtn.getAttribute('data-quick-open-selection');
        openSelectedDirectoryGroup(); updateDirectoryActiveDom(); renderReader(); closeMobileDrawerAfterPick();
        try{ history.replaceState(null,'', location.pathname + '?view=quick#' + encodeURIComponent(state.selectedId)); }catch(qsSelErr){}
        return;
      }
      var qsOpenBtn = e.target.closest('[data-quick-open]');
      if(qsOpenBtn){
        e.preventDefault(); e.stopPropagation();
        state.selectedId = quickShelfSelectionId(qsOpenBtn.getAttribute('data-quick-open'));
        openSelectedDirectoryGroup(); updateDirectoryActiveDom(); renderReader(); closeMobileDrawerAfterPick();
        try{ history.replaceState(null,'', location.pathname + '?view=quick#' + encodeURIComponent(state.selectedId)); }catch(qsErr){}
        return;
      }
      var qsRefreshBtn = e.target.closest('[data-quick-refresh]');
      if(qsRefreshBtn){
        e.preventDefault(); e.stopPropagation();
        refreshQuickShelfEntry(qsRefreshBtn.getAttribute('data-quick-refresh'));
        return;
      }
      var qsRemoveSectionBtn = e.target.closest('[data-quick-remove-section-entry]');
      if(qsRemoveSectionBtn){
        e.preventDefault(); e.stopPropagation();
        removeQuickShelfSection(qsRemoveSectionBtn.getAttribute('data-quick-remove-section-entry'), qsRemoveSectionBtn.getAttribute('data-quick-remove-section-item'));
        return;
      }
      var qsRemoveBtn = e.target.closest('[data-quick-remove]');
      if(qsRemoveBtn){
        e.preventDefault(); e.stopPropagation();
        removeQuickShelfEntry(qsRemoveBtn.getAttribute('data-quick-remove'));
        return;
      }
      var addItemBtn = e.target.closest('[data-builder-add]');
      if(addItemBtn){
        e.preventDefault(); e.stopPropagation();
        addItemToBuilder(addItemBtn.getAttribute('data-builder-add'));
        setBuilderOpen(true);
        return;
      }
      var addBookBtn = e.target.closest('[data-builder-add-book]');
      if(addBookBtn){
        e.preventDefault(); e.stopPropagation();
        addBookToBuilder(addBookBtn.getAttribute('data-builder-add-book'));
        return;
      }
      var toggle = e.target.closest('[data-toggle-group]');
      if(toggle){
        var key = toggle.getAttribute('data-toggle-group');
        if(toggle.classList && toggle.classList.contains('tydLib__godNestedBtn')){
          e.preventDefault(); e.stopPropagation();
          var group = toggle.closest('.tydLib__godNestedGroup');
          var willOpen = !(group && group.classList.contains('open'));
          state.openGroups[key] = willOpen;
          if(group){
            group.classList.toggle('open', willOpen);
            var arrow = null;
            try{ arrow = group.querySelector(':scope > .tydLib__godNestedBtn .tydLib__groupArrow'); }catch(err){}
            if(!arrow) arrow = group.querySelector('.tydLib__godNestedBtn .tydLib__groupArrow') || group.querySelector('.tydLib__groupArrow');
            if(arrow) arrow.textContent = willOpen ? '▾' : '▸';
            var body = null;
            try{ body = group.querySelector(':scope > .tydLib__groupBody'); }catch(err2){}
            if(!body) body = group.querySelector('.tydLib__groupBody');
            if(body){
              if(willOpen && !String(body.innerHTML || '').trim()) body.innerHTML = renderDirectoryGroupBody(key);
              body.hidden = !willOpen;
              body.style.display = willOpen ? 'block' : 'none';
            }
            return;
          }
        }
        state.openGroups[key] = !state.openGroups[key];
        if(!updateDirectoryGroupDom(key)) renderList();
        return;
      }
      var bookBtn = e.target.closest('[data-book-read]');
      if(bookBtn){
        var bookId = bookBtn.getAttribute('data-book-read');
        state.selectedId = bookGroupKey(bookId);
        state.openGroups[bookGroupKey(bookId)] = true;
        updateDirectoryActiveDom(); renderReader();
        closeMobileDrawerAfterPick();
        try{ history.replaceState(null,'','#'+encodeURIComponent(state.selectedId)); }catch(err){}
        return;
      }
      var godCatBtn = e.target.closest('[data-god-category-select]');
      if(godCatBtn){
        var gid2 = godCatBtn.getAttribute('data-god-category-select') || '';
        var sec2 = godCatBtn.getAttribute('data-god-category') || '';
        var ge2 = godEntryById(gid2);
        if(ge2){
          state.selectedId = gid2;
          if(state.category){
            // Category dropdown mode: keep the directory in the all-prayers/all-spells list.
            state.godSection = '';
            if(els.category) els.category.value = state.category;
            updateDirectoryActiveDom();
            renderReader();
          }else{
            // Type/all-god navigation mode: show this one section in the reader only.
            // Do not change the Category dropdown and do not rebuild the directory.
            state.godSection = sec2;
            if(els.category) els.category.value = '';
            state.openGroups[godGroupKeyForEntry(ge2)] = true;
            state.openGroups[godEntryGroupKey(ge2)] = true;
            updateDirectoryActiveDom();
            renderReader();
          }
          closeMobileDrawerAfterPick();
          try{ history.replaceState(null,'','#'+encodeURIComponent(state.selectedId)+'/'+encodeURIComponent(sec2)); }catch(errCat){}
        }
        return;
      }
      var btn = e.target.closest('[data-id]'); if(!btn) return;
      state.selectedId = btn.getAttribute('data-id');
      if(isGodDirectory() && isGodSelection(state.selectedId)){ state.category = ''; state.godSection = ''; if(els.category) els.category.value = ''; }
      openSelectedDirectoryGroup();
      updateDirectoryActiveDom(); renderReader();
      closeMobileDrawerAfterPick();
      try{ history.replaceState(null,'','#'+encodeURIComponent(state.selectedId)); }catch(err){}
    });
    els.reader.addEventListener('click', function(e){
      var collectionEditBtn=e.target.closest && e.target.closest('[data-collection-edit]');
      if(collectionEditBtn){ var ceid=collectionEditBtn.getAttribute('data-collection-edit'), centry=null; state.collections.forEach(function(r){if(r.collection_id===ceid)centry=r;}); if(centry) openCollectionEditor_(centry.kind,centry); return; }
      var collectionDeleteBtn=e.target.closest && e.target.closest('[data-collection-delete]');
      if(collectionDeleteBtn){ deleteCollection_(collectionDeleteBtn.getAttribute('data-collection-delete')); return; }
      if(e.target && e.target.id === 'tydQuickShelfCurrent'){
        e.preventDefault();
        toggleCurrentQuickShelf();
        return;
      }
      var qsRemoveReaderSection = e.target.closest && e.target.closest('[data-quick-remove-section-entry]');
      if(qsRemoveReaderSection){
        e.preventDefault();
        removeQuickShelfSection(qsRemoveReaderSection.getAttribute('data-quick-remove-section-entry'), qsRemoveReaderSection.getAttribute('data-quick-remove-section-item'));
        return;
      }
      var qsRemoveReader = e.target.closest && e.target.closest('[data-quick-remove]');
      if(qsRemoveReader){
        e.preventDefault();
        removeQuickShelfEntry(qsRemoveReader.getAttribute('data-quick-remove'));
        return;
      }
      var godOpenItem = e.target.closest && e.target.closest('[data-god-open-item]');
      if(godOpenItem){
        var itemId = godOpenItem.getAttribute('data-god-open-item');
        if(itemById(itemId)){
          state.selectedId = itemId;
          updateDirectoryActiveDom();
          renderReader();
          try{ history.replaceState(null,'','#'+encodeURIComponent(state.selectedId)); }catch(err){}
        }else setStatus('Linked item not found: '+itemId, 'bad');
        return;
      }
      var godOpenBook = e.target.closest && e.target.closest('[data-god-open-book]');
      if(godOpenBook){
        var bookId = godOpenBook.getAttribute('data-god-open-book');
        if(bookById(bookId)){
          state.selectedId = bookGroupKey(bookId);
          updateDirectoryActiveDom();
          renderReader();
          try{ history.replaceState(null,'','#'+encodeURIComponent(state.selectedId)); }catch(err2){}
        }else setStatus('Linked book not found: '+bookId, 'bad');
        return;
      }
      var godOpenGod = e.target.closest && e.target.closest('[data-god-open-god]');
      if(godOpenGod){
        var gid = godOpenGod.getAttribute('data-god-open-god');
        if(godEntryById(gid)){
          state.directoryView = 'gods'; if(els.directoryView) els.directoryView.value = 'gods';
          state.selectedId = gid; state.category = ''; state.godSection = ''; populateFilters(); renderList(); updateDirectoryActiveDom(); renderReader();
          try{ history.replaceState(null,'','#'+encodeURIComponent(state.selectedId)); }catch(err3){}
        }else setStatus('Linked god not found: '+gid, 'bad');
        return;
      }
      var godOpenRc = e.target.closest && e.target.closest('[data-god-open-rc]');
      if(godOpenRc){
        var rid = godOpenRc.getAttribute('data-god-open-rc');
        if(rcEntryById(rid)){
          state.directoryView = 'rc'; if(els.directoryView) els.directoryView.value = 'rc';
          state.selectedId = rid; populateFilters(); renderList(); updateDirectoryActiveDom(); renderReader();
          try{ history.replaceState(null,'','#'+encodeURIComponent(state.selectedId)); }catch(err4){}
        }else setStatus('Linked RC entry not found: '+rid, 'bad');
        return;
      }
      /* RC Atlas reader related click */
      var rcRelBtn = e.target.closest('[data-id]');
      if(rcRelBtn && rcEntryById(rcRelBtn.getAttribute('data-id'))){
        state.selectedId = rcRelBtn.getAttribute('data-id');
        openSelectedDirectoryGroup();
        renderList();
        updateDirectoryActiveDom();
        renderReader();
        try{ history.replaceState(null,'','#'+encodeURIComponent(state.selectedId)); }catch(err){}
        return;
      }
      if(state.auditMode){
        var panelBtn2 = e.target.closest('[data-audit-panel]');
        if(panelBtn2){ state.auditPanel = panelBtn2.getAttribute('data-audit-panel') || 'saamlawnese'; renderCurrent(); return; }
        var backReview = e.target.closest('[data-back-review]');
        if(backReview){ renderReviewLogView(); return; }
        var reviewFilterBtn2 = e.target.closest('[data-review-filter]');
        if(reviewFilterBtn2){ state.reviewFilter = reviewFilterBtn2.getAttribute('data-review-filter') || 'open'; renderReviewLogView(); return; }
        var copyReviewBtn2 = e.target.closest('[data-copy-review-log]');
        if(copyReviewBtn2){ copyReviewLog(); return; }
        var copyReviewDecBtn2 = e.target.closest('[data-copy-review-decisions]');
        if(copyReviewDecBtn2){ copyReviewDecisions(); return; }
        var reviewHideApprovedToggle2 = e.target.closest('[data-toggle-review-hide-approved]');
        if(reviewHideApprovedToggle2){ state.reviewHideApproved = reviewHideApprovedToggle2.checked; renderReviewLogView(); return; }
        var reviewHideDupToggle2 = e.target.closest('[data-toggle-review-hide-duplicates]');
        if(reviewHideDupToggle2){ state.reviewHideDuplicates = reviewHideDupToggle2.checked; renderReviewLogView(); return; }
        var reviewFillBtn = e.target.closest('[data-review-fill]');
        if(reviewFillBtn){
          var fillCard = reviewFillBtn.closest('[data-review-key]');
          if(!fillCard) return;
          var fillTarget = fillCard.querySelector('[data-review-fix-target]');
          var fillValue = fillCard.querySelector('[data-review-fix-value]');
          var fillSource = fillCard.querySelector('[data-review-fix-source]');
          if(fillTarget) fillTarget.value = reviewFillBtn.getAttribute('data-review-fill-target') || 'AUTO_DETECT';
          if(fillValue) fillValue.value = reviewFillBtn.getAttribute('data-review-fill-value') || '';
          if(fillSource) fillSource.value = 'quick-fill: '+(reviewFillBtn.textContent || 'current linked data');
          setStatus('Quick fill added. Click Save Fix Instruction or Needs Edit / Fix.', 'ok');
          return;
        }
        var reviewSaveFixBtn = e.target.closest('[data-review-save-fix]');
        if(reviewSaveFixBtn){
          var saveCard = reviewSaveFixBtn.closest('[data-review-key]');
          if(!saveCard) return;
          hydrateReviewDecisionFromCard(saveCard, 'NEEDS_EDIT');
          renderReviewLogView();
          return;
        }
        var reviewActionBtn = e.target.closest('[data-review-action]');
        if(reviewActionBtn){
          var reviewCard = reviewActionBtn.closest('[data-review-key]');
          if(!reviewCard) return;
          hydrateReviewDecisionFromCard(reviewCard, reviewActionBtn.getAttribute('data-review-action'));
          renderReviewLogView();
          return;
        }
        var reviewClearBtn = e.target.closest('[data-review-clear]');
        if(reviewClearBtn){
          var reviewCard2 = reviewClearBtn.closest('[data-review-key]');
          if(!reviewCard2) return;
          clearReviewDecisionByKey(reviewCard2.getAttribute('data-review-key'));
          renderReviewLogView();
          return;
        }
        var copyReviewOne = e.target.closest('[data-copy-review-one]');
        if(copyReviewOne){
          var rows = filteredReviewRows();
          var n = Number(copyReviewOne.getAttribute('data-copy-review-one') || -1);
          if(rows[n]) copyReviewLog([rows[n]]);
          return;
        }
        var back = e.target.closest('[data-back-audit]');
        if(back){ renderAuditView(); return; }
        var hideToggle = e.target.closest('[data-toggle-hide-decided]');
        if(hideToggle){ state.auditHideDecided = hideToggle.checked; renderAuditView(); return; }
        var groupToggle = e.target.closest('[data-toggle-group-duplicates]');
        if(groupToggle){ state.auditGroupDuplicates = groupToggle.checked; renderAuditView(); return; }
        var showExToggle = e.target.closest('[data-toggle-show-exceptions]');
        if(showExToggle){ state.auditShowExceptions = showExToggle.checked; renderAuditView(); return; }
        var copyMain = e.target.closest('[data-copy-fixes-main]');
        if(copyMain){ copyApprovedFixes(); return; }
        var pUse = e.target.closest('[data-pattern-use-main]');
        if(pUse){ applyPatternDecision(pUse.getAttribute('data-pattern-use-main'), 'USE_MASTER'); renderAuditView(); return; }
        var pKeep = e.target.closest('[data-pattern-keep-main]');
        if(pKeep){ applyPatternDecision(pKeep.getAttribute('data-pattern-keep-main'), 'KEEP_CURRENT'); renderAuditView(); return; }
        var pFlag = e.target.closest('[data-pattern-flag-main]');
        if(pFlag){ applyPatternDecision(pFlag.getAttribute('data-pattern-flag-main'), 'FLAG_REVIEW'); renderAuditView(); return; }
        var pCustom = e.target.closest('[data-pattern-custom-main]');
        if(pCustom){
          var pk = pCustom.getAttribute('data-pattern-custom-main');
          var inp = els.reader.querySelector('[data-pattern-custom-input-main="'+CSS.escape(pk)+'"]');
          var cv = inp ? String(inp.value || '').trim().toLowerCase() : '';
          if(!cv){ setStatus('Type custom pinyin first', 'bad'); return; }
          applyPatternDecision(pk, 'CUSTOM_MASTER_CHAR', cv); renderAuditView(); return;
        }
        var customBtn = e.target.closest('[data-custom-char-apply]');
        if(customBtn){
          var card2 = customBtn.closest('[data-audit-id]');
          if(!card2) return;
          var id2 = card2.getAttribute('data-audit-id');
          var row2 = customBtn.closest('[data-custom-key]');
          var key2 = customBtn.getAttribute('data-custom-char-apply');
          var input2 = card2.querySelector('[data-custom-token="'+CSS.escape(key2)+'"]');
          var custom2 = input2 ? String(input2.value || '').trim().toLowerCase() : '';
          if(!custom2){ setStatus('Type custom pinyin first', 'bad'); return; }
          state.auditDecisions[id2] = { action:'CUSTOM_MASTER_CHAR', chineseChar:row2 ? row2.getAttribute('data-custom-char') : '', currentToken:row2 ? row2.getAttribute('data-current-token') : '', masterToken:row2 ? row2.getAttribute('data-master-token') : '', customToken:custom2, notes:'custom from audit card' };
          renderAuditView(); return;
        }
        var actionBtn = e.target.closest('[data-audit-action]');
        if(actionBtn){
          var card = actionBtn.closest('[data-audit-id]');
          if(!card) return;
          var id = card.getAttribute('data-audit-id');
          var action = actionBtn.getAttribute('data-audit-action');
          state.auditDecisions[id] = { action:action, notes:'' };
          renderAuditView();
          return;
        }
        return;
      }
      if(e.target && e.target.id === 'tydChantMode') openChantMode();
      if(e.target && e.target.id === 'tydModeCycle') cycleReadMode();
      if(e.target && e.target.id === 'tydZhFontCycle') cycleZhFont();
      if(e.target && e.target.id === 'tydReaderSizeCycle') cycleReaderSize();
      if(e.target && e.target.id === 'tydBuilderAddCurrent') addCurrentToBuilder();
      if(e.target && e.target.id === 'tydQuickShelfCurrent') toggleCurrentQuickShelf();
      if(e.target && e.target.id === 'tydQuickShelfBookCurrent'){ var _qsBookId = quickShelfBookTargetForCurrent(); if(_qsBookId) addBookToQuickShelf(_qsBookId); else setStatus('Could not find the parent book for this item.', 'bad'); }
      if(e.target && e.target.id === 'tydPrintCurrent') openPrintView('paper');
      if(e.target && e.target.id === 'tydKpdfCurrent') openPrintView('kpdf');
      if(e.target && e.target.id === 'tydCopyDeepLink') copyCurrentDeepLink();
      if(e.target && e.target.id === 'tydPrintSmaller') updatePrintScale(-0.1);
      if(e.target && e.target.id === 'tydPrintBigger') updatePrintScale(0.1);
      if(e.target && e.target.id === 'tydPrintNow') runPrintNow();
      if(e.target && e.target.id === 'tydPrintClose') cleanupPrintStage();
      if(e.target && e.target.id === 'tydCopyCurrent') copyText('current');
    });
  }

  function liveFastDirectoryLoaders_(){
    // V114+ fast-snapshot model: the bundled directory opens immediately.
    // A saved complete Lines snapshot is restored when available; otherwise Lines prepares quietly in the background.
    var core = Promise.all([
      loadSheet(CFG.sheets.items),
      loadSheet(CFG.sheets.books),
      loadSheet(CFG.sheets.index)
    ]);
    var atlases = withSoftTimeout(Promise.all([
      loadOptionalSheet(CFG.sheets.rc),
      loadOptionalSheet(CFG.sheets.gods)
    ]), 4500, [[], []]);
    return Promise.all([core, atlases]).then(function(parts){
      var rows = parts[0] || [], optional = parts[1] || [[], []];
      return {
        items:rows[0] || [], lines:[], books:rows[1] || [], index:rows[2] || [],
        rcAtlas:optional[0] || [], godAtlas:optional[1] || [], review:[],
        supercharged:false, fastDirectoryMode:true, manifest:null
      };
    });
  }

  function liveDatabaseLoaders(){
    if(state.auditMode){
      var loaders = [loadSheet(CFG.sheets.items), loadSheet(CFG.sheets.lines), loadSheet(CFG.sheets.books), loadSheet(CFG.sheets.index), loadOptionalSheet(CFG.sheets.rc), loadOptionalSheet(CFG.sheets.gods)];
      loaders.push(loadSheet(CFG.sheets.review));
      loaders.push(loadMasterCharSheet().catch(function(err){ state.masterError = err && err.message ? err.message : String(err || 'Master load failed'); return []; }));
      loaders.push(loadOptionalSheet(CFG.sheets.exceptions));
      return Promise.all(loaders).then(function(res){
        var auditData = {
          items:res[0] || [], lines:res[1] || [], books:res[2] || [], index:res[3] || [],
          rcAtlas:res[4] || [], godAtlas:res[5] || [], review:res[6] || [],
          masterRows:res[7] || [], exceptions:res[8] || []
        };
        auditData.manifest = buildLibraryManifest(auditData);
        return auditData;
      });
    }

    // The four core tabs determine whether the Library can be used. RC/God Atlas
    // are optional and should never hold the whole first render for 12 seconds.
    var core = Promise.all([
      loadSheet(CFG.sheets.items),
      loadSheet(CFG.sheets.lines),
      loadSheet(CFG.sheets.books),
      loadSheet(CFG.sheets.index)
    ]);
    var optionalAtlases = withSoftTimeout(Promise.all([
      loadOptionalSheet(CFG.sheets.rc),
      loadOptionalSheet(CFG.sheets.gods)
    ]), 4500, [[], []]);
    return Promise.all([core, optionalAtlases]).then(function(parts){
      var res = parts[0] || [];
      var atlases = parts[1] || [[], []];
      var data = {
        items: res[0] || [],
        lines: res[1] || [],
        books: res[2] || [],
        index: res[3] || [],
        rcAtlas: atlases[0] || [],
        godAtlas: atlases[1] || [],
        review: [],
        masterRows: [],
        exceptions: []
      };
      data.manifest = buildLibraryManifest(data);
      return data;
    });
  }


  function renderBootPlaceholder(){
    els.reader.innerHTML = '<div class="tydLib__empty"><h2>Library ready</h2><p>Pick a book or item from the directory to open the content.</p><p class="tydLib__small">The directory is ready immediately. Complete text prepares quietly in the background, and ✦ Supercharge can refresh the full offline snapshot.</p></div>';
    setReaderMeta(readerMetaHtml(['local cache','ready','pick to open']));
  }

  function renderNormalLoadedView(fromCache, opts){
    opts = opts || {};
    var run = function(){
      try{
        if(!opts.skipList) renderList();
        if(opts.deferReader && !state.selectedId && !(state.quickShelfFirstPaint && isQuickShelfDirectory())) renderBootPlaceholder();
        else renderReader();
        root.classList.toggle('tydLib--cachedData', !!fromCache);
      }finally{
        clearLibraryLoading();
        root.classList.remove('tydLib--preparingView');
        state._initialNormalRendered = true;
        scheduleDirectoryCachePrewarm();
      }
    };
    if(!state._initialNormalRendered && window.requestAnimationFrame){
      root.classList.add('tydLib--preparingView');
      requestAnimationFrame(function(){ setTimeout(run, 0); });
    }else{
      run();
    }
  }

  function scheduleDirectoryCachePrewarm(){
    if(state.auditMode || state._directoryCacheWarmRunning || state._directoryCacheWarmedAt) return;
    setTimeout(function(){
      if(state.auditMode || state._directoryCacheWarmRunning || state._directoryCacheWarmedAt) return;
      prewarmDirectoryCaches();
    }, 450);
  }

  function prewarmDirectoryCaches(){
    if(state.auditMode || state._directoryCacheWarmRunning) return;
    var books = sortedBookIdsForDirectory();
    var items = state._validItemsCache || validItemRows(state.items);
    if(!books.length && !items.length) return;
    state._directoryCacheWarmRunning = true;
    var bi = 0, ii = 0;
    function keepGoing(started){ return (Date.now() - started) < 14; }
    function finish(){ state._directoryCacheWarmRunning = false; state._directoryCacheWarmedAt = Date.now(); }
    function bookStep(){
      var started = Date.now();
      try{
        while(bi < books.length && keepGoing(started)){ indexedItemsForBook(books[bi++], items); }
      }catch(e){ finish(); return; }
      if(bi < books.length){ setTimeout(bookStep, 0); return; }
      setTimeout(itemStep, 0);
    }
    function itemStep(){
      var started = Date.now();
      try{
        while(ii < items.length && keepGoing(started)){
          var item = items[ii++];
          itemLibraryTypeForDirectory(item);
          itemBrowseCategoriesForDirectory(item);
        }
      }catch(e){ finish(); return; }
      if(ii < items.length){ setTimeout(itemStep, 0); return; }
      finish();
    }
    setTimeout(bookStep, 0);
  }

  function applyLoadedDatabase(data, fromCache){
    perfMark_('applyStart');
    data = data || {};
    // Keep the complete unfiltered payload. The Daily-only gate filters state.items at render time,
    // so when ACG/admin is later confirmed we can restore the full library instantly from this snapshot.
    try{ state._rawLibraryData = data; }catch(_eRaw){}
    state.dataLoaded = true;
    state.cacheManifest = data.manifest || state.cacheManifest || null;
    state.supercharged = !!data.supercharged;
    state.fastDirectoryMode = !!data.fastDirectoryMode;
    state.compactDirectory = !!data.compactDirectory;
    state.fullLinesLoaded = !state.fastDirectoryMode;
    // Assign raw directory rows first. Full-access users do not need the old
    // build-filter-build cycle; it doubled the heaviest CPU work on every boot.
    state.items = (data.items || []).filter(dataItemHasId);
    state.lines = (data.lines || []).filter(function(l){ return l && String(l.item_id || '').trim(); });
    state.books = (data.books || []).filter(function(b){ return b && String(b.book_id || '').trim(); });
    state.index = (data.index || []).filter(function(x){ return x && String(x.book_id || '').trim() && String(x.item_id || '').trim(); });
    applyRcAtlasRows(data.rcAtlas || []);
    applyGodAtlasRows(data.godAtlas || []);
    state.review = data.review || [];
    state.books = state.books.map(function(b){ return hydrateBookTitleFields(b); });
    state.books = state.books.filter(function(b){ return !isLegacyBook(b); });
    state.index = state.index.filter(function(x){ return !isLegacyBook(x.book_id) && !isLegacySourceText(x.source_book); });
    state.review = state.review.filter(function(r){ return !isLegacyBook(r.book_id); });
    state.items = state.items.filter(function(item){ return !itemIsLegacyOnly(item); });
    state.lines = state.lines.filter(function(l){ return !isLegacySourceText(l.source_book); });
    perfMark_('beforeIndexes');
    // v120: do not prebuild the huge per-item search-text map during boot.
    // Search text is built lazily inside searchableText() only when search is used.
    if(acgFullAccess_()){
      buildDerivedIndexes({ skipSearch:true });
    }else{
      // Daily Rite filtering needs book/index relationships, so limited users
      // still require one pre-filter index and one small filtered index.
      buildDerivedIndexes({ skipSearch:true });
      state.items = validItemRows(state.items);
      buildDerivedIndexes({ skipSearch:true });
    }
    perfMark_('afterIndexes');
    if(state.fastDirectoryMode){
      state._linesByItem = state._linesByItem || {};
      state.fullLinesLoaded = false;
    }
    loadQuickShelfToState(true).catch(function(){});

    if(state.auditMode){
      state.masterRows = data.masterRows || [];
      state.exceptions = data.exceptions || [];
      populateFilters(); setupAuditUI(); runAudit(); renderCurrent();
      clearLibraryLoading();
      if(state.auditPanel === 'review'){
        var rc = reviewCounts();
        setStatus('Review Log: '+rc.open+' open / '+rc.resolved+' resolved', rc.open ? '' : 'ok');
      }else{
        var c = auditCounts();
        setStatus('Audit: '+c.problem+' problems / '+c.OK+' OK / '+(c.APPROVED_EXCEPTION||0)+' exceptions', c.problem ? '' : 'ok');
      }
      return;
    }

    var deepHash = parseLibraryDeepLinkHash();
    if(deepHash.id){
      if(isBuilderSelection(deepHash.id)){
        state.selectedId = deepHash.id;
      }else if(quickShelfEntryBySelection(deepHash.id)){
        state.directoryView = 'quick';
        state.selectedId = deepHash.id;
      }else if(godEntryById(deepHash.id)){
        state.directoryView = 'gods';
        state.selectedId = deepHash.id;
        state.godSection = deepHash.section || '';
      }else if(rcEntryById(deepHash.id)){
        state.directoryView = 'rc';
        state.selectedId = deepHash.id;
      }else if(state.items.some(function(i){return i.item_id === deepHash.id;})){
        state.directoryView = 'book';
        state.selectedId = deepHash.id;
      }else if(isBookSelection(deepHash.id) && allBookIdsForDirectory().indexOf(deepHash.id.slice(5)) !== -1){
        state.directoryView = 'book';
        state.selectedId = deepHash.id;
      }
    }
    normalizeDirectoryView();
    var useBootDirectory = !!(fromCache && data.bootHtml && !deepHash.id && state.directoryView === 'book' && !state.query && !state.type && !state.category);
    populateFilters();
    if(useBootDirectory){
      var bootKey = ['book','sheet','',''].join('\u001f');
      var bootGroups = expandBootGroupData_(data.bootGroups || {});
      state._directoryGroupData = bootGroups;
      state._lastDirectoryCount = Number(data.bootCount || 0);
      els.count.textContent = state._lastDirectoryCount + (state._lastDirectoryCount === 1 ? ' item' : ' items');
      els.list.innerHTML = data.bootHtml;
      state._directoryRenderCache[bootKey] = { html:data.bootHtml, count:state._lastDirectoryCount, groupData:bootGroups };
      state._directoryRenderCacheOrder = [bootKey];
      perfMark_('bootHtmlInstalled');
    }else{
      initOpenGroups();
    }
    if(els.directoryView) els.directoryView.value = state.directoryView;
    godTryReadAnnivCache();
    godRequestAnnivList();
    if(isRcDirectory() && !state.selectedId && RC_ATLAS_ENTRIES[0]) state.selectedId = RC_ATLAS_ENTRIES[0].rc_id;
    // v120: do not auto-select/open the first book or item on page entry.
    // Auto-opening can draw a long scripture immediately and make cached boot feel frozen.
    // A hash link still opens directly; otherwise the reader waits for the user's pick.
    // Builder template options are expensive to derive across every book. They
    // are populated by renderBuilder() only when the hidden Builder is opened.
    if(state.selectedId) openSelectedDirectoryGroup();
    renderNormalLoadedView(fromCache, { deferReader: fromCache && !location.hash, skipList:useBootDirectory });
    perfMark_('applyReturned');
  }


  function refreshRcAtlasQuiet(){
    return loadSheet(CFG.sheets.rc).then(function(rows){
      applyRcAtlasRows(rows || []);
      scheduleCachedLibraryWrite();
      return true;
    }).catch(function(){ return false; });
  }

  function refreshGodAtlasQuiet(){
    return loadSheet(CFG.sheets.gods).then(function(rows){
      applyGodAtlasRows(rows || []);
      scheduleCachedLibraryWrite();
      return true;
    }).catch(function(){ return false; });
  }
  function libraryCountStatus(prefix){
    return String(prefix || '') + state.items.length+' items / '+state.lines.length+' lines / '+state.rcAtlas.length+' RC entries / '+GOD_ATLAS_ENTRIES.length+' gods';
  }

  function applyFastDirectoryCache(cached){
    cached = cacheDirectoryData(cached || {});
    cached.fastDirectoryMode = true;
    cached.compactDirectory = !!cached.compactDirectory;
    cached.lines = [];
    applyLoadedDatabase(cached, true);
    var lineInfo = cached.lineCount ? (' / '+cached.lineCount+' text lines saved separately') : '';
    setStatus('Directory ready instantly — '+state.items.length+' items / '+state.books.length+' books'+lineInfo, 'ok');
    tydPerfMark_('directory-ready', state.items.length+' items / '+state.books.length+' books');
    if(!state.selectedId) renderBootPlaceholder();
  }

  function readFullCachedLibraryOnce_(){
    if(validCachedLibrary(state._fullCachedLibrary)) return Promise.resolve(state._fullCachedLibrary);
    if(state._fullCacheReadPromise) return state._fullCacheReadPromise;
    state._fullCacheReadPromise = readCachedLibrary().then(function(cached){
      if(validCachedLibrary(cached)){
        state._fullCachedLibrary = cached;
        return cached;
      }
      return null;
    }).catch(function(){ return null; }).finally(function(){ state._fullCacheReadPromise = null; });
    return state._fullCacheReadPromise;
  }

  function installFastFullSnapshot_(rows, rcRows, godRows, sourceLabel){
    rows = (rows || []).filter(function(l){ return l && String(l.item_id || '').trim(); });
    state.lines = rows;
    state._linesByItem = groupLinesByItem_(rows);
    state.fullLinesLoaded = true;
    state.fastDirectoryMode = true;
    state.supercharged = true;
    if(Array.isArray(rcRows) && rcRows.length) applyRcAtlasRows(rcRows);
    if(Array.isArray(godRows) && godRows.length) applyGodAtlasRows(godRows);
    var data = {
      v:TYD_CACHE_VERSION,
      savedAt:Date.now(),
      supercharged:true,
      items:state.items || [],
      lines:rows,
      books:state.books || [],
      index:state.index || [],
      rcAtlas:state.rcAtlas || [],
      godAtlas:state.godAtlas || [],
      review:state.review || []
    };
    data.manifest = buildLibraryManifest(data);
    state.cacheManifest = data.manifest;
    state._fullCachedLibrary = cacheMiniData(data);
    writeCachedLibrary(data).catch(function(){});
    if(state.selectedId && !state.lazyLineLoading){ try{ renderReader(); }catch(e){} }
    setStatus((sourceLabel || 'Complete Library text ready')+' — '+rows.length+' lines saved locally.', 'ok');
    tydPerfMark_('full-snapshot-ready', rows.length+' lines');
    return data;
  }

  function warmFullSnapshotQuiet_(){
    if(state.auditMode || !state.authReady || state.acgAccess !== 'full' || state.fullLinesLoaded) return Promise.resolve(null);
    if(state._fullSnapshotPromise) return state._fullSnapshotPromise;
    state._fullSnapshotPromise = readFullCachedLibraryOnce_().then(function(cached){
      if(validCachedLibrary(cached) && (cached.lines || []).length){
        return installFastFullSnapshot_(cached.lines || [], cached.rcAtlas || [], cached.godAtlas || [], 'Complete Library opened from saved snapshot');
      }
      setStatus('Directory ready — preparing complete text quietly...', 'ok');
      return loadSheet(CFG.sheets.lines).then(function(rows){
        return installFastFullSnapshot_(rows || [], null, null, 'Complete Library ready');
      });
    }).catch(function(err){
      setStatus('Directory ready. The complete text snapshot could not refresh, but books can still open from the live Library.', 'bad');
      reportLibraryTelemetry_('sheet_load_error', err && err.message ? err.message : String(err || 'Background snapshot failed'), Date.now()-TYD_LIBRARY_BOOT_STARTED_AT);
      return null;
    }).finally(function(){ state._fullSnapshotPromise = null; });
    return state._fullSnapshotPromise;
  }

  function refreshDirectoryStructureQuiet_(current){
    if(state._directoryStructureRefreshRunning || recentLiveCheck(TYD_LIVE_CHECK_INTERVAL_MS)) return Promise.resolve(null);
    state._directoryStructureRefreshRunning = true;
    return liveFastDirectoryLoaders_().then(function(data){
      data.compactDirectory = false;
      data.manifest = buildLibraryManifest(data);
      applyFastDirectoryCache(data);
      writeFastDirectoryCache(data);
      markLiveCheckDone();
      setStatus('Directory checked and current.', 'ok');
      return data;
    }).catch(function(){
      setStatus('Directory ready from the saved snapshot; online update check was unavailable.', 'bad');
      return null;
    }).finally(function(){ state._directoryStructureRefreshRunning = false; });
  }

  function continueAfterFastDirectory_(fastDirectory){
    if(state._fastDirectoryBackgroundStarted) return;
    state._fastDirectoryBackgroundStarted = true;
    // Prefer a newer saved directory without blocking the first paint.
    setTimeout(function(){
      readFastDirectoryCacheAsync().then(function(saved){
        if(!validFastDirectoryCache(saved)) return;
        if(Number(saved.savedAt || 0) <= Number((fastDirectory && fastDirectory.savedAt) || 0)) return;
        applyFastDirectoryCache(saved);
        setStatus('Opened the newest saved directory.', 'ok');
      }).catch(function(){});
    }, 200);
    // Full text is restored from local cache immediately, or downloaded once in
    // the background. The directory remains usable the whole time.
    setTimeout(function(){ warmFullSnapshotQuiet_(); }, 450);
    // A small structural refresh runs later and never blocks the reader.
    setTimeout(function(){ runWhenQuiet(function(){ refreshDirectoryStructureQuiet_(fastDirectory); }, 15000); }, 12000);
  }

  function ensureFullTextSearchReady_(){
    if(state.fullLinesLoaded) return Promise.resolve(true);
    return warmFullSnapshotQuiet_().then(function(){ return !!state.fullLinesLoaded; });
  }

  function loadAll(opts){
    opts = opts || {};
    if(!state.authReady){ return; }
    if(state._libraryLoadRunning && !opts.force){
      // Avoid two startup loads when saved login opens first and SLB confirms the session a moment later.
      return;
    }
    state._libraryLoadRunning = true;
    function finishLibraryLoad_(){ state._libraryLoadRunning = false; }
    // Fast Quick Shelf boot: paint saved full-copy books/items immediately from localStorage,
    // then continue opening the normal library cache/database in the background.
    // This must never interrupt the normal DB loader; if the fast shelf has any issue,
    // fall back to the normal library startup.
    try{
      if(!state.auditMode && quickShelfBootFromLocalStorage()){
        renderQuickShelfFirstPaint();
      }
    }catch(qsBootErr){
      state.quickShelfFirstPaint = false;
      try{ root.classList.remove('tydLib--quickShelfFirstPaint','tydLib--quickShelfBackgroundLoad'); }catch(e){}
    }
    loadQuickShelfToState(true).catch(function(){});

    if(state.auditMode){
      showLibraryLoading('Loading audit database...', 'Opening the Library database and SLB master sheet.');
      liveDatabaseLoaders().then(function(data){ applyLoadedDatabase(data, false); finishLibraryLoad_(); }).catch(function(err){
        finishLibraryLoad_();
        clearLibraryLoading();
        setStatus('Sheet loading failed', 'bad');
        reportLibraryTelemetry_('sheet_load_error', err && err.message ? err.message : String(err || 'Audit database failed'), Date.now()-TYD_LIBRARY_BOOT_STARTED_AT);
        els.reader.innerHTML = '<div class="tydLib__empty"><h2>Could not load the Google Sheet</h2><p>'+escapeHtml(err.message || err)+'</p><p class="tydLib__small">Make sure both Google Sheets are shared as Anyone with the link can view, or published to the web.</p></div>';
      });
      return;
    }

    if(opts.force){
      showLibraryLoading('Refreshing latest directory...', 'Updating books and item listings.');
      liveFastDirectoryLoaders_().then(function(data){
        data.supercharged = !!state.supercharged;
        data.compactDirectory = false;
        data.manifest = buildLibraryManifest(data);
        return yieldToBrowser(40).then(function(){
          applyFastDirectoryCache(data);
          writeFastDirectoryCache(data);
          markLiveCheckDone();
          setStatus('Directory refreshed — full text is preparing quietly.', 'ok');
          state._fastDirectoryBackgroundStarted = false;
          continueAfterFastDirectory_(data);
          finishLibraryLoad_();
        });
      }).catch(function(err){
        finishLibraryLoad_(); clearLibraryLoading(); setStatus('Directory refresh failed', 'bad');
        reportLibraryTelemetry_('sheet_load_error', err && err.message ? err.message : String(err || 'Directory refresh failed'), Date.now()-TYD_LIBRARY_BOOT_STARTED_AT);
        if(els.reader) els.reader.innerHTML = '<div class="tydLib__empty"><h2>Could not refresh the Library directory</h2><p>'+escapeHtml(err.message || err)+'</p></div>';
      });
      return;
    }

    showLibraryLoading(opts.fastBoot ? 'Opening fast directory...' : 'Opening saved snapshot...', opts.fastBoot ? 'Opening the local directory immediately.' : 'Looking for a saved browser snapshot before going online.');
    if(!state.auditMode){
      var fastDir = readFastDirectoryCacheSync();
      if(validFastDirectoryCache(fastDir)){
        applyFastDirectoryCache(fastDir);
        finishLibraryLoad_();
        continueAfterFastDirectory_(fastDir);
        return;
      }
      var bundledDir = readBundledDirectoryBootstrap_();
      if(validFastDirectoryCache(bundledDir)){
        applyFastDirectoryCache(bundledDir);
        writeFastDirectoryCache(bundledDir);
        setStatus('Directory ready instantly — full text is preparing quietly.', 'ok');
        finishLibraryLoad_();
        continueAfterFastDirectory_(bundledDir);
        return;
      }
    }
    return readFastDirectoryCacheAsync().then(function(fastDir2){
      if(!state.auditMode && validFastDirectoryCache(fastDir2)){
        applyFastDirectoryCache(fastDir2);
        finishLibraryLoad_();
        continueAfterFastDirectory_(fastDir2);
        return { __fastDirectoryHandled:true };
      }
      return readCachedLibrary();
    }).then(function(cached){
      if(cached && cached.__fastDirectoryHandled) return;
      var hasCache = validCachedLibrary(cached);
      if(hasCache){
        applyFastDirectoryCache(cached);
        writeFastDirectoryCache(cached);
        scheduleLazyLineCacheWrite(cached);
        setStatus('Showing saved directory — full text is preparing quietly.', 'ok');
        finishLibraryLoad_();
        continueAfterFastDirectory_(cached);
        return;
      }else{
        showLibraryLoading('Opening built-in directory...', 'The page will be usable immediately while complete text prepares quietly.');
      }

      return liveFastDirectoryLoaders_().then(function(data){
        setStatus('Opening live directory...', 'loading');
        return yieldToBrowser(60).then(function(){
          applyFastDirectoryCache(data);
          writeFastDirectoryCache(data);
          setStatus('Directory ready — full text is preparing quietly.', 'ok');
          finishLibraryLoad_();
          continueAfterFastDirectory_(data);
        });
      }).catch(function(err){
        finishLibraryLoad_();
        if(hasCache){
          setStatus('Showing saved library from '+cacheStamp(cached.savedAt)+'; live refresh failed', 'bad');
          return;
        }
        clearLibraryLoading();
        setStatus('Sheet loading failed', 'bad');
        els.reader.innerHTML = '<div class="tydLib__empty"><h2>Could not load the Google Sheet</h2><p>'+escapeHtml(err.message || err)+'</p><p class="tydLib__small">Make sure both Google Sheets are shared as Anyone with the link can view, or published to the web.</p></div>';
      });
    }).catch(function(err){
      finishLibraryLoad_();
      if(state.dataLoaded){
        clearLibraryLoading();
        setStatus('Showing saved library; background cache recovery failed.', 'bad');
        return null;
      }
      showLibraryLoading('Cache unavailable — loading the live database...', 'The saved browser cache did not answer in time. Recovering from the live Library now.');
      state._libraryLoadRunning = true;
      return liveFastDirectoryLoaders_().then(function(data){
        data.compactDirectory = false;
        data.manifest = buildLibraryManifest(data);
        applyFastDirectoryCache(data);
        writeFastDirectoryCache(data);
        markLiveCheckDone();
        setStatus('Recovered live directory — full text is preparing quietly.', 'ok');
        return data;
      }).catch(function(liveErr){
        clearLibraryLoading();
        setStatus('Library loading failed. Use Refresh Library to retry.', 'bad');
        reportLibraryTelemetry_('client_error', (liveErr && liveErr.message) || (err && err.message) || 'Library loading failed', Date.now()-TYD_LIBRARY_BOOT_STARTED_AT);
        if(els.reader) els.reader.innerHTML = '<div class="tydLib__empty"><h2>Could not open the Library</h2><p>'+escapeHtml((liveErr && liveErr.message) || (err && err.message) || 'Please try again.')+'</p><p><button type="button" class="tydLib__btn" id="tydLibraryRecoveryRetry">Retry Library</button></p></div>';
        var retry = document.getElementById('tydLibraryRecoveryRetry');
        if(retry) retry.addEventListener('click', function(){ loadAll({ force:true }); });
        return null;
      }).finally(function(){ finishLibraryLoad_(); });
    });
  }


  function bindDownloadGateHardGuard_(){
    try{
      document.addEventListener('click', function(ev){
        var t = ev.target;
        var acgBtn = t && t.closest ? t.closest('[data-acg-download]') : null;
        var imeBtn = t && t.closest ? t.closest('[data-ime-download]') : null;
        if(!acgBtn && !imeBtn) return;
        var acgAllowed = root && root.classList && root.classList.contains('tydLib--downloadsAllowed');
        var imeAllowed = root && root.classList && root.classList.contains('tydLib--imeDownloadsAllowed');
        if((acgBtn && !acgAllowed) || (imeBtn && !imeAllowed)){
          ev.preventDefault();
          ev.stopPropagation();
          ev.stopImmediatePropagation && ev.stopImmediatePropagation();
          if(acgBtn){ setDownloadGateVisible_(false); setStatus('SLB GO downloads are for ACG/full Library access only.', 'bad'); }
          else { setImeDownloadVisible_(false); setStatus('TYD Keyboard downloads require IME group access.', 'bad'); }
          syncDownloadsDrawerAccess_();
          return false;
        }
      }, true);
    }catch(e){}
  }

  // Read-only diagnostics used by the local DEV performance regression test.
  // No auth token or cached Library payload is exposed.
  window.TYD_LIBRARY_PERF_DEBUG = {
    buildTag:TYD_LIBRARY_BUILD_TAG,
    loadLiveManifest:loadLiveManifest,
    buildIncrementalPlan:buildIncrementalPlan,
    cacheDirectoryData:cacheDirectoryData,
    manifestSummaryForTab:manifestSummaryForTab_
  };

  bindDownloadGateHardGuard_();
  bind();
  startAuthGate();
})();

/* SLB_TYD_QS_DB_LOAD_RESTORE_20260704 */
